import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import secureLocalStorage from "react-secure-storage";

const resources = {
    en: {
        translation: {
            "Enter Mobile Number !!": "Enter Mobile Number !!",
            "In Valid OTP !!": "In Valid OTP !!",
            "Please enter password !!": "Please enter password !!",
            "Password not match !!": "Password not match !!",
            "Reset Password": "Reset Password",
            "Enter your phone number and new password": "Enter your phone number and new password",
            "Phone Number": "Phone Number",
            "Enter your number": "Enter your number",
            "Search": "Search",
            "Verify": "Verify",
            "You will receive a 6 digit code for": "You will receive a 6 digit code for",
            "verification to": "verification to",
            "Submit": "Submit",
            "Enter your password and new password": "Enter your password and new password",
            "New Password": "New Password",
            "Enter new password": "Enter new password",
            "Confirm New Password": "Confirm New Password",
            "Confirm new password": "Confirm new password",
            "Back to Login": "Back to Login",
            "Back": "Back",
            "Enter Login Details !!": "Enter Login Details !!",
            "Welcome Back!": "Welcome Back!",
            "Sign in to your account": "Sign in to your account",
            "Password": "Password",
            "Enter your password": "Enter your password",
            "Forgot Password?": "Forgot Password?",
            "Sign In": "Sign In",
            "Don't have an account?": "Don't have an account?",
            "Sign Up": "Sign Up",
            "Please enter all details !!": "Please enter all details !!",
            "Please enter valid email !!": "Please enter valid email !!",
            "Please enter birth place !!": "Please enter birth place !!",
            "Please select language !!": "Please select language !!",
            "Step": "Step",
            "Enter Your Details": "Enter Your Details",
            "Hey there! what is your name?": "Hey there! what is your name?",
            "Full Name": "Full Name",
            "Email Address": "Email Address",
            "Enter your Full Name": "Enter your Full Name",
            "Enter your email": "Enter your email",
            "What is your gender?": "What is your gender?",
            "Male": "Male",
            "Female": "Female",
            "Enter your birth date": "Enter your birth date",
            "Enter your birth time": "Enter your birth time",
            "Enter your birth Place": "Enter your birth Place",
            "Do you know which languages?": "Do you know which languages?",
            "Enter Your Place": "Enter Your Place",
            "Back to Step": "Back to Step",
            "Next": "Next",
            "My Appointments": "My Appointments",
            "Manage your astrology consultations": "Manage your astrology consultations",
            "Upcoming": "Upcoming",
            "Past": "Past",
            "Pending": "Pending",
            "Accepted": "Accepted",
            "Start": "Start",
            "Completed": "Completed",
            "Canceled": "Canceled",
            "ID": "ID",
            "Chat": "Chat",
            "Audio Call": "Audio Call",
            "Video Call": "Video Call",
            "View Details": "View Details",
            "Cancel": "Cancel",
            "No Upcoming Appointment Found !!": "No Upcoming Appointment Found !!",
            "Currently you don't have any upcoming appointment.": "Currently you don't have any upcoming appointment.",
            "No Past Appointment Found !!": "No Past Appointment Found !!",
            "Currently you don't have any past appointment.": "Currently you don't have any past appointment.",
            "Status": "Status",
            "Service Type": "Service Type",
            "Date": "Date",
            "Time": "Time",
            "Price": "Price",
            "Booked Person Details": "Booked Person Details",
            "name": "name",
            "Date of Birth": "Date of Birth",
            "Birth Place": "Birth Place",
            "Gender": "Gender",
            "Complete Details": "Complete Details",
            "Start Time": "Start Time",
            "End Time": "End Time",
            "Total Duration": "Total Duration",
            "Billable Time": "Billable Time",
            "Billed Fee First": "Billed Fee First",
            "Billed Fee After": "Billed Fee After",
            "Total Consultation Fee": "Total Consultation Fee",
            "Kundali Details": "Kundali Details",
            "Name": "Name",
            "Send Notification": "Send Notification",
            "Continue Chat": "Continue Chat",
            "Write message !!": "Write message !!",
            "Astrologer Ai Assistant": "Astrologer Ai Assistant",
            "Ask anything about your horoscope...": "Ask anything about your horoscope...",
            "Write message to assistant": "Write message to assistant",
            "Clear Chat?": "Clear Chat?",
            "All messages will be deleted permanently.": "All messages will be deleted permanently.",
            "Clear": "Clear",
            "Payment faild !!": "Payment faild !!",
            "Please Complete Last Apointment !!": "Please Complete Last Apointment !!",
            "Please enter comment !!": "Please enter comment !!",
            "Insufficient wallet balance !!": "Insufficient wallet balance !!",
            "Orders": "Orders",
            "Experience": "Experience",
            "Rating": "Rating",
            "Unfollow": "Unfollow",
            "Follow": "Follow",
            "Send Gift": "Send Gift",
            "Start a Consultation": "Start a Consultation",
            "Chat with astrologer": "Chat with astrologer",
            "For new user": "For new user",
            "min free": "min free",
            "Call with astrologer": "Call with astrologer",
            "Video call with astrologer": "Video call with astrologer",
            "Astrologer Bio": "Astrologer Bio",
            "Reviews": "Reviews",
            "Activity": "Activity",
            "FAQ's": "FAQ's",
            "Media": "Media",
            "Comment": "Comment",
            "No comment yet": "No comment yet",
            "start the conversation": "start the conversation",
            "Poast your replay": "Poast your replay",
            "Delete comment": "Delete comment",
            "Are you sure you want to delete this comment?": "Are you sure you want to delete this comment?",
            "Cancle": "Cancle",
            "Delete": "Delete",
            "Intro Audio": "Intro Audio",
            "Intro Video": "Intro Video",
            "Hear from": "Hear from",
            "Please select user !!": "Please select user !!",
            "Please select amount !!": "Please select amount !!",







            "Please select payment method !!": "Please select payment method !!",
            "Select Kundli": "Select Kundli",
            "Add Kundli": "Add Kundli",
            "Minimum balance of": "Minimum balance of",
            "minutes": "minutes",
            "is required to start chat with": "is required to start chat with",
            "Wallet Balance": "Wallet Balance",
            "Required": "Required",
            "Proceed to Pay": "Proceed to Pay",
            "extra in your": "extra in your",
            "wallet with this": "wallet with this",
            "Woohoo!": "Woohoo!",
            "Recharge Amount": "Recharge Amount",
            "GST": "GST",
            "Wallet Amount": "Wallet Amount",
            "Payble Amount": "Payble Amount",
            "Pay from Wallet": "Pay from Wallet",
            "Available": "Available",
            "Payment Getway Method": "Payment Getway Method",
            "Continue": "Continue",
            "Fortune Cookie - Unveil Your Daily Wisdom": "Fortune Cookie - Unveil Your Daily Wisdom",
            "Crack open a fortune cookie to reveal a piece of daily wisdom. Let the message guide you through your day with positivity and insight.": "Crack open a fortune cookie to reveal a piece of daily wisdom. Let the message guide you through your day with positivity and insight.",
            "Ask The Fortune Cookie": "Ask The Fortune Cookie",
            "Crack open your Fortune Cookie": "Crack open your Fortune Cookie",
            "Crack another one open": "Crack another one open",
            "Love Compatibility": "Love Compatibility",
            "Find out how compatible you are with your lover, friend, or colleague using our love compatibility calculator. Get your results now.": "Find out how compatible you are with your lover, friend, or colleague using our love compatibility calculator. Get your results now.",
            "Are Aries And Taurus Compatible": "Are Aries And Taurus Compatible",
            "Aries And Taurus Strengths": "Aries And Taurus Strengths",
            "Aries And Taurus Weaknesses": "Aries And Taurus Weaknesses",
            "Aries And Taurus Elements": "Aries And Taurus Elements",
            "Aries And Taurus Dates": "Aries And Taurus Dates",
            "Are Aries And Taurus Compatibility Score": "Are Aries And Taurus Compatibility Score",
            "General": "General",
            "Communication": "Communication",
            "Sex": "Sex",
            "Select Another": "Select Another",
            "Aries": "Aries",
            "Taurus": "Taurus",
            "Gemini": "Gemini",
            "Cancer": "Cancer",
            "Leo": "Leo",
            "Virgo": "Virgo",
            "Libra": "Libra",
            "Scorpio": "Scorpio",
            "Sagittarius": "Sagittarius",
            "Capricorn": "Capricorn",
            "Aquarius": "Aquarius",
            "Pisces": "Pisces",
            "Please select Your Partner Sign": "Please select Your Partner Sign",
            "Please select Your Sign": "Please select Your Sign",
            "Please fill all details !!": "Please fill all details !!",
            "Discover Your Core Numbers That Define You": "Discover Your Core Numbers That Define You",
            "Explore your core numbers like Life Path, Destiny, and Personal Year—complete with strengths, challenges, and meaningful interpretations.": "Explore your core numbers like Life Path, Destiny, and Personal Year—complete with strengths, challenges, and meaningful interpretations.",
            "Get Your Numbers": "Get Your Numbers",
            "First Name": "First Name",
            "Last Name": "Last Name",
            "Method": "Method",
            "Chaldean": "Chaldean",
            "Pythagorean": "Pythagorean",
            "Strengths": "Strengths",
            "Challenges": "Challenges",
            "Advice": "Advice",
            "Get Report": "Get Report",
            "Select Tarot One Card": "Select Tarot One Card",
            "Select Your Card": "Select Your Card",
            "Get Another": "Get Another",
            "Yes Or No Tarot": "Yes Or No Tarot",
            "Get instant Yes or No answers to pressing questions.": "Get instant Yes or No answers to pressing questions.",
            "Daily Tarot": "Daily Tarot",
            "Receive daily tarot readings on love, career, and finance.": "Receive daily tarot readings on love, career, and finance.",
            "In-Depth Love Reading": "In-Depth Love Reading",
            "Deep dive into your love life with relationship-specific readings.": "Deep dive into your love life with relationship-specific readings.",
            "Flirt Love Reading": "Flirt Love Reading",
            "Reveal insights into playful and romantic connections.": "Reveal insights into playful and romantic connections.",
            "Erotic Love Reading": "Erotic Love Reading",
            "Insights into intimate and personal love dynamics.": "Insights into intimate and personal love dynamics.",
            "Egyptian Prediction": "Egyptian Prediction",
            "Access ancient Egyptian insights beyond visible truths.": "Access ancient Egyptian insights beyond visible truths.",
            "Ex-Flame Reading": "Ex-Flame Reading",
            "Explore the possibilities of rekindling with an ex-partner.": "Explore the possibilities of rekindling with an ex-partner.",
            "Made For Each Other Or Not Reading": "Made For Each Other Or Not Reading",
            "Discover if your relationship has long-term potential.": "Discover if your relationship has long-term potential.",
            "Power Life Reading": "Power Life Reading",
            "Take control of your destiny with life-changing tarot readings.": "Take control of your destiny with life-changing tarot readings.",
            "Know Your Friend Reading": "Know Your Friend Reading",
            "Understand the true intentions of your friendships.": "Understand the true intentions of your friendships.",
            "Divine Angel Reading": "Divine Angel Reading",
            "Connect with divine guidance for clarity and spiritual insight.": "Connect with divine guidance for clarity and spiritual insight.",
            "Career Daily Reading": "Career Daily Reading",
            "Elevate your career with daily tarot insights to achieve your professional goals.": "Elevate your career with daily tarot insights to achieve your professional goals.",
            "Dream Come True Reading": "Dream Come True Reading",
            "Gain insights into making your dreams and goals a reality.": "Gain insights into making your dreams and goals a reality.",
            "Past Lives Connection Reading": "Past Lives Connection Reading",
            "Explore your journey across time to understand your path ahead.": "Explore your journey across time to understand your path ahead.",
            "Yes or No Tarot - Find Clear and Immediate Answers": "Yes or No Tarot - Find Clear and Immediate Answers",
            "Daily Tarot - Gain Insights Across Love, Finance, and Career": "Daily Tarot - Gain Insights Across Love, Finance, and Career",
            "In-Depth Love Tarot - Reveal the Realities of Your Relationship": "In-Depth Love Tarot - Reveal the Realities of Your Relationship",
            "Flirt Love Tarot - Discover Your Romantic Potential": "Flirt Love Tarot - Discover Your Romantic Potential",
            "Erotic Love Tarot - Explore Your Intimate Desires": "Erotic Love Tarot - Explore Your Intimate Desires",
            "Discover the Secrets of Your Soul with Egyptian Tarot": "Discover the Secrets of Your Soul with Egyptian Tarot",
            "Ex-Flame Tarot - Reignite or Release the Past": "Ex-Flame Tarot - Reignite or Release the Past",
            "Made For Each Other Tarot - Discover True Compatibility": "Made For Each Other Tarot - Discover True Compatibility",
            "Power Life Tarot - Take Control of Your Destiny": "Power Life Tarot - Take Control of Your Destiny",
            "Know Your Friend Tarot Reading - Unveil the True Nature of Your Relationships": "Know Your Friend Tarot Reading - Unveil the True Nature of Your Relationships",
            "Divine Angel Tarot - Receive Angelic Guidance for Clarity and Relief": "Divine Angel Tarot - Receive Angelic Guidance for Clarity and Relief",
            "Career Daily Tarot Reading - Navigate Your Workday with Confidence": "Career Daily Tarot Reading - Navigate Your Workday with Confidence",
            "Explore the Depths of Your Heart's Desires with a Dream Come True Tarot Reading": "Explore the Depths of Your Heart's Desires with a Dream Come True Tarot Reading",








            "Delve into Your Past Lives - Unravel the Enigma of Your Previous Incarnations": "Delve into Your Past Lives - Unravel the Enigma of Your Previous Incarnations",
            "The Yes or No Tarot widget offers quick, straightforward answers to your pressing questions, helping you make decisions with confidence in areas like love, finance, and career.": "The Yes or No Tarot widget offers quick, straightforward answers to your pressing questions, helping you make decisions with confidence in areas like love, finance, and career.",
            "Daily Tarot provides readings that focus on three key areas of your life: Love, Finance, and Career. Discover the guidance you need for each aspect of your day.": "Daily Tarot provides readings that focus on three key areas of your life: Love, Finance, and Career. Discover the guidance you need for each aspect of your day.",
            "In-Depth Love Tarot provides comprehensive readings to bring clarity to your love life, help you make crucial decisions, and guide you toward understanding your soulmate and future partner.": "In-Depth Love Tarot provides comprehensive readings to bring clarity to your love life, help you make crucial decisions, and guide you toward understanding your soulmate and future partner.",
            "The Flirt Love Tarot Reading provides playful insights into your romantic life. Whether it's a friendship, a new admirer, or a potential soulmate, this reading helps you navigate love with ease.": "The Flirt Love Tarot Reading provides playful insights into your romantic life. Whether it's a friendship, a new admirer, or a potential soulmate, this reading helps you navigate love with ease.",
            "This reading reveals insights into passion, love, and sexual chemistry, helping you understand your relationships and uncover hidden fantasies.": "This reading reveals insights into passion, love, and sexual chemistry, helping you understand your relationships and uncover hidden fantasies.",
            "Explore your twin flame, current struggles, ancestral roots, and past healing with the ancient wisdom of Egyptian Tarot": "Explore your twin flame, current struggles, ancestral roots, and past healing with the ancient wisdom of Egyptian Tarot",
            "The Ex-Flame Tarot Reading provides clarity on whether to rekindle a past relationship or move on. Explore your ex’s feelings, the potential for a renewed connection, and the impact on your future.": "The Ex-Flame Tarot Reading provides clarity on whether to rekindle a past relationship or move on. Explore your ex’s feelings, the potential for a renewed connection, and the impact on your future.",
            "This Tarot reading reveals whether your relationship is worth the effort, safe to pursue, and aligned with your life goals. Understand if you’re truly made for each other or if it’s time to move on.": "This Tarot reading reveals whether your relationship is worth the effort, safe to pursue, and aligned with your life goals. Understand if you’re truly made for each other or if it’s time to move on.",
            "The Power Life Tarot Reading helps you plan your life, overcome struggles, create a clear vision, and take charge of your destiny. Unlock the guidance you need to steer your life towards success.": "The Power Life Tarot Reading helps you plan your life, overcome struggles, create a clear vision, and take charge of your destiny. Unlock the guidance you need to steer your life towards success.",
            "Divine Angel Tarot connects you with your guardian angels, offering guidance to overcome challenges and find peace in love, freedom, and resolution.": "Divine Angel Tarot connects you with your guardian angels, offering guidance to overcome challenges and find peace in love, freedom, and resolution.",
            "Career Daily Tarot offers insights to manage your workday, from handling your boss to staying proactive and managing tasks effectively. Let the Tarot guide you to a successful and stress-free day.": "Career Daily Tarot offers insights to manage your workday, from handling your boss to staying proactive and managing tasks effectively. Let the Tarot guide you to a successful and stress-free day.",
            "The Dream Come True Tarot Reading helps you manifest your deepest wishes and aspirations. Whether it's love, material desires, or unfulfilled dreams, this reading offers clarity and guidance to turn your desires into reality.": "The Dream Come True Tarot Reading helps you manifest your deepest wishes and aspirations. Whether it's love, material desires, or unfulfilled dreams, this reading offers clarity and guidance to turn your desires into reality.",
            "Explore your past lives to understand current fears, recurring patterns, and influences. Gain clarity on challenges rooted in your previous incarnations.": "Explore your past lives to understand current fears, recurring patterns, and influences. Gain clarity on challenges rooted in your previous incarnations.",
            "Select Tarot Three Card": "Select Tarot Three Card",
            "Heartbreak Reading": "Heartbreak Reading",
            "Find guidance and healing for a broken heart.": "Find guidance and healing for a broken heart.",
            "Wisdom Reading": "Wisdom Reading",
            "Balance your energies and find mental peace through wisdom.": "Balance your energies and find mental peace through wisdom.",
            "Divine Magic Reading": "Divine Magic Reading",
            "Discover mystical insights with magical tarot guidance.": "Discover mystical insights with magical tarot guidance.",
            "Heartbreak Tarot Reading - Find Closure and Guidance": "Heartbreak Tarot Reading - Find Closure and Guidance",
            "The Heartbreak Tarot Reading offers insight into the cause of your pain and provides advice on how to heal and move forward. This two-card reading delivers clarity and the necessary steps to mend your broken heart.": "The Heartbreak Tarot Reading offers insight into the cause of your pain and provides advice on how to heal and move forward. This two-card reading delivers clarity and the necessary steps to mend your broken heart.",
            "Wisdom Tarot - Find Balance with Yin and Yang": "Wisdom Tarot - Find Balance with Yin and Yang",
            "Wisdom Tarot provides guidance by balancing the Yin and Yang energies in your life. Discover clarity, peace, and a path forward with this two-card reading.": "Wisdom Tarot provides guidance by balancing the Yin and Yang energies in your life. Discover clarity, peace, and a path forward with this two-card reading.",
            "Divine Magic Tarot Reading - Discover Cause and Remedy": "Divine Magic Tarot Reading - Discover Cause and Remedy",
            "The Divine Magic Tarot Reading offers insights into the root cause of your problems and provides a remedy to guide you toward resolution. With this reading, discover the steps you need to take to transform challenges into solutions.": "The Divine Magic Tarot Reading offers insights into the root cause of your problems and provides a remedy to guide you toward resolution. With this reading, discover the steps you need to take to transform challenges into solutions.",
            "Please pick your cards !!": "Please pick your cards !!",
            "Get Your Reading": "Get Your Reading",
            "Select Tarot Two Card": "Select Tarot Two Card",
            "Love Triangle Reading": "Love Triangle Reading",
            "Get clarity in choosing between multiple romantic interests.": "Get clarity in choosing between multiple romantic interests.",
            "Past-Present-Future Reading": "Past-Present-Future Reading",
            "Love Triangle Tarot - Discover the Dynamics Between You, Lover 1, and Lover 2": "Love Triangle Tarot - Discover the Dynamics Between You, Lover 1, and Lover 2",
            "Love Triangle Tarot provides insights into the relationships and dynamics between you and your two lovers. Understand where you stand, and what each lover brings into your life, and make an informed decision guided by the cards.": "Love Triangle Tarot provides insights into the relationships and dynamics between you and your two lovers. Understand where you stand, and what each lover brings into your life, and make an informed decision guided by the cards.",
            "Zodiac Gift Guru": "Zodiac Gift Guru",
            "January": "January",
            "February": "February", "March": "March",
            "April": "April",
            "May": "May",
            "June": "June",
            "July": "July",
            "August": "August",
            "September": "September",
            "October": "October",
            "November": "November",
            "December": "December",
            "Yesterday": "Yesterday",
            "Today": "Today",
            "Tomorrow": "Tomorrow",
            "Gift Recommendations": "Gift Recommendations",
            "insight": "insight",
            "Career": "Career",
            "Love": "Love",
            "Finance": "Finance",
            "Popularity": "Popularity",
            "Experience: High to Low": "Experience: High to Low",
            "Experience: Low to High": "Experience: Low to High",
            "Orders: High to Low": "Orders: High to Low",
            "Orders: Low to High": "Orders: Low to High",
            "Price: High to Low": "Price: High to Low",
            "Price: Low to High": "Price: Low to High",
            "Rating: High to Low": "Rating: High to Low",
            "Search name...": "Search name...",
            "Online": "Online",
            "Busy": "Busy",
            "Exp": "Exp",
            "yrs": "yrs",
            "orders": "orders",
            "min": "min",
            "Chat Now": "Chat Now",
            "Wait": "Wait",
            "There are no astrologers in this category.": "There are no astrologers in this category.",
            "Sort": "Sort",
            "Filter": "Filter",
            "Category": "Category",
            "All": "All",
            "Sort by": "Sort by",
            "Skill": "Skill",
            "Language": "Language",
            "Reset": "Reset",
            "Apply": "Apply",
            "You have 30 seconds left. Please recharge immediately to continue the conversation.": "You have 30 seconds left. Please recharge immediately to continue the conversation.",
            "Free chat over! Next minutes will use wallet balance.": "Free chat over! Next minutes will use wallet balance.",
            "Complete": "Complete",
            "End Chat": "End Chat",
            "Message": "Message",
            "Hi": "Hi",
            "lets continue this chat at discounted price of": "lets continue this chat at discounted price of",
            "Are you sure you want to end tha chat to": "Are you sure you want to end tha chat to",
            "No": "No",
            "Yes": "Yes",
            "Chat With Astrologer": "Chat With Astrologer",
            "Appointment List": "Appointment List",
            "My Following": "My Following",
            "Recent Post": "Recent Post",
            "Welcome back": "Welcome back",
            "Manage your astrology services": "Manage your astrology services",
            "Logout": "Logout",
            "Login": "Login",
            "My Profile (Member Since)": "My Profile (Member Since)",
            "My Followings": "My Followings",
            "You are following": "You are following",
            "people": "people",
            "Years": "Years",
            "No Following Found !!": "No Following Found !!",
            "Currently you don't have any follow.": "Currently you don't have any follow.",
            "Hey There!": "Hey There!",
            "What is your name?": "What is your name?",
            "Enter your first Name": "Enter your first Name",
            "Enter your last Name": "Enter your last Name",
            "male": "male",
            "female": "female",
            "Where wrer you bron?": "Where wrer you bron?",
            "Please Select Language": "Please Select Language",
            "english": "english",





            "hindi": "hindi",
            "north": "north",
            "south": "south",
            "Select Chart Type": "Select Chart Type",
            "Start chat with astrologer": "Start chat with astrologer",
            "Search location": "Search location",
            "Location not found !!": "Location not found !!",
            "Enter bord state": "Enter bord state",
            "Search location...": "Search location...",
            "Astrologers": "Astrologers",
            "Top Astrologers. 24 * 7 customer support. Happy to help": "Top Astrologers. 24 * 7 customer support. Happy to help",
            "per min": "per min",
            "Top Astrologers": "Top Astrologers",
            "rate": "rate",
            "Top Rated Astrologers": "Top Rated Astrologers",
            "No astrologers found !!": "No astrologers found !!",
            "FAQs": "FAQs",
            "Raning": "Running",
            "Raning Apointment": "Running Appointments",
            "Active Session": "Active Session",
            "Running Appointments": "Running Appointments",
            "Active": "Active",
            "Session": "Session",
            "Sessions": "Sessions",
            "Continue": "Continue",
            "Select Other Sign": "Select Other Sign",
            "Horoscopes": "Horoscopes",
            "Daily Horoscope": "Daily Horoscope",
            "Weekly Horoscope": "Weekly Horoscope",
            "Monthly Horoscope": "Monthly Horoscope",
            "Yearly Horoscope": "Yearly Horoscope",
            "Composite Friendship Table": "Composite Friendship Table",
            "Kp Planetary Details": "Kp Planetary Details",
            "Kp House Cusps And Chart": "Kp House Cusps And Chart",
            "Ascendant Report": "Ascendant Report",
            "Bhava Kundli": "Bhava Kundli",
            "Vimshottari Dasha": "Vimshottari Dasha",
            "Yogini Dasha": "Yogini Dasha",
            "Sadhesati Analysis": "Sadhesati Analysis",
            "Sadhesati Life Analysis": "Sadhesati Life Analysis",
            "Kalsarpa Dosha": "Kalsarpa Dosha",
            "Manglik Analysis": "Manglik Analysis",
            "Planet Profiles": "Planet Profiles",
            "Gemstone Suggestions": "Gemstone Suggestions",
            "Upagraha": "Upagraha",
            "Jaimini Astrology": "Jaimini Astrology",
            "Chara Dasha": "Chara Dasha",
            "Shadbala": "Shadbala",
            "Sudarshana Chakra": "Sudarshana Chakra",
            "Bhinnashtakvarga": "Bhinnashtakvarga",
            "Yogas": "Yogas",
            "Introduction": "Introduction",
            "Basic Astrological Details": "Basic Astrological Details",
            "Planetary Positions": "Planetary Positions",
            "Horoscope Charts": "Horoscope Charts",
            "House Cusps And Sandhi": "House Cusps And Sandhi",
            "Divisional Charts": "Divisional Charts",
            "Basic Details": "Basic Details",
            "Ghat Chakra": "Ghat Chakra",
            "Panchange Details": "Panchange Details",
            "Astrological Details": "Astrological Details",
            "Time of Birth": "Time of Birth",
            "Place of Birth": "Place of Birth",
            "Latitude": "Latitude",
            "Longitude": "Longitude",
            "Timezone": "Timezone",
            "Ayanamsa": "Ayanamsa",
            "Sunrise": "Sunrise",
            "Sunset": "Sunset",
            "Month": "Month",
            "Tithi": "Tithi",
            "Yoga": "Yoga",
            "Karana": "Karana",
            "Moon Sign": "Moon Sign",
            "Moon Vaar": "Moon Vaar",
            "Nakshatra": "Nakshatra",
            "Varna": "Varna",
            "Vashya": "Vashya",
            "Yoni": "Yoni",
            "Gana": "Gana",
            "Nadi": "Nadi",
            "Sun Sign": "Sun Sign",
            "Tatva": "Tatva",
            "Paya": "Paya",
            "Yanja": "Yanja",
            "Planets": "Planets",
            "Sign": "Sign",
            "Sign No": "Sign No",
            "LAGNA CHART (BIRTH CHART)": "LAGNA CHART (BIRTH CHART)",
            "MOON CHART": "MOON CHART",
            "NAVMANSHA CHART (D9)": "NAVMANSHA CHART (D9)", "House": "House",
            "Bhav Madhya": "Bhav Madhya",
            "Bhav Sandhi": "Bhav Sandhi",
            "Chalit Chart": "Chalit Chart",
            "Sun Chart": "Sun Chart",
            "Health, Constitution, Body": "Health, Constitution, Body",
            "Hora Chart(D2)": "Hora Chart(D2)",
            "Finance, Wealth, Prosperity": "Finance, Wealth, Prosperity",
            "Dreshkan Chart(D3)": "Dreshkan Chart(D3)",
            "Brothers, Sisters": "Brothers, Sisters",
            "Chathurthamasha Chart(D4)": "Chathurthamasha Chart(D4)",
            "Fortunes, Luck of native": "Fortunes, Luck of native",
            "Saptamansha Chart(D7)": "Saptamansha Chart(D7)",
            "Impregnation, Birth of the child": "Impregnation, Birth of the child",
            "Dashamansha Chart(D10)": "Dashamansha Chart(D10)",
            "livelihood, Profession": "livelihood, Profession",
            "Dwadasha Chart(D12)": "Dwadasha Chart(D12)",
            "Parents, paternal happiness": "Parents, paternal happiness",
            "Shodashamsha Chart(D16)": "Shodashamsha Chart(D16)",
            "Happiness, miseries, conveyance": "Happiness, miseries, conveyance",
            "Vishamansha Chart(D20)": "Vishamansha Chart(D20)",
            "Spiritual progress, worship": "Spiritual progress, worship",
            "Chaturvimshamsha(D24)": "Chaturvimshamsha(D24)",
            "Academic achievement, education": "Academic achievement, education",
            "Bhamsha Chart(D27)": "Bhamsha Chart(D27)",






            "Physical strength, stamina": "Physical strength, stamina",
            "Trishamansha Chart(D30)": "Trishamansha Chart(D30)",
            "Evil, Adversities of life": "Evil, Adversities of life",
            "Khavedamsha Chart(D40)": "Khavedamsha Chart(D40)",
            "Auspicious & inauspicious effect": "Auspicious & inauspicious effect",
            "Akshvedansha Chart(D45)": "Akshvedansha Chart(D45)",
            "Character and couduct of the native": "Character and couduct of the native",
            "Shashtymsah Chart(D60)": "Shashtymsah Chart(D60)",
            "Shows general happiness": "Shows general happiness",
            "Degrees": "Degrees",
            "Sign Lord": "Sign Lord",
            "Nakshatra Lord": "Nakshatra Lord",
            "Sub Lord": "Sub Lord",
            "Sub Sub Lord": "Sub Sub Lord",
            "Lord": "Lord",
            "Symbol": "Symbol",
            "Characteristics": "Characteristics",
            "Day of Fast": "Day of Fast",
            "luchy Gems": "luchy Gems",
            "Personality": "Personality",
            "Health": "Health",
            "Relationships": "Relationships",
            "BHAVA KUNDLI": "BHAVA KUNDLI",
            "Bhramari": "Bhramari",
            "Bhadrika": "Bhadrika",
            "Ulka": "Ulka",
            "Siddha": "Siddha",
            "Sankata": "Sankata",
            "Mangala": "Mangala",
            "Pingala": "Pingala",
            "Dhanya": "Dhanya",
            "Remedies Of Sadhesati": "Remedies Of Sadhesati",
            "Saturn Sign": "Saturn Sign",
            "Is Saturn Retro?": "Is Saturn Retro?",
            "Phase": "Phase",
            "Intensity": "Intensity",
            "Direction": "Direction",
            "Strength": "Strength",
            "Percentage": "Percentage",
            "Zodiac Sign": "Zodiac Sign",
            "Planet Degree": "Planet Degree",
            "Lord Of": "Lord Of",
            "Combust/Aw...": "Combust/Aw...",
            "Lucky Stone": "Lucky Stone",
            "Life Stone": "Life Stone",
            "Finger": "Finger",
            "Day": "Day",
            "Time to Wear": "Time to Wear",
            "Mantra": "Mantra",
            "Upagraha Longitude": "Upagraha Longitude",
            "Rashi": "Rashi",
            "Pada": "Pada",
            "Upagraha/Nakshatra/Sub Lord": "Upagraha/Nakshatra/Sub Lord",
            "Jamini Planets": "Jamini Planets",
            "Jamini Padas": "Jamini Padas",
            "Code": "Code",
            "Jamini Karakara": "Jamini Karakara",
            "Uchcha Bala": "Uchcha Bala",
            "Saptavarga Bala": "Saptavarga Bala",
            "Yugmayugma Bhamsha Bala": "Yugmayugma Bhamsha Bala",
            "Kendradi Bala": "Kendradi Bala",
            "Drekkana Bala": "Drekkana Bala",
            "Total Sthana Bala": "Total Sthana Bala",
            "Total Dig Bala": "Total Dig Bala",
            "Nattunnata Bala": "Nattunnata Bala",
            "Paksha Bala": "Paksha Bala",
            "Tribhaga Bala": "Tribhaga Bala",
            "Varshadhipati": "Varshadhipati",
            "Maasadipati": "Maasadipati",
            "Vaaradhipati": "Vaaradhipati",
            "Horadhipati": "Horadhipati",
            "Ayana Bala": "Ayana Bala",
            "Yuddha Bala": "Yuddha Bala",
            "Total Kaal Bala": "Total Kaal Bala",
            "Naisargika Bala": "Naisargika Bala",
            "Chestha Bala": "Chestha Bala",
            "Drik Bala": "Drik Bala",
            "Total Shadbala": "Total Shadbala",
            "Shadbala In Rupa": "Shadbala In Rupa",
            "Min Require": "Min Require",
            "Ratio": "Ratio",
            "Rank": "Rank",
            "Sun": "Sun",
            "Moon": "Moon",
            "Mars": "Mars",
            "Mercury": "Mercury",
            "Jupiter": "Jupiter",
            "Venus": "Venus",
            "Saturn": "Saturn",
            "Ashtakvarga": "Ashtakvarga",
            "Sarvashtakava": "Sarvashtakava",
            "Prasthara Chakra": "Prasthara Chakra",
            "Ascendant": "Ascendant",
            "Total": "Total",
            "Natural Friendship": "Natural Friendship",
            "Temporary Friendship": "Temporary Friendship",
            "Five Fold Friendship": "Five Fold Friendship",
            "Ketu": "Ketu",
            "Rahu": "Rahu",
            "Vimshottari Dasha P1": "Vimshottari Dasha P1",
            "Vimshottari Dasha P2": "Vimshottari Dasha P2",
            "AshtaKoot": "AshtaKoot", "Bhakut Dosha": "Bhakut Dosha",
            "Nadi Dosha": "Nadi Dosha",
            "Ashtakoot Analysis": "Ashtakoot Analysis",
            "DashaKoot": "DashaKoot",
            "Personality Report": "Personality Report",
            "Match Making Report": "Match Making Report",
            "Nav Pancham Yoga": "Nav Pancham Yoga",
            "Charan": "Charan",
            "Name Alphabet": "Name Alphabet",
            "Planetary Position": "Planetary Position",
            "Lagna Chart (Birth Chart)": "Lagna Chart (Birth Chart)",
            "Moon Chart": "Moon Chart",
            "Navmansha Chart (D9)": "Navmansha Chart (D9)",
            "Mahadasha": "Mahadasha",
            "End": "End",
            "Is Recommended ??": "Is Recommended ??",




            "Manglik Details": "Manglik Details",
            "What is AshtaKoot ??": "What is AshtaKoot ??",
            "Attributes": "Attributes",
            "Description": "Description",
            "Received": "Received",
            "Graha Maitri": "Graha Maitri",
            "Bhakoota": "Bhakoota",
            "What is BhaKoot Dosha ??": "What is BhaKoot Dosha ??",
            "What is Nadi Dosha ??": "What is Nadi Dosha ??",
            "Madhya": "Madhya",
            "Nadi dosha is present": "Nadi dosha is present",
            "The": "The",
            "porutham considered for horoscope matching are as follows :": "porutham considered for horoscope matching are as follows :",
            "Dina": "Dina",
            "Rajju": "Rajju",
            "Rasyadhipati": "Rasyadhipati",
            "Vedha": "Vedha",
            "Mahendra": "Mahendra",
            "Streedargha": "Streedargha",
            "Uranus": "Uranus",
            "Neptune": "Neptune",
            "Pluto": "Pluto",
            "Tara": "Tara",
            "Please fill boy's details !!": "Please fill boy's details !!",
            "Please fill girl's details !!": "Please fill girl's details !!",
            "Please fill chart details !!": "Please fill chart details !!",
            "Kundli Matching": "Kundli Matching",
            "Find your right one, through matchmaking": "Find your right one, through matchmaking",
            "Open Kundli": "Open Kundli",
            "New Matching": "New Matching",
            "View Kundli": "View Kundli",
            "Boy's Details": "Boy's Details",
            "Girl's Details": "Girl's Details",
            "Search city, state, country": "Search city, state, country",
            "Enter first name": "Enter first name",
            "Enter last name": "Enter last name",
            "Chart Style": "Chart Style",
            "North Indian": "North Indian",
            "South Indian": "South Indian",
            "English": "English",
            "Hindi": "Hindi",
            "MATCH HOROSCOPE": "MATCH HOROSCOPE",
            "No Saved Kundlis Yet": "No Saved Kundlis Yet",
            "Create your first profile to view, edit, and run compatibility matching reports with ease.": "Create your first profile to view, edit, and run compatibility matching reports with ease.",
            "My Profile": "My Profile",
            "Enter full name": "Enter full name",
            "Enter email address": "Enter email address",
            "Enter password": "Enter password",
            "Enter phone number": "Enter phone number",
            "Save Chanage": "Save Chanage",
            "Manage your astrologers recent post": "Manage your astrologers recent post",
            "Show Less": "Show Less",
            "Show More": "Show More",
            "Total Balance": "Total Balance",
            "Add Money": "Add Money",
            "Extra": "Extra",
            "Transaction History": "Transaction History",
            "Build better products with flexible tools, helpful documentation,": "Build better products with flexible tools, helpful documentation,",
            "and a team that champions your growth.": "and a team that champions your growth.",
            "Useful Link": "Useful Link",
            "Socials": "Socials",
            "Logout Seccuessfuly !!": "Logout Seccuessfuly !!",
            "Free Kundli": "Free Kundli",
            "Horoscope": "Horoscope",
            "Dashboard": "Dashboard",
            "Enter your feedback !!": "Enter your feedback !!",
            "Languages": "Languages",
            "incoming": "incoming",
            "request from": "request from",
            "Waitlist Joined !!": "Waitlist Joined !!",
            "will start in": "will start in",
            "You will receive a": "You will receive a",
            "request when the": "request when the",
            "astrologer is ready. Don’t worry! You will not be": "astrologer is ready. Don’t worry! You will not be",
            "charged for missing this session.": "charged for missing this session.",
            "Accept": "Accept",
            "Reject": "Reject",
            "Great, what did you like the mast? 😍": "Great, what did you like the mast? 😍",
            "Skip": "Skip",
            "Payment Information": "Payment Information",
            "Amount": "Amount",
            "Tax": "Tax",
            "Payment": "Payment",
            "Payment Method": "Payment Method",
        
            "AstroSpace": "AstroSpace",
            "Astrology Consultation Platform": "Astrology Consultation Platform",
            "INVOICE": "INVOICE",
            "Consultation Service Receipt": "Consultation Service Receipt",
            "Invoice Number": "Invoice Number",
            "Date Issued": "Date Issued",
            "PAID": "PAID",
            "From": "From",
            "Bill To": "Bill To",
            "Service": "Service",
            "Booking ID": "Booking ID",
            "Description": "Description",
            "Duration": "Duration",
            "Rate": "Rate",
            "Amount": "Amount",
            "Free Consultation Time": "Free Consultation Time",
            "Complimentary session minutes": "Complimentary session minutes",
            "Free": "Free",
            "Consultation Fee": "Consultation Fee",
            "Standard rate (first block)": "Standard rate (first block)",
            "Extended Consultation Fee": "Extended Consultation Fee",
            "Premium rate (extended block)": "Premium rate (extended block)",
            "Consultation Service": "Consultation Service",
            "Astrology consultation session": "Astrology consultation session",
            "Subtotal": "Subtotal",
            "Platform Fee": "Platform Fee",
            "Included": "Included",
            "Total Amount": "Total Amount",
            "DOB": "DOB",
            "Kundali Chart Used": "Kundali Chart Used",
            "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.": "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.",
            "For support, contact us at support@astrospace.com": "For support, contact us at support@astrospace.com",
            "Free Minute": "Free Minute",
            "Verified": "Verified",
            "End Session": "End Session",
            "Voice Call": "Voice Call",
            "typing...": "typing...",
            "CANCEL": "CANCEL",
            "OK": "OK",
            "Install Progressive Web Application": "Install Progressive Web Application",
            "This site has app functionality. Install it on your device for extensive experience and easy access.": "This site has app functionality. Install it on your device for extensive experience and easy access.",
            "Install": "Install",
            "Search location": "Search location",
            "Location not found !!": "Location not found !!",
            "Waiting for remote user to join...": "Waiting for remote user to join...",
            "End Video Session": "End Video Session",
            "Initializing WebRTC P2P...": "Initializing WebRTC P2P...",
            "Access Denied (Camera/Mic)": "Access Denied (Camera/Mic)",
            "Connection Failed": "Connection Failed",
            "Time Remaining": "Time Remaining",
            "Call ended": "Call ended",

            "Offline": "Offline",}
    },
    hi: {
        translation: {
            "Enter Mobile Number !!": "मोबाइल नंबर दर्ज करें !!",
            "In Valid OTP !!": "अमान्य ओटीपी !!",
            "Please enter password !!": "कृपया पासवर्ड दर्ज करें !!",
            "Password not match !!": "पासवर्ड मेल नहीं खाता !!",
            "Reset Password": "पासवर्ड रीसेट करें",
            "Enter your phone number and new password": "अपना फोन नंबर और नया पासवर्ड दर्ज करें",
            "Phone Number": "फोन नंबर",
            "Enter your number": "अपना नंबर दर्ज करें",
            "Search": "खोजें",
            "Verify": "सत्यापित करें",
            "You will receive a 6 digit code for": "आपको 6 अंकों का कोड प्राप्त होगा",
            "verification to": "सत्यापन के लिए",
            "Submit": "सबमिट करें",
            "Enter your password and new password": "अपना पासवर्ड और नया पासवर्ड दर्ज करें",
            "New Password": "नया पासवर्ड",
            "Enter new password": "नया पासवर्ड दर्ज करें",
            "Confirm New Password": "नए पासवर्ड की पुष्टि करें",
            "Confirm new password": "नया पासवर्ड पुष्टि करें",
            "Back to Login": "लॉगिन पर वापस जाएं",
            "Back": "वापस",
            "Enter Login Details !!": "लॉगिन विवरण दर्ज करें !!",
            "Welcome Back!": "वापसी पर स्वागत है!",
            "Sign in to your account": "अपने खाते में साइन इन करें",
            "Password": "पासवर्ड",
            "Enter your password": "अपना पासवर्ड दर्ज करें",
            "Forgot Password?": "पासवर्ड भूल गए?",
            "Sign In": "साइन इन करें",
            "Don't have an account?": "क्या आपके पास खाता नहीं है?",
            "Sign Up": "साइन अप करें",
            "Please enter all details !!": "कृपया सभी विवरण दर्ज करें !!",
            "Please enter valid email !!": "कृपया मान्य ईमेल दर्ज करें !!",
            "Please enter birth place !!": "कृपया जन्म स्थान दर्ज करें !!",
            "Please select language !!": "कृपया भाषा चुनें !!",
            "Step": "चरण",
            "Enter Your Details": "अपने विवरण दर्ज करें",
            "Hey there! what is your name?": "नमस्ते! आपका नाम क्या है?",
            "Full Name": "पूरा नाम",
            "Email Address": "ईमेल पता",
            "Enter your Full Name": "अपना पूरा नाम दर्ज करें",
            "Enter your email": "अपना ईमेल दर्ज करें",
            "What is your gender?": "आपका लिंग क्या है?",
            "Male": "पुरुष",
            "Female": "महिला",
            "Enter your birth date": "अपनी जन्म तिथि दर्ज करें",
            "Enter your birth time": "अपना जन्म समय दर्ज करें",
            "Enter your birth Place": "अपना जन्म स्थान दर्ज करें",
            "Do you know which languages?": "आप कौन-कौन सी भाषाएं जानते हैं?",
            "Enter Your Place": "अपना स्थान दर्ज करें",
            "Back to Step": "चरण पर वापस जाएं",
            "Next": "आगे",
            "My Appointments": "मेरी अपॉइंटमेंट्स",
            "Manage your astrology consultations": "अपनी ज्योतिष परामर्श का प्रबंधन करें",
            "Upcoming": "आगामी",
            "Past": "पिछली",
            "Pending": "लंबित",
            "Accepted": "स्वीकृत",
            "Start": "शुरू करें",
            "Completed": "पूर्ण",
            "Canceled": "रद्द",
            "ID": "आईडी",
            "Chat": "चैट",
            "Audio Call": "ऑडियो कॉल",
            "Video Call": "वीडियो कॉल",
            "View Details": "विवरण देखें",
            "Cancel": "रद्द करें",
            "No Upcoming Appointment Found !!": "कोई आगामी अपॉइंटमेंट नहीं मिली !!",
            "Currently you don't have any upcoming appointment.": "वर्तमान में आपकी कोई आगामी अपॉइंटमेंट नहीं है।",
            "No Past Appointment Found !!": "कोई पिछली अपॉइंटमेंट नहीं मिली !!",
            "Currently you don't have any past appointment.": "वर्तमान में आपकी कोई पिछली अपॉइंटमेंट नहीं है।",
            "Status": "स्थिति",
            "Service Type": "सेवा प्रकार",
            "Date": "तारीख",
            "Time": "समय",
            "Price": "कीमत",
            "Booked Person Details": "बुक किए गए व्यक्ति का विवरण",
            "name": "नाम",
            "Date of Birth": "जन्म तिथि",
            "Birth Place": "जन्म स्थान",
            "Gender": "लिंग",
            "Complete Details": "पूर्ण विवरण",
            "Start Time": "शुरू होने का समय",
            "End Time": "समाप्ति समय",
            "Total Duration": "कुल अवधि",
            "Billable Time": "बिल योग्य समय",
            "Billed Fee First": "पहली बिल राशि",
            "Billed Fee After": "बाद की बिल राशि",
            "Total Consultation Fee": "कुल परामर्श शुल्क",
            "Kundali Details": "कुंडली विवरण",
            "Name": "नाम",
            "Send Notification": "सूचना भेजें",
            "Continue Chat": "चैट जारी रखें",
            "Write message !!": "संदेश लिखें !!",
            "Astrologer Ai Assistant": "ज्योतिष एआई सहायक",
            "Ask anything about your horoscope...": "अपनी कुंडली के बारे में कुछ भी पूछें...",
            "Write message to assistant": "सहायक को संदेश लिखें",
            "Clear Chat?": "चैट साफ़ करें?",
            "All messages will be deleted permanently.": "सभी संदेश स्थायी रूप से हटा दिए जाएंगे।",
            "Clear": "साफ़ करें",
            "Payment faild !!": "भुगतान विफल हो गया !!",
            "Please Complete Last Apointment !!": "कृपया पिछली अपॉइंटमेंट पूरी करें !!",
            "Please enter comment !!": "कृपया टिप्पणी दर्ज करें !!",
            "Insufficient wallet balance !!": "वॉलेट बैलेंस अपर्याप्त है !!",
            "Orders": "ऑर्डर्स",
            "Experience": "अनुभव",
            "Rating": "रेटिंग",
            "Unfollow": "अनफॉलो करें",
            "Follow": "फॉलो करें",
            "Send Gift": "उपहार भेजें",
            "Start a Consultation": "परामर्श शुरू करें",
            "Chat with astrologer": "ज्योतिषी से चैट करें",
            "For new user": "नए उपयोगकर्ता के लिए",
            "min free": "मिनट मुफ्त",
            "Call with astrologer": "ज्योतिषी से कॉल करें",
            "Video call with astrologer": "ज्योतिषी से वीडियो कॉल करें",
            "Astrologer Bio": "ज्योतिषी परिचय",
            "Reviews": "समीक्षाएं",
            "Activity": "गतिविधि",
            "FAQ's": "अक्सर पूछे जाने वाले प्रश्न",
            "Media": "मीडिया",
            "Comment": "टिप्पणी",
            "No comment yet": "अभी तक कोई टिप्पणी नहीं",
            "start the conversation": "बातचीत शुरू करें",
            "Poast your replay": "अपना जवाब पोस्ट करें",
            "Delete comment": "टिप्पणी हटाएं",
            "Are you sure you want to delete this comment?": "क्या आप वाकई इस टिप्पणी को हटाना चाहते हैं?",
            "Cancle": "रद्द करें",
            "Delete": "हटाएं",
            "Intro Audio": "परिचय ऑडियो",
            "Intro Video": "परिचय वीडियो",
            "Hear from": "सुनें",
            "Please select user !!": "कृपया उपयोगकर्ता चुनें !!",
            "Please select amount !!": "कृपया राशि चुनें !!",
            "Please select payment method !!": "कृपया भुगतान विधि चुनें !!",
            "Select Kundli": "कुंडली चुनें",
            "Add Kundli": "कुंडली जोड़ें",
            "Minimum balance of": "न्यूनतम बैलेंस",
            "minutes": "मिनट",
            "is required to start chat with": "के साथ चैट शुरू करने के लिए आवश्यक है",
            "Wallet Balance": "वॉलेट बैलेंस",
            "Required": "आवश्यक",
            "Proceed to Pay": "भुगतान के लिए आगे बढ़ें",
            "extra in your": "आपके",
            "wallet with this": "वॉलेट में अतिरिक्त",
            "Woohoo!": "वाह!",
            "Recharge Amount": "रिचार्ज राशि",
            "GST": "जीएसटी",
            "Wallet Amount": "वॉलेट राशि",
            "Payble Amount": "देय राशि",
            "Pay from Wallet": "वॉलेट से भुगतान करें",
            "Available": "उपलब्ध",
            "Payment Getway Method": "भुगतान गेटवे विधि",
            "Continue": "जारी रखें",
            "Fortune Cookie - Unveil Your Daily Wisdom": "फॉर्च्यून कुकी - अपनी दैनिक बुद्धिमत्ता का अनावरण करें",
            "Crack open a fortune cookie to reveal a piece of daily wisdom. Let the message guide you through your day with positivity and insight.": "दैनिक ज्ञान का एक संदेश पाने के लिए फॉर्च्यून कुकी खोलें। यह संदेश आपके दिन को सकारात्मकता और समझ के साथ मार्गदर्शन करे।",
            "Ask The Fortune Cookie": "फॉर्च्यून कुकी से पूछें",
            "Crack open your Fortune Cookie": "अपनी फॉर्च्यून कुकी खोलें",
            "Crack another one open": "एक और खोलें",
            "Love Compatibility": "प्रेम संगतता",
            "Find out how compatible you are with your lover, friend, or colleague using our love compatibility calculator. Get your results now.": "हमारे प्रेम संगतता कैलकुलेटर का उपयोग करके जानें कि आप अपने प्रेमी, मित्र या सहकर्मी के साथ कितने संगत हैं। अभी अपने परिणाम प्राप्त करें।",
            "Are Aries And Taurus Compatible": "क्या मेष और वृषभ संगत हैं",
            "Aries And Taurus Strengths": "मेष और वृषभ की ताकत",
            "Aries And Taurus Weaknesses": "मेष और वृषभ की कमजोरियाँ",
            "Aries And Taurus Elements": "मेष और वृषभ के तत्व",
            "Aries And Taurus Dates": "मेष और वृषभ की तिथियाँ",
            "Are Aries And Taurus Compatibility Score": "मेष और वृषभ की संगतता स्कोर",
            "General": "सामान्य",
            "Communication": "संचार",
            "Sex": "यौन जीवन",
            "Select Another": "दूसरा चुनें",
            "Aries": "मेष",
            "Taurus": "वृषभ",
            "Gemini": "मिथुन",
            "Cancer": "कर्क",
            "Leo": "सिंह",
            "Virgo": "कन्या",
            "Libra": "तुला",
            "Scorpio": "वृश्चिक",
            "Sagittarius": "धनु",
            "Capricorn": "मकर",
            "Aquarius": "कुंभ",
            "Pisces": "मीन",
            "Please select Your Partner Sign": "कृपया अपने साथी का राशि चिन्ह चुनें",
            "Please select Your Sign": "कृपया अपनी राशि चुनें",
            "Please fill all details !!": "कृपया सभी विवरण भरें !!",
            "Discover Your Core Numbers That Define You": "अपने मुख्य संख्याओं को जानें जो आपको परिभाषित करती हैं",
            "Explore your core numbers like Life Path, Destiny, and Personal Year—complete with strengths, challenges, and meaningful interpretations.": "अपने मुख्य संख्याओं का पता लगाएं जैसे जीवन पथ, भाग्य और व्यक्तिगत वर्ष—साथ ही ताकत, चुनौतियाँ और अर्थपूर्ण व्याख्याओं के साथ।",
            "Get Your Numbers": "अपनी संख्याएँ प्राप्त करें",
            "First Name": "पहला नाम",
            "Last Name": "अंतिम नाम",
            "Method": "विधि",
            "Chaldean": "काल्डियन",
            "Pythagorean": "पाइथागोरियन",
            "Strengths": "ताकत",
            "Challenges": "चुनौतियाँ",
            "Advice": "सलाह",
            "Get Report": "रिपोर्ट प्राप्त करें",
            "Select Tarot One Card": "टैरो एक कार्ड चुनें",
            "Select Your Card": "अपना कार्ड चुनें",
            "Get Another": "एक और प्राप्त करें",
            "Yes Or No Tarot": "हाँ या नहीं टैरो",
            "Get instant Yes or No answers to pressing questions.": "जरूरी प्रश्नों के त्वरित हाँ या नहीं उत्तर प्राप्त करें।",
            "Daily Tarot": "दैनिक टैरो",
            "Receive daily tarot readings on love, career, and finance.": "प्रेम, करियर और वित्त पर दैनिक टैरो रीडिंग प्राप्त करें।",
            "In-Depth Love Reading": "गहन प्रेम रीडिंग",
            "Deep dive into your love life with relationship-specific readings.": "अपने प्रेम जीवन में संबंध-विशेष रीडिंग के साथ गहराई से जानें।",
            "Flirt Love Reading": "फ्लर्ट प्रेम रीडिंग",
            "Reveal insights into playful and romantic connections.": "खेलपूर्ण और रोमांटिक संबंधों की जानकारी प्राप्त करें।",
            "Erotic Love Reading": "इरोटिक प्रेम रीडिंग",
            "Insights into intimate and personal love dynamics.": "निजी और अंतरंग प्रेम गतिशीलता की जानकारी।",
            "Egyptian Prediction": "मिस्री भविष्यवाणी",
            "Access ancient Egyptian insights beyond visible truths.": "दृश्य सत्य से परे प्राचीन मिस्री ज्ञान तक पहुँचें।",
            "Ex-Flame Reading": "पूर्व प्रेमी रीडिंग",
            "Explore the possibilities of rekindling with an ex-partner.": "पूर्व साथी के साथ पुनः संबंध बनाने की संभावनाएँ जानें।",
            "Made For Each Other Or Not Reading": "क्या आप एक-दूसरे के लिए बने हैं या नहीं रीडिंग",
            "Discover if your relationship has long-term potential.": "जानें कि आपके संबंध में दीर्घकालिक संभावना है या नहीं।",
            "Power Life Reading": "पावर जीवन रीडिंग",
            "Take control of your destiny with life-changing tarot readings.": "जीवन बदलने वाली टैरो रीडिंग के साथ अपनी नियति नियंत्रित करें।",
            "Know Your Friend Reading": "अपने मित्र को जानें रीडिंग",
            "Understand the true intentions of your friendships.": "अपने मित्रता के सच्चे इरादों को समझें।",
            "Divine Angel Reading": "दिव्य एंजेल रीडिंग",
            "Connect with divine guidance for clarity and spiritual insight.": "स्पष्टता और आध्यात्मिक ज्ञान के लिए दिव्य मार्गदर्शन से जुड़ें।",
            "Career Daily Reading": "करियर दैनिक रीडिंग",
            "Elevate your career with daily tarot insights to achieve your professional goals.": "अपने पेशेवर लक्ष्यों को प्राप्त करने के लिए दैनिक टैरो अंतर्दृष्टि से अपने करियर को ऊँचा उठाएँ।",
            "Dream Come True Reading": "सपनों की साकार रीडिंग",
            "Gain insights into making your dreams and goals a reality.": "अपने सपनों और लक्ष्यों को वास्तविकता में बदलने की जानकारी प्राप्त करें।",
            "Past Lives Connection Reading": "भूतकालीन जीवन संबंध रीडिंग",
            "Explore your journey across time to understand your path ahead.": "अपने भविष्य के मार्ग को समझने के लिए समय में अपने सफर का अन्वेषण करें।",
            "Yes or No Tarot - Find Clear and Immediate Answers": "हाँ या नहीं टैरो - स्पष्ट और त्वरित उत्तर पाएँ",
            "Daily Tarot - Gain Insights Across Love, Finance, and Career": "दैनिक टैरो - प्रेम, वित्त और करियर में अंतर्दृष्टि प्राप्त करें",
            "In-Depth Love Tarot - Reveal the Realities of Your Relationship": "गहन प्रेम टैरो - अपने संबंध की वास्तविकताओं का पता लगाएँ",
            "Flirt Love Tarot - Discover Your Romantic Potential": "फ्लर्ट प्रेम टैरो - अपने रोमांटिक संभावनाओं की खोज करें",
            "Erotic Love Tarot - Explore Your Intimate Desires": "इरोटिक प्रेम टैरो - अपनी अंतरंग इच्छाओं का अन्वेषण करें",
            "Discover the Secrets of Your Soul with Egyptian Tarot": "मिस्री टैरो के साथ अपनी आत्मा के रहस्यों का अनावरण करें",
            "Ex-Flame Tarot - Reignite or Release the Past": "पूर्व प्रेमी टैरो - अतीत को फिर से प्रज्वलित करें या छोड़ दें",
            "Made For Each Other Tarot - Discover True Compatibility": "एक-दूसरे के लिए बने टैरो - सच्ची संगतता खोजें",
            "Power Life Tarot - Take Control of Your Destiny": "पावर जीवन टैरो - अपनी नियति का नियंत्रण लें",
            "Know Your Friend Tarot Reading - Unveil the True Nature of Your Relationships": "अपने मित्र को जानें टैरो रीडिंग - अपने संबंधों की सच्ची प्रकृति का पता लगाएँ",
            "Divine Angel Tarot - Receive Angelic Guidance for Clarity and Relief": "दिव्य एंजेल टैरो - स्पष्टता और शांति के लिए एंजेलिक मार्गदर्शन प्राप्त करें",
            "Career Daily Tarot Reading - Navigate Your Workday with Confidence": "करियर दैनिक टैरो रीडिंग - अपने कार्यदिवस को आत्मविश्वास के साथ संचालित करें",
            "Explore the Depths of Your Heart's Desires with a Dream Come True Tarot Reading": "ड्रीम कम ट्रू टैरो रीडिंग के साथ अपने हृदय की गहरी इच्छाओं का अन्वेषण करें",
            "Delve into Your Past Lives - Unravel the Enigma of Your Previous Incarnations": "अपने पिछले जीवन में गहराई से जाएँ - अपनी पिछली जन्मों के रहस्यों को उजागर करें",
            "The Yes or No Tarot widget offers quick, straightforward answers to your pressing questions, helping you make decisions with confidence in areas like love, finance, and career.": "हाँ या नहीं टैरो विजेट आपके महत्वपूर्ण प्रश्नों के त्वरित और स्पष्ट उत्तर देता है, जिससे आप प्रेम, वित्त और करियर जैसे क्षेत्रों में आत्मविश्वास के साथ निर्णय ले सकें।",
            "Daily Tarot provides readings that focus on three key areas of your life: Love, Finance, and Career. Discover the guidance you need for each aspect of your day.": "दैनिक टैरो रीडिंग आपके जीवन के तीन मुख्य क्षेत्रों पर केंद्रित होती है: प्रेम, वित्त और करियर। अपने दिन के प्रत्येक पहलू के लिए आवश्यक मार्गदर्शन प्राप्त करें।",
            "In-Depth Love Tarot provides comprehensive readings to bring clarity to your love life, help you make crucial decisions, and guide you toward understanding your soulmate and future partner.": "गहन प्रेम टैरो व्यापक रीडिंग प्रदान करता है जो आपके प्रेम जीवन में स्पष्टता लाए, महत्वपूर्ण निर्णय लेने में मदद करे, और आपको अपने आत्मसाथी और भविष्य के साथी को समझने में मार्गदर्शन करे।",
            "The Flirt Love Tarot Reading provides playful insights into your romantic life. Whether it's a friendship, a new admirer, or a potential soulmate, this reading helps you navigate love with ease.": "फ्लर्ट प्रेम टैरो रीडिंग आपके रोमांटिक जीवन में खेलपूर्ण अंतर्दृष्टि प्रदान करती है। चाहे यह मित्रता हो, नया प्रशंसक हो, या संभावित आत्मसाथी, यह रीडिंग आपको प्रेम में सहजता से मार्गदर्शन करती है।",
            "This reading reveals insights into passion, love, and sexual chemistry, helping you understand your relationships and uncover hidden fantasies.": "यह रीडिंग जुनून, प्रेम और यौन रसायन के बारे में जानकारी देती है, जिससे आप अपने संबंधों को समझ सकें और छिपी हुई कल्पनाओं को उजागर कर सकें।",
            "Explore your twin flame, current struggles, ancestral roots, and past healing with the ancient wisdom of Egyptian Tarot": "मिस्री टैरो की प्राचीन बुद्धि के साथ अपने ट्विन फ्लेम, वर्तमान संघर्षों, पैतृक जड़ों और अतीत के उपचार का अन्वेषण करें",
            "The Ex-Flame Tarot Reading provides clarity on whether to rekindle a past relationship or move on. Explore your ex’s feelings, the potential for a renewed connection, and the impact on your future.": "पूर्व प्रेमी टैरो रीडिंग यह स्पष्टता देती है कि क्या पुराने संबंध को फिर से जलाना है या आगे बढ़ना है। अपने पूर्व साथी की भावनाओं, नवीनीकृत संबंध की संभावनाओं और आपके भविष्य पर प्रभाव को जानें।",
            "This Tarot reading reveals whether your relationship is worth the effort, safe to pursue, and aligned with your life goals. Understand if you’re truly made for each other or if it’s time to move on.": "यह टैरो रीडिंग यह बताती है कि आपका संबंध प्रयास करने लायक है, सुरक्षित है और आपके जीवन के लक्ष्यों के अनुरूप है। समझें कि क्या आप वास्तव में एक-दूसरे के लिए बने हैं या आगे बढ़ने का समय है।",
            "The Power Life Tarot Reading helps you plan your life, overcome struggles, create a clear vision, and take charge of your destiny. Unlock the guidance you need to steer your life towards success.": "पावर जीवन टैरो रीडिंग आपकी जीवन योजना बनाने, संघर्षों को पार करने, स्पष्ट दृष्टि बनाने और अपनी नियति नियंत्रित करने में मदद करती है। अपने जीवन को सफलता की ओर ले जाने के लिए आवश्यक मार्गदर्शन प्राप्त करें।",
            "Divine Angel Tarot connects you with your guardian angels, offering guidance to overcome challenges and find peace in love, freedom, and resolution.": "दिव्य एंजेल टैरो आपको आपके संरक्षक देवदूतों से जोड़ता है, चुनौतियों को पार करने और प्रेम, स्वतंत्रता और शांति पाने के लिए मार्गदर्शन प्रदान करता है।",
            "Career Daily Tarot offers insights to manage your workday, from handling your boss to staying proactive and managing tasks effectively. Let the Tarot guide you to a successful and stress-free day.": "करियर दैनिक टैरो आपके कार्यदिवस को प्रबंधित करने के लिए अंतर्दृष्टि प्रदान करता है, अपने बॉस को संभालने से लेकर सक्रिय रहने और कार्यों को प्रभावी ढंग से प्रबंधित करने तक। टैरो को एक सफल और तनाव-मुक्त दिन की दिशा दिखाने दें।",
            "The Dream Come True Tarot Reading helps you manifest your deepest wishes and aspirations. Whether it's love, material desires, or unfulfilled dreams, this reading offers clarity and guidance to turn your desires into reality.": "ड्रीम कम ट्रू टैरो रीडिंग आपकी गहरी इच्छाओं और आकांक्षाओं को साकार करने में मदद करती है। चाहे वह प्रेम हो, भौतिक इच्छाएँ हों या अधूरे सपने, यह रीडिंग आपकी इच्छाओं को वास्तविकता में बदलने के लिए स्पष्टता और मार्गदर्शन प्रदान करती है।",
            "Explore your past lives to understand current fears, recurring patterns, and influences. Gain clarity on challenges rooted in your previous incarnations.": "अपने पिछले जीवन का अन्वेषण करें ताकि वर्तमान डर, पुनरावर्ती पैटर्न और प्रभाव को समझ सकें। अपने पिछले जन्मों में निहित चुनौतियों पर स्पष्टता प्राप्त करें।",
            "Select Tarot Three Card": "टैरो तीन कार्ड चुनें",
            "Heartbreak Reading": "दिल टूटने की रीडिंग",
            "Find guidance and healing for a broken heart.": "टूटे दिल के लिए मार्गदर्शन और उपचार प्राप्त करें।",
            "Wisdom Reading": "ज्ञान रीडिंग",
            "Balance your energies and find mental peace through wisdom.": "अपने ऊर्जा संतुलित करें और ज्ञान के माध्यम से मानसिक शांति पाएं।",
            "Divine Magic Reading": "दिव्य जादू रीडिंग",
            "Discover mystical insights with magical tarot guidance.": "जादुई टैरो मार्गदर्शन के साथ रहस्यमय अंतर्दृष्टि खोजें।",
            "Heartbreak Tarot Reading - Find Closure and Guidance": "दिल टूटने का टैरो रीडिंग - समाधान और मार्गदर्शन पाएँ",
            "The Heartbreak Tarot Reading offers insight into the cause of your pain and provides advice on how to heal and move forward. This two-card reading delivers clarity and the necessary steps to mend your broken heart.": "दिल टूटने का टैरो रीडिंग आपके दर्द के कारण की जानकारी देता है और उपचार और आगे बढ़ने के लिए सलाह प्रदान करता है। यह दो-कार्ड रीडिंग स्पष्टता और टूटे दिल को ठीक करने के आवश्यक कदम देती है।",
            "Wisdom Tarot - Find Balance with Yin and Yang": "ज्ञान टैरो - यिन और यांग के साथ संतुलन पाएँ",
            "Wisdom Tarot provides guidance by balancing the Yin and Yang energies in your life. Discover clarity, peace, and a path forward with this two-card reading.": "ज्ञान टैरो आपके जीवन में यिन और यांग ऊर्जा का संतुलन करके मार्गदर्शन प्रदान करता है। इस दो-कार्ड रीडिंग के साथ स्पष्टता, शांति और आगे का मार्ग खोजें।",
            "Divine Magic Tarot Reading - Discover Cause and Remedy": "दिव्य जादू टैरो रीडिंग - कारण और समाधान खोजें",
            "The Divine Magic Tarot Reading offers insights into the root cause of your problems and provides a remedy to guide you toward resolution. With this reading, discover the steps you need to take to transform challenges into solutions.": "दिव्य जादू टैरो रीडिंग आपके समस्याओं के मूल कारण की जानकारी देती है और समाधान की दिशा में मार्गदर्शन प्रदान करती है। इस रीडिंग के साथ जानें कि चुनौतियों को हल में बदलने के लिए आपको कौन से कदम उठाने हैं।",
            "Please pick your cards !!": "कृपया अपने कार्ड चुनें !!",
            "Get Your Reading": "अपनी रीडिंग प्राप्त करें",
            "Select Tarot Two Card": "टैरो दो कार्ड चुनें",
            "Love Triangle Reading": "लव ट्रायंगल रीडिंग",
            "Get clarity in choosing between multiple romantic interests.": "कई रोमांटिक रुचियों में से चयन करने में स्पष्टता प्राप्त करें।",
            "Past-Present-Future Reading": "भूत-वर्तमान-भविष्य रीडिंग",
            "Love Triangle Tarot - Discover the Dynamics Between You, Lover 1, and Lover 2": "लव ट्रायंगल टैरो - आपके, प्रेमी 1 और प्रेमी 2 के बीच की गतिशीलता जानें",
            "Love Triangle Tarot provides insights into the relationships and dynamics between you and your two lovers. Understand where you stand, and what each lover brings into your life, and make an informed decision guided by the cards.": "लव ट्रायंगल टैरो आपको आपके और आपके दो प्रेमियों के बीच संबंधों और गतिशीलताओं की जानकारी देता है। समझें कि आप कहाँ खड़े हैं, प्रत्येक प्रेमी आपके जीवन में क्या लेकर आता है, और कार्ड्स द्वारा मार्गदर्शन प्राप्त कर सूचित निर्णय लें।",
            "Zodiac Gift Guru": "राशि उपहार गुरु",
            "January": "जनवरी",
            "February": "फ़रवरी",
            "March": "मार्च",
            "April": "अप्रैल",
            "May": "मई",
            "June": "जून",
            "July": "जुलाई",
            "August": "अगस्त",
            "September": "सितंबर",
            "October": "अक्टूबर",
            "November": "नवंबर",
            "December": "दिसंबर",
            "Yesterday": "कल",
            "Today": "आज",
            "Tomorrow": "कल",
            "Gift Recommendations": "उपहार सिफारिशें",
            "insight": "जानकारी",
            "Career": "करियर",
            "Love": "प्रेम",
            "Finance": "वित्त",
            "Popularity": "लोकप्रियता",
            "Experience: High to Low": "अनुभव: अधिक से कम",
            "Experience: Low to High": "अनुभव: कम से अधिक",
            "Orders: High to Low": "ऑर्डर: अधिक से कम",
            "Orders: Low to High": "ऑर्डर: कम से अधिक",
            "Price: High to Low": "कीमत: अधिक से कम",
            "Price: Low to High": "कीमत: कम से अधिक",
            "Rating: High to Low": "रेटिंग: उच्च से निम्न",
            "Search name...": "नाम खोजें...",
            "Online": "ऑनलाइन",
            "Busy": "व्यस्त",
            "Exp": "अनुभव",
            "yrs": "वर्ष",
            "orders": "ऑर्डर",
            "min": "मिनट",
            "Chat Now": "अभी चैट करें",
            "Wait": "प्रतीक्षा करें",
            "There are no astrologers in this category.": "इस श्रेणी में कोई ज्योतिषी नहीं हैं।",
            "Sort": "सॉर्ट करें",
            "Filter": "फ़िल्टर",
            "Category": "श्रेणी",
            "All": "सभी",
            "Sort by": "इसके अनुसार सॉर्ट करें",
            "Skill": "कौशल",
            "Language": "भाषा",
            "Reset": "रीसेट करें",
            "Apply": "लागू करें",
            "You have 30 seconds left. Please recharge immediately to continue the conversation.": "आपके पास 30 सेकंड बचे हैं। कृपया बातचीत जारी रखने के लिए तुरंत रिचार्ज करें।",
            "Free chat over! Next minutes will use wallet balance.": "मुफ़्त चैट समाप्त! अगले मिनट वॉलेट बैलेंस से कटेंगे।",
            "Complete": "पूर्ण करें",
            "End Chat": "चैट समाप्त करें",
            "Message": "संदेश",
            "Hi": "नमस्ते",
            "lets continue this chat at discounted price of": "आइए इस चैट को इस छूट वाली कीमत पर जारी रखें",
            "Are you sure you want to end tha chat to": "क्या आप वाकई इस चैट को समाप्त करना चाहते हैं",
            "No": "नहीं",
            "Yes": "हाँ",
            "Chat With Astrologer": "ज्योतिषी से चैट करें",
            "Appointment List": "अपॉइंटमेंट सूची",
            "My Following": "मेरे फॉलोइंग",
            "Recent Post": "हाल की पोस्ट",
            "Welcome back": "फिर से स्वागत है",
            "Manage your astrology services": "अपनी ज्योतिष सेवाओं का प्रबंधन करें",
            "Logout": "लॉगआउट",
            "Login": "लॉगिन",
            "My Profile (Member Since)": "मेरी प्रोफ़ाइल (सदस्यता से)",
            "My Followings": "मेरे फॉलोइंग",
            "You are following": "आप फॉलो कर रहे हैं",
            "people": "लोग",
            "Years": "साल",
            "No Following Found !!": "कोई फॉलोइंग नहीं मिला !!",
            "Currently you don't have any follow.": "वर्तमान में आपका कोई फॉलो नहीं है।",
            "Hey There!": "अरे वहाँ!",
            "What is your name?": "आपका नाम क्या है?",
            "Enter your first Name": "अपना पहला नाम दर्ज करें",
            "Enter your last Name": "अपना अंतिम नाम दर्ज करें",
            "male": "पुरुष",
            "female": "महिला",
            "Where wrer you bron?": "आपका जन्म कहाँ हुआ था?",
            "Please Select Language": "कृपया भाषा चुनें",
            "english": "अंग्रेज़ी",
            "hindi": "हिंदी",
            "north": "उत्तर",
            "south": "दक्षिण",
            "Select Chart Type": "चार्ट प्रकार चुनें",
            "Start chat with astrologer": "ज्योतिषी के साथ चैट शुरू करें",
            "Search location": "स्थान खोजें",
            "Location not found !!": "स्थान नहीं मिला !!",
            "Enter bord state": "जन्म राज्य दर्ज करें",
            "Search location...": "स्थान खोजें...",
            "Astrologers": "ज्योतिषी",
            "Top Astrologers. 24 * 7 customer support. Happy to help": "शीर्ष ज्योतिषी। 24 * 7 ग्राहक सहायता। मदद के लिए सदैव तैयार",
            "per min": "प्रति मिनट",
            "Top Astrologers": "शीर्ष ज्योतिषी",
            "rate": "रेट",
            "Top Rated Astrologers": "शीर्ष रेटेड ज्योतिषी",
            "No astrologers found !!": "कोई ज्योतिषी नहीं मिला !!",
            "FAQs": "अक्सर पूछे जाने वाले प्रश्न",
            "Raning": "रेटिंग",
            "Raning Apointment": "रेटिंग अपॉइंटमेंट",
            "Select Other Sign": "अन्य राशि चुनें",
            "Horoscopes": "राशिफल",
            "Daily Horoscope": "दैनिक राशिफल",
            "Weekly Horoscope": "साप्ताहिक राशिफल",
            "Monthly Horoscope": "मासिक राशिफल",
            "Yearly Horoscope": "वार्षिक राशिफल",
            "Composite Friendship Table": "संयुक्त मित्रता तालिका",
            "Kp Planetary Details": "केपी ग्रह विवरण",
            "Kp House Cusps And Chart": "केपी भाव कुस्प और चार्ट",
            "Ascendant Report": "लग्न रिपोर्ट",
            "Bhava Kundli": "भाव कुंडली",
            "Vimshottari Dasha": "विंशोत्तरी दशा",
            "Yogini Dasha": "योगिनी दशा",
            "Sadhesati Analysis": "साढ़ेसाती विश्लेषण",
            "Sadhesati Life Analysis": "साढ़ेसाती जीवन विश्लेषण",
            "Kalsarpa Dosha": "कालसर्प दोष",
            "Manglik Analysis": "मांगलिक विश्लेषण",
            "Planet Profiles": "ग्रह प्रोफ़ाइल",
            "Gemstone Suggestions": "रत्न सुझाव",
            "Upagraha": "उपग्रह",
            "Jaimini Astrology": "जैमिनी ज्योतिष",
            "Chara Dasha": "चर दशा",
            "Shadbala": "षड्बल",
            "Sudarshana Chakra": "सुदर्शन चक्र",
            "Bhinnashtakvarga": "भिन्नाष्टकवर्ग",
            "Yogas": "योग",
            "Introduction": "परिचय",
            "Basic Astrological Details": "मूल ज्योतिषीय विवरण",
            "Planetary Positions": "ग्रह स्थितियाँ",
            "Horoscope Charts": "राशिफल चार्ट",
            "House Cusps And Sandhi": "भाव कुस्प और संधि",
            "Divisional Charts": "विभाजन चार्ट",
            "Basic Details": "मूल विवरण",
            "Ghat Chakra": "घट चक्र",
            "Panchange Details": "पंचांग विवरण",
            "Astrological Details": "ज्योतिषीय विवरण",
            "Time of Birth": "जन्म समय",
            "Place of Birth": "जन्म स्थान",
            "Latitude": "अक्षांश",
            "Longitude": "देशांतर",
            "Timezone": "समय क्षेत्र",
            "Ayanamsa": "अयनांश",
            "Sunrise": "सूर्योदय",
            "Sunset": "सूर्यास्त",
            "Month": "माह",
            "Tithi": "तिथि",
            "Yoga": "योग",
            "Karana": "करण",
            "Moon Sign": "चंद्र राशि",
            "Moon Vaar": "चंद्र वार",
            "Nakshatra": "नक्षत्र",
            "Varna": "वर्ण",
            "Vashya": "वश्य",
            "Yoni": "योनि",
            "Gana": "गण",
            "Nadi": "नाड़ी",
            "Sun Sign": "सूर्य राशि",
            "Tatva": "तत्व",
            "Paya": "पाया",
            "Yanja": "यज्ञ",
            "Planets": "ग्रह",
            "Sign": "राशि",
            "Sign No": "राशि संख्या",
            "LAGNA CHART (BIRTH CHART)": "लग्न चार्ट (जन्म कुंडली)",
            "MOON CHART": "चंद्र चार्ट",
            "NAVMANSHA CHART (D9)": "नवांश चार्ट (D9)",
            "House": "भाव",
            "Bhav Madhya": "भाव मध्य",
            "Bhav Sandhi": "भाव संधि",
            "Chalit Chart": "चलित चार्ट",
            "Sun Chart": "सूर्य चार्ट",
            "Health, Constitution, Body": "स्वास्थ्य, शरीर संरचना",
            "Hora Chart(D2)": "होरा चार्ट (D2)",
            "Finance, Wealth, Prosperity": "वित्त, धन, समृद्धि",
            "Dreshkan Chart(D3)": "द्रेष्काण चार्ट (D3)",
            "Brothers, Sisters": "भाई, बहन",
            "Chathurthamasha Chart(D4)": "चतुर्थांश चार्ट (D4)",
            "Fortunes, Luck of native": "भाग्य, जातक का सौभाग्य",
            "Saptamansha Chart(D7)": "सप्तमांश चार्ट (D7)",
            "Impregnation, Birth of the child": "गर्भाधान, संतान जन्म",
            "Dashamansha Chart(D10)": "दशमांश चार्ट (D10)",
            "livelihood, Profession": "जीविका, पेशा",
            "Dwadasha Chart(D12)": "द्वादशांश चार्ट (D12)",
            "Parents, paternal happiness": "माता-पिता, पितृ सुख",
            "Shodashamsha Chart(D16)": "षोडशांश चार्ट (D16)",
            "Happiness, miseries, conveyance": "सुख, दुख, वाहन",
            "Vishamansha Chart(D20)": "विंशांश चार्ट (D20)",
            "Spiritual progress, worship": "आध्यात्मिक प्रगति, उपासना",
            "Chaturvimshamsha(D24)": "चतुर्विंशांश (D24)",
            "Academic achievement, education": "शैक्षणिक उपलब्धि, शिक्षा",
            "Bhamsha Chart(D27)": "भाम्श चार्ट (D27)",
            "Physical strength, stamina": "शारीरिक शक्ति, सहनशक्ति",
            "Trishamansha Chart(D30)": "त्रिंशांश चार्ट (D30)",
            "Evil, Adversities of life": "कष्ट, जीवन की विपत्तियाँ",
            "Khavedamsha Chart(D40)": "खवेदांश चार्ट (D40)",
            "Auspicious & inauspicious effect": "शुभ और अशुभ प्रभाव",
            "Akshvedansha Chart(D45)": "अक्षवेदांश चार्ट (D45)",
            "Character and couduct of the native": "जातक का चरित्र और आचरण",
            "Shashtymsah Chart(D60)": "षष्ट्यंश चार्ट (D60)",
            "Shows general happiness": "सामान्य सुख दर्शाता है",
            "Degrees": "अंश",
            "Sign Lord": "राशि स्वामी",
            "Nakshatra Lord": "नक्षत्र स्वामी",
            "Sub Lord": "उप स्वामी",
            "Sub Sub Lord": "उप-उप स्वामी",
            "Lord": "स्वामी",
            "Symbol": "प्रतीक",
            "Characteristics": "विशेषताएँ",
            "Day of Fast": "व्रत का दिन",
            "luchy Gems": "लकी रत्न",
            "Personality": "व्यक्तित्व",
            "Health": "स्वास्थ्य",
            "Relationships": "संबंध",
            "BHAVA KUNDLI": "भाव कुंडली",
            "Bhramari": "भ्रामरी",
            "Bhadrika": "भद्रिका",
            "Ulka": "उल्का",
            "Siddha": "सिद्ध",
            "Sankata": "संकटा",
            "Mangala": "मंगला",
            "Pingala": "पिंगला",
            "Dhanya": "धन्या",
            "Remedies Of Sadhesati": "साढ़ेसाती के उपाय",
            "Saturn Sign": "शनि राशि",
            "Is Saturn Retro?": "क्या शनि वक्री है?",
            "Phase": "चरण",
            "Intensity": "तीव्रता",
            "Direction": "दिशा",
            "Strength": "शक्ति",
            "Percentage": "प्रतिशत",
            "Zodiac Sign": "राशि",
            "Planet Degree": "ग्रह अंश",
            "Lord Of": "का स्वामी",
            "Combust/Aw...": "अस्त/अव...",
            "Lucky Stone": "लकी रत्न",
            "Life Stone": "जीवन रत्न",
            "Finger": "उंगली",
            "Day": "दिन",
            "Time to Wear": "धारण करने का समय",
            "Mantra": "मंत्र",
            "Upagraha Longitude": "उपग्रह देशांतर",
            "Rashi": "राशि",
            "Pada": "पद",
            "Upagraha/Nakshatra/Sub Lord": "उपग्रह/नक्षत्र/उप स्वामी",
            "Jamini Planets": "जैमिनी ग्रह",
            "Jamini Padas": "जैमिनी पद",
            "Code": "कोड",
            "Jamini Karakara": "जैमिनी कारक",
            "Uchcha Bala": "उच्च बल",
            "Saptavarga Bala": "सप्तवर्ग बल",
            "Yugmayugma Bhamsha Bala": "युग्मयुग्म भाम्श बल",
            "Kendradi Bala": "केंद्रादि बल",
            "Drekkana Bala": "द्रेष्काण बल",
            "Total Sthana Bala": "कुल स्थान बल",
            "Total Dig Bala": "कुल दिग्बल",
            "Nattunnata Bala": "नतोनत बल",
            "Paksha Bala": "पक्ष बल",
            "Tribhaga Bala": "त्रिभाग बल",
            "Varshadhipati": "वर्षाधिपति",
            "Maasadipati": "मासाधिपति",
            "Vaaradhipati": "वाराधिपति",
            "Horadhipati": "होराधिपति",
            "Ayana Bala": "अयन बल",
            "Yuddha Bala": "युद्ध बल",
            "Total Kaal Bala": "कुल काल बल",
            "Naisargika Bala": "नैसर्गिक बल",
            "Chestha Bala": "चेष्टा बल",
            "Drik Bala": "दृक बल",
            "Total Shadbala": "कुल षड्बल",
            "Shadbala In Rupa": "रूप में षड्बल",
            "Min Require": "न्यूनतम आवश्यक",
            "Ratio": "अनुपात",
            "Rank": "रैंक",
            "Sun": "सूर्य",
            "Moon": "चंद्र",
            "Mars": "मंगल",
            "Mercury": "बुध",
            "Jupiter": "गुरु",
            "Venus": "शुक्र",
            "Saturn": "शनि",
            "Ashtakvarga": "अष्टकवर्ग",
            "Sarvashtakava": "सर्वाष्टकवर्ग",
            "Prasthara Chakra": "प्रस्थार चक्र",
            "Ascendant": "लग्न",
            "Total": "कुल",
            "Natural Friendship": "प्राकृतिक मित्रता",
            "Temporary Friendship": "तात्कालिक मित्रता",
            "Five Fold Friendship": "पंचधा मित्रता",
            "Ketu": "केतु",
            "Rahu": "राहु",
            "Vimshottari Dasha P1": "विंशोत्तरी दशा भाग 1",
            "Vimshottari Dasha P2": "विंशोत्तरी दशा भाग 2",
            "AshtaKoot": "अष्टकूट",
            "Bhakut Dosha": "भकूट दोष",
            "Nadi Dosha": "नाड़ी दोष",
            "Ashtakoot Analysis": "अष्टकूट विश्लेषण",
            "DashaKoot": "दशकूट",
            "Personality Report": "व्यक्तित्व रिपोर्ट",
            "Match Making Report": "विवाह मिलान रिपोर्ट",
            "Nav Pancham Yoga": "नव पंचम योग",
            "Charan": "चरण",
            "Name Alphabet": "नाम अक्षर",
            "Planetary Position": "ग्रह स्थिति",
            "Lagna Chart (Birth Chart)": "लग्न चार्ट (जन्म कुंडली)",
            "Moon Chart": "चंद्र चार्ट",
            "Navmansha Chart (D9)": "नवांश चार्ट (D9)",
            "Mahadasha": "महादशा",
            "End": "समाप्ति",
            "Is Recommended ??": "क्या अनुशंसित है ??",
            "Manglik Details": "मांगलिक विवरण",
            "What is AshtaKoot ??": "अष्टकूट क्या है ??",
            "Attributes": "गुण",
            "Description": "विवरण",
            "Received": "प्राप्त",
            "Graha Maitri": "ग्रह मैत्री",
            "Bhakoota": "भकूट",
            "What is BhaKoot Dosha ??": "भकूट दोष क्या है ??",
            "What is Nadi Dosha ??": "नाड़ी दोष क्या है ??",
            "Madhya": "मध्य",
            "Nadi dosha is present": "नाड़ी दोष उपस्थित है",
            "The": "निम्नलिखित",
            "porutham considered for horoscope matching are as follows :": "कुंडली मिलान के लिए निम्नलिखित पोरुथम विचार किए जाते हैं :",
            "Dina": "दिना",
            "Rajju": "रज्जु",
            "Rasyadhipati": "राश्याधिपति",
            "Vedha": "वेध",
            "Mahendra": "महेंद्र",
            "Streedargha": "स्त्रीदीर्घा",
            "Uranus": "अरुण",
            "Neptune": "वरुण",
            "Pluto": "यम",
            "Tara": "तारा",
            "Please fill boy's details !!": "कृपया लड़के का विवरण भरें !!",
            "Please fill girl's details !!": "कृपया लड़की का विवरण भरें !!",
            "Please fill chart details !!": "कृपया चार्ट का विवरण भरें !!",
            "Kundli Matching": "कुंडली मिलान",
            "Find your right one, through matchmaking": "विवाह मिलान के माध्यम से अपने सही साथी को खोजें",
            "Open Kundli": "कुंडली खोलें",
            "New Matching": "नया मिलान",
            "View Kundli": "कुंडली देखें",
            "Boy's Details": "लड़के का विवरण",
            "Girl's Details": "लड़की का विवरण",
            "Search city, state, country": "शहर, राज्य, देश खोजें",
            "Enter first name": "पहला नाम दर्ज करें",
            "Enter last name": "अंतिम नाम दर्ज करें",
            "Chart Style": "चार्ट शैली",
            "North Indian": "उत्तर भारतीय",
            "South Indian": "दक्षिण भारतीय",
            "English": "अंग्रेज़ी",
            "Hindi": "हिंदी",
            "MATCH HOROSCOPE": "राशिफल मिलान",
            "No Saved Kundlis Yet": "अभी तक कोई सहेजी गई कुंडली नहीं है",
            "Create your first profile to view, edit, and run compatibility matching reports with ease.": "आसानी से संगतता मिलान रिपोर्ट देखने, संपादित करने और चलाने के लिए अपनी पहली प्रोफ़ाइल बनाएं।",
            "My Profile": "मेरी प्रोफ़ाइल",
            "Enter full name": "पूरा नाम दर्ज करें",
            "Enter email address": "ईमेल पता दर्ज करें",
            "Enter password": "पासवर्ड दर्ज करें",
            "Enter phone number": "फ़ोन नंबर दर्ज करें",
            "Save Chanage": "परिवर्तन सहेजें",
            "Manage your astrologers recent post": "अपने ज्योतिषी की हाल की पोस्ट प्रबंधित करें",
            "Show Less": "कम दिखाएँ",
            "Show More": "और दिखाएँ",
            "Total Balance": "कुल शेष राशि",
            "Add Money": "पैसे जोड़ें",
            "Extra": "अतिरिक्त",
            "Transaction History": "लेन-देन इतिहास",
            "Build better products with flexible tools, helpful documentation,": "लचीले टूल्स, उपयोगी डॉक्यूमेंटेशन के साथ बेहतर प्रोडक्ट बनाएं,",
            "and a team that champions your growth.": "और एक टीम जो आपकी प्रगति का समर्थन करती है।",
            "Useful Link": "उपयोगी लिंक",
            "Socials": "सोशल मीडिया",
            "Logout Seccuessfuly !!": "सफलतापूर्वक लॉगआउट हो गया !!",
            "Free Kundli": "मुफ्त कुंडली",
            "Horoscope": "राशिफल",
            "Dashboard": "डैशबोर्ड",
            "Enter your feedback !!": "अपनी प्रतिक्रिया दर्ज करें !!",
            "Languages": "भाषाएँ",
            "incoming": "आने वाला",
            "request from": "से अनुरोध",
            "Waitlist Joined !!": "वेटलिस्ट जॉइन हो गई !!",
            "will start in": "शुरू होगा",
            "You will receive a": "आपको एक",
            "request when the": "अनुरोध प्राप्त होगा जब",
            "astrologer is ready. Don’t worry! You will not be": "ज्योतिषी तैयार होगा। चिंता न करें! आपसे",
            "charged for missing this session.": "इस सत्र को मिस करने पर कोई शुल्क नहीं लिया जाएगा।",
            "Accept": "स्वीकार करें",
            "Reject": "अस्वीकार करें",
            "Great, what did you like the mast? 😍": "बहुत बढ़िया, आपको सबसे ज्यादा क्या पसंद आया? 😍",
            "Skip": "छोड़ें",
            "Payment Information": "भुगतान जानकारी",
            "Amount": "राशि",
            "Tax": "कर",
            "Payment": "भुगतान",
            "Payment Method": "भुगतान विधि",
        
            "AstroSpace": "एस्ट्रोस्पेस",
            "Astrology Consultation Platform": "ज्योतिष परामर्श मंच",
            "INVOICE": "इनवॉइस",
            "Consultation Service Receipt": "परामर्श सेवा रसीद",
            "Invoice Number": "इनवॉइस संख्या",
            "Date Issued": "जारी करने की तिथि",
            "PAID": "भुगतान किया गया",
            "From": "प्रेषक",
            "Bill To": "बिल प्राप्तकर्ता",
            "Service": "सेवा",
            "Booking ID": "बुकिंग आईडी",
            "Description": "विवरण",
            "Duration": "अवधि",
            "Rate": "दर",
            "Amount": "राशि",
            "Free Consultation Time": "निःशुल्क परामर्श समय",
            "Complimentary session minutes": "मानार्थ सत्र मिनट",
            "Free": "निःशुल्क",
            "Consultation Fee": "परामर्श शुल्क",
            "Standard rate (first block)": "मानक दर (पहला ब्लॉक)",
            "Extended Consultation Fee": "विस्तारित परामर्श शुल्क",
            "Premium rate (extended block)": "प्रीमियम दर (विस्तारित ब्लॉक)",
            "Consultation Service": "परामर्श सेवा",
            "Astrology consultation session": "ज्योतिष परामर्श सत्र",
            "Subtotal": "उपयोग",
            "Platform Fee": "प्लेटफ़ॉर्म शुल्क",
            "Included": "शामिल",
            "Total Amount": "कुल राशि",
            "DOB": "जन्म तिथि",
            "Kundali Chart Used": "प्रयुक्त कुंडली चार्ट",
            "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.": "एस्ट्रोस्पेस चुनने के लिए धन्यवाद। यह इनवॉइस स्वचालित रूप से उत्पन्न होता है और आपके परामर्श का एक मान्य रिकॉर्ड है।",
            "For support, contact us at support@astrospace.com": "सहायता के लिए, हमसे support@astrospace.com पर संपर्क करें",
            "Free Minute": "निःशुल्क मिनट",
            "Verified": "सत्यापित",
            "End Session": "सत्र समाप्त करें",
            "Voice Call": "वॉयस कॉल",
            "typing...": "टाइपिंग...",
            "CANCEL": "रद्द करें",
            "OK": "ठीक है",
            "Install Progressive Web Application": "प्रोग्रेसिव वेब एप्लिकेशन इंस्टॉल करें",
            "This site has app functionality. Install it on your device for extensive experience and easy access.": "इस साइट में ऐप की कार्यक्षमता है। व्यापक अनुभव और आसान पहुंच के लिए इसे अपने डिवाइस पर इंस्टॉल करें।",
            "Install": "इंस्टॉल करें",
            "Search location": "स्थान खोजें",
            "Location not found !!": "स्थान नहीं मिला !!",
            "Waiting for remote user to join...": "रिमोट यूजर के शामिल होने की प्रतीक्षा की जा रही है...",
            "End Video Session": "वीडियो सत्र समाप्त करें",
            "Initializing WebRTC P2P...": "WebRTC P2P प्रारंभ किया जा रहा है...",
            "Access Denied (Camera/Mic)": "पहुंच अस्वीकृत (कैमरा/माइक)",
            "Connection Failed": "कनेक्शन विफल",
            "Time Remaining": "समय शेष",
            "Call ended": "कॉल समाप्त",

            "Offline": "ऑफ़लाइन",}
    },
    sp: {
        translation: {
            "Enter Mobile Number !!": "¡¡Ingrese el número de móvil!!",
            "In Valid OTP !!": "¡¡OTP no válido!!",
            "Please enter password !!": "¡¡Por favor ingrese la contraseña!!",
            "Password not match !!": "¡¡Las contraseñas no coinciden!!",
            "Reset Password": "Restablecer contraseña",
            "Enter your phone number and new password": "Ingrese su número de teléfono y nueva contraseña",
            "Phone Number": "Número de teléfono",
            "Enter your number": "Ingrese su número",
            "Search": "Buscar",
            "Verify": "Verificar",
            "You will receive a 6 digit code for": "Recibirá un código de 6 dígitos para",
            "verification to": "verificación en",
            "Submit": "Enviar",
            "Enter your password and new password": "Ingrese su contraseña y nueva contraseña",
            "New Password": "Nueva contraseña",
            "Enter new password": "Ingrese nueva contraseña",
            "Confirm New Password": "Confirmar nueva contraseña",
            "Confirm new password": "Confirme nueva contraseña",
            "Back to Login": "Volver al inicio de sesión",
            "Back": "Atrás",
            "Enter Login Details !!": "¡¡Ingrese los datos de inicio de sesión!!",
            "Welcome Back!": "¡Bienvenido de nuevo!",
            "Sign in to your account": "Inicie sesión en su cuenta",
            "Password": "Contraseña",
            "Enter your password": "Ingrese su contraseña",
            "Forgot Password?": "¿Olvidó su contraseña?",
            "Sign In": "Iniciar sesión",
            "Don't have an account?": "¿No tiene una cuenta?",
            "Sign Up": "Registrarse",
            "Please enter all details !!": "¡¡Por favor ingrese todos los datos!!",
            "Please enter valid email !!": "¡¡Por favor ingrese un correo electrónico válido!!",
            "Please enter birth place !!": "¡¡Por favor ingrese el lugar de nacimiento!!",
            "Please select language !!": "¡¡Por favor seleccione un idioma!!",
            "Step": "Paso",
            "Enter Your Details": "Ingrese sus datos",
            "Hey there! what is your name?": "¡Hola! ¿Cuál es su nombre?",
            "Full Name": "Nombre completo",
            "Email Address": "Correo electrónico",
            "Enter your Full Name": "Ingrese su nombre completo",
            "Enter your email": "Ingrese su correo electrónico",
            "What is your gender?": "¿Cuál es su género?",
            "Male": "Masculino",
            "Female": "Femenino",
            "Enter your birth date": "Ingrese su fecha de nacimiento",
            "Enter your birth time": "Ingrese su hora de nacimiento",
            "Enter your birth Place": "Ingrese su lugar de nacimiento",
            "Do you know which languages?": "¿Qué idiomas conoce?",
            "Enter Your Place": "Ingrese su lugar",
            "Back to Step": "Volver al paso",
            "Next": "Siguiente",
            "My Appointments": "Mis citas",
            "Manage your astrology consultations": "Administre sus consultas astrológicas",
            "Upcoming": "Próximas",
            "Past": "Pasadas",
            "Pending": "Pendiente",
            "Accepted": "Aceptada",
            "Start": "Iniciar",
            "Completed": "Completada",
            "Canceled": "Cancelada",
            "ID": "ID",
            "Chat": "Chat",
            "Audio Call": "Llamada de audio",
            "Video Call": "Videollamada",
            "View Details": "Ver detalles",
            "Cancel": "Cancelar",
            "No Upcoming Appointment Found !!": "¡¡No se encontraron citas próximas!!",
            "Currently you don't have any upcoming appointment.": "Actualmente no tiene citas próximas.",
            "No Past Appointment Found !!": "¡¡No se encontraron citas pasadas!!",
            "Currently you don't have any past appointment.": "Actualmente no tiene citas pasadas.",
            "Status": "Estado",
            "Service Type": "Tipo de servicio",
            "Date": "Fecha",
            "Time": "Hora",
            "Price": "Precio",
            "Booked Person Details": "Detalles de la persona reservada",
            "name": "nombre",
            "Date of Birth": "Fecha de nacimiento",
            "Birth Place": "Lugar de nacimiento",
            "Gender": "Género",
            "Complete Details": "Detalles completos",
            "Start Time": "Hora de inicio",
            "End Time": "Hora de finalización",
            "Total Duration": "Duración total",
            "Billable Time": "Tiempo facturable",
            "Billed Fee First": "Tarifa facturada inicial",
            "Billed Fee After": "Tarifa facturada posterior",
            "Total Consultation Fee": "Tarifa total de consulta",
            "Kundali Details": "Detalles del Kundali",
            "Name": "Nombre",
            "Send Notification": "Enviar notificación",
            "Continue Chat": "Continuar chat",
            "Write message !!": "¡¡Escriba un mensaje!!",
            "Astrologer Ai Assistant": "Asistente IA del astrólogo",
            "Ask anything about your horoscope...": "Pregunte lo que quiera sobre su horóscopo...",
            "Write message to assistant": "Escriba un mensaje al asistente",
            "Clear Chat?": "¿Borrar chat?",
            "All messages will be deleted permanently.": "Todos los mensajes se eliminarán permanentemente.",
            "Clear": "Borrar",
            "Payment faild !!": "¡¡Pago fallido!!",
            "Please Complete Last Apointment !!": "¡¡Por favor complete la última cita!!",
            "Please enter comment !!": "¡¡Por favor ingrese un comentario!!",
            "Insufficient wallet balance !!": "¡¡Saldo insuficiente en la billetera!!",
            "Orders": "Pedidos",
            "Experience": "Experiencia",
            "Rating": "Calificación",
            "Unfollow": "Dejar de seguir",
            "Follow": "Seguir",
            "Send Gift": "Enviar regalo",
            "Start a Consultation": "Iniciar una consulta",
            "Chat with astrologer": "Chatear con el astrólogo",
            "For new user": "Para nuevo usuario",
            "min free": "min gratis",
            "Call with astrologer": "Llamar al astrólogo",
            "Video call with astrologer": "Videollamada con el astrólogo",
            "Astrologer Bio": "Biografía del astrólogo",
            "Reviews": "Reseñas",
            "Activity": "Actividad",
            "FAQ's": "Preguntas frecuentes",
            "Media": "Multimedia",
            "Comment": "Comentario",
            "No comment yet": "Aún no hay comentarios",
            "start the conversation": "iniciar la conversación",
            "Poast your replay": "Publica tu respuesta",
            "Delete comment": "Eliminar comentario",
            "Are you sure you want to delete this comment?": "¿Está seguro de que desea eliminar este comentario?",
            "Cancle": "Cancelar",
            "Delete": "Eliminar",
            "Intro Audio": "Audio introductorio",
            "Intro Video": "Video introductorio",
            "Hear from": "Escuchar a",
            "Please select user !!": "¡¡Por favor seleccione un usuario!!",
            "Please select amount !!": "¡¡Por favor seleccione una cantidad!!",
            "Please select payment method !!": "¡¡Por favor seleccione el método de pago!!",
            "Select Kundli": "Seleccionar Kundli",
            "Add Kundli": "Agregar Kundli",
            "Minimum balance of": "Saldo mínimo de",
            "minutes": "minutos",
            "is required to start chat with": "es requerido para iniciar el chat con",
            "Wallet Balance": "Saldo de la billetera",
            "Required": "Requerido",
            "Proceed to Pay": "Proceder al pago",
            "extra in your": "extra en su",
            "wallet with this": "billetera con esto",
            "Woohoo!": "¡Genial!",
            "Recharge Amount": "Monto de recarga",
            "GST": "IVA",
            "Wallet Amount": "Monto en la billetera",
            "Payble Amount": "Monto a pagar",
            "Pay from Wallet": "Pagar desde la billetera",
            "Available": "Disponible",
            "Payment Getway Method": "Método de pasarela de pago",
            "Continue": "Continuar",
            "Fortune Cookie - Unveil Your Daily Wisdom": "Galleta de la Fortuna - Revela tu sabiduría diaria",
            "Crack open a fortune cookie to reveal a piece of daily wisdom. Let the message guide you through your day with positivity and insight.": "Abre una galleta de la fortuna para revelar un mensaje de sabiduría diaria. Deja que el mensaje te guíe durante tu día con positividad y claridad.",
            "Ask The Fortune Cookie": "Pregunta a la Galleta de la Fortuna",
            "Crack open your Fortune Cookie": "Abre tu Galleta de la Fortuna",
            "Crack another one open": "Abre otra más",
            "Love Compatibility": "Compatibilidad amorosa",
            "Find out how compatible you are with your lover, friend, or colleague using our love compatibility calculator. Get your results now.": "Descubre qué tan compatible eres con tu pareja, amigo o colega usando nuestra calculadora de compatibilidad amorosa. Obtén tus resultados ahora.",
            "Are Aries And Taurus Compatible": "¿Son Aries y Tauro compatibles?",
            "Aries And Taurus Strengths": "Fortalezas de Aries y Tauro",
            "Aries And Taurus Weaknesses": "Debilidades de Aries y Tauro",
            "Aries And Taurus Elements": "Elementos de Aries y Tauro",
            "Aries And Taurus Dates": "Fechas de Aries y Tauro",
            "Are Aries And Taurus Compatibility Score": "Puntuación de compatibilidad entre Aries y Tauro",
            "General": "General",
            "Communication": "Comunicación",
            "Sex": "Sexo",
            "Select Another": "Seleccionar otro",
            "Aries": "Aries",
            "Taurus": "Tauro",
            "Gemini": "Géminis",
            "Cancer": "Cáncer",
            "Leo": "Leo",
            "Virgo": "Virgo",
            "Libra": "Libra",
            "Scorpio": "Escorpio",
            "Sagittarius": "Sagitario",
            "Capricorn": "Capricornio",
            "Aquarius": "Acuario",
            "Pisces": "Piscis",
            "Please select Your Partner Sign": "Por favor seleccione el signo de su pareja",
            "Please select Your Sign": "Por favor seleccione su signo",
            "Please fill all details !!": "¡¡Por favor complete todos los datos!!",
            "Discover Your Core Numbers That Define You": "Descubre tus números esenciales que te definen",
            "Explore your core numbers like Life Path, Destiny, and Personal Year—complete with strengths, challenges, and meaningful interpretations.": "Explora tus números esenciales como Camino de Vida, Destino y Año Personal, incluyendo fortalezas, desafíos e interpretaciones significativas.",
            "Get Your Numbers": "Obtén tus números",
            "First Name": "Nombre",
            "Last Name": "Apellido",
            "Method": "Método",
            "Chaldean": "Caldeo",
            "Pythagorean": "Pitagórico",
            "Strengths": "Fortalezas",
            "Challenges": "Desafíos",
            "Advice": "Consejo",
            "Get Report": "Obtener informe",
            "Select Tarot One Card": "Selecciona una carta de Tarot",
            "Select Your Card": "Selecciona tu carta",
            "Get Another": "Obtener otra",
            "Yes Or No Tarot": "Tarot Sí o No",
            "Get instant Yes or No answers to pressing questions.": "Obtén respuestas instantáneas de Sí o No a tus preguntas urgentes.",
            "Daily Tarot": "Tarot Diario",
            "Receive daily tarot readings on love, career, and finance.": "Recibe lecturas diarias de tarot sobre amor, carrera y finanzas.",
            "In-Depth Love Reading": "Lectura de Amor Profunda",
            "Deep dive into your love life with relationship-specific readings.": "Profundiza en tu vida amorosa con lecturas específicas para relaciones.",
            "Flirt Love Reading": "Lectura de Amor Coqueta",
            "Reveal insights into playful and romantic connections.": "Descubre perspectivas sobre conexiones románticas y juguetonas.",
            "Erotic Love Reading": "Lectura de Amor Erótica",
            "Insights into intimate and personal love dynamics.": "Perspectivas sobre dinámicas íntimas y personales del amor.",
            "Egyptian Prediction": "Predicción Egipcia",
            "Access ancient Egyptian insights beyond visible truths.": "Accede a conocimientos del antiguo Egipto más allá de las verdades visibles.",
            "Ex-Flame Reading": "Lectura de Ex-Pareja",
            "Explore the possibilities of rekindling with an ex-partner.": "Explora las posibilidades de reavivar la relación con una ex pareja.",
            "Made For Each Other Or Not Reading": "Lectura ¿Hechos el uno para el otro o no?",
            "Discover if your relationship has long-term potential.": "Descubre si tu relación tiene potencial a largo plazo.",
            "Power Life Reading": "Lectura de Vida Poderosa",
            "Take control of your destiny with life-changing tarot readings.": "Toma el control de tu destino con lecturas de tarot transformadoras.",
            "Know Your Friend Reading": "Lectura Conoce a tu Amigo",
            "Understand the true intentions of your friendships.": "Comprende las verdaderas intenciones de tus amistades.",
            "Divine Angel Reading": "Lectura del Ángel Divino",
            "Connect with divine guidance for clarity and spiritual insight.": "Conéctate con la guía divina para obtener claridad e inspiración espiritual.",
            "Career Daily Reading": "Lectura Diaria de Carrera",
            "Elevate your career with daily tarot insights to achieve your professional goals.": "Impulsa tu carrera con perspectivas diarias del tarot para lograr tus metas profesionales.",
            "Dream Come True Reading": "Lectura Sueño Hecho Realidad",
            "Gain insights into making your dreams and goals a reality.": "Obtén claridad para convertir tus sueños y metas en realidad.",
            "Past Lives Connection Reading": "Lectura de Conexión con Vidas Pasadas",
            "Explore your journey across time to understand your path ahead.": "Explora tu viaje a través del tiempo para comprender tu camino futuro.",
            "Please pick your cards !!": "¡¡Por favor elige tus cartas!!",
            "Get Your Reading": "Obtén tu lectura",
            "Select Tarot Two Card": "Selecciona dos cartas de Tarot",
            "Love Triangle Reading": "Lectura de Triángulo Amoroso",
            "Get clarity in choosing between multiple romantic interests.": "Obtén claridad al elegir entre múltiples intereses románticos.",
            "Past-Present-Future Reading": "Lectura Pasado-Presente-Futuro",
            "Zodiac Gift Guru": "Guru de Regalos del Zodiaco",
            "January": "Enero",
            "February": "Febrero",
            "March": "Marzo",
            "April": "Abril",
            "May": "Mayo",
            "June": "Junio",
            "July": "Julio",
            "August": "Agosto",
            "September": "Septiembre",
            "October": "Octubre",
            "November": "Noviembre",
            "December": "Diciembre",
            "Yesterday": "Ayer",
            "Today": "Hoy",
            "Tomorrow": "Mañana",
            "Gift Recommendations": "Recomendaciones de regalos",
            "insight": "perspectiva",
            "Career": "Carrera",
            "Love": "Amor",
            "Finance": "Finanzas",
            "Popularity": "Popularidad",
            "Experience: High to Low": "Experiencia: de mayor a menor",
            "Experience: Low to High": "Experiencia: de menor a mayor",
            "Orders: High to Low": "Pedidos: de mayor a menor",
            "Orders: Low to High": "Pedidos: de menor a mayor",
            "Price: High to Low": "Precio: de mayor a menor",
            "Price: Low to High": "Precio: de menor a mayor",
            "Rating: High to Low": "Calificación: de mayor a menor",
            "Search name...": "Buscar nombre...",
            "Online": "En línea",
            "Busy": "Ocupado",
            "Exp": "Exp",
            "yrs": "años",
            "orders": "pedidos",
            "min": "min",
            "Chat Now": "Chatear ahora",
            "Wait": "Esperar",
            "There are no astrologers in this category.": "No hay astrólogos en esta categoría.",
            "Sort": "Ordenar",
            "Filter": "Filtrar",
            "Category": "Categoría",
            "All": "Todos",
            "Sort by": "Ordenar por",
            "Skill": "Habilidad",
            "Language": "Idioma",
            "Reset": "Restablecer",
            "Apply": "Aplicar",
            "You have 30 seconds left. Please recharge immediately to continue the conversation.": "Te quedan 30 segundos. Por favor recarga inmediatamente para continuar la conversación.",
            "Free chat over! Next minutes will use wallet balance.": "¡El chat gratis ha terminado! Los siguientes minutos usarán el saldo de la billetera.",
            "Complete": "Completar",
            "End Chat": "Finalizar chat",
            "Message": "Mensaje",
            "Hi": "Hola",
            "lets continue this chat at discounted price of": "continuemos este chat al precio con descuento de",
            "Are you sure you want to end tha chat to": "¿Estás seguro de que deseas finalizar el chat con",
            "No": "No",
            "Yes": "Sí",
            "Chat With Astrologer": "Chatear con astrólogo",
            "Appointment List": "Lista de citas",
            "My Following": "A quién sigo",
            "Recent Post": "Publicación reciente",
            "Welcome back": "Bienvenido de nuevo",
            "Manage your astrology services": "Administra tus servicios de astrología",
            "Logout": "Cerrar sesión",
            "Login": "Iniciar sesión",
            "My Profile (Member Since)": "Mi perfil (Miembro desde)",
            "My Followings": "Mis seguidos",
            "You are following": "Estás siguiendo a",
            "people": "personas",
            "Years": "Años",
            "No Following Found !!": "¡¡No se encontraron seguidos!!",
            "Currently you don't have any follow.": "Actualmente no sigues a nadie.",
            "Hey There!": "¡Hola!",
            "What is your name?": "¿Cuál es tu nombre?",
            "Enter your first Name": "Ingresa tu nombre",
            "Enter your last Name": "Ingresa tu apellido",
            "male": "masculino",
            "female": "femenino",
            "Where wrer you bron?": "¿Dónde naciste?",
            "Please Select Language": "Por favor selecciona el idioma",
            "english": "inglés",
            "hindi": "hindi",
            "north": "norte",
            "south": "sur",
            "Select Chart Type": "Seleccionar tipo de carta",
            "Start chat with astrologer": "Iniciar chat con astrólogo",
            "Search location": "Buscar ubicación",
            "Location not found !!": "¡¡Ubicación no encontrada!!",
            "Enter bord state": "Ingresa el estado de nacimiento",
            "Search location...": "Buscar ubicación...",
            "Astrologers": "Astrólogos",
            "Top Astrologers. 24 * 7 customer support. Happy to help": "Mejores astrólogos. Atención al cliente 24 * 7. Encantados de ayudar",
            "per min": "por min",
            "Top Astrologers": "Mejores astrólogos",
            "rate": "tarifa",
            "Top Rated Astrologers": "Astrólogos mejor valorados",
            "No astrologers found !!": "¡¡No se encontraron astrólogos!!",
            "FAQs": "Preguntas frecuentes",
            "Raning": "Calificación",
            "Raning Apointment": "Calificar cita",
            "Select Other Sign": "Seleccionar otro signo",
            "Horoscopes": "Horóscopos",
            "Daily Horoscope": "Horóscopo diario",
            "Weekly Horoscope": "Horóscopo semanal",
            "Monthly Horoscope": "Horóscopo mensual",
            "Yearly Horoscope": "Horóscopo anual",
            "Composite Friendship Table": "Tabla compuesta de amistad",
            "Kp Planetary Details": "Detalles planetarios KP",
            "Kp House Cusps And Chart": "Cúspides de casas KP y carta",
            "Ascendant Report": "Informe del ascendente",
            "Bhava Kundli": "Bhava Kundli",
            "Vimshottari Dasha": "Vimshottari Dasha",
            "Yogini Dasha": "Yogini Dasha",
            "Sadhesati Analysis": "Análisis de Sadhesati",
            "Sadhesati Life Analysis": "Análisis de vida Sadhesati",
            "Kalsarpa Dosha": "Kalsarpa Dosha",
            "Manglik Analysis": "Análisis Manglik",
            "Planet Profiles": "Perfiles planetarios",
            "Gemstone Suggestions": "Sugerencias de piedras preciosas",
            "Upagraha": "Upagraha",
            "Jaimini Astrology": "Astrología Jaimini",
            "Chara Dasha": "Chara Dasha",
            "Shadbala": "Shadbala",
            "Sudarshana Chakra": "Sudarshana Chakra",
            "Bhinnashtakvarga": "Bhinnashtakvarga",
            "Yogas": "Yogas",
            "Introduction": "Introducción",
            "Basic Astrological Details": "Detalles astrológicos básicos",
            "Planetary Positions": "Posiciones planetarias",
            "Horoscope Charts": "Cartas del horóscopo",
            "House Cusps And Sandhi": "Cúspides de casas y Sandhi",
            "Divisional Charts": "Cartas divisionales",
            "Basic Details": "Detalles básicos",
            "Ghat Chakra": "Ghat Chakra",
            "Panchange Details": "Detalles del Panchang",
            "Astrological Details": "Detalles astrológicos",
            "Time of Birth": "Hora de nacimiento",
            "Place of Birth": "Lugar de nacimiento",
            "Latitude": "Latitud",
            "Longitude": "Longitud",
            "Timezone": "Zona horaria",
            "Ayanamsa": "Ayanamsa",
            "Sunrise": "Amanecer",
            "Sunset": "Atardecer",
            "Month": "Mes",
            "Tithi": "Tithi",
            "Yoga": "Yoga",
            "Karana": "Karana",
            "Moon Sign": "Signo lunar",
            "Moon Vaar": "Día lunar",
            "Nakshatra": "Nakshatra",
            "Varna": "Varna",
            "Vashya": "Vashya",
            "Yoni": "Yoni",
            "Gana": "Gana",
            "Nadi": "Nadi",
            "Sun Sign": "Signo solar",
            "Tatva": "Tatva",
            "Paya": "Paya",
            "Yanja": "Yanja",
            "Planets": "Planetas",
            "Sign": "Signo",
            "Sign No": "N.º de signo",
            "LAGNA CHART (BIRTH CHART)": "CARTA LAGNA (CARTA NATAL)",
            "MOON CHART": "CARTA LUNAR",
            "NAVMANSHA CHART (D9)": "CARTA NAVAMSHA (D9)",
            "House": "Casa",
            "Bhav Madhya": "Bhav Madhya",
            "Bhav Sandhi": "Bhav Sandhi",
            "Chalit Chart": "Carta Chalit",
            "Sun Chart": "Carta Solar",
            "Health, Constitution, Body": "Salud, Constitución, Cuerpo",
            "Hora Chart(D2)": "Carta Hora (D2)",
            "Finance, Wealth, Prosperity": "Finanzas, Riqueza, Prosperidad",
            "Dreshkan Chart(D3)": "Carta Drekkana (D3)",
            "Brothers, Sisters": "Hermanos, Hermanas",
            "Chathurthamasha Chart(D4)": "Carta Chaturthamsha (D4)",
            "Fortunes, Luck of native": "Fortuna, Suerte del nativo",
            "Saptamansha Chart(D7)": "Carta Saptamsha (D7)",
            "Impregnation, Birth of the child": "Concepción, Nacimiento del hijo",
            "Dashamansha Chart(D10)": "Carta Dashamsha (D10)",
            "livelihood, Profession": "Sustento, Profesión",
            "Dwadasha Chart(D12)": "Carta Dwadashamsha (D12)",
            "Parents, paternal happiness": "Padres, felicidad paterna",
            "Shodashamsha Chart(D16)": "Carta Shodashamsha (D16)",
            "Happiness, miseries, conveyance": "Felicidad, dificultades, vehículos",
            "Vishamansha Chart(D20)": "Carta Vishamsha (D20)",
            "Spiritual progress, worship": "Progreso espiritual, adoración",
            "Chaturvimshamsha(D24)": "Chaturvimshamsha (D24)",
            "Academic achievement, education": "Logros académicos, educación",
            "Bhamsha Chart(D27)": "Carta Bhamsa (D27)",
            "Physical strength, stamina": "Fuerza física, resistencia",
            "Trishamansha Chart(D30)": "Carta Trishamsha (D30)",
            "Evil, Adversities of life": "Mal, adversidades de la vida",
            "Khavedamsha Chart(D40)": "Carta Khavedamsha (D40)",
            "Auspicious & inauspicious effect": "Efectos auspiciosos e inauspiciosos",
            "Akshvedansha Chart(D45)": "Carta Akshavedamsha (D45)",
            "Character and couduct of the native": "Carácter y conducta del nativo",
            "Shashtymsah Chart(D60)": "Carta Shashtyamsha (D60)",
            "Shows general happiness": "Muestra felicidad general",
            "Degrees": "Grados",
            "Sign Lord": "Regente del signo",
            "Nakshatra Lord": "Regente del Nakshatra",
            "Sub Lord": "Subregente",
            "Sub Sub Lord": "Sub-Subregente",
            "Lord": "Regente",
            "Symbol": "Símbolo",
            "Characteristics": "Características",
            "Day of Fast": "Día de ayuno",
            "luchy Gems": "Gemas de la suerte",
            "Personality": "Personalidad",
            "Health": "Salud",
            "Relationships": "Relaciones",
            "BHAVA KUNDLI": "BHAVA KUNDLI",
            "Bhramari": "Bhramari",
            "Bhadrika": "Bhadrika",
            "Ulka": "Ulka",
            "Siddha": "Siddha",
            "Sankata": "Sankata",
            "Mangala": "Mangala",
            "Pingala": "Pingala",
            "Dhanya": "Dhanya",
            "Remedies Of Sadhesati": "Remedios de Sadhesati",
            "Saturn Sign": "Signo de Saturno",
            "Is Saturn Retro?": "¿Saturno está retrógrado?",
            "Phase": "Fase",
            "Intensity": "Intensidad",
            "Direction": "Dirección",
            "Strength": "Fuerza",
            "Percentage": "Porcentaje",
            "Zodiac Sign": "Signo zodiacal",
            "Planet Degree": "Grado del planeta",
            "Lord Of": "Regente de",
            "Combust/Aw...": "Combusto/Af...",
            "Lucky Stone": "Piedra de la suerte",
            "Life Stone": "Piedra de vida",
            "Finger": "Dedo",
            "Day": "Día",
            "Time to Wear": "Hora para usar",
            "Mantra": "Mantra",
            "Upagraha Longitude": "Longitud de Upagraha",
            "Rashi": "Rashi",
            "Pada": "Pada",
            "Upagraha/Nakshatra/Sub Lord": "Upagraha/Nakshatra/Subregente",
            "Jamini Planets": "Planetas Jamini",
            "Jamini Padas": "Padas Jamini",
            "Code": "Código",
            "Jamini Karakara": "Jamini Karakara",
            "Uchcha Bala": "Uchcha Bala",
            "Saptavarga Bala": "Saptavarga Bala",
            "Yugmayugma Bhamsha Bala": "Yugmayugma Bhamsa Bala",
            "Kendradi Bala": "Kendradi Bala",
            "Drekkana Bala": "Drekkana Bala",
            "Total Sthana Bala": "Total Sthana Bala",
            "Total Dig Bala": "Total Dig Bala",
            "Nattunnata Bala": "Nattunnata Bala",
            "Paksha Bala": "Paksha Bala",
            "Tribhaga Bala": "Tribhaga Bala",
            "Varshadhipati": "Varshadhipati",
            "Maasadipati": "Maasadipati",
            "Vaaradhipati": "Vaaradhipati",
            "Horadhipati": "Horadhipati",
            "Ayana Bala": "Ayana Bala",
            "Yuddha Bala": "Yuddha Bala",
            "Total Kaal Bala": "Total Kaal Bala",
            "Naisargika Bala": "Naisargika Bala",
            "Chestha Bala": "Chestha Bala",
            "Drik Bala": "Drik Bala",
            "Total Shadbala": "Total Shadbala",
            "Shadbala In Rupa": "Shadbala en Rupa",
            "Min Require": "Mín. requerido",
            "Ratio": "Proporción",
            "Rank": "Rango",
            "Sun": "Sol",
            "Moon": "Luna",
            "Mars": "Marte",
            "Mercury": "Mercurio",
            "Jupiter": "Júpiter",
            "Venus": "Venus",
            "Saturn": "Saturno",
            "Ashtakvarga": "Ashtakvarga",
            "Sarvashtakava": "Sarvashtakavarga",
            "Prasthara Chakra": "Prasthara Chakra",
            "Ascendant": "Ascendente",
            "Total": "Total",
            "Natural Friendship": "Amistad natural",
            "Temporary Friendship": "Amistad temporal",
            "Five Fold Friendship": "Amistad quíntuple",
            "Ketu": "Ketu",
            "Rahu": "Rahu",
            "Vimshottari Dasha P1": "Vimshottari Dasha P1",
            "Vimshottari Dasha P2": "Vimshottari Dasha P2",
            "AshtaKoot": "AshtaKoot",
            "Bhakut Dosha": "Bhakut Dosha",
            "Nadi Dosha": "Nadi Dosha",
            "Ashtakoot Analysis": "Análisis Ashtakoot",
            "DashaKoot": "DashaKoot",
            "Personality Report": "Informe de personalidad",
            "Match Making Report": "Informe de compatibilidad",
            "Nav Pancham Yoga": "Nav Pancham Yoga",
            "Charan": "Charan",
            "Name Alphabet": "Inicial del nombre",
            "Planetary Position": "Posición planetaria",
            "Lagna Chart (Birth Chart)": "Carta Lagna (Carta natal)",
            "Moon Chart": "Carta lunar",
            "Navmansha Chart (D9)": "Carta Navamsha (D9)",
            "Mahadasha": "Mahadasha",
            "End": "Fin",
            "Is Recommended ??": "¿Es recomendado?",
            "Manglik Details": "Detalles Manglik",
            "What is AshtaKoot ??": "¿Qué es AshtaKoot?",
            "Attributes": "Atributos",
            "Description": "Descripción",
            "Received": "Recibido",
            "Graha Maitri": "Graha Maitri",
            "Bhakoota": "Bhakoota",
            "What is BhaKoot Dosha ??": "¿Qué es BhaKoot Dosha?",
            "What is Nadi Dosha ??": "¿Qué es Nadi Dosha?",
            "Madhya": "Madhya",
            "Nadi dosha is present": "Nadi dosha está presente",
            "The": "Los",
            "porutham considered for horoscope matching are as follows :": "porutham considerados para la compatibilidad del horóscopo son los siguientes:",
            "Dina": "Dina",
            "Rajju": "Rajju",
            "Rasyadhipati": "Rasyadhipati",
            "Vedha": "Vedha",
            "Mahendra": "Mahendra",
            "Streedargha": "Streedargha",
            "Uranus": "Urano",
            "Neptune": "Neptuno",
            "Pluto": "Plutón",
            "Tara": "Tara",
            "Please fill boy's details !!": "¡¡Por favor complete los datos del chico!!",
            "Please fill girl's details !!": "¡¡Por favor complete los datos de la chica!!",
            "Please fill chart details !!": "¡¡Por favor complete los detalles de la carta!!",
            "Kundli Matching": "Compatibilidad de Kundli",
            "Find your right one, through matchmaking": "Encuentra a tu pareja ideal mediante compatibilidad",
            "Open Kundli": "Abrir Kundli",
            "New Matching": "Nueva compatibilidad",
            "View Kundli": "Ver Kundli",
            "Boy's Details": "Datos del chico",
            "Girl's Details": "Datos de la chica",
            "Search city, state, country": "Buscar ciudad, estado, país",
            "Enter first name": "Ingrese nombre",
            "Enter last name": "Ingrese apellido",
            "Chart Style": "Estilo de carta",
            "North Indian": "Norte de la India",
            "South Indian": "Sur de la India",
            "English": "Inglés",
            "Hindi": "Hindi",
            "MATCH HOROSCOPE": "COMPATIBILIDAD DE HORÓSCOPO",
            "My Profile": "Mi perfil",
            "Enter full name": "Ingrese nombre completo",
            "Enter email address": "Ingrese correo electrónico",
            "Enter password": "Ingrese contraseña",
            "Enter phone number": "Ingrese número de teléfono",
            "Save Chanage": "Guardar cambios",
            "Manage your astrologers recent post": "Administra las publicaciones recientes de tus astrólogos",
            "Show Less": "Mostrar menos",
            "Show More": "Mostrar más",
            "Total Balance": "Saldo total",
            "Add Money": "Agregar dinero",
            "Extra": "Extra",
            "Transaction History": "Historial de transacciones",
            "Build better products with flexible tools, helpful documentation,": "Construye mejores productos con herramientas flexibles y documentación útil,",
            "and a team that champions your growth.": "y un equipo que impulsa tu crecimiento.",
            "Useful Link": "Enlace útil",
            "Socials": "Redes sociales",
            "Logout Seccuessfuly !!": "¡¡Sesión cerrada con éxito!!",
            "Free Kundli": "Kundli gratis",
            "Horoscope": "Horóscopo",
            "Dashboard": "Panel",
            "Enter your feedback !!": "¡¡Ingresa tus comentarios!!",
            "Languages": "Idiomas",
            "incoming": "entrante",
            "request from": "solicitud de",
            "Waitlist Joined !!": "¡¡Te uniste a la lista de espera!!",
            "will start in": "comenzará en",
            "You will receive a": "Recibirás una",
            "request when the": "solicitud cuando el",
            "astrologer is ready. Don’t worry! You will not be": "astrólogo esté listo. ¡No te preocupes! No se te",
            "charged for missing this session.": "cobrará por perder esta sesión.",
            "Accept": "Aceptar",
            "Reject": "Rechazar",
            "Great, what did you like the mast? 😍": "Genial, ¿qué fue lo que más te gustó? 😍",
            "Skip": "Omitir",
            "Payment Information": "Información de pago",
            "Amount": "Monto",
            "Tax": "Impuesto",
            "Payment": "Pago",
            "Payment Method": "Método de pago",
        
            "AstroSpace": "AstroSpace",
            "Astrology Consultation Platform": "Astrology Consultation Platform",
            "INVOICE": "INVOICE",
            "Consultation Service Receipt": "Consultation Service Receipt",
            "Invoice Number": "Invoice Number",
            "Date Issued": "Date Issued",
            "PAID": "PAID",
            "From": "From",
            "Bill To": "Bill To",
            "Service": "Service",
            "Booking ID": "Booking ID",
            "Description": "Description",
            "Duration": "Duration",
            "Rate": "Rate",
            "Amount": "Amount",
            "Free Consultation Time": "Free Consultation Time",
            "Complimentary session minutes": "Complimentary session minutes",
            "Free": "Free",
            "Consultation Fee": "Consultation Fee",
            "Standard rate (first block)": "Standard rate (first block)",
            "Extended Consultation Fee": "Extended Consultation Fee",
            "Premium rate (extended block)": "Premium rate (extended block)",
            "Consultation Service": "Consultation Service",
            "Astrology consultation session": "Astrology consultation session",
            "Subtotal": "Subtotal",
            "Platform Fee": "Platform Fee",
            "Included": "Included",
            "Total Amount": "Total Amount",
            "DOB": "DOB",
            "Kundali Chart Used": "Kundali Chart Used",
            "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.": "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.",
            "For support, contact us at support@astrospace.com": "For support, contact us at support@astrospace.com",
            "Free Minute": "Free Minute",
            "Verified": "Verified",
            "End Session": "End Session",
            "Voice Call": "Voice Call",
            "typing...": "typing...",
            "CANCEL": "CANCEL",
            "OK": "OK",
            "Install Progressive Web Application": "Install Progressive Web Application",
            "This site has app functionality. Install it on your device for extensive experience and easy access.": "This site has app functionality. Install it on your device for extensive experience and easy access.",
            "Install": "Install",
            "Search location": "Search location",
            "Location not found !!": "Location not found !!",
            "Waiting for remote user to join...": "Waiting for remote user to join...",
            "End Video Session": "End Video Session",
            "Initializing WebRTC P2P...": "Initializing WebRTC P2P...",
            "Access Denied (Camera/Mic)": "Access Denied (Camera/Mic)",
            "Connection Failed": "Connection Failed",
            "Time Remaining": "Time Remaining",
            "Call ended": "Call ended",

            "Offline": "Offline",}
    },
    ar: {
        translation: {
            "Enter Mobile Number !!": "أدخل رقم الجوال !!",
            "In Valid OTP !!": "رمز التحقق غير صالح !!",
            "Please enter password !!": "يرجى إدخال كلمة المرور !!",
            "Password not match !!": "كلمة المرور غير متطابقة !!",
            "Reset Password": "إعادة تعيين كلمة المرور",
            "Enter your phone number and new password": "أدخل رقم هاتفك وكلمة المرور الجديدة",
            "Phone Number": "رقم الهاتف",
            "Enter your number": "أدخل رقمك",
            "Search": "بحث",
            "Verify": "تحقق",
            "You will receive a 6 digit code for": "سوف تستلم رمزًا مكونًا من 6 أرقام من أجل",
            "verification to": "التحقق إلى",
            "Submit": "إرسال",
            "Enter your password and new password": "أدخل كلمة المرور الحالية والجديدة",
            "New Password": "كلمة المرور الجديدة",
            "Enter new password": "أدخل كلمة المرور الجديدة",
            "Confirm New Password": "تأكيد كلمة المرور الجديدة",
            "Confirm new password": "أكد كلمة المرور الجديدة",
            "Back to Login": "العودة إلى تسجيل الدخول",
            "Back": "رجوع",
            "Enter Login Details !!": "أدخل بيانات تسجيل الدخول !!",
            "Welcome Back!": "مرحبًا بعودتك!",
            "Sign in to your account": "سجّل الدخول إلى حسابك",
            "Password": "كلمة المرور",
            "Enter your password": "أدخل كلمة المرور",
            "Forgot Password?": "هل نسيت كلمة المرور؟",
            "Sign In": "تسجيل الدخول",
            "Don't have an account?": "ليس لديك حساب؟",
            "Sign Up": "إنشاء حساب",
            "Please enter all details !!": "يرجى إدخال جميع التفاصيل !!",
            "Please enter valid email !!": "يرجى إدخال بريد إلكتروني صالح !!",
            "Please enter birth place !!": "يرجى إدخال مكان الميلاد !!",
            "Please select language !!": "يرجى اختيار اللغة !!",
            "Step": "الخطوة",
            "Enter Your Details": "أدخل بياناتك",
            "Hey there! what is your name?": "مرحبًا! ما اسمك؟",
            "Full Name": "الاسم الكامل",
            "Email Address": "عنوان البريد الإلكتروني",
            "Enter your Full Name": "أدخل اسمك الكامل",
            "Enter your email": "أدخل بريدك الإلكتروني",
            "What is your gender?": "ما هو جنسك؟",
            "Male": "ذكر",
            "Female": "أنثى",
            "Enter your birth date": "أدخل تاريخ ميلادك",
            "Enter your birth time": "أدخل وقت ميلادك",
            "Enter your birth Place": "أدخل مكان ميلادك",
            "Do you know which languages?": "ما اللغات التي تعرفها؟",
            "Enter Your Place": "أدخل موقعك",
            "Back to Step": "العودة إلى الخطوة",
            "Next": "التالي",
            "My Appointments": "مواعيدي",
            "Manage your astrology consultations": "إدارة استشاراتك الفلكية",
            "Upcoming": "القادمة",
            "Past": "السابقة",
            "Pending": "قيد الانتظار",
            "Accepted": "مقبول",
            "Start": "ابدأ",
            "Completed": "مكتمل",
            "Canceled": "ملغي",
            "ID": "المعرف",
            "Chat": "دردشة",
            "Audio Call": "مكالمة صوتية",
            "Video Call": "مكالمة فيديو",
            "View Details": "عرض التفاصيل",
            "Cancel": "إلغاء",
            "No Upcoming Appointment Found !!": "لا توجد مواعيد قادمة !!",
            "Currently you don't have any upcoming appointment.": "لا يوجد لديك أي موعد قادم حاليًا.",
            "No Past Appointment Found !!": "لا توجد مواعيد سابقة !!",
            "Currently you don't have any past appointment.": "لا يوجد لديك أي موعد سابق حاليًا.",
            "Status": "الحالة",
            "Service Type": "نوع الخدمة",
            "Date": "التاريخ",
            "Time": "الوقت",
            "Price": "السعر",
            "Booked Person Details": "تفاصيل الشخص الحاجز",
            "name": "الاسم",
            "Date of Birth": "تاريخ الميلاد",
            "Birth Place": "مكان الميلاد",
            "Gender": "الجنس",
            "Complete Details": "التفاصيل الكاملة",
            "Start Time": "وقت البدء",
            "End Time": "وقت الانتهاء",
            "Total Duration": "إجمالي المدة",
            "Billable Time": "الوقت القابل للفوترة",
            "Billed Fee First": "الرسوم المحتسبة أولاً",
            "Billed Fee After": "الرسوم المحتسبة بعد ذلك",
            "Total Consultation Fee": "إجمالي رسوم الاستشارة",
            "Kundali Details": "تفاصيل الكوندلي",
            "Name": "الاسم",
            "Send Notification": "إرسال إشعار",
            "Continue Chat": "متابعة الدردشة",
            "Write message !!": "اكتب رسالة !!",
            "Astrologer Ai Assistant": "مساعد المنجم الذكي",
            "Ask anything about your horoscope...": "اسأل أي شيء عن برجك...",
            "Write message to assistant": "اكتب رسالة للمساعد",
            "Clear Chat?": "مسح الدردشة؟",
            "All messages will be deleted permanently.": "سيتم حذف جميع الرسائل نهائيًا.",
            "Clear": "مسح",
            "Payment faild !!": "فشل الدفع !!",
            "Please Complete Last Apointment !!": "يرجى إكمال الموعد الأخير !!",
            "Please enter comment !!": "يرجى إدخال تعليق !!",
            "Insufficient wallet balance !!": "رصيد المحفظة غير كافٍ !!",
            "Orders": "الطلبات",
            "Experience": "الخبرة",
            "Rating": "التقييم",
            "Unfollow": "إلغاء المتابعة",
            "Follow": "متابعة",
            "Send Gift": "إرسال هدية",
            "Start a Consultation": "ابدأ استشارة",
            "Chat with astrologer": "الدردشة مع المنجم",
            "For new user": "للمستخدم الجديد",
            "min free": "دقائق مجانية",
            "Call with astrologer": "مكالمة مع المنجم",
            "Video call with astrologer": "مكالمة فيديو مع المنجم",
            "Astrologer Bio": "نبذة عن المنجم",
            "Reviews": "المراجعات",
            "Activity": "النشاط",
            "FAQ's": "الأسئلة الشائعة",
            "Media": "الوسائط",
            "Comment": "تعليق",
            "No comment yet": "لا توجد تعليقات بعد",
            "start the conversation": "ابدأ المحادثة",
            "Poast your replay": "انشر ردك",
            "Delete comment": "حذف التعليق",
            "Are you sure you want to delete this comment?": "هل أنت متأكد أنك تريد حذف هذا التعليق؟",
            "Cancle": "إلغاء",
            "Delete": "حذف",
            "Intro Audio": "مقدمة صوتية",
            "Intro Video": "مقدمة فيديو",
            "Hear from": "استمع إلى",
            "Please select user !!": "يرجى اختيار المستخدم !!",
            "Please select amount !!": "يرجى اختيار المبلغ !!",
            "Please select payment method !!": "يرجى اختيار طريقة الدفع !!",
            "Select Kundli": "اختر الكوندلي",
            "Add Kundli": "إضافة كوندلي",
            "Minimum balance of": "الحد الأدنى للرصيد",
            "minutes": "دقائق",
            "is required to start chat with": "مطلوب لبدء الدردشة مع",
            "Wallet Balance": "رصيد المحفظة",
            "Required": "مطلوب",
            "Proceed to Pay": "المتابعة إلى الدفع",
            "extra in your": "إضافي في",
            "wallet with this": "محفظتك مع هذا",
            "Woohoo!": "رائع!",
            "Recharge Amount": "مبلغ الشحن",
            "GST": "ضريبة القيمة المضافة",
            "Wallet Amount": "مبلغ المحفظة",
            "Payble Amount": "المبلغ المستحق",
            "Pay from Wallet": "الدفع من المحفظة",
            "Available": "متاح",
            "Payment Getway Method": "طريقة بوابة الدفع",
            "Continue": "متابعة",
            "Fortune Cookie - Unveil Your Daily Wisdom": "كعكة الحظ - اكتشف حكمتك اليومية",
            "Crack open a fortune cookie to reveal a piece of daily wisdom. Let the message guide you through your day with positivity and insight.": "افتح كعكة الحظ لتكشف عن حكمة يومية. دع الرسالة ترشدك خلال يومك بإيجابية وبصيرة.",
            "Ask The Fortune Cookie": "اسأل كعكة الحظ",
            "Crack open your Fortune Cookie": "افتح كعكة الحظ الخاصة بك",
            "Crack another one open": "افتح واحدة أخرى",
            "Love Compatibility": "توافق الحب",
            "Find out how compatible you are with your lover, friend, or colleague using our love compatibility calculator. Get your results now.": "اكتشف مدى توافقك مع شريكك أو صديقك أو زميلك باستخدام حاسبة توافق الحب. احصل على نتائجك الآن.",
            "Are Aries And Taurus Compatible": "هل الحمل والثور متوافقان؟",
            "Aries And Taurus Strengths": "نقاط قوة الحمل والثور",
            "Aries And Taurus Weaknesses": "نقاط ضعف الحمل والثور",
            "Aries And Taurus Elements": "عناصر الحمل والثور",
            "Aries And Taurus Dates": "تواريخ الحمل والثور",
            "Are Aries And Taurus Compatibility Score": "درجة توافق الحمل والثور",
            "General": "عام",
            "Communication": "التواصل",
            "Sex": "العلاقة الحميمة",
            "Select Another": "اختر آخر",
            "Aries": "الحمل",
            "Taurus": "الثور",
            "Gemini": "الجوزاء",
            "Cancer": "السرطان",
            "Leo": "الأسد",
            "Virgo": "العذراء",
            "Libra": "الميزان",
            "Scorpio": "العقرب",
            "Sagittarius": "القوس",
            "Capricorn": "الجدي",
            "Aquarius": "الدلو",
            "Pisces": "الحوت",
            "Please select Your Partner Sign": "يرجى اختيار برج الشريك",
            "Please select Your Sign": "يرجى اختيار برجك",
            "Please fill all details !!": "يرجى ملء جميع التفاصيل !!",
            "Discover Your Core Numbers That Define You": "اكتشف أرقامك الأساسية التي تحدد شخصيتك",
            "Explore your core numbers like Life Path, Destiny, and Personal Year—complete with strengths, challenges, and meaningful interpretations.": "استكشف أرقامك الأساسية مثل مسار الحياة والقدر والسنة الشخصية، مع نقاط القوة والتحديات والتفسيرات المهمة.",
            "Get Your Numbers": "احصل على أرقامك",
            "First Name": "الاسم الأول",
            "Last Name": "اسم العائلة",
            "Method": "الطريقة",
            "Chaldean": "الكلدانية",
            "Pythagorean": "الفيثاغورية",
            "Strengths": "نقاط القوة",
            "Challenges": "التحديات",
            "Advice": "نصيحة",
            "Get Report": "احصل على التقرير",
            "Select Tarot One Card": "اختر بطاقة تاروت واحدة",
            "Select Your Card": "اختر بطاقتك",
            "Get Another": "احصل على أخرى",
            "Yes Or No Tarot": "تاروت نعم أو لا",
            "Get instant Yes or No answers to pressing questions.": "احصل على إجابات فورية بنعم أو لا لأسئلتك الملحة.",
            "Daily Tarot": "التاروت اليومي",
            "Receive daily tarot readings on love, career, and finance.": "احصل على قراءات يومية عن الحب والعمل والمال.",
            "In-Depth Love Reading": "قراءة حب متعمقة",
            "Deep dive into your love life with relationship-specific readings.": "تعمق في حياتك العاطفية بقراءات مخصصة للعلاقات.",
            "Flirt Love Reading": "قراءة حب مرحة",
            "Reveal insights into playful and romantic connections.": "اكشف رؤى حول العلاقات الرومانسية المرحة.",
            "Erotic Love Reading": "قراءة حب حميمة",
            "Insights into intimate and personal love dynamics.": "رؤى حول الديناميكيات العاطفية والحميمة.",
            "Egyptian Prediction": "التنبؤ المصري",
            "Access ancient Egyptian insights beyond visible truths.": "اكتشف الحكمة المصرية القديمة وراء الحقائق الظاهرة.",
            "Ex-Flame Reading": "قراءة الشريك السابق",
            "Explore the possibilities of rekindling with an ex-partner.": "استكشف إمكانية إعادة إحياء العلاقة مع الشريك السابق.",
            "Made For Each Other Or Not Reading": "قراءة هل أنتما مناسبين لبعضكما أم لا",
            "Discover if your relationship has long-term potential.": "اكتشف ما إذا كانت علاقتك تحمل إمكانات طويلة الأمد.",
            "Power Life Reading": "قراءة قوة الحياة",
            "Take control of your destiny with life-changing tarot readings.": "تحكم في مصيرك من خلال قراءات تاروت تغير حياتك.",
            "Know Your Friend Reading": "قراءة اعرف صديقك",
            "Understand the true intentions of your friendships.": "افهم النوايا الحقيقية في صداقاتك.",
            "Divine Angel Reading": "قراءة الملاك الإلهي",
            "Connect with divine guidance for clarity and spiritual insight.": "تواصل مع الإرشاد الإلهي للوضوح والبصيرة الروحية.",
            "Career Daily Reading": "قراءة مهنية يومية",
            "Elevate your career with daily tarot insights to achieve your professional goals.": "ارتقِ بمسيرتك المهنية مع إرشادات يومية لتحقيق أهدافك.",
            "Dream Come True Reading": "قراءة تحقق الأحلام",
            "Gain insights into making your dreams and goals a reality.": "احصل على رؤى لتحويل أحلامك وأهدافك إلى واقع.",
            "Past Lives Connection Reading": "قراءة ارتباط الحيوات السابقة",
            "Explore your journey across time to understand your path ahead.": "استكشف رحلتك عبر الزمن لفهم طريقك القادم.",
            "Please pick your cards !!": "يرجى اختيار بطاقاتك !!",
            "Get Your Reading": "احصل على قراءتك",
            "Select Tarot Two Card": "اختر بطاقتي تاروت",
            "Love Triangle Reading": "قراءة مثلث الحب",
            "Get clarity in choosing between multiple romantic interests.": "احصل على وضوح عند الاختيار بين اهتمامات عاطفية متعددة.",
            "Past-Present-Future Reading": "قراءة الماضي-الحاضر-المستقبل",
            "Zodiac Gift Guru": "خبير هدايا الأبراج",
            "January": "يناير",
            "February": "فبراير",
            "March": "مارس",
            "April": "أبريل",
            "May": "مايو",
            "June": "يونيو",
            "July": "يوليو",
            "August": "أغسطس",
            "September": "سبتمبر",
            "October": "أكتوبر",
            "November": "نوفمبر",
            "December": "ديسمبر",
            "Yesterday": "أمس",
            "Today": "اليوم",
            "Tomorrow": "غدًا",
            "Gift Recommendations": "اقتراحات الهدايا",
            "insight": "رؤية",
            "Career": "المهنة",
            "Love": "الحب",
            "Finance": "المال",
            "Popularity": "الشعبية",
            "Experience: High to Low": "الخبرة: من الأعلى إلى الأقل",
            "Experience: Low to High": "الخبرة: من الأقل إلى الأعلى",
            "Orders: High to Low": "الطلبات: من الأعلى إلى الأقل",
            "Orders: Low to High": "الطلبات: من الأقل إلى الأعلى",
            "Price: High to Low": "السعر: من الأعلى إلى الأقل",
            "Price: Low to High": "السعر: من الأقل إلى الأعلى",
            "Rating: High to Low": "التقييم: من الأعلى إلى الأقل",
            "Search name...": "ابحث عن اسم...",
            "Online": "متصل",
            "Busy": "مشغول",
            "Exp": "الخبرة",
            "yrs": "سنة",
            "orders": "الطلبات",
            "min": "دقيقة",
            "Chat Now": "الدردشة الآن",
            "Wait": "انتظار",
            "There are no astrologers in this category.": "لا يوجد منجمون في هذه الفئة.",
            "Sort": "ترتيب",
            "Filter": "تصفية",
            "Category": "الفئة",
            "All": "الكل",
            "Sort by": "ترتيب حسب",
            "Skill": "المهارة",
            "Language": "اللغة",
            "Reset": "إعادة تعيين",
            "Apply": "تطبيق",
            "You have 30 seconds left. Please recharge immediately to continue the conversation.": "لديك 30 ثانية متبقية. يرجى إعادة الشحن فورًا لمتابعة المحادثة.",
            "Free chat over! Next minutes will use wallet balance.": "انتهت الدردشة المجانية! سيتم خصم الدقائق التالية من رصيد المحفظة.",
            "Complete": "مكتمل",
            "End Chat": "إنهاء الدردشة",
            "Message": "رسالة",
            "Hi": "مرحبًا",
            "lets continue this chat at discounted price of": "لنواصل هذه الدردشة بسعر مخفض قدره",
            "Are you sure you want to end tha chat to": "هل أنت متأكد أنك تريد إنهاء الدردشة مع",
            "No": "لا",
            "Yes": "نعم",
            "Chat With Astrologer": "الدردشة مع المنجم",
            "Appointment List": "قائمة المواعيد",
            "My Following": "متابَعاتي",
            "Recent Post": "أحدث منشور",
            "Welcome back": "مرحبًا بعودتك",
            "Manage your astrology services": "إدارة خدماتك الفلكية",
            "Logout": "تسجيل الخروج",
            "Login": "تسجيل الدخول",
            "My Profile (Member Since)": "ملفي الشخصي (عضو منذ)",
            "My Followings": "الأشخاص الذين أتابعهم",
            "You are following": "أنت تتابع",
            "people": "أشخاص",
            "Years": "سنوات",
            "No Following Found !!": "لم يتم العثور على متابعات !!",
            "Currently you don't have any follow.": "حاليًا لا تتابع أي شخص.",
            "Hey There!": "مرحبًا!",
            "What is your name?": "ما اسمك؟",
            "Enter your first Name": "أدخل اسمك الأول",
            "Enter your last Name": "أدخل اسم العائلة",
            "male": "ذكر",
            "female": "أنثى",
            "Where wrer you bron?": "أين وُلدت؟",
            "Please Select Language": "يرجى اختيار اللغة",
            "english": "الإنجليزية",
            "hindi": "الهندية",
            "north": "شمالي",
            "south": "جنوبي",
            "Select Chart Type": "اختر نوع الخريطة",
            "Start chat with astrologer": "ابدأ الدردشة مع المنجم",
            "Search location": "ابحث عن موقع",
            "Location not found !!": "الموقع غير موجود !!",
            "Enter bord state": "أدخل الولاية أو المنطقة",
            "Search location...": "ابحث عن موقع...",
            "Astrologers": "المنجمون",
            "Top Astrologers. 24 * 7 customer support. Happy to help": "أفضل المنجمين. دعم عملاء 24/7. سعداء بمساعدتك.",
            "per min": "لكل دقيقة",
            "Top Astrologers": "أفضل المنجمين",
            "rate": "التقييم",
            "Top Rated Astrologers": "أعلى المنجمين تقييمًا",
            "No astrologers found !!": "لم يتم العثور على منجمين !!",
            "FAQs": "الأسئلة الشائعة",
            "Raning": "التقييم",
            "Raning Apointment": "تقييم الموعد",
            "Select Other Sign": "اختر برجًا آخر",
            "Horoscopes": "الأبراج",
            "Daily Horoscope": "البرج اليومي",
            "Weekly Horoscope": "البرج الأسبوعي",
            "Monthly Horoscope": "البرج الشهري",
            "Yearly Horoscope": "البرج السنوي",
            "Composite Friendship Table": "جدول الصداقة المركب",
            "Kp Planetary Details": "تفاصيل الكواكب KP",
            "Kp House Cusps And Chart": "حدود البيوت ومخطط KP",
            "Ascendant Report": "تقرير الطالع",
            "Bhava Kundli": "بهافا كوندلي",
            "Vimshottari Dasha": "فيمشوتاري داشا",
            "Yogini Dasha": "يوجيني داشا",
            "Sadhesati Analysis": "تحليل ساديساتي",
            "Sadhesati Life Analysis": "تحليل ساديساتي للحياة",
            "Kalsarpa Dosha": "كال ساربا دوشا",
            "Manglik Analysis": "تحليل مانجليك",
            "Planet Profiles": "ملفات الكواكب",
            "Gemstone Suggestions": "اقتراحات الأحجار الكريمة",
            "Upagraha": "أوباغراها",
            "Jaimini Astrology": "تنجيم جيميني",
            "Chara Dasha": "تشارا داشا",
            "Shadbala": "شادبالا",
            "Sudarshana Chakra": "سودارشان شاكرا",
            "Bhinnashtakvarga": "بهيناشتاكفارجا",
            "Yogas": "يوغا",
            "Introduction": "مقدمة",
            "Basic Astrological Details": "التفاصيل الفلكية الأساسية",
            "Planetary Positions": "مواقع الكواكب",
            "Horoscope Charts": "خرائط الأبراج",
            "House Cusps And Sandhi": "حدود البيوت وساندهي",
            "Divisional Charts": "الخرائط التقسيمية",
            "Basic Details": "تفاصيل أساسية",
            "Ghat Chakra": "غات شاكرا",
            "Panchange Details": "تفاصيل بانشانج",
            "Astrological Details": "التفاصيل الفلكية",
            "Time of Birth": "وقت الميلاد",
            "Place of Birth": "مكان الميلاد",
            "Latitude": "خط العرض",
            "Longitude": "خط الطول",
            "Timezone": "المنطقة الزمنية",
            "Ayanamsa": "أياناَمسا",
            "Sunrise": "شروق الشمس",
            "Sunset": "غروب الشمس",
            "Month": "الشهر",
            "Tithi": "تيثي",
            "Yoga": "يوغا",
            "Karana": "كارانا",
            "Moon Sign": "برج القمر",
            "Moon Vaar": "يوم القمر",
            "Nakshatra": "ناكشاترا",
            "Varna": "فارنا",
            "Vashya": "فاشيا",
            "Yoni": "يوني",
            "Gana": "جانا",
            "Nadi": "نادي",
            "Sun Sign": "برج الشمس",
            "Tatva": "تاتفا",
            "Paya": "بايا",
            "Yanja": "يانجا",
            "Planets": "الكواكب",
            "Sign": "البرج",
            "Sign No": "رقم البرج",
            "LAGNA CHART (BIRTH CHART)": "خريطة الطالع (خريطة الميلاد)",
            "MOON CHART": "خريطة القمر",
            "NAVMANSHA CHART (D9)": "خريطة نافامشا (D9)",
            "House": "البيت",
            "Bhav Madhya": "بهاف ماديا",
            "Bhav Sandhi": "بهاف ساندي",
            "Chalit Chart": "خريطة تشاليت",
            "Sun Chart": "خريطة الشمس",
            "Health, Constitution, Body": "الصحة، البنية، الجسد",
            "Hora Chart(D2)": "خريطة هورا (D2)",
            "Finance, Wealth, Prosperity": "المال، الثروة، الازدهار",
            "Dreshkan Chart(D3)": "خريطة دريشكان (D3)",
            "Brothers, Sisters": "الإخوة، الأخوات",
            "Chathurthamasha Chart(D4)": "خريطة تشاتورثاماشا (D4)",
            "Fortunes, Luck of native": "الحظوظ، حظ المولود",
            "Saptamansha Chart(D7)": "خريطة سبتامانشا (D7)",
            "Impregnation, Birth of the child": "الحمل، ولادة الطفل",
            "Dashamansha Chart(D10)": "خريطة داشامانشا (D10)",
            "livelihood, Profession": "المعيشة، المهنة",
            "Dwadasha Chart(D12)": "خريطة دواداشا (D12)",
            "Parents, paternal happiness": "الوالدان، السعادة الأبوية",
            "Shodashamsha Chart(D16)": "خريطة شوداشامشا (D16)",
            "Happiness, miseries, conveyance": "السعادة، المتاعب، وسائل النقل",
            "Vishamansha Chart(D20)": "خريطة فيشامانشا (D20)",
            "Spiritual progress, worship": "التقدم الروحي، العبادة",
            "Chaturvimshamsha(D24)": "تشاتورفيمشامشا (D24)",
            "Academic achievement, education": "التحصيل الأكاديمي، التعليم",
            "Bhamsha Chart(D27)": "خريطة بهامشا (D27)",
            "Physical strength, stamina": "القوة البدنية، القدرة على التحمل",
            "Trishamansha Chart(D30)": "خريطة تريشامانشا (D30)",
            "Evil, Adversities of life": "الشرور، مصاعب الحياة",
            "Khavedamsha Chart(D40)": "خريطة خافيدامشا (D40)",
            "Auspicious & inauspicious effect": "التأثيرات المباركة وغير المباركة",
            "Akshvedansha Chart(D45)": "خريطة أكشفيدانشا (D45)",
            "Character and couduct of the native": "شخصية وسلوك المولود",
            "Shashtymsah Chart(D60)": "خريطة شاشتيمشاه (D60)",
            "Shows general happiness": "يُظهر السعادة العامة",
            "Degrees": "الدرجات",
            "Sign Lord": "حاكم البرج",
            "Nakshatra Lord": "حاكم النكشاترا",
            "Sub Lord": "الحاكم الفرعي",
            "Sub Sub Lord": "الحاكم الفرعي الثانوي",
            "Lord": "الحاكم",
            "Symbol": "الرمز",
            "Characteristics": "الخصائص",
            "Day of Fast": "يوم الصيام",
            "luchy Gems": "الأحجار الكريمة المحظوظة",
            "Personality": "الشخصية",
            "Health": "الصحة",
            "Relationships": "العلاقات",
            "BHAVA KUNDLI": "بهافا كوندلي",
            "Bhramari": "بهراماري",
            "Bhadrika": "بهادريكا",
            "Ulka": "أولكا",
            "Siddha": "سيده",
            "Sankata": "سانكاتا",
            "Mangala": "مانجالا",
            "Pingala": "بينجالا",
            "Dhanya": "دهنيا",
            "Remedies Of Sadhesati": "علاجات سادي ساتي",
            "Saturn Sign": "برج زحل",
            "Is Saturn Retro?": "هل زحل متراجع؟",
            "Phase": "المرحلة",
            "Intensity": "الشدة",
            "Direction": "الاتجاه",
            "Strength": "القوة",
            "Percentage": "النسبة المئوية",
            "Zodiac Sign": "البرج",
            "Planet Degree": "درجة الكوكب",
            "Lord Of": "حاكم",
            "Combust/Aw...": "محترق/ضعيف...",
            "Lucky Stone": "الحجر المحظوظ",
            "Life Stone": "حجر الحياة",
            "Finger": "الإصبع",
            "Day": "اليوم",
            "Time to Wear": "وقت الارتداء",
            "Mantra": "المانترا",
            "Upagraha Longitude": "خط طول أوباغراها",
            "Rashi": "راشي",
            "Pada": "بادا",
            "Upagraha/Nakshatra/Sub Lord": "أوباغراها/نكشاترا/الحاكم الفرعي",
            "Jamini Planets": "كواكب جاميني",
            "Jamini Padas": "بادات جاميني",
            "Code": "الرمز",
            "Jamini Karakara": "كاراكا جاميني",
            "Uchcha Bala": "أوتشا بالا",
            "Saptavarga Bala": "سابتاڤارغا بالا",
            "Yugmayugma Bhamsha Bala": "يوغمايوغما بهامشا بالا",
            "Kendradi Bala": "كندرادي بالا",
            "Drekkana Bala": "دريككانا بالا",
            "Total Sthana Bala": "إجمالي ستانا بالا",
            "Total Dig Bala": "إجمالي ديغ بالا",
            "Nattunnata Bala": "ناتوناتا بالا",
            "Paksha Bala": "باكشا بالا",
            "Tribhaga Bala": "تريبهاجا بالا",
            "Varshadhipati": "فارشدهيباتي",
            "Maasadipati": "ماسادهيباتي",
            "Vaaradhipati": "فارادهيباتي",
            "Horadhipati": "هورادهيباتي",
            "Ayana Bala": "أيانا بالا",
            "Yuddha Bala": "يوده بالا",
            "Total Kaal Bala": "إجمالي كال بالا",
            "Naisargika Bala": "نيسارغيكا بالا",
            "Chestha Bala": "تشِشتا بالا",
            "Drik Bala": "دريك بالا",
            "Total Shadbala": "إجمالي شادبالا",
            "Shadbala In Rupa": "شادبالا بالروبا",
            "Min Require": "الحد الأدنى المطلوب",
            "Ratio": "النسبة",
            "Rank": "الترتيب",
            "Sun": "الشمس",
            "Moon": "القمر",
            "Mars": "المريخ",
            "Mercury": "عطارد",
            "Jupiter": "المشتري",
            "Venus": "الزهرة",
            "Saturn": "زحل",
            "Ashtakvarga": "أشتاكفارجا",
            "Sarvashtakava": "سارفاشتكافا",
            "Prasthara Chakra": "براستهارا تشاكرا",
            "Ascendant": "الطالع",
            "Total": "الإجمالي",
            "Natural Friendship": "الصداقة الطبيعية",
            "Temporary Friendship": "الصداقة المؤقتة",
            "Five Fold Friendship": "الصداقة الخماسية",
            "Ketu": "كيتو",
            "Rahu": "راهو",
            "Vimshottari Dasha P1": "فيمشوتاري داشا P1",
            "Vimshottari Dasha P2": "فيمشوتاري داشا P2",
            "AshtaKoot": "أشتاكوت",
            "Bhakut Dosha": "بهاكوت دوشا",
            "Nadi Dosha": "نادي دوشا",
            "Ashtakoot Analysis": "تحليل أشتاكوت",
            "DashaKoot": "داشاكوت",
            "Personality Report": "تقرير الشخصية",
            "Match Making Report": "تقرير التوافق",
            "Nav Pancham Yoga": "ناف بانشام يوجا",
            "Charan": "تشاران",
            "Name Alphabet": "حرف الاسم",
            "Planetary Position": "مواضع الكواكب",
            "Lagna Chart (Birth Chart)": "خريطة لاغنا (خريطة الميلاد)",
            "Moon Chart": "خريطة القمر",
            "Navmansha Chart (D9)": "خريطة نافمانشا (D9)",
            "Mahadasha": "مهادشا",
            "End": "النهاية",
            "Is Recommended ??": "هل يُنصح به؟",
            "Manglik Details": "تفاصيل مانجليك",
            "What is AshtaKoot ??": "ما هو أشتاكوت؟",
            "Attributes": "السمات",
            "Description": "الوصف",
            "Received": "تم الاستلام",
            "Graha Maitri": "غراها مايتري",
            "Bhakoota": "بهاكوتا",
            "What is BhaKoot Dosha ??": "ما هو بهاكوت دوشا؟",
            "What is Nadi Dosha ??": "ما هو نادي دوشا؟",
            "Madhya": "ماديا",
            "Nadi dosha is present": "يوجد نادي دوشا",
            "The": "الـ",
            "porutham considered for horoscope matching are as follows :": "عوامل بورثام المعتمدة لتوافق الأبراج هي كما يلي:",
            "Dina": "دينا",
            "Rajju": "راجو",
            "Rasyadhipati": "راسيادهيباتي",
            "Vedha": "فيده",
            "Mahendra": "ماهيندرا",
            "Streedargha": "ستريدارغا",
            "Uranus": "أورانوس",
            "Neptune": "نبتون",
            "Pluto": "بلوتو",
            "Tara": "تارا",
            "Please fill boy's details !!": "يرجى إدخال بيانات الشاب !!",
            "Please fill girl's details !!": "يرجى إدخال بيانات الفتاة !!",
            "Please fill chart details !!": "يرجى إدخال تفاصيل الخريطة !!",
            "Kundli Matching": "توافق الكوندلي",
            "Find your right one, through matchmaking": "اعثر على شريكك المناسب من خلال التوافق",
            "Open Kundli": "فتح الكوندلي",
            "New Matching": "توافق جديد",
            "View Kundli": "عرض الكوندلي",
            "Boy's Details": "بيانات الشاب",
            "Girl's Details": "بيانات الفتاة",
            "Search city, state, country": "ابحث عن المدينة، الولاية، الدولة",
            "Enter first name": "أدخل الاسم الأول",
            "Enter last name": "أدخل اسم العائلة",
            "Chart Style": "نمط الخريطة",
            "North Indian": "شمال هندي",
            "South Indian": "جنوب هندي",
            "English": "الإنجليزية",
            "Hindi": "الهندية",
            "MATCH HOROSCOPE": "مطابقة الأبراج",
            "My Profile": "ملفي الشخصي",
            "Enter full name": "أدخل الاسم الكامل",
            "Enter email address": "أدخل عنوان البريد الإلكتروني",
            "Enter password": "أدخل كلمة المرور",
            "Enter phone number": "أدخل رقم الهاتف",
            "Save Chanage": "حفظ التغييرات",
            "Manage your astrologers recent post": "إدارة أحدث منشورات المنجمين",
            "Show Less": "عرض أقل",
            "Show More": "عرض المزيد",
            "Total Balance": "إجمالي الرصيد",
            "Add Money": "إضافة رصيد",
            "Extra": "إضافي",
            "Transaction History": "سجل المعاملات",
            "Build better products with flexible tools, helpful documentation,": "أنشئ منتجات أفضل باستخدام أدوات مرنة ووثائق مفيدة،",
            "and a team that champions your growth.": "وفريق يدعم نموك.",
            "Useful Link": "روابط مفيدة",
            "Socials": "وسائل التواصل",
            "Logout Seccuessfuly !!": "تم تسجيل الخروج بنجاح !!",
            "Free Kundli": "كوندلي مجاني",
            "Horoscope": "الأبراج",
            "Dashboard": "لوحة التحكم",
            "Enter your feedback !!": "أدخل ملاحظاتك !!",
            "Languages": "اللغات",
            "incoming": "وارد",
            "request from": "طلب من",
            "Waitlist Joined !!": "تم الانضمام إلى قائمة الانتظار !!",
            "will start in": "سيبدأ خلال",
            "You will receive a": "سوف تستلم",
            "request when the": "طلبًا عندما يكون",
            "astrologer is ready. Don’t worry! You will not be": "المنجم جاهزًا. لا تقلق! لن يتم",
            "charged for missing this session.": "تحصيل رسوم في حال فاتتك هذه الجلسة.",
            "Accept": "قبول",
            "Reject": "رفض",
            "Great, what did you like the mast? 😍": "رائع، ما أكثر شيء أعجبك؟ 😍",
            "Skip": "تخطي",
            "Payment Information": "معلومات الدفع",
            "Amount": "المبلغ",
            "Tax": "الضريبة",
            "Payment": "الدفع",
            "Payment Method": "طريقة الدفع",
        
            "AstroSpace": "AstroSpace",
            "Astrology Consultation Platform": "Astrology Consultation Platform",
            "INVOICE": "INVOICE",
            "Consultation Service Receipt": "Consultation Service Receipt",
            "Invoice Number": "Invoice Number",
            "Date Issued": "Date Issued",
            "PAID": "PAID",
            "From": "From",
            "Bill To": "Bill To",
            "Service": "Service",
            "Booking ID": "Booking ID",
            "Description": "Description",
            "Duration": "Duration",
            "Rate": "Rate",
            "Amount": "Amount",
            "Free Consultation Time": "Free Consultation Time",
            "Complimentary session minutes": "Complimentary session minutes",
            "Free": "Free",
            "Consultation Fee": "Consultation Fee",
            "Standard rate (first block)": "Standard rate (first block)",
            "Extended Consultation Fee": "Extended Consultation Fee",
            "Premium rate (extended block)": "Premium rate (extended block)",
            "Consultation Service": "Consultation Service",
            "Astrology consultation session": "Astrology consultation session",
            "Subtotal": "Subtotal",
            "Platform Fee": "Platform Fee",
            "Included": "Included",
            "Total Amount": "Total Amount",
            "DOB": "DOB",
            "Kundali Chart Used": "Kundali Chart Used",
            "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.": "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.",
            "For support, contact us at support@astrospace.com": "For support, contact us at support@astrospace.com",
            "Free Minute": "Free Minute",
            "Verified": "Verified",
            "End Session": "End Session",
            "Voice Call": "Voice Call",
            "typing...": "typing...",
            "CANCEL": "CANCEL",
            "OK": "OK",
            "Install Progressive Web Application": "Install Progressive Web Application",
            "This site has app functionality. Install it on your device for extensive experience and easy access.": "This site has app functionality. Install it on your device for extensive experience and easy access.",
            "Install": "Install",
            "Search location": "Search location",
            "Location not found !!": "Location not found !!",
            "Waiting for remote user to join...": "Waiting for remote user to join...",
            "End Video Session": "End Video Session",
            "Initializing WebRTC P2P...": "Initializing WebRTC P2P...",
            "Access Denied (Camera/Mic)": "Access Denied (Camera/Mic)",
            "Connection Failed": "Connection Failed",
            "Time Remaining": "Time Remaining",
            "Call ended": "Call ended",

            "Offline": "Offline",}
    },
    bn: {
        translation: {
            "Enter Mobile Number !!": "মোবাইল নম্বর লিখুন !!",
            "In Valid OTP !!": "অবৈধ ওটিপি !!",
            "Please enter password !!": "অনুগ্রহ করে পাসওয়ার্ড লিখুন !!",
            "Password not match !!": "পাসওয়ার্ড মিলছে না !!",
            "Reset Password": "পাসওয়ার্ড রিসেট করুন",
            "Enter your phone number and new password": "আপনার ফোন নম্বর ও নতুন পাসওয়ার্ড লিখুন",
            "Phone Number": "ফোন নম্বর",
            "Enter your number": "আপনার নম্বর লিখুন",
            "Search": "অনুসন্ধান",
            "Verify": "যাচাই করুন",
            "You will receive a 6 digit code for": "আপনি একটি ৬ সংখ্যার কোড পাবেন",
            "verification to": "যাচাইকরণের জন্য",
            "Submit": "জমা দিন",
            "Enter your password and new password": "আপনার বর্তমান ও নতুন পাসওয়ার্ড লিখুন",
            "New Password": "নতুন পাসওয়ার্ড",
            "Enter new password": "নতুন পাসওয়ার্ড লিখুন",
            "Confirm New Password": "নতুন পাসওয়ার্ড নিশ্চিত করুন",
            "Confirm new password": "নতুন পাসওয়ার্ড নিশ্চিত করুন",
            "Back to Login": "লগইনে ফিরে যান",
            "Back": "ফিরে যান",
            "Enter Login Details !!": "লগইন তথ্য লিখুন !!",
            "Welcome Back!": "আবার স্বাগতম!",
            "Sign in to your account": "আপনার অ্যাকাউন্টে সাইন ইন করুন",
            "Password": "পাসওয়ার্ড",
            "Enter your password": "আপনার পাসওয়ার্ড লিখুন",
            "Forgot Password?": "পাসওয়ার্ড ভুলে গেছেন?",
            "Sign In": "সাইন ইন",
            "Don't have an account?": "অ্যাকাউন্ট নেই?",
            "Sign Up": "সাইন আপ",
            "Please enter all details !!": "অনুগ্রহ করে সব তথ্য লিখুন !!",
            "Please enter valid email !!": "অনুগ্রহ করে সঠিক ইমেইল লিখুন !!",
            "Please enter birth place !!": "অনুগ্রহ করে জন্মস্থান লিখুন !!",
            "Please select language !!": "অনুগ্রহ করে ভাষা নির্বাচন করুন !!",
            "Step": "ধাপ",
            "Enter Your Details": "আপনার তথ্য লিখুন",
            "Hey there! what is your name?": "হ্যালো! আপনার নাম কী?",
            "Full Name": "পূর্ণ নাম",
            "Email Address": "ইমেইল ঠিকানা",
            "Enter your Full Name": "আপনার পূর্ণ নাম লিখুন",
            "Enter your email": "আপনার ইমেইল লিখুন",
            "What is your gender?": "আপনার লিঙ্গ কী?",
            "Male": "পুরুষ",
            "Female": "মহিলা",
            "Enter your birth date": "আপনার জন্মতারিখ লিখুন",
            "Enter your birth time": "আপনার জন্মসময় লিখুন",
            "Enter your birth Place": "আপনার জন্মস্থান লিখুন",
            "Do you know which languages?": "আপনি কোন ভাষাগুলো জানেন?",
            "Enter Your Place": "আপনার স্থান লিখুন",
            "Back to Step": "ধাপে ফিরে যান",
            "Next": "পরবর্তী",
            "My Appointments": "আমার অ্যাপয়েন্টমেন্ট",
            "Manage your astrology consultations": "আপনার জ্যোতিষ পরামর্শ পরিচালনা করুন",
            "Upcoming": "আসন্ন",
            "Past": "পূর্ববর্তী",
            "Pending": "মুলতুবি",
            "Accepted": "গৃহীত",
            "Start": "শুরু",
            "Completed": "সম্পন্ন",
            "Canceled": "বাতিল",
            "ID": "আইডি",
            "Chat": "চ্যাট",
            "Audio Call": "অডিও কল",
            "Video Call": "ভিডিও কল",
            "View Details": "বিস্তারিত দেখুন",
            "Cancel": "বাতিল করুন",
            "No Upcoming Appointment Found !!": "কোনো আসন্ন অ্যাপয়েন্টমেন্ট পাওয়া যায়নি !!",
            "Currently you don't have any upcoming appointment.": "বর্তমানে আপনার কোনো আসন্ন অ্যাপয়েন্টমেন্ট নেই।",
            "No Past Appointment Found !!": "কোনো পূর্ববর্তী অ্যাপয়েন্টমেন্ট পাওয়া যায়নি !!",
            "Currently you don't have any past appointment.": "বর্তমানে আপনার কোনো পূর্ববর্তী অ্যাপয়েন্টমেন্ট নেই।",
            "Status": "অবস্থা",
            "Service Type": "সেবার ধরন",
            "Date": "তারিখ",
            "Time": "সময়",
            "Price": "মূল্য",
            "Booked Person Details": "বুক করা ব্যক্তির বিবরণ",
            "name": "নাম",
            "Date of Birth": "জন্মতারিখ",
            "Birth Place": "জন্মস্থান",
            "Gender": "লিঙ্গ",
            "Complete Details": "সম্পূর্ণ বিবরণ",
            "Start Time": "শুরুর সময়",
            "End Time": "শেষের সময়",
            "Total Duration": "মোট সময়কাল",
            "Billable Time": "বিলযোগ্য সময়",
            "Billed Fee First": "প্রথম বিলকৃত ফি",
            "Billed Fee After": "পরবর্তী বিলকৃত ফি",
            "Total Consultation Fee": "মোট পরামর্শ ফি",
            "Kundali Details": "কুণ্ডলী বিবরণ",
            "Name": "নাম",
            "Send Notification": "নোটিফিকেশন পাঠান",
            "Continue Chat": "চ্যাট চালিয়ে যান",
            "Write message !!": "বার্তা লিখুন !!",
            "Astrologer Ai Assistant": "জ্যোতিষ এআই সহকারী",
            "Ask anything about your horoscope...": "আপনার রাশিফল সম্পর্কে যেকোনো কিছু জিজ্ঞাসা করুন...",
            "Write message to assistant": "সহকারীকে বার্তা লিখুন",
            "Clear Chat?": "চ্যাট মুছে ফেলবেন?",
            "All messages will be deleted permanently.": "সব বার্তা স্থায়ীভাবে মুছে যাবে।",
            "Clear": "মুছুন",
            "Payment faild !!": "পেমেন্ট ব্যর্থ হয়েছে !!",
            "Please Complete Last Apointment !!": "অনুগ্রহ করে শেষ অ্যাপয়েন্টমেন্ট সম্পূর্ণ করুন !!",
            "Please enter comment !!": "অনুগ্রহ করে মন্তব্য লিখুন !!",
            "Insufficient wallet balance !!": "ওয়ালেট ব্যালেন্স অপর্যাপ্ত !!",
            "Orders": "অর্ডার",
            "Experience": "অভিজ্ঞতা",
            "Rating": "রেটিং",
            "Unfollow": "আনফলো",
            "Follow": "ফলো",
            "Send Gift": "উপহার পাঠান",
            "Start a Consultation": "পরামর্শ শুরু করুন",
            "Chat with astrologer": "জ্যোতিষীর সাথে চ্যাট করুন",
            "For new user": "নতুন ব্যবহারকারীর জন্য",
            "min free": "মিনিট ফ্রি",
            "Call with astrologer": "জ্যোতিষীর সাথে কল করুন",
            "Video call with astrologer": "জ্যোতিষীর সাথে ভিডিও কল করুন",
            "Astrologer Bio": "জ্যোতিষীর পরিচিতি",
            "Reviews": "রিভিউ",
            "Activity": "কার্যক্রম",
            "FAQ's": "প্রশ্নোত্তর",
            "Media": "মিডিয়া",
            "Comment": "মন্তব্য",
            "No comment yet": "এখনও কোনো মন্তব্য নেই",
            "start the conversation": "আলাপ শুরু করুন",
            "Poast your replay": "আপনার উত্তর পোস্ট করুন",
            "Delete comment": "মন্তব্য মুছুন",
            "Are you sure you want to delete this comment?": "আপনি কি নিশ্চিত যে এই মন্তব্যটি মুছতে চান?",
            "Cancle": "বাতিল",
            "Delete": "মুছুন",
            "Intro Audio": "ইন্ট্রো অডিও",
            "Intro Video": "ইন্ট্রো ভিডিও",
            "Hear from": "শুনুন",
            "Please select user !!": "অনুগ্রহ করে ব্যবহারকারী নির্বাচন করুন !!",
            "Please select amount !!": "অনুগ্রহ করে পরিমাণ নির্বাচন করুন !!",
            "Please select payment method !!": "অনুগ্রহ করে পেমেন্ট পদ্ধতি নির্বাচন করুন !!",
            "Select Kundli": "কুণ্ডলী নির্বাচন করুন",
            "Add Kundli": "কুণ্ডলী যোগ করুন",
            "Minimum balance of": "ন্যূনতম ব্যালেন্স",
            "minutes": "মিনিট",
            "is required to start chat with": "এর সাথে চ্যাট শুরু করতে প্রয়োজন",
            "Wallet Balance": "ওয়ালেট ব্যালেন্স",
            "Required": "প্রয়োজন",
            "Proceed to Pay": "পেমেন্টে এগিয়ে যান",
            "extra in your": "অতিরিক্ত আপনার",
            "wallet with this": "ওয়ালেটে এর সাথে",
            "Woohoo!": "ইয়াহু!",
            "Recharge Amount": "রিচার্জ পরিমাণ",
            "GST": "জিএসটি",
            "Wallet Amount": "ওয়ালেট পরিমাণ",
            "Payble Amount": "পরিশোধযোগ্য পরিমাণ",
            "Pay from Wallet": "ওয়ালেট থেকে পরিশোধ করুন",
            "Available": "উপলব্ধ",
            "Payment Getway Method": "পেমেন্ট গেটওয়ে পদ্ধতি",
            "Continue": "চালিয়ে যান",
            "Fortune Cookie - Unveil Your Daily Wisdom": "ফরচুন কুকি - আপনার দৈনিক জ্ঞান উন্মোচন করুন",
            "Crack open a fortune cookie to reveal a piece of daily wisdom. Let the message guide you through your day with positivity and insight.": "একটি ফরচুন কুকি ভেঙে দৈনিক জ্ঞানের বার্তা জানুন। এই বার্তাটি ইতিবাচকতা ও অন্তর্দৃষ্টির মাধ্যমে আপনার দিনকে পরিচালিত করুক।",
            "Ask The Fortune Cookie": "ফরচুন কুকিকে জিজ্ঞাসা করুন",
            "Crack open your Fortune Cookie": "আপনার ফরচুন কুকি খুলুন",
            "Crack another one open": "আরেকটি খুলুন",
            "Love Compatibility": "ভালোবাসার সামঞ্জস্য",
            "Find out how compatible you are with your lover, friend, or colleague using our love compatibility calculator. Get your results now.": "আমাদের লাভ কম্প্যাটিবিলিটি ক্যালকুলেটর ব্যবহার করে আপনার প্রেমিক/প্রেমিকা, বন্ধু বা সহকর্মীর সাথে আপনার সামঞ্জস্য জানুন। এখনই ফলাফল পান।",
            "Are Aries And Taurus Compatible": "মেষ ও বৃষ কি সামঞ্জস্যপূর্ণ?",
            "Aries And Taurus Strengths": "মেষ ও বৃষের শক্তি",
            "Aries And Taurus Weaknesses": "মেষ ও বৃষের দুর্বলতা",
            "Aries And Taurus Elements": "মেষ ও বৃষের উপাদান",
            "Aries And Taurus Dates": "মেষ ও বৃষের তারিখ",
            "Are Aries And Taurus Compatibility Score": "মেষ ও বৃষের সামঞ্জস্য স্কোর",
            "General": "সাধারণ",
            "Communication": "যোগাযোগ",
            "Sex": "যৌনতা",
            "Select Another": "অন্যটি নির্বাচন করুন",
            "Aries": "মেষ",
            "Taurus": "বৃষ",
            "Gemini": "মিথুন",
            "Cancer": "কর্কট",
            "Leo": "সিংহ",
            "Virgo": "কন্যা",
            "Libra": "তুলা",
            "Scorpio": "বৃশ্চিক",
            "Sagittarius": "ধনু",
            "Capricorn": "মকর",
            "Aquarius": "কুম্ভ",
            "Pisces": "মীন",
            "Please select Your Partner Sign": "অনুগ্রহ করে আপনার সঙ্গীর রাশি নির্বাচন করুন",
            "Please select Your Sign": "অনুগ্রহ করে আপনার রাশি নির্বাচন করুন",
            "Please fill all details !!": "অনুগ্রহ করে সব তথ্য পূরণ করুন !!",
            "Discover Your Core Numbers That Define You": "আপনার পরিচয় নির্ধারণকারী মূল সংখ্যা আবিষ্কার করুন",
            "Explore your core numbers like Life Path, Destiny, and Personal Year—complete with strengths, challenges, and meaningful interpretations.": "লাইফ পাথ, ডেসটিনি এবং পার্সোনাল ইয়ার-এর মতো আপনার মূল সংখ্যা জানুন—শক্তি, চ্যালেঞ্জ এবং অর্থপূর্ণ বিশ্লেষণসহ।",
            "Get Your Numbers": "আপনার সংখ্যা পান",
            "First Name": "প্রথম নাম",
            "Last Name": "শেষ নাম",
            "Method": "পদ্ধতি",
            "Chaldean": "ক্যালডিয়ান",
            "Pythagorean": "পিথাগোরিয়ান",
            "Strengths": "শক্তি",
            "Challenges": "চ্যালেঞ্জ",
            "Advice": "পরামর্শ",
            "Get Report": "রিপোর্ট পান",
            "Select Tarot One Card": "একটি ট্যারোট কার্ড নির্বাচন করুন",
            "Select Your Card": "আপনার কার্ড নির্বাচন করুন",
            "Get Another": "আরেকটি নিন",
            "Yes Or No Tarot": "হ্যাঁ বা না ট্যারোট",
            "Get instant Yes or No answers to pressing questions.": "গুরুত্বপূর্ণ প্রশ্নের তাৎক্ষণিক হ্যাঁ বা না উত্তর পান।",
            "Daily Tarot": "দৈনিক ট্যারোট",
            "Receive daily tarot readings on love, career, and finance.": "ভালোবাসা, ক্যারিয়ার ও অর্থ নিয়ে দৈনিক ট্যারোট রিডিং পান।",
            "In-Depth Love Reading": "গভীর ভালোবাসার রিডিং",
            "Deep dive into your love life with relationship-specific readings.": "সম্পর্কভিত্তিক রিডিংয়ের মাধ্যমে আপনার প্রেমজীবনে গভীরভাবে প্রবেশ করুন।",
            "Flirt Love Reading": "ফ্লার্ট লাভ রিডিং",
            "Reveal insights into playful and romantic connections.": "খেলাচ্ছলে ও রোমান্টিক সম্পর্কের অন্তর্দৃষ্টি জানুন।",
            "Erotic Love Reading": "এরোটিক লাভ রিডিং",
            "Insights into intimate and personal love dynamics.": "ঘনিষ্ঠ ও ব্যক্তিগত সম্পর্কের অন্তর্দৃষ্টি।",
            "Egyptian Prediction": "মিশরীয় ভবিষ্যদ্বাণী",
            "Access ancient Egyptian insights beyond visible truths.": "দৃশ্যমান সত্যের বাইরে প্রাচীন মিশরীয় জ্ঞান লাভ করুন।",
            "Ex-Flame Reading": "এক্স-ফ্লেম রিডিং",
            "Explore the possibilities of rekindling with an ex-partner.": "প্রাক্তন সঙ্গীর সাথে পুনর্মিলনের সম্ভাবনা জানুন।",
            "Made For Each Other Or Not Reading": "একসাথে থাকার উপযুক্ত কিনা রিডিং",
            "Discover if your relationship has long-term potential.": "আপনার সম্পর্কের দীর্ঘমেয়াদি সম্ভাবনা আছে কিনা জানুন।",
            "Power Life Reading": "পাওয়ার লাইফ রিডিং",
            "Take control of your destiny with life-changing tarot readings.": "জীবন পরিবর্তনকারী ট্যারোট রিডিংয়ের মাধ্যমে আপনার ভাগ্যের নিয়ন্ত্রণ নিন।",
            "Know Your Friend Reading": "আপনার বন্ধুকে জানুন রিডিং",
            "Understand the true intentions of your friendships.": "আপনার বন্ধুত্বের প্রকৃত উদ্দেশ্য বুঝুন।",
            "Divine Angel Reading": "ডিভাইন অ্যাঞ্জেল রিডিং",
            "Connect with divine guidance for clarity and spiritual insight.": "স্পষ্টতা ও আধ্যাত্মিক অন্তর্দৃষ্টির জন্য ঐশ্বরিক দিকনির্দেশনার সাথে সংযুক্ত হোন।",
            "Career Daily Reading": "ক্যারিয়ার দৈনিক রিডিং",
            "Elevate your career with daily tarot insights to achieve your professional goals.": "পেশাগত লক্ষ্য অর্জনে দৈনিক ট্যারোট অন্তর্দৃষ্টি দিয়ে আপনার ক্যারিয়ার উন্নত করুন।",
            "Dream Come True Reading": "স্বপ্নপূরণ রিডিং",
            "Gain insights into making your dreams and goals a reality.": "আপনার স্বপ্ন ও লক্ষ্য বাস্তবে রূপ দেওয়ার অন্তর্দৃষ্টি পান।",
            "Past Lives Connection Reading": "পূর্বজন্ম সংযোগ রিডিং",
            "Explore your journey across time to understand your path ahead.": "সময়ের পথে আপনার যাত্রা অনুসন্ধান করে ভবিষ্যৎ পথ বুঝুন।",
            "Select Tarot Three Card": "তিনটি ট্যারোট কার্ড নির্বাচন করুন",
            "Heartbreak Reading": "হার্টব্রেক রিডিং",
            "Find guidance and healing for a broken heart.": "ভাঙা হৃদয়ের জন্য দিকনির্দেশনা ও নিরাময় পান।",
            "Wisdom Reading": "উইজডম রিডিং",
            "Balance your energies and find mental peace through wisdom.": "জ্ঞান দিয়ে আপনার শক্তির ভারসাম্য বজায় রেখে মানসিক শান্তি খুঁজুন।",
            "Divine Magic Reading": "ডিভাইন ম্যাজিক রিডিং",
            "Discover mystical insights with magical tarot guidance.": "জাদুকরী ট্যারোট নির্দেশনায় রহস্যময় অন্তর্দৃষ্টি আবিষ্কার করুন।",
            "Please pick your cards !!": "অনুগ্রহ করে আপনার কার্ড বেছে নিন !!",
            "Get Your Reading": "আপনার রিডিং পান",
            "Select Tarot Two Card": "দুটি ট্যারোট কার্ড নির্বাচন করুন",
            "Love Triangle Reading": "লাভ ট্রায়াঙ্গেল রিডিং",
            "Get clarity in choosing between multiple romantic interests.": "একাধিক রোমান্টিক আগ্রহের মধ্যে নির্বাচন করতে স্পষ্টতা পান।",
            "Past-Present-Future Reading": "অতীত-বর্তমান-ভবিষ্যৎ রিডিং",
            "Zodiac Gift Guru": "রাশিচক্র গিফট গুরু",
            "January": "জানুয়ারি",
            "February": "ফেব্রুয়ারি",
            "March": "মার্চ",
            "April": "এপ্রিল",
            "May": "মে",
            "June": "জুন",
            "July": "জুলাই",
            "August": "আগস্ট",
            "September": "সেপ্টেম্বর",
            "October": "অক্টোবর",
            "November": "নভেম্বর",
            "December": "ডিসেম্বর",
            "Yesterday": "গতকাল",
            "Today": "আজ",
            "Tomorrow": "আগামীকাল",
            "Gift Recommendations": "উপহার পরামর্শ",
            "insight": "অন্তর্দৃষ্টি",
            "Career": "ক্যারিয়ার",
            "Love": "ভালোবাসা",
            "Finance": "অর্থ",
            "Popularity": "জনপ্রিয়তা",
            "Experience: High to Low": "অভিজ্ঞতা: বেশি থেকে কম",
            "Experience: Low to High": "অভিজ্ঞতা: কম থেকে বেশি",
            "Orders: High to Low": "অর্ডার: বেশি থেকে কম",
            "Orders: Low to High": "অর্ডার: কম থেকে বেশি",
            "Price: High to Low": "মূল্য: বেশি থেকে কম",
            "Price: Low to High": "মূল্য: কম থেকে বেশি",
            "Rating: High to Low": "রেটিং: বেশি থেকে কম",
            "Search name...": "নাম অনুসন্ধান করুন...",
            "Online": "অনলাইন",
            "Busy": "ব্যস্ত",
            "Exp": "অভিজ্ঞতা",
            "yrs": "বছর",
            "orders": "অর্ডার",
            "min": "মিনিট",
            "Chat Now": "এখনই চ্যাট করুন",
            "Wait": "অপেক্ষা করুন",
            "There are no astrologers in this category.": "এই বিভাগে কোনো জ্যোতিষী নেই।",
            "Sort": "সাজান",
            "Filter": "ফিল্টার",
            "Category": "বিভাগ",
            "All": "সব",
            "Sort by": "অনুযায়ী সাজান",
            "Skill": "দক্ষতা",
            "Language": "ভাষা",
            "Reset": "রিসেট",
            "Apply": "প্রয়োগ করুন",
            "You have 30 seconds left. Please recharge immediately to continue the conversation.": "আপনার কাছে ৩০ সেকেন্ড বাকি আছে। কথোপকথন চালিয়ে যেতে অনুগ্রহ করে এখনই রিচার্জ করুন।",
            "Free chat over! Next minutes will use wallet balance.": "ফ্রি চ্যাট শেষ! পরবর্তী মিনিটগুলিতে ওয়ালেট ব্যালেন্স থেকে কাটা হবে।",
            "Complete": "সম্পূর্ণ",
            "End Chat": "চ্যাট শেষ করুন",
            "Message": "বার্তা",
            "Hi": "হাই",
            "lets continue this chat at discounted price of": "চলুন এই চ্যাটটি ছাড় মূল্যে চালিয়ে যাই",
            "Are you sure you want to end tha chat to": "আপনি কি নিশ্চিত যে চ্যাটটি শেষ করতে চান",
            "No": "না",
            "Yes": "হ্যাঁ",
            "Chat With Astrologer": "জ্যোতিষীর সাথে চ্যাট করুন",
            "Appointment List": "অ্যাপয়েন্টমেন্ট তালিকা",
            "My Following": "আমার অনুসরণ",
            "Recent Post": "সাম্প্রতিক পোস্ট",
            "Welcome back": "ফিরে আসায় স্বাগতম",
            "Manage your astrology services": "আপনার জ্যোতিষ পরিষেবা পরিচালনা করুন",
            "Logout": "লগ আউট",
            "Login": "লগ ইন",
            "My Profile (Member Since)": "আমার প্রোফাইল (সদস্য হওয়ার পর থেকে)",
            "My Followings": "আমার অনুসরণসমূহ",
            "You are following": "আপনি অনুসরণ করছেন",
            "people": "জন",
            "Years": "বছর",
            "No Following Found !!": "কোনো অনুসরণ পাওয়া যায়নি !!",
            "Currently you don't have any follow.": "বর্তমানে আপনি কাউকে অনুসরণ করছেন না।",
            "Hey There!": "হ্যালো!",
            "What is your name?": "আপনার নাম কী?",
            "Enter your first Name": "আপনার নাম লিখুন",
            "Enter your last Name": "আপনার পদবি লিখুন",
            "male": "পুরুষ",
            "female": "মহিলা",
            "Where wrer you bron?": "আপনার জন্ম কোথায়?",
            "Please Select Language": "অনুগ্রহ করে ভাষা নির্বাচন করুন",
            "english": "ইংরেজি",
            "hindi": "হিন্দি",
            "north": "উত্তর",
            "south": "দক্ষিণ",
            "Select Chart Type": "চার্টের ধরন নির্বাচন করুন",
            "Start chat with astrologer": "জ্যোতিষীর সাথে চ্যাট শুরু করুন",
            "Search location": "অবস্থান অনুসন্ধান করুন",
            "Location not found !!": "অবস্থান পাওয়া যায়নি !!",
            "Enter bord state": "জন্ম রাজ্য লিখুন",
            "Search location...": "অবস্থান অনুসন্ধান করুন...",
            "Astrologers": "জ্যোতিষীরা",
            "Top Astrologers. 24 * 7 customer support. Happy to help": "সেরা জ্যোতিষীরা। ২৪*৭ গ্রাহক সহায়তা। সাহায্য করতে প্রস্তুত।",
            "per min": "প্রতি মিনিট",
            "Top Astrologers": "সেরা জ্যোতিষীরা",
            "rate": "রেট",
            "Top Rated Astrologers": "সর্বোচ্চ রেটপ্রাপ্ত জ্যোতিষীরা",
            "No astrologers found !!": "কোনো জ্যোতিষী পাওয়া যায়নি !!",
            "FAQs": "প্রশ্নোত্তর",
            "Raning": "রেটিং",
            "Raning Apointment": "অ্যাপয়েন্টমেন্ট রেটিং",
            "Select Other Sign": "অন্য রাশি নির্বাচন করুন",
            "Horoscopes": "রাশিফল",
            "Daily Horoscope": "দৈনিক রাশিফল",
            "Weekly Horoscope": "সাপ্তাহিক রাশিফল",
            "Monthly Horoscope": "মাসিক রাশিফল",
            "Yearly Horoscope": "বার্ষিক রাশিফল",
            "Composite Friendship Table": "সমন্বিত বন্ধুত্ব তালিকা",
            "Kp Planetary Details": "কেপি গ্রহগত বিবরণ",
            "Kp House Cusps And Chart": "কেপি হাউস কাস্প ও চার্ট",
            "Ascendant Report": "লগ্ন রিপোর্ট",
            "Bhava Kundli": "ভাব কুণ্ডলী",
            "Vimshottari Dasha": "বিমশোত্তরী দশা",
            "Yogini Dasha": "যোগিনী দশা",
            "Sadhesati Analysis": "সাড়ে সাতি বিশ্লেষণ",
            "Sadhesati Life Analysis": "সাড়ে সাতি জীবন বিশ্লেষণ",
            "Kalsarpa Dosha": "কালসর্গ দোষ",
            "Manglik Analysis": "মাঙ্গলিক বিশ্লেষণ",
            "Planet Profiles": "গ্রহ প্রোফাইল",
            "Gemstone Suggestions": "রত্ন পরামর্শ",
            "Upagraha": "উপগ্রহ",
            "Jaimini Astrology": "জৈমিনি জ্যোতিষ",
            "Chara Dasha": "চর দশা",
            "Shadbala": "ষড়বলা",
            "Sudarshana Chakra": "সুদর্শন চক্র",
            "Bhinnashtakvarga": "ভিন্নাষ্টকবর্গ",
            "Yogas": "যোগ",
            "Introduction": "ভূমিকা",
            "Basic Astrological Details": "মৌলিক জ্যোতিষ তথ্য",
            "Planetary Positions": "গ্রহের অবস্থান",
            "Horoscope Charts": "রাশিচক্র চার্ট",
            "House Cusps And Sandhi": "হাউস কাস্প ও সন্ধি",
            "Divisional Charts": "বিভাগীয় চার্ট",
            "Basic Details": "মৌলিক বিবরণ",
            "Ghat Chakra": "ঘট চক্র",
            "Panchange Details": "পঞ্চাঙ্গ বিবরণ",
            "Astrological Details": "জ্যোতিষীয় বিবরণ",
            "Time of Birth": "জন্ম সময়",
            "Place of Birth": "জন্মস্থান",
            "Latitude": "অক্ষাংশ",
            "Longitude": "দ্রাঘিমাংশ",
            "Timezone": "সময় অঞ্চল",
            "Ayanamsa": "অয়নাংশ",
            "Sunrise": "সূর্যোদয়",
            "Sunset": "সূর্যাস্ত",
            "Month": "মাস",
            "Tithi": "তিথি",
            "Yoga": "যোগ",
            "Karana": "করণ",
            "Moon Sign": "চন্দ্র রাশি",
            "Moon Vaar": "চন্দ্র বার",
            "Nakshatra": "নক্ষত্র",
            "Varna": "বর্ণ",
            "Vashya": "বশ্য",
            "Yoni": "যোনি",
            "Gana": "গণ",
            "Nadi": "নাড়ি",
            "Sun Sign": "সূর্য রাশি",
            "Tatva": "তত্ত্ব",
            "Paya": "পায়া",
            "Yanja": "যজ্ঞ",
            "Planets": "গ্রহ",
            "Sign": "রাশি",
            "Sign No": "রাশি নম্বর",
            "LAGNA CHART (BIRTH CHART)": "লগ্ন চার্ট (জন্মকুণ্ডলী)",
            "MOON CHART": "চন্দ্র চার্ট",
            "NAVMANSHA CHART (D9)": "নবমাংশ চার্ট (D9)",
            "House": "ভাব",
            "Bhav Madhya": "ভাব মধ্য",
            "Bhav Sandhi": "ভাব সন্ধি",
            "Chalit Chart": "চলিত চার্ট",
            "Sun Chart": "সূর্য চার্ট",
            "Health, Constitution, Body": "স্বাস্থ্য, গঠন, শরীর",
            "Hora Chart(D2)": "হোরা চার্ট (D2)",
            "Finance, Wealth, Prosperity": "অর্থ, সম্পদ, সমৃদ্ধি",
            "Dreshkan Chart(D3)": "দ্রেষ্কাণ চার্ট (D3)",
            "Brothers, Sisters": "ভাই, বোন",
            "Chathurthamasha Chart(D4)": "চতুর্থাংশ চার্ট (D4)",
            "Fortunes, Luck of native": "ভাগ্য, সৌভাগ্য",
            "Saptamansha Chart(D7)": "সপ্তমাংশ চার্ট (D7)",
            "Impregnation, Birth of the child": "গর্ভধারণ, সন্তানের জন্ম",
            "Dashamansha Chart(D10)": "দশমাংশ চার্ট (D10)",
            "livelihood, Profession": "জীবিকা, পেশা",
            "Dwadasha Chart(D12)": "দ্বাদশাংশ চার্ট (D12)",
            "Parents, paternal happiness": "পিতা-মাতা, পিতৃসুখ",
            "Shodashamsha Chart(D16)": "ষোড়শাংশ চার্ট (D16)",
            "Happiness, miseries, conveyance": "সুখ, দুঃখ, যানবাহন",
            "Vishamansha Chart(D20)": "বিংশাংশ চার্ট (D20)",
            "Spiritual progress, worship": "আধ্যাত্মিক উন্নতি, উপাসনা",
            "Chaturvimshamsha(D24)": "চতুর্বিংশাংশ (D24)",
            "Academic achievement, education": "শিক্ষাগত সাফল্য, শিক্ষা",
            "Bhamsha Chart(D27)": "ভাংশ চার্ট (D27)",
            "Physical strength, stamina": "শারীরিক শক্তি, সহনশক্তি",
            "Trishamansha Chart(D30)": "ত্রিশাংশ চার্ট (D30)",
            "Evil, Adversities of life": "অশুভ, জীবনের প্রতিকূলতা",
            "Khavedamsha Chart(D40)": "খবেদাংশ চার্ট (D40)",
            "Auspicious & inauspicious effect": "শুভ ও অশুভ প্রভাব",
            "Akshvedansha Chart(D45)": "অক্ষবেদাংশ চার্ট (D45)",
            "Character and couduct of the native": "স্বভাব ও আচরণ",
            "Shashtymsah Chart(D60)": "ষষ্ট্যংশ চার্ট (D60)",
            "Shows general happiness": "সাধারণ সুখ নির্দেশ করে",
            "Degrees": "ডিগ্রি",
            "Sign Lord": "রাশির অধিপতি",
            "Nakshatra Lord": "নক্ষত্র অধিপতি",
            "Sub Lord": "উপ-অধিপতি",
            "Sub Sub Lord": "উপ-উপ অধিপতি",
            "Lord": "অধিপতি",
            "Symbol": "প্রতীক",
            "Characteristics": "বৈশিষ্ট্য",
            "Day of Fast": "উপবাসের দিন",
            "luchy Gems": "শুভ রত্ন",
            "Personality": "ব্যক্তিত্ব",
            "Health": "স্বাস্থ্য",
            "Relationships": "সম্পর্ক",
            "BHAVA KUNDLI": "ভাব কুণ্ডলী",
            "Bhramari": "ভ্রমরী",
            "Bhadrika": "ভদ্রিকা",
            "Ulka": "উল্কা",
            "Siddha": "সিদ্ধ",
            "Sankata": "সঙ্কট",
            "Mangala": "মঙ্গল",
            "Pingala": "পিঙ্গলা",
            "Dhanya": "ধান্য",
            "Remedies Of Sadhesati": "সাড়ে সাতির প্রতিকার",
            "Saturn Sign": "শনি রাশি",
            "Is Saturn Retro?": "শনি কি বক্রী?",
            "Phase": "পর্যায়",
            "Intensity": "তীব্রতা",
            "Direction": "দিক",
            "Strength": "শক্তি",
            "Percentage": "শতাংশ",
            "Zodiac Sign": "রাশিচক্র রাশি",
            "Planet Degree": "গ্রহের ডিগ্রি",
            "Lord Of": "এর অধিপতি",
            "Combust/Aw...": "দগ্ধ/অস্ত...",
            "Lucky Stone": "শুভ পাথর",
            "Life Stone": "জীবন পাথর",
            "Finger": "আঙুল",
            "Day": "দিন",
            "Time to Wear": "পরার সময়",
            "Mantra": "মন্ত্র",
            "Upagraha Longitude": "উপগ্রহ দ্রাঘিমাংশ",
            "Rashi": "রাশি",
            "Pada": "পদ",
            "Upagraha/Nakshatra/Sub Lord": "উপগ্রহ/নক্ষত্র/উপ-অধিপতি",
            "Jamini Planets": "জৈমিনি গ্রহ",
            "Jamini Padas": "জৈমিনি পদ",
            "Code": "কোড",
            "Jamini Karakara": "জৈমিনি কারক",
            "Uchcha Bala": "উচ্চ বল",
            "Saptavarga Bala": "সপ্তবর্গ বল",
            "Yugmayugma Bhamsha Bala": "যুগ্মযুগ্ম ভাংশ বল",
            "Kendradi Bala": "কেন্দ্রাদি বল",
            "Drekkana Bala": "দ্রেক্কান বল",
            "Total Sthana Bala": "মোট স্থান বল",
            "Total Dig Bala": "মোট দিক বল",
            "Nattunnata Bala": "নট্টুন্নত বল",
            "Paksha Bala": "পক্ষ বল",
            "Tribhaga Bala": "ত্রিভাগ বল",
            "Varshadhipati": "বর্ষাধিপতি",
            "Maasadipati": "মাসাধিপতি",
            "Vaaradhipati": "বারাধিপতি",
            "Horadhipati": "হোরাধিপতি",
            "Ayana Bala": "অয়ন বল",
            "Yuddha Bala": "যুদ্ধ বল",
            "Total Kaal Bala": "মোট কাল বল",
            "Naisargika Bala": "নৈসর্গিক বল",
            "Chestha Bala": "চেষ্টা বল",
            "Drik Bala": "দৃষ্টি বল",
            "Total Shadbala": "মোট ষড়বল",
            "Shadbala In Rupa": "রূপে ষড়বল",
            "Min Require": "ন্যূনতম প্রয়োজন",
            "Ratio": "অনুপাত",
            "Rank": "ক্রম",
            "Sun": "সূর্য",
            "Moon": "চন্দ্র",
            "Mars": "মঙ্গল",
            "Mercury": "বুধ",
            "Jupiter": "বৃহস্পতি",
            "Venus": "শুক্র",
            "Saturn": "শনি",
            "Ashtakvarga": "অষ্টকবর্গ",
            "Sarvashtakava": "সর্বাষ্টকবর্গ",
            "Prasthara Chakra": "প্রস্থর চক্র",
            "Ascendant": "লগ্ন",
            "Total": "মোট",
            "Natural Friendship": "স্বাভাবিক মিত্রতা",
            "Temporary Friendship": "অস্থায়ী মিত্রতা",
            "Five Fold Friendship": "পঞ্চধা মিত্রতা",
            "Ketu": "কেতু",
            "Rahu": "রাহু",
            "Vimshottari Dasha P1": "বিমশোত্তরী দশা P1",
            "Vimshottari Dasha P2": "বিমশোত্তরী দশা P2",
            "AshtaKoot": "অষ্টকূট",
            "Bhakut Dosha": "ভাকুট দোষ",
            "Nadi Dosha": "নাড়ি দোষ",
            "Ashtakoot Analysis": "অষ্টকূট বিশ্লেষণ",
            "DashaKoot": "দশকূট",
            "Personality Report": "ব্যক্তিত্ব প্রতিবেদন",
            "Match Making Report": "বিবাহ মিলান প্রতিবেদন",
            "Nav Pancham Yoga": "নব পঞ্চম যোগ",
            "Charan": "চরণ",
            "Name Alphabet": "নামের অক্ষর",
            "Planetary Position": "গ্রহের অবস্থান",
            "Lagna Chart (Birth Chart)": "লগ্ন চার্ট (জন্মকুণ্ডলী)",
            "Moon Chart": "চন্দ্র চার্ট",
            "Navmansha Chart (D9)": "নবমাংশ চার্ট (D9)",
            "Mahadasha": "মহাদশা",
            "End": "শেষ",
            "Is Recommended ??": "এটি কি সুপারিশযোগ্য?",
            "Manglik Details": "মাঙ্গলিক বিবরণ",
            "What is AshtaKoot ??": "অষ্টকূট কী?",
            "Attributes": "বৈশিষ্ট্যসমূহ",
            "Description": "বর্ণনা",
            "Received": "প্রাপ্ত",
            "Graha Maitri": "গ্রহ মৈত্রী",
            "Bhakoota": "ভাকূট",
            "What is BhaKoot Dosha ??": "ভাকূট দোষ কী?",
            "What is Nadi Dosha ??": "নাড়ি দোষ কী?",
            "Madhya": "মধ্য",
            "Nadi dosha is present": "নাড়ি দোষ বিদ্যমান",
            "The": "এই",
            "porutham considered for horoscope matching are as follows :": "রাশিফল মিলানের জন্য বিবেচিত পোরুথামসমূহ নিম্নরূপ:",
            "Dina": "দিন",
            "Rajju": "রজ্জু",
            "Rasyadhipati": "রাশ্যাধিপতি",
            "Vedha": "বেধ",
            "Mahendra": "মহেন্দ্র",
            "Streedargha": "স্ত্রীদীর্ঘ",
            "Uranus": "ইউরেনাস",
            "Neptune": "নেপচুন",
            "Pluto": "প্লুটো",
            "Tara": "তারা",
            "Please fill boy's details !!": "অনুগ্রহ করে পাত্রের বিবরণ পূরণ করুন !!",
            "Please fill girl's details !!": "অনুগ্রহ করে পাত্রীর বিবরণ পূরণ করুন !!",
            "Please fill chart details !!": "অনুগ্রহ করে চার্টের বিবরণ পূরণ করুন !!",
            "Kundli Matching": "কুণ্ডলী মিলান",
            "Find your right one, through matchmaking": "ম্যাচমেকিংয়ের মাধ্যমে আপনার সঠিক সঙ্গী খুঁজুন",
            "Open Kundli": "কুণ্ডলী খুলুন",
            "New Matching": "নতুন মিলান",
            "View Kundli": "কুণ্ডলী দেখুন",
            "Boy's Details": "পাত্রের বিবরণ",
            "Girl's Details": "পাত্রীর বিবরণ",
            "Search city, state, country": "শহর, রাজ্য, দেশ অনুসন্ধান করুন",
            "Enter first name": "প্রথম নাম লিখুন",
            "Enter last name": "শেষ নাম লিখুন",
            "Chart Style": "চার্টের ধরন",
            "North Indian": "উত্তর ভারতীয়",
            "South Indian": "দক্ষিণ ভারতীয়",
            "English": "ইংরেজি",
            "Hindi": "হিন্দি",
            "MATCH HOROSCOPE": "রাশিফল মিলান",
            "My Profile": "আমার প্রোফাইল",
            "Enter full name": "সম্পূর্ণ নাম লিখুন",
            "Enter email address": "ইমেইল ঠিকানা লিখুন",
            "Enter password": "পাসওয়ার্ড লিখুন",
            "Enter phone number": "ফোন নম্বর লিখুন",
            "Save Chanage": "পরিবর্তন সংরক্ষণ করুন",
            "Manage your astrologers recent post": "আপনার জ্যোতিষীর সাম্প্রতিক পোস্ট পরিচালনা করুন",
            "Show Less": "কম দেখান",
            "Show More": "আরও দেখান",
            "Total Balance": "মোট ব্যালেন্স",
            "Add Money": "টাকা যোগ করুন",
            "Extra": "অতিরিক্ত",
            "Transaction History": "লেনদেনের ইতিহাস",
            "Build better products with flexible tools, helpful documentation,": "নমনীয় টুলস ও সহায়ক ডকুমেন্টেশন দিয়ে আরও ভালো পণ্য তৈরি করুন,",
            "and a team that champions your growth.": "এবং একটি দল যা আপনার উন্নয়নে সহায়তা করে।",
            "Useful Link": "প্রয়োজনীয় লিংক",
            "Socials": "সামাজিক মাধ্যম",
            "Logout Seccuessfuly !!": "সফলভাবে লগআউট হয়েছে !!",
            "Free Kundli": "ফ্রি কুণ্ডলী",
            "Horoscope": "রাশিফল",
            "Dashboard": "ড্যাশবোর্ড",
            "Enter your feedback !!": "আপনার মতামত লিখুন !!",
            "Languages": "ভাষাসমূহ",
            "incoming": "আসছে",
            "request from": "অনুরোধ থেকে",
            "Waitlist Joined !!": "ওয়েটলিস্টে যুক্ত হয়েছেন !!",
            "will start in": "শুরু হবে",
            "You will receive a": "আপনি একটি পাবেন",
            "request when the": "অনুরোধ যখন",
            "astrologer is ready. Don’t worry! You will not be": "জ্যোতিষী প্রস্তুত থাকলে। চিন্তা করবেন না! আপনাকে",
            "charged for missing this session.": "এই সেশন মিস করলে কোনো চার্জ নেওয়া হবে না।",
            "Accept": "গ্রহণ করুন",
            "Reject": "প্রত্যাখ্যান করুন",
            "Great, what did you like the mast? 😍": "দারুণ, আপনার সবচেয়ে কী ভালো লেগেছে? 😍",
            "Skip": "এড়িয়ে যান",
            "Payment Information": "পেমেন্ট তথ্য",
            "Amount": "পরিমাণ",
            "Tax": "কর",
            "Payment": "পেমেন্ট",
            "Payment Method": "পেমেন্ট পদ্ধতি",
        
            "AstroSpace": "AstroSpace",
            "Astrology Consultation Platform": "Astrology Consultation Platform",
            "INVOICE": "INVOICE",
            "Consultation Service Receipt": "Consultation Service Receipt",
            "Invoice Number": "Invoice Number",
            "Date Issued": "Date Issued",
            "PAID": "PAID",
            "From": "From",
            "Bill To": "Bill To",
            "Service": "Service",
            "Booking ID": "Booking ID",
            "Description": "Description",
            "Duration": "Duration",
            "Rate": "Rate",
            "Amount": "Amount",
            "Free Consultation Time": "Free Consultation Time",
            "Complimentary session minutes": "Complimentary session minutes",
            "Free": "Free",
            "Consultation Fee": "Consultation Fee",
            "Standard rate (first block)": "Standard rate (first block)",
            "Extended Consultation Fee": "Extended Consultation Fee",
            "Premium rate (extended block)": "Premium rate (extended block)",
            "Consultation Service": "Consultation Service",
            "Astrology consultation session": "Astrology consultation session",
            "Subtotal": "Subtotal",
            "Platform Fee": "Platform Fee",
            "Included": "Included",
            "Total Amount": "Total Amount",
            "DOB": "DOB",
            "Kundali Chart Used": "Kundali Chart Used",
            "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.": "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.",
            "For support, contact us at support@astrospace.com": "For support, contact us at support@astrospace.com",
            "Free Minute": "Free Minute",
            "Verified": "Verified",
            "End Session": "End Session",
            "Voice Call": "Voice Call",
            "typing...": "typing...",
            "CANCEL": "CANCEL",
            "OK": "OK",
            "Install Progressive Web Application": "Install Progressive Web Application",
            "This site has app functionality. Install it on your device for extensive experience and easy access.": "This site has app functionality. Install it on your device for extensive experience and easy access.",
            "Install": "Install",
            "Search location": "Search location",
            "Location not found !!": "Location not found !!",
            "Waiting for remote user to join...": "Waiting for remote user to join...",
            "End Video Session": "End Video Session",
            "Initializing WebRTC P2P...": "Initializing WebRTC P2P...",
            "Access Denied (Camera/Mic)": "Access Denied (Camera/Mic)",
            "Connection Failed": "Connection Failed",
            "Time Remaining": "Time Remaining",
            "Call ended": "Call ended",

            "Offline": "Offline",}
    },
    pt: {
        translation: {
            "Enter Mobile Number !!": "Digite o número de celular !!",
            "In Valid OTP !!": "OTP inválido !!",
            "Please enter password !!": "Por favor, digite a senha !!",
            "Password not match !!": "As senhas não coincidem !!",
            "Reset Password": "Redefinir senha",
            "Enter your phone number and new password": "Digite seu número de telefone e a nova senha",
            "Phone Number": "Número de telefone",
            "Enter your number": "Digite seu número",
            "Search": "Pesquisar",
            "Verify": "Verificar",
            "You will receive a 6 digit code for": "Você receberá um código de 6 dígitos para",
            "verification to": "verificação em",
            "Submit": "Enviar",
            "Enter your password and new password": "Digite sua senha atual e a nova senha",
            "New Password": "Nova senha",
            "Enter new password": "Digite a nova senha",
            "Confirm New Password": "Confirmar nova senha",
            "Confirm new password": "Confirme a nova senha",
            "Back to Login": "Voltar para o login",
            "Back": "Voltar",
            "Enter Login Details !!": "Digite os dados de login !!",
            "Welcome Back!": "Bem-vindo(a) de volta!",
            "Sign in to your account": "Entre na sua conta",
            "Password": "Senha",
            "Enter your password": "Digite sua senha",
            "Forgot Password?": "Esqueceu a senha?",
            "Sign In": "Entrar",
            "Don't have an account?": "Não tem uma conta?",
            "Sign Up": "Cadastrar-se",
            "Please enter all details !!": "Por favor, preencha todos os dados !!",
            "Please enter valid email !!": "Por favor, digite um e-mail válido !!",
            "Please enter birth place !!": "Por favor, digite o local de nascimento !!",
            "Please select language !!": "Por favor, selecione o idioma !!",
            "Step": "Etapa",
            "Enter Your Details": "Digite seus dados",
            "Hey there! what is your name?": "Olá! Qual é o seu nome?",
            "Full Name": "Nome completo",
            "Email Address": "Endereço de e-mail",
            "Enter your Full Name": "Digite seu nome completo",
            "Enter your email": "Digite seu e-mail",
            "What is your gender?": "Qual é o seu gênero?",
            "Male": "Masculino",
            "Female": "Feminino",
            "Enter your birth date": "Digite sua data de nascimento",
            "Enter your birth time": "Digite seu horário de nascimento",
            "Enter your birth Place": "Digite seu local de nascimento",
            "Do you know which languages?": "Quais idiomas você conhece?",
            "Enter Your Place": "Digite seu local",
            "Back to Step": "Voltar para a etapa",
            "Next": "Próximo",
            "My Appointments": "Meus agendamentos",
            "Manage your astrology consultations": "Gerencie suas consultas astrológicas",
            "Upcoming": "Próximos",
            "Past": "Anteriores",
            "Pending": "Pendente",
            "Accepted": "Aceito",
            "Start": "Iniciar",
            "Completed": "Concluído",
            "Canceled": "Cancelado",
            "ID": "ID",
            "Chat": "Chat",
            "Audio Call": "Chamada de áudio",
            "Video Call": "Chamada de vídeo",
            "View Details": "Ver detalhes",
            "Cancel": "Cancelar",
            "No Upcoming Appointment Found !!": "Nenhum agendamento futuro encontrado !!",
            "Currently you don't have any upcoming appointment.": "No momento você não tem nenhum agendamento futuro.",
            "No Past Appointment Found !!": "Nenhum agendamento anterior encontrado !!",
            "Currently you don't have any past appointment.": "No momento você não tem nenhum agendamento anterior.",
            "Status": "Status",
            "Service Type": "Tipo de serviço",
            "Date": "Data",
            "Time": "Hora",
            "Price": "Preço",
            "Booked Person Details": "Detalhes da pessoa agendada",
            "name": "nome",
            "Date of Birth": "Data de nascimento",
            "Birth Place": "Local de nascimento",
            "Gender": "Gênero",
            "Complete Details": "Detalhes completos",
            "Start Time": "Hora de início",
            "End Time": "Hora de término",
            "Total Duration": "Duração total",
            "Billable Time": "Tempo faturável",
            "Billed Fee First": "Taxa cobrada inicialmente",
            "Billed Fee After": "Taxa cobrada posteriormente",
            "Total Consultation Fee": "Taxa total da consulta",
            "Kundali Details": "Detalhes do Kundali",
            "Name": "Nome",
            "Send Notification": "Enviar notificação",
            "Continue Chat": "Continuar chat",
            "Write message !!": "Escreva uma mensagem !!",
            "Astrologer Ai Assistant": "Assistente de IA do astrólogo",
            "Ask anything about your horoscope...": "Pergunte qualquer coisa sobre seu horóscopo...",
            "Write message to assistant": "Escreva uma mensagem para o assistente",
            "Clear Chat?": "Limpar chat?",
            "All messages will be deleted permanently.": "Todas as mensagens serão excluídas permanentemente.",
            "Clear": "Limpar",
            "Payment faild !!": "Pagamento falhou !!",
            "Please Complete Last Apointment !!": "Por favor, conclua o último agendamento !!",
            "Please enter comment !!": "Por favor, digite um comentário !!",
            "Insufficient wallet balance !!": "Saldo insuficiente na carteira !!",
            "Orders": "Pedidos",
            "Experience": "Experiência",
            "Rating": "Avaliação",
            "Unfollow": "Deixar de seguir",
            "Follow": "Seguir",
            "Send Gift": "Enviar presente",
            "Start a Consultation": "Iniciar uma consulta",
            "Chat with astrologer": "Conversar com o astrólogo",
            "For new user": "Para novo usuário",
            "min free": "min grátis",
            "Call with astrologer": "Ligar para o astrólogo",
            "Video call with astrologer": "Chamada de vídeo com o astrólogo",
            "Astrologer Bio": "Biografia do astrólogo",
            "Reviews": "Avaliações",
            "Activity": "Atividade",
            "FAQ's": "Perguntas frequentes",
            "Media": "Mídia",
            "Comment": "Comentário",
            "No comment yet": "Nenhum comentário ainda",
            "start the conversation": "Iniciar a conversa",
            "Poast your replay": "Publique sua resposta",
            "Delete comment": "Excluir comentário",
            "Are you sure you want to delete this comment?": "Tem certeza de que deseja excluir este comentário?",
            "Cancle": "Cancelar",
            "Delete": "Excluir",
            "Intro Audio": "Áudio de introdução",
            "Intro Video": "Vídeo de introdução",
            "Hear from": "Ouça de",
            "Please select user !!": "Por favor, selecione o usuário !!",
            "Please select amount !!": "Por favor, selecione o valor !!",
            "Please select payment method !!": "Por favor, selecione o método de pagamento !!",
            "Select Kundli": "Selecionar Kundli",
            "Add Kundli": "Adicionar Kundli",
            "Minimum balance of": "Saldo mínimo de",
            "minutes": "minutos",
            "is required to start chat with": "é necessário para iniciar o chat com",
            "Wallet Balance": "Saldo da carteira",
            "Required": "Necessário",
            "Proceed to Pay": "Prosseguir para pagamento",
            "extra in your": "extra na sua",
            "wallet with this": "carteira com isto",
            "Woohoo!": "Uhuu!",
            "Recharge Amount": "Valor da recarga",
            "GST": "GST",
            "Wallet Amount": "Valor na carteira",
            "Payble Amount": "Valor a pagar",
            "Pay from Wallet": "Pagar com a carteira",
            "Available": "Disponível",
            "Payment Getway Method": "Método do gateway de pagamento",
            "Continue": "Continuar",
            "Fortune Cookie - Unveil Your Daily Wisdom": "Biscoito da Sorte - Revele sua sabedoria diária",
            "Crack open a fortune cookie to reveal a piece of daily wisdom. Let the message guide you through your day with positivity and insight.": "Abra um biscoito da sorte para revelar uma mensagem de sabedoria diária. Deixe a mensagem guiar seu dia com positividade e reflexão.",
            "Ask The Fortune Cookie": "Pergunte ao Biscoito da Sorte",
            "Crack open your Fortune Cookie": "Abra seu Biscoito da Sorte",
            "Crack another one open": "Abra outro",
            "Love Compatibility": "Compatibilidade Amorosa",
            "Find out how compatible you are with your lover, friend, or colleague using our love compatibility calculator. Get your results now.": "Descubra o quanto você é compatível com seu parceiro(a), amigo(a) ou colega usando nossa calculadora de compatibilidade amorosa. Veja seus resultados agora.",
            "Are Aries And Taurus Compatible": "Áries e Touro são compatíveis?",
            "Aries And Taurus Strengths": "Pontos fortes de Áries e Touro",
            "Aries And Taurus Weaknesses": "Pontos fracos de Áries e Touro",
            "Aries And Taurus Elements": "Elementos de Áries e Touro",
            "Aries And Taurus Dates": "Datas de Áries e Touro",
            "Are Aries And Taurus Compatibility Score": "Pontuação de compatibilidade entre Áries e Touro",
            "General": "Geral",
            "Communication": "Comunicação",
            "Sex": "Sexo",
            "Select Another": "Selecionar outro",
            "Aries": "Áries",
            "Taurus": "Touro",
            "Gemini": "Gêmeos",
            "Cancer": "Câncer",
            "Leo": "Leão",
            "Virgo": "Virgem",
            "Libra": "Libra",
            "Scorpio": "Escorpião",
            "Sagittarius": "Sagitário",
            "Capricorn": "Capricórnio",
            "Aquarius": "Aquário",
            "Pisces": "Peixes",
            "Please select Your Partner Sign": "Por favor, selecione o signo do seu parceiro(a)",
            "Please select Your Sign": "Por favor, selecione o seu signo",
            "Please fill all details !!": "Por favor, preencha todos os dados !!",
            "Discover Your Core Numbers That Define You": "Descubra seus números principais que definem você",
            "Explore your core numbers like Life Path, Destiny, and Personal Year—complete with strengths, challenges, and meaningful interpretations.": "Explore seus números principais como Caminho de Vida, Destino e Ano Pessoal — incluindo pontos fortes, desafios e interpretações significativas.",
            "Get Your Numbers": "Obter seus números",
            "First Name": "Nome",
            "Last Name": "Sobrenome",
            "Method": "Método",
            "Chaldean": "Caldeu",
            "Pythagorean": "Pitagórico",
            "Strengths": "Pontos fortes",
            "Challenges": "Desafios",
            "Advice": "Conselho",
            "Get Report": "Obter relatório",
            "Select Tarot One Card": "Selecione uma carta de Tarô",
            "Select Your Card": "Selecione sua carta",
            "Get Another": "Obter outra",
            "Yes Or No Tarot": "Tarô Sim ou Não",
            "Get instant Yes or No answers to pressing questions.": "Obtenha respostas instantâneas de Sim ou Não para suas perguntas urgentes.",
            "Daily Tarot": "Tarô Diário",
            "Receive daily tarot readings on love, career, and finance.": "Receba leituras diárias de tarô sobre amor, carreira e finanças.",
            "In-Depth Love Reading": "Leitura Amorosa Aprofundada",
            "Deep dive into your love life with relationship-specific readings.": "Aprofunde-se na sua vida amorosa com leituras específicas para relacionamentos.",
            "Flirt Love Reading": "Leitura Amorosa de Paquera",
            "Reveal insights into playful and romantic connections.": "Revele insights sobre conexões românticas e divertidas.",
            "Erotic Love Reading": "Leitura Amorosa Erótica",
            "Insights into intimate and personal love dynamics.": "Insights sobre dinâmicas íntimas e pessoais do amor.",
            "Egyptian Prediction": "Previsão Egípcia",
            "Access ancient Egyptian insights beyond visible truths.": "Acesse insights do antigo Egito além das verdades visíveis.",
            "Ex-Flame Reading": "Leitura de Ex-Chama",
            "Explore the possibilities of rekindling with an ex-partner.": "Explore as possibilidades de reatar com um ex-parceiro.",
            "Made For Each Other Or Not Reading": "Leitura Feitos um para o Outro ou Não",
            "Discover if your relationship has long-term potential.": "Descubra se seu relacionamento tem potencial a longo prazo.",
            "Power Life Reading": "Leitura Poder da Vida",
            "Take control of your destiny with life-changing tarot readings.": "Assuma o controle do seu destino com leituras de tarô transformadoras.",
            "Know Your Friend Reading": "Leitura Conheça seu Amigo",
            "Understand the true intentions of your friendships.": "Entenda as verdadeiras intenções das suas amizades.",
            "Divine Angel Reading": "Leitura Anjo Divino",
            "Connect with divine guidance for clarity and spiritual insight.": "Conecte-se com orientação divina para clareza e visão espiritual.",
            "Career Daily Reading": "Leitura Diária de Carreira",
            "Elevate your career with daily tarot insights to achieve your professional goals.": "Impulsione sua carreira com insights diários de tarô para alcançar seus objetivos profissionais.",
            "Dream Come True Reading": "Leitura Sonho Tornando-se Realidade",
            "Gain insights into making your dreams and goals a reality.": "Obtenha insights para transformar seus sonhos e objetivos em realidade.",
            "Past Lives Connection Reading": "Leitura de Conexão com Vidas Passadas",
            "Explore your journey across time to understand your path ahead.": "Explore sua jornada ao longo do tempo para entender seu caminho à frente.",
            "Please pick your cards !!": "Por favor, escolha suas cartas !!",
            "Get Your Reading": "Obter sua leitura",
            "Select Tarot Two Card": "Selecione duas cartas de Tarô",
            "Love Triangle Reading": "Leitura Triângulo Amoroso",
            "Get clarity in choosing between multiple romantic interests.": "Tenha clareza ao escolher entre múltiplos interesses românticos.",
            "Past-Present-Future Reading": "Leitura Passado-Presente-Futuro",
            "Zodiac Gift Guru": "Guru de Presentes do Zodíaco",
            "January": "Janeiro",
            "February": "Fevereiro",
            "March": "Março",
            "April": "Abril",
            "May": "Maio",
            "June": "Junho",
            "July": "Julho",
            "August": "Agosto",
            "September": "Setembro",
            "October": "Outubro",
            "November": "Novembro",
            "December": "Dezembro",
            "Yesterday": "Ontem",
            "Today": "Hoje",
            "Tomorrow": "Amanhã",
            "Gift Recommendations": "Recomendações de Presentes",
            "insight": "insight",
            "Career": "Carreira",
            "Love": "Amor",
            "Finance": "Finanças",
            "Popularity": "Popularidade",
            "Experience: High to Low": "Experiência: Maior para Menor",
            "Experience: Low to High": "Experiência: Menor para Maior",
            "Orders: High to Low": "Pedidos: Maior para Menor",
            "Orders: Low to High": "Pedidos: Menor para Maior",
            "Price: High to Low": "Preço: Maior para Menor",
            "Price: Low to High": "Preço: Menor para Maior",
            "Rating: High to Low": "Avaliação: Maior para Menor",
            "Search name...": "Pesquisar nome...",
            "Online": "Online",
            "Busy": "Ocupado",
            "Exp": "Exp",
            "yrs": "anos",
            "orders": "pedidos",
            "min": "min",
            "Chat Now": "Conversar Agora",
            "Wait": "Aguardar",
            "There are no astrologers in this category.": "Não há astrólogos nesta categoria.",
            "Sort": "Ordenar",
            "Filter": "Filtrar",
            "Category": "Categoria",
            "All": "Todos",
            "Sort by": "Ordenar por",
            "Skill": "Habilidade",
            "Language": "Idioma",
            "Reset": "Redefinir",
            "Apply": "Aplicar",
            "You have 30 seconds left. Please recharge immediately to continue the conversation.": "Você tem 30 segundos restantes. Por favor, recarregue imediatamente para continuar a conversa.",
            "Free chat over! Next minutes will use wallet balance.": "Chat gratuito encerrado! Os próximos minutos usarão o saldo da carteira.",
            "Complete": "Concluir",
            "End Chat": "Encerrar Chat",
            "Message": "Mensagem",
            "Hi": "Olá",
            "lets continue this chat at discounted price of": "vamos continuar este chat pelo preço com desconto de",
            "Are you sure you want to end tha chat to": "Tem certeza de que deseja encerrar o chat com",
            "No": "Não",
            "Yes": "Sim",
            "Chat With Astrologer": "Conversar com Astrólogo",
            "Appointment List": "Lista de Agendamentos",
            "My Following": "Quem eu sigo",
            "Recent Post": "Postagem Recente",
            "Welcome back": "Bem-vindo de volta",
            "Manage your astrology services": "Gerencie seus serviços de astrologia",
            "Logout": "Sair",
            "Login": "Entrar",
            "My Profile (Member Since)": "Meu Perfil (Membro desde)",
            "My Followings": "Minhas Conexões",
            "You are following": "Você está seguindo",
            "people": "pessoas",
            "Years": "Anos",
            "No Following Found !!": "Nenhum seguido encontrado !!",
            "Currently you don't have any follow.": "Atualmente você não segue ninguém.",
            "Hey There!": "Olá!",
            "What is your name?": "Qual é o seu nome?",
            "Enter your first Name": "Digite seu primeiro nome",
            "Enter your last Name": "Digite seu sobrenome",
            "male": "masculino",
            "female": "feminino",
            "Where wrer you bron?": "Onde você nasceu?",
            "Please Select Language": "Por favor, selecione o idioma",
            "english": "inglês",
            "hindi": "híndi",
            "north": "norte",
            "south": "sul",
            "Select Chart Type": "Selecione o tipo de mapa",
            "Start chat with astrologer": "Iniciar chat com astrólogo",
            "Search location": "Pesquisar localização",
            "Location not found !!": "Localização não encontrada !!",
            "Enter bord state": "Digite o estado de nascimento",
            "Search location...": "Pesquisar localização...",
            "Astrologers": "Astrólogos",
            "Top Astrologers. 24 * 7 customer support. Happy to help": "Melhores astrólogos. Suporte ao cliente 24*7. Feliz em ajudar",
            "per min": "por min",
            "Top Astrologers": "Melhores Astrólogos",
            "rate": "taxa",
            "Top Rated Astrologers": "Astrólogos Mais Bem Avaliados",
            "No astrologers found !!": "Nenhum astrólogo encontrado !!",
            "FAQs": "Perguntas Frequentes",
            "Raning": "Avaliação",
            "Raning Apointment": "Avaliar Agendamento",
            "Select Other Sign": "Selecionar Outro Signo",
            "Horoscopes": "Horóscopos",
            "Daily Horoscope": "Horóscopo Diário",
            "Weekly Horoscope": "Horóscopo Semanal",
            "Monthly Horoscope": "Horóscopo Mensal",
            "Yearly Horoscope": "Horóscopo Anual",
            "Composite Friendship Table": "Tabela de Amizade Composta",
            "Kp Planetary Details": "Detalhes Planetários KP",
            "Kp House Cusps And Chart": "Cúspides das Casas KP e Mapa",
            "Ascendant Report": "Relatório do Ascendente",
            "Bhava Kundli": "Bhava Kundli",
            "Vimshottari Dasha": "Vimshottari Dasha",
            "Yogini Dasha": "Yogini Dasha",
            "Sadhesati Analysis": "Análise de Sadhesati",
            "Sadhesati Life Analysis": "Análise de Vida Sadhesati",
            "Kalsarpa Dosha": "Kalsarpa Dosha",
            "Manglik Analysis": "Análise Manglik",
            "Planet Profiles": "Perfis Planetários",
            "Gemstone Suggestions": "Sugestões de Pedras Preciosas",
            "Upagraha": "Upagraha",
            "Jaimini Astrology": "Astrologia Jaimini",
            "Chara Dasha": "Chara Dasha",
            "Shadbala": "Shadbala",
            "Sudarshana Chakra": "Sudarshana Chakra",
            "Bhinnashtakvarga": "Bhinnashtakvarga",
            "Yogas": "Yogas",
            "Introduction": "Introdução",
            "Basic Astrological Details": "Detalhes Astrológicos Básicos",
            "Planetary Positions": "Posições Planetárias",
            "Horoscope Charts": "Mapas Astrológicos",
            "House Cusps And Sandhi": "Cúspides das Casas e Sandhi",
            "Divisional Charts": "Mapas Divisionais",
            "Basic Details": "Detalhes Básicos",
            "Ghat Chakra": "Ghat Chakra",
            "Panchange Details": "Detalhes do Panchang",
            "Astrological Details": "Detalhes Astrológicos",
            "Time of Birth": "Hora de Nascimento",
            "Place of Birth": "Local de Nascimento",
            "Latitude": "Latitude",
            "Longitude": "Longitude",
            "Timezone": "Fuso Horário",
            "Ayanamsa": "Ayanamsa",
            "Sunrise": "Nascer do Sol",
            "Sunset": "Pôr do Sol",
            "Month": "Mês",
            "Tithi": "Tithi",
            "Yoga": "Yoga",
            "Karana": "Karana",
            "Moon Sign": "Signo Lunar",
            "Moon Vaar": "Dia Lunar",
            "Nakshatra": "Nakshatra",
            "Varna": "Varna",
            "Vashya": "Vashya",
            "Yoni": "Yoni",
            "Gana": "Gana",
            "Nadi": "Nadi",
            "Sun Sign": "Signo Solar",
            "Tatva": "Tatva",
            "Paya": "Paya",
            "Yanja": "Yanja",
            "Planets": "Planetas",
            "Sign": "Signo",
            "Sign No": "Número do Signo",
            "LAGNA CHART (BIRTH CHART)": "MAPA LAGNA (MAPA NATAL)",
            "MOON CHART": "MAPA LUNAR",
            "NAVMANSHA CHART (D9)": "MAPA NAVAMSHA (D9)",
            "House": "Casa",
            "Bhav Madhya": "Bhav Madhya",
            "Bhav Sandhi": "Bhav Sandhi",
            "Chalit Chart": "Mapa Chalit",
            "Sun Chart": "Mapa Solar",
            "Health, Constitution, Body": "Saúde, Constituição, Corpo",
            "Hora Chart(D2)": "Mapa Hora (D2)",
            "Finance, Wealth, Prosperity": "Finanças, Riqueza, Prosperidade",
            "Dreshkan Chart(D3)": "Mapa Dreshkan (D3)",
            "Brothers, Sisters": "Irmãos, Irmãs",
            "Chathurthamasha Chart(D4)": "Mapa Chaturthamsha (D4)",
            "Fortunes, Luck of native": "Fortuna, Sorte do nativo",
            "Saptamansha Chart(D7)": "Mapa Saptamansha (D7)",
            "Impregnation, Birth of the child": "Concepção, Nascimento do filho",
            "Dashamansha Chart(D10)": "Mapa Dashamansha (D10)",
            "livelihood, Profession": "Sustento, Profissão",
            "Dwadasha Chart(D12)": "Mapa Dwadashamsha (D12)",
            "Parents, paternal happiness": "Pais, Felicidade paternal",
            "Shodashamsha Chart(D16)": "Mapa Shodashamsha (D16)",
            "Happiness, miseries, conveyance": "Felicidade, Dificuldades, Veículos",
            "Vishamansha Chart(D20)": "Mapa Vishamansha (D20)",
            "Spiritual progress, worship": "Progresso espiritual, Devoção",
            "Chaturvimshamsha(D24)": "Chaturvimshamsha (D24)",
            "Academic achievement, education": "Realização acadêmica, Educação",
            "Bhamsha Chart(D27)": "Mapa Bhamsha (D27)",
            "Physical strength, stamina": "Força física, Resistência",
            "Trishamansha Chart(D30)": "Mapa Trishamansha (D30)",
            "Evil, Adversities of life": "Mal, Adversidades da vida",
            "Khavedamsha Chart(D40)": "Mapa Khavedamsha (D40)",
            "Auspicious & inauspicious effect": "Efeitos auspiciosos e inauspiciosos",
            "Akshvedansha Chart(D45)": "Mapa Akshvedamsha (D45)",
            "Character and couduct of the native": "Caráter e conduta do nativo",
            "Shashtymsah Chart(D60)": "Mapa Shashtiamsha (D60)",
            "Shows general happiness": "Mostra felicidade geral",
            "Degrees": "Graus",
            "Sign Lord": "Regente do Signo",
            "Nakshatra Lord": "Regente do Nakshatra",
            "Sub Lord": "Sub-Regente",
            "Sub Sub Lord": "Sub-Sub-Regente",
            "Lord": "Regente",
            "Symbol": "Símbolo",
            "Characteristics": "Características",
            "Day of Fast": "Dia de Jejum",
            "luchy Gems": "Pedras da Sorte",
            "Personality": "Personalidade",
            "Health": "Saúde",
            "Relationships": "Relacionamentos",
            "BHAVA KUNDLI": "BHAVA KUNDLI",
            "Bhramari": "Bhramari",
            "Bhadrika": "Bhadrika",
            "Ulka": "Ulka",
            "Siddha": "Siddha",
            "Sankata": "Sankata",
            "Mangala": "Mangala",
            "Pingala": "Pingala",
            "Dhanya": "Dhanya",
            "Remedies Of Sadhesati": "Remédios para Sadhesati",
            "Saturn Sign": "Signo de Saturno",
            "Is Saturn Retro?": "Saturno está retrógrado?",
            "Phase": "Fase",
            "Intensity": "Intensidade",
            "Direction": "Direção",
            "Strength": "Força",
            "Percentage": "Porcentagem",
            "Zodiac Sign": "Signo do Zodíaco",
            "Planet Degree": "Grau do Planeta",
            "Lord Of": "Regente de",
            "Combust/Aw...": "Combusto/Af...",
            "Lucky Stone": "Pedra da Sorte",
            "Life Stone": "Pedra da Vida",
            "Finger": "Dedo",
            "Day": "Dia",
            "Time to Wear": "Horário para Usar",
            "Mantra": "Mantra",
            "Upagraha Longitude": "Longitude do Upagraha",
            "Rashi": "Rashi",
            "Pada": "Pada",
            "Upagraha/Nakshatra/Sub Lord": "Upagraha/Nakshatra/Sub-Regente",
            "Jamini Planets": "Planetas Jamini",
            "Jamini Padas": "Padas Jamini",
            "Code": "Código",
            "Jamini Karakara": "Jamini Karakara",
            "Uchcha Bala": "Uchcha Bala",
            "Saptavarga Bala": "Saptavarga Bala",
            "Yugmayugma Bhamsha Bala": "Yugmayugma Bhamsha Bala",
            "Kendradi Bala": "Kendradi Bala",
            "Drekkana Bala": "Drekkana Bala",
            "Total Sthana Bala": "Total Sthana Bala",
            "Total Dig Bala": "Total Dig Bala",
            "Nattunnata Bala": "Nattunnata Bala",
            "Paksha Bala": "Paksha Bala",
            "Tribhaga Bala": "Tribhaga Bala",
            "Varshadhipati": "Varshadhipati",
            "Maasadipati": "Maasadipati",
            "Vaaradhipati": "Vaaradhipati",
            "Horadhipati": "Horadhipati",
            "Ayana Bala": "Ayana Bala",
            "Yuddha Bala": "Yuddha Bala",
            "Total Kaal Bala": "Total Kaal Bala",
            "Naisargika Bala": "Naisargika Bala",
            "Chestha Bala": "Chestha Bala",
            "Drik Bala": "Drik Bala",
            "Total Shadbala": "Total Shadbala",
            "Shadbala In Rupa": "Shadbala em Rupa",
            "Min Require": "Mín. Requerido",
            "Ratio": "Proporção",
            "Rank": "Classificação",
            "Sun": "Sol",
            "Moon": "Lua",
            "Mars": "Marte",
            "Mercury": "Mercúrio",
            "Jupiter": "Júpiter",
            "Venus": "Vênus",
            "Saturn": "Saturno",
            "Ashtakvarga": "Ashtakvarga",
            "Sarvashtakava": "Sarvashtakavarga",
            "Prasthara Chakra": "Prasthara Chakra",
            "Ascendant": "Ascendente",
            "Total": "Total",
            "Natural Friendship": "Amizade Natural",
            "Temporary Friendship": "Amizade Temporária",
            "Five Fold Friendship": "Amizade Quíntupla",
            "Ketu": "Ketu",
            "Rahu": "Rahu",
            "Vimshottari Dasha P1": "Vimshottari Dasha P1",
            "Vimshottari Dasha P2": "Vimshottari Dasha P2",
            "AshtaKoot": "AshtaKoot",
            "Bhakut Dosha": "Bhakut Dosha",
            "Nadi Dosha": "Nadi Dosha",
            "Ashtakoot Analysis": "Análise Ashtakoot",
            "DashaKoot": "DashaKoot",
            "Personality Report": "Relatório de Personalidade",
            "Match Making Report": "Relatório de Compatibilidade",
            "Nav Pancham Yoga": "Nav Pancham Yoga",
            "Charan": "Charan",
            "Name Alphabet": "Letra do Nome",
            "Planetary Position": "Posição Planetária",
            "Lagna Chart (Birth Chart)": "Mapa Lagna (Mapa Natal)",
            "Moon Chart": "Mapa Lunar",
            "Navmansha Chart (D9)": "Mapa Navamsha (D9)",
            "Mahadasha": "Mahadasha",
            "End": "Fim",
            "Is Recommended ??": "É recomendado??",
            "Manglik Details": "Detalhes Manglik",
            "What is AshtaKoot ??": "O que é AshtaKoot??",
            "Attributes": "Atributos",
            "Description": "Descrição",
            "Received": "Recebido",
            "Graha Maitri": "Graha Maitri",
            "Bhakoota": "Bhakoota",
            "What is BhaKoot Dosha ??": "O que é BhaKoot Dosha??",
            "What is Nadi Dosha ??": "O que é Nadi Dosha??",
            "Madhya": "Madhya",
            "Nadi dosha is present": "Nadi Dosha está presente",
            "The": "Os",
            "porutham considered for horoscope matching are as follows :": "poruthams considerados para compatibilidade de horóscopo são os seguintes:",
            "Dina": "Dina",
            "Rajju": "Rajju",
            "Rasyadhipati": "Rasyadhipati",
            "Vedha": "Vedha",
            "Mahendra": "Mahendra",
            "Streedargha": "Streedargha",
            "Uranus": "Urano",
            "Neptune": "Netuno",
            "Pluto": "Plutão",
            "Tara": "Tara",
            "Please fill boy's details !!": "Por favor, preencha os dados do rapaz !!",
            "Please fill girl's details !!": "Por favor, preencha os dados da moça !!",
            "Please fill chart details !!": "Por favor, preencha os dados do mapa !!",
            "Kundli Matching": "Compatibilidade de Kundli",
            "Find your right one, through matchmaking": "Encontre a pessoa certa através da compatibilidade",
            "Open Kundli": "Abrir Kundli",
            "New Matching": "Nova Compatibilidade",
            "View Kundli": "Ver Kundli",
            "Boy's Details": "Dados do Rapaz",
            "Girl's Details": "Dados da Moça",
            "Search city, state, country": "Pesquisar cidade, estado, país",
            "Enter first name": "Digite o primeiro nome",
            "Enter last name": "Digite o sobrenome",
            "Chart Style": "Estilo do Mapa",
            "North Indian": "Norte da Índia",
            "South Indian": "Sul da Índia",
            "English": "Inglês",
            "Hindi": "Híndi",
            "MATCH HOROSCOPE": "COMPARAR HORÓSCOPO",
            "My Profile": "Meu Perfil",
            "Enter full name": "Digite o nome completo",
            "Enter email address": "Digite o endereço de e-mail",
            "Enter password": "Digite a senha",
            "Enter phone number": "Digite o número de telefone",
            "Save Chanage": "Salvar Alteração",
            "Manage your astrologers recent post": "Gerenciar postagens recentes do astrólogo",
            "Show Less": "Mostrar Menos",
            "Show More": "Mostrar Mais",
            "Total Balance": "Saldo Total",
            "Add Money": "Adicionar Dinheiro",
            "Extra": "Extra",
            "Transaction History": "Histórico de Transações",
            "Build better products with flexible tools, helpful documentation,": "Crie produtos melhores com ferramentas flexíveis, documentação útil,",
            "and a team that champions your growth.": "e uma equipe que apoia seu crescimento.",
            "Useful Link": "Links Úteis",
            "Socials": "Redes Sociais",
            "Logout Seccuessfuly !!": "Logout realizado com sucesso !!",
            "Free Kundli": "Kundli Gratuito",
            "Horoscope": "Horóscopo",
            "Dashboard": "Painel",
            "Enter your feedback !!": "Digite seu feedback !!",
            "Languages": "Idiomas",
            "incoming": "recebido",
            "request from": "solicitação de",
            "Waitlist Joined !!": "Você entrou na lista de espera !!",
            "will start in": "começará em",
            "You will receive a": "Você receberá uma",
            "request when the": "solicitação quando o",
            "astrologer is ready. Don’t worry! You will not be": "astrólogo estiver pronto. Não se preocupe! Você não será",
            "charged for missing this session.": "cobrado por perder esta sessão.",
            "Accept": "Aceitar",
            "Reject": "Rejeitar",
            "Great, what did you like the mast? 😍": "Ótimo, do que você mais gostou? 😍",
            "Skip": "Pular",
            "Payment Information": "Informações de Pagamento",
            "Amount": "Valor",
            "Tax": "Imposto",
            "Payment": "Pagamento",
            "Payment Method": "Método de Pagamento",
        
            "AstroSpace": "AstroSpace",
            "Astrology Consultation Platform": "Astrology Consultation Platform",
            "INVOICE": "INVOICE",
            "Consultation Service Receipt": "Consultation Service Receipt",
            "Invoice Number": "Invoice Number",
            "Date Issued": "Date Issued",
            "PAID": "PAID",
            "From": "From",
            "Bill To": "Bill To",
            "Service": "Service",
            "Booking ID": "Booking ID",
            "Description": "Description",
            "Duration": "Duration",
            "Rate": "Rate",
            "Amount": "Amount",
            "Free Consultation Time": "Free Consultation Time",
            "Complimentary session minutes": "Complimentary session minutes",
            "Free": "Free",
            "Consultation Fee": "Consultation Fee",
            "Standard rate (first block)": "Standard rate (first block)",
            "Extended Consultation Fee": "Extended Consultation Fee",
            "Premium rate (extended block)": "Premium rate (extended block)",
            "Consultation Service": "Consultation Service",
            "Astrology consultation session": "Astrology consultation session",
            "Subtotal": "Subtotal",
            "Platform Fee": "Platform Fee",
            "Included": "Included",
            "Total Amount": "Total Amount",
            "DOB": "DOB",
            "Kundali Chart Used": "Kundali Chart Used",
            "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.": "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.",
            "For support, contact us at support@astrospace.com": "For support, contact us at support@astrospace.com",
            "Free Minute": "Free Minute",
            "Verified": "Verified",
            "End Session": "End Session",
            "Voice Call": "Voice Call",
            "typing...": "typing...",
            "CANCEL": "CANCEL",
            "OK": "OK",
            "Install Progressive Web Application": "Install Progressive Web Application",
            "This site has app functionality. Install it on your device for extensive experience and easy access.": "This site has app functionality. Install it on your device for extensive experience and easy access.",
            "Install": "Install",
            "Search location": "Search location",
            "Location not found !!": "Location not found !!",
            "Waiting for remote user to join...": "Waiting for remote user to join...",
            "End Video Session": "End Video Session",
            "Initializing WebRTC P2P...": "Initializing WebRTC P2P...",
            "Access Denied (Camera/Mic)": "Access Denied (Camera/Mic)",
            "Connection Failed": "Connection Failed",
            "Time Remaining": "Time Remaining",
            "Call ended": "Call ended",

            "Offline": "Offline",}
    },
    ru: {
        translation: {
            "Enter Mobile Number !!": "Введите номер мобильного телефона !!",
            "In Valid OTP !!": "Неверный OTP !!",
            "Please enter password !!": "Пожалуйста, введите пароль !!",
            "Password not match !!": "Пароли не совпадают !!",
            "Reset Password": "Сбросить пароль",
            "Enter your phone number and new password": "Введите номер телефона и новый пароль",
            "Phone Number": "Номер телефона",
            "Enter your number": "Введите ваш номер",
            "Search": "Поиск",
            "Verify": "Подтвердить",
            "You will receive a 6 digit code for": "Вы получите 6-значный код для",
            "verification to": "подтверждения для",
            "Submit": "Отправить",
            "Enter your password and new password": "Введите текущий пароль и новый пароль",
            "New Password": "Новый пароль",
            "Enter new password": "Введите новый пароль",
            "Confirm New Password": "Подтвердите новый пароль",
            "Confirm new password": "Подтвердите новый пароль",
            "Back to Login": "Назад к входу",
            "Back": "Назад",
            "Enter Login Details !!": "Введите данные для входа !!",
            "Welcome Back!": "С возвращением!",
            "Sign in to your account": "Войдите в свою учетную запись",
            "Password": "Пароль",
            "Enter your password": "Введите ваш пароль",
            "Forgot Password?": "Забыли пароль?",
            "Sign In": "Войти",
            "Don't have an account?": "Нет аккаунта?",
            "Sign Up": "Зарегистрироваться",
            "Please enter all details !!": "Пожалуйста, заполните все данные !!",
            "Please enter valid email !!": "Пожалуйста, введите корректный email !!",
            "Please enter birth place !!": "Пожалуйста, укажите место рождения !!",
            "Please select language !!": "Пожалуйста, выберите язык !!",
            "Step": "Шаг",
            "Enter Your Details": "Введите ваши данные",
            "Hey there! what is your name?": "Привет! Как вас зовут?",
            "Full Name": "Полное имя",
            "Email Address": "Адрес электронной почты",
            "Enter your Full Name": "Введите ваше полное имя",
            "Enter your email": "Введите ваш email",
            "What is your gender?": "Ваш пол?",
            "Male": "Мужской",
            "Female": "Женский",
            "Enter your birth date": "Введите дату рождения",
            "Enter your birth time": "Введите время рождения",
            "Enter your birth Place": "Введите место рождения",
            "Do you know which languages?": "Какими языками вы владеете?",
            "Enter Your Place": "Введите ваше место",
            "Back to Step": "Назад к шагу",
            "Next": "Далее",
            "My Appointments": "Мои записи",
            "Manage your astrology consultations": "Управляйте своими астрологическими консультациями",
            "Upcoming": "Предстоящие",
            "Past": "Прошедшие",
            "Pending": "В ожидании",
            "Accepted": "Принятые",
            "Start": "Начать",
            "Completed": "Завершено",
            "Canceled": "Отменено",
            "ID": "ID",
            "Chat": "Чат",
            "Audio Call": "Аудиозвонок",
            "Video Call": "Видеозвонок",
            "View Details": "Посмотреть детали",
            "Cancel": "Отменить",
            "No Upcoming Appointment Found !!": "Предстоящих записей не найдено !!",
            "Currently you don't have any upcoming appointment.": "В настоящее время у вас нет предстоящих записей.",
            "No Past Appointment Found !!": "Прошедших записей не найдено !!",
            "Currently you don't have any past appointment.": "В настоящее время у вас нет прошедших записей.",
            "Status": "Статус",
            "Service Type": "Тип услуги",
            "Date": "Дата",
            "Time": "Время",
            "Price": "Цена",
            "Booked Person Details": "Данные записанного человека",
            "name": "имя",
            "Date of Birth": "Дата рождения",
            "Birth Place": "Место рождения",
            "Gender": "Пол",
            "Complete Details": "Полные данные",
            "Start Time": "Время начала",
            "End Time": "Время окончания",
            "Total Duration": "Общая продолжительность",
            "Billable Time": "Оплачиваемое время",
            "Billed Fee First": "Начальная стоимость",
            "Billed Fee After": "Стоимость после",
            "Total Consultation Fee": "Общая стоимость консультации",
            "Kundali Details": "Детали Кундали",
            "Name": "Имя",
            "Send Notification": "Отправить уведомление",
            "Continue Chat": "Продолжить чат",
            "Write message !!": "Напишите сообщение !!",
            "Astrologer Ai Assistant": "AI-ассистент астролога",
            "Ask anything about your horoscope...": "Спросите что угодно о вашем гороскопе...",
            "Write message to assistant": "Напишите сообщение ассистенту",
            "Clear Chat?": "Очистить чат?",
            "All messages will be deleted permanently.": "Все сообщения будут удалены навсегда.",
            "Clear": "Очистить",
            "Payment faild !!": "Платеж не выполнен !!",
            "Please Complete Last Apointment !!": "Пожалуйста, завершите предыдущую запись !!",
            "Please enter comment !!": "Пожалуйста, введите комментарий !!",
            "Insufficient wallet balance !!": "Недостаточно средств на балансе !!",
            "Orders": "Заказы",
            "Experience": "Опыт",
            "Rating": "Рейтинг",
            "Unfollow": "Отписаться",
            "Follow": "Подписаться",
            "Send Gift": "Отправить подарок",
            "Start a Consultation": "Начать консультацию",
            "Chat with astrologer": "Чат с астрологом",
            "For new user": "Для новых пользователей",
            "min free": "мин бесплатно",
            "Call with astrologer": "Звонок с астрологом",
            "Video call with astrologer": "Видеозвонок с астрологом",
            "Astrologer Bio": "Биография астролога",
            "Reviews": "Отзывы",
            "Activity": "Активность",
            "FAQ's": "Вопросы и ответы",
            "Media": "Медиа",
            "Comment": "Комментарий",
            "No comment yet": "Пока нет комментариев",
            "start the conversation": "начните разговор",
            "Poast your replay": "Опубликуйте ваш ответ",
            "Delete comment": "Удалить комментарий",
            "Are you sure you want to delete this comment?": "Вы уверены, что хотите удалить этот комментарий?",
            "Cancle": "Отмена",
            "Delete": "Удалить",
            "Intro Audio": "Вступительное аудио",
            "Intro Video": "Вступительное видео",
            "Hear from": "Услышьте от",
            "Please select user !!": "Пожалуйста, выберите пользователя !!",
            "Please select amount !!": "Пожалуйста, выберите сумму !!",
            "Please select payment method !!": "Пожалуйста, выберите способ оплаты !!",
            "Select Kundli": "Выберите Кундли",
            "Add Kundli": "Добавить Кундли",
            "Minimum balance of": "Минимальный баланс",
            "minutes": "минут",
            "is required to start chat with": "требуется для начала чата с",
            "Wallet Balance": "Баланс кошелька",
            "Required": "Требуется",
            "Proceed to Pay": "Перейти к оплате",
            "extra in your": "дополнительно в вашем",
            "wallet with this": "кошельке с этим",
            "Woohoo!": "Ура!",
            "Recharge Amount": "Сумма пополнения",
            "GST": "НДС",
            "Wallet Amount": "Сумма в кошельке",
            "Payble Amount": "Сумма к оплате",
            "Pay from Wallet": "Оплатить с кошелька",
            "Available": "Доступно",
            "Payment Getway Method": "Способ оплаты",
            "Continue": "Продолжить",
            "Fortune Cookie - Unveil Your Daily Wisdom": "Печенье с предсказанием — откройте свою мудрость дня",
            "Crack open a fortune cookie to reveal a piece of daily wisdom. Let the message guide you through your day with positivity and insight.": "Откройте печенье с предсказанием, чтобы узнать мудрость дня. Пусть это послание направит вас с позитивом и осознанностью.",
            "Ask The Fortune Cookie": "Спросить печенье с предсказанием",
            "Crack open your Fortune Cookie": "Откройте своё печенье с предсказанием",
            "Crack another one open": "Откройте ещё одно",
            "Love Compatibility": "Совместимость в любви",
            "Find out how compatible you are with your lover, friend, or colleague using our love compatibility calculator. Get your results now.": "Узнайте, насколько вы совместимы с любимым человеком, другом или коллегой с помощью нашего калькулятора совместимости. Получите результат прямо сейчас.",
            "Are Aries And Taurus Compatible": "Совместимы ли Овен и Телец",
            "Aries And Taurus Strengths": "Сильные стороны Овна и Тельца",
            "Aries And Taurus Weaknesses": "Слабые стороны Овна и Тельца",
            "Aries And Taurus Elements": "Стихии Овна и Тельца",
            "Aries And Taurus Dates": "Даты Овна и Тельца",
            "Are Aries And Taurus Compatibility Score": "Оценка совместимости Овна и Тельца",
            "General": "Общее",
            "Communication": "Общение",
            "Sex": "Секс",
            "Select Another": "Выбрать другой",
            "Aries": "Овен",
            "Taurus": "Телец",
            "Gemini": "Близнецы",
            "Cancer": "Рак",
            "Leo": "Лев",
            "Virgo": "Дева",
            "Libra": "Весы",
            "Scorpio": "Скорпион",
            "Sagittarius": "Стрелец",
            "Capricorn": "Козерог",
            "Aquarius": "Водолей",
            "Pisces": "Рыбы",
            "Please select Your Partner Sign": "Пожалуйста, выберите знак партнёра",
            "Please select Your Sign": "Пожалуйста, выберите ваш знак",
            "Please fill all details !!": "Пожалуйста, заполните все данные !!",
            "Discover Your Core Numbers That Define You": "Откройте свои ключевые числа, которые определяют вас",
            "Explore your core numbers like Life Path, Destiny, and Personal Year—complete with strengths, challenges, and meaningful interpretations.": "Изучите свои ключевые числа — Число жизненного пути, Судьбы и Персонального года — с описанием сильных сторон, вызовов и значений.",
            "Get Your Numbers": "Получить свои числа",
            "First Name": "Имя",
            "Last Name": "Фамилия",
            "Method": "Метод",
            "Chaldean": "Халдейский",
            "Pythagorean": "Пифагорейский",
            "Strengths": "Сильные стороны",
            "Challenges": "Испытания",
            "Advice": "Совет",
            "Get Report": "Получить отчёт",
            "Select Tarot One Card": "Выберите одну карту Таро",
            "Select Your Card": "Выберите свою карту",
            "Get Another": "Выбрать другую",
            "Yes Or No Tarot": "Таро «Да или Нет»",
            "Get instant Yes or No answers to pressing questions.": "Получите мгновенный ответ «Да» или «Нет» на волнующие вопросы.",
            "Daily Tarot": "Ежедневное Таро",
            "Receive daily tarot readings on love, career, and finance.": "Получайте ежедневные расклады на любовь, карьеру и финансы.",
            "In-Depth Love Reading": "Глубокий любовный расклад",
            "Deep dive into your love life with relationship-specific readings.": "Погрузитесь в свою личную жизнь с помощью подробных любовных раскладов.",
            "Flirt Love Reading": "Флирт-расклад на любовь",
            "Reveal insights into playful and romantic connections.": "Узнайте больше о лёгких и романтических отношениях.",
            "Erotic Love Reading": "Эротический любовный расклад",
            "Insights into intimate and personal love dynamics.": "Инсайты о близости и интимной динамике отношений.",
            "Egyptian Prediction": "Египетское предсказание",
            "Access ancient Egyptian insights beyond visible truths.": "Получите доступ к древнеегипетской мудрости за пределами очевидного.",
            "Ex-Flame Reading": "Расклад на бывшего партнёра",
            "Explore the possibilities of rekindling with an ex-partner.": "Изучите возможность возобновления отношений с бывшим партнёром.",
            "Made For Each Other Or Not Reading": "Подходите ли вы друг другу",
            "Discover if your relationship has long-term potential.": "Узнайте, есть ли у ваших отношений долгосрочный потенциал.",
            "Power Life Reading": "Расклад «Сила жизни»",
            "Take control of your destiny with life-changing tarot readings.": "Возьмите судьбу под контроль с помощью трансформационных раскладов Таро.",
            "Know Your Friend Reading": "Расклад «Узнай своего друга»",
            "Understand the true intentions of your friendships.": "Поймите истинные намерения ваших друзей.",
            "Divine Angel Reading": "Божественный ангельский расклад",
            "Connect with divine guidance for clarity and spiritual insight.": "Соединитесь с божественным руководством для ясности и духовного понимания.",
            "Career Daily Reading": "Ежедневный карьерный расклад",
            "Elevate your career with daily tarot insights to achieve your professional goals.": "Развивайте карьеру с ежедневными подсказками Таро для достижения профессиональных целей.",
            "Dream Come True Reading": "Расклад «Мечта сбывается»",
            "Gain insights into making your dreams and goals a reality.": "Получите понимание того, как воплотить мечты и цели в реальность.",
            "Past Lives Connection Reading": "Расклад «Связь прошлых жизней»",
            "Explore your journey across time to understand your path ahead.": "Исследуйте своё путешествие через время, чтобы понять дальнейший путь.",
            "Please pick your cards !!": "Пожалуйста, выберите карты !!",
            "Get Your Reading": "Получить расклад",
            "Select Tarot Three Card": "Выберите три карты Таро",
            "Heartbreak Reading": "Расклад при разбитом сердце",
            "Find guidance and healing for a broken heart.": "Найдите руководство и исцеление для разбитого сердца.",
            "Wisdom Reading": "Расклад мудрости",
            "Balance your energies and find mental peace through wisdom.": "Сбалансируйте энергию и обретите душевный покой.",
            "Divine Magic Reading": "Расклад божественной магии",
            "Discover mystical insights with magical tarot guidance.": "Откройте мистические инсайты с помощью магического Таро.",
            "Select Tarot Two Card": "Выберите две карты Таро",
            "Love Triangle Reading": "Расклад «Любовный треугольник»",
            "Get clarity in choosing between multiple romantic interests.": "Получите ясность при выборе между несколькими романтическими интересами.",
            "Past-Present-Future Reading": "Расклад «Прошлое–Настоящее–Будущее»",
            "Zodiac Gift Guru": "Зодиакальный гуру подарков",
            "January": "Январь",
            "February": "Февраль",
            "March": "Март",
            "April": "Апрель",
            "May": "Май",
            "June": "Июнь",
            "July": "Июль",
            "August": "Август",
            "September": "Сентябрь",
            "October": "Октябрь",
            "November": "Ноябрь",
            "December": "Декабрь",
            "Yesterday": "Вчера",
            "Today": "Сегодня",
            "Tomorrow": "Завтра",
            "Gift Recommendations": "Рекомендации подарков",
            "insight": "инсайт",
            "Career": "Карьера",
            "Love": "Любовь",
            "Finance": "Финансы",
            "Popularity": "Популярность",
            "Experience: High to Low": "Опыт: по убыванию",
            "Experience: Low to High": "Опыт: по возрастанию",
            "Orders: High to Low": "Заказы: по убыванию",
            "Orders: Low to High": "Заказы: по возрастанию",
            "Price: High to Low": "Цена: по убыванию",
            "Price: Low to High": "Цена: по возрастанию",
            "Rating: High to Low": "Рейтинг: по убыванию",
            "Search name...": "Поиск по имени...",
            "Online": "Онлайн",
            "Busy": "Занят",
            "Exp": "Опыт",
            "yrs": "лет",
            "orders": "заказов",
            "min": "мин",
            "Chat Now": "Начать чат",
            "Wait": "Подождите",
            "There are no astrologers in this category.": "В этой категории нет астрологов.",
            "Sort": "Сортировка",
            "Filter": "Фильтр",
            "Category": "Категория",
            "All": "Все",
            "Sort by": "Сортировать по",
            "Skill": "Навык",
            "Language": "Язык",
            "Reset": "Сбросить",
            "Apply": "Применить",
            "You have 30 seconds left. Please recharge immediately to continue the conversation.": "У вас осталось 30 секунд. Пожалуйста, пополните баланс, чтобы продолжить разговор.",
            "Free chat over! Next minutes will use wallet balance.": "Бесплатный чат завершён! Далее минуты будут списываться с баланса.",
            "Complete": "Завершить",
            "End Chat": "Завершить чат",
            "Message": "Сообщение",
            "Hi": "Привет",
            "lets continue this chat at discounted price of": "давайте продолжим этот чат по сниженной цене",
            "Are you sure you want to end tha chat to": "Вы уверены, что хотите завершить чат с",
            "No": "Нет",
            "Yes": "Да",
            "Chat With Astrologer": "Чат с астрологом",
            "Appointment List": "Список записей",
            "My Following": "Мои подписки",
            "Recent Post": "Последний пост",
            "Welcome back": "С возвращением",
            "Manage your astrology services": "Управляйте своими астрологическими услугами",
            "Logout": "Выйти",
            "Login": "Войти",
            "My Profile (Member Since)": "Мой профиль (участник с)",
            "My Followings": "Мои подписки",
            "You are following": "Вы подписаны на",
            "people": "чел.",
            "Years": "Лет",
            "No Following Found !!": "Подписки не найдены !!",
            "Currently you don't have any follow.": "В настоящее время у вас нет подписок.",
            "Hey There!": "Привет!",
            "What is your name?": "Как вас зовут?",
            "Enter your first Name": "Введите ваше имя",
            "Enter your last Name": "Введите вашу фамилию",
            "male": "мужской",
            "female": "женский",
            "Where wrer you bron?": "Где вы родились?",
            "Please Select Language": "Пожалуйста, выберите язык",
            "english": "английский",
            "hindi": "хинди",
            "north": "северный",
            "south": "южный",
            "Select Chart Type": "Выберите тип карты",
            "Start chat with astrologer": "Начать чат с астрологом",
            "Search location": "Поиск локации",
            "Location not found !!": "Локация не найдена !!",
            "Enter bord state": "Введите штат/область рождения",
            "Search location...": "Поиск локации...",
            "Astrologers": "Астрологи",
            "Top Astrologers. 24 * 7 customer support. Happy to help": "Лучшие астрологи. Поддержка 24/7. Рады помочь",
            "per min": "за мин",
            "Top Astrologers": "Лучшие астрологи",
            "rate": "ставка",
            "Top Rated Astrologers": "Астрологи с высоким рейтингом",
            "No astrologers found !!": "Астрологи не найдены !!",
            "FAQs": "Часто задаваемые вопросы",
            "Raning": "Рейтинг",
            "Raning Apointment": "Оценка консультации",
            "Select Other Sign": "Выберите другой знак",
            "Horoscopes": "Гороскопы",
            "Daily Horoscope": "Ежедневный гороскоп",
            "Weekly Horoscope": "Еженедельный гороскоп",
            "Monthly Horoscope": "Ежемесячный гороскоп",
            "Yearly Horoscope": "Годовой гороскоп",
            "Composite Friendship Table": "Таблица совместимости дружбы",
            "Kp Planetary Details": "Планетарные детали KP",
            "Kp House Cusps And Chart": "Куспы домов и карта KP",
            "Ascendant Report": "Отчёт по асценденту",
            "Bhava Kundli": "Бхава Кундли",
            "Vimshottari Dasha": "Вимшоттари Даша",
            "Yogini Dasha": "Йогини Даша",
            "Sadhesati Analysis": "Анализ Саде-Сати",
            "Sadhesati Life Analysis": "Жизненный анализ Саде-Сати",
            "Kalsarpa Dosha": "Калсарпа Доша",
            "Manglik Analysis": "Анализ Мангалик",
            "Planet Profiles": "Профили планет",
            "Gemstone Suggestions": "Рекомендации по камням",
            "Upagraha": "Упаграха",
            "Jaimini Astrology": "Астрология Джаймини",
            "Chara Dasha": "Чара Даша",
            "Shadbala": "Шадбала",
            "Sudarshana Chakra": "Сударшана Чакра",
            "Bhinnashtakvarga": "Бхиннаштакаварга",
            "Yogas": "Йоги",
            "Introduction": "Введение",
            "Basic Astrological Details": "Основные астрологические данные",
            "Planetary Positions": "Положение планет",
            "Horoscope Charts": "Карты гороскопа",
            "House Cusps And Sandhi": "Куспы домов и сандхи",
            "Divisional Charts": "Дивизионные карты",
            "Basic Details": "Основные данные",
            "Ghat Chakra": "Гхат Чакра",
            "Panchange Details": "Детали Панчанга",
            "Astrological Details": "Астрологические детали",
            "Time of Birth": "Время рождения",
            "Place of Birth": "Место рождения",
            "Latitude": "Широта",
            "Longitude": "Долгота",
            "Timezone": "Часовой пояс",
            "Ayanamsa": "Аянамша",
            "Sunrise": "Восход",
            "Sunset": "Закат",
            "Month": "Месяц",
            "Tithi": "Титхи",
            "Yoga": "Йога",
            "Karana": "Карана",
            "Moon Sign": "Лунный знак",
            "Moon Vaar": "Лунный день",
            "Nakshatra": "Накшатра",
            "Varna": "Варна",
            "Vashya": "Вашья",
            "Yoni": "Йони",
            "Gana": "Гана",
            "Nadi": "Нади",
            "Sun Sign": "Солнечный знак",
            "Tatva": "Татва",
            "Paya": "Пайя",
            "Yanja": "Янджа",
            "Planets": "Планеты",
            "Sign": "Знак",
            "Sign No": "№ знака",
            "LAGNA CHART (BIRTH CHART)": "ЛАГНА КАРТА (НАТАЛЬНАЯ КАРТА)",
            "MOON CHART": "ЛУННАЯ КАРТА",
            "NAVMANSHA CHART (D9)": "НАВМАНША КАРТА (D9)",
            "House": "Дом",
            "Bhav Madhya": "Бхав Мадхья",
            "Bhav Sandhi": "Бхав Сандхи",
            "Chalit Chart": "Чалит Карта",
            "Sun Chart": "Солнечная карта",
            "Health, Constitution, Body": "Здоровье, конституция, тело",
            "Hora Chart(D2)": "Хора Карта (D2)",
            "Finance, Wealth, Prosperity": "Финансы, богатство, процветание",
            "Dreshkan Chart(D3)": "Дрешкан Карта (D3)",
            "Brothers, Sisters": "Братья, сёстры",
            "Chathurthamasha Chart(D4)": "Чатуртхамша Карта (D4)",
            "Fortunes, Luck of native": "Фортуна, удача человека",
            "Saptamansha Chart(D7)": "Саптаманша Карта (D7)",
            "Impregnation, Birth of the child": "Зачатие, рождение ребёнка",
            "Dashamansha Chart(D10)": "Дашаманша Карта (D10)",
            "livelihood, Profession": "Заработок, профессия",
            "Dwadasha Chart(D12)": "Двадаша Карта (D12)",
            "Parents, paternal happiness": "Родители, отцовское счастье",
            "Shodashamsha Chart(D16)": "Шодашамша Карта (D16)",
            "Happiness, miseries, conveyance": "Счастье, страдания, транспорт",
            "Vishamansha Chart(D20)": "Вишаманша Карта (D20)",
            "Spiritual progress, worship": "Духовный прогресс, поклонение",
            "Chaturvimshamsha(D24)": "Чатурвимшамша (D24)",
            "Academic achievement, education": "Академические достижения, образование",
            "Bhamsha Chart(D27)": "Бхамша Карта (D27)",
            "Physical strength, stamina": "Физическая сила, выносливость",
            "Trishamansha Chart(D30)": "Тришаманша Карта (D30)",
            "Evil, Adversities of life": "Зло, жизненные трудности",
            "Khavedamsha Chart(D40)": "Кхаведамша Карта (D40)",
            "Auspicious & inauspicious effect": "Благоприятные и неблагоприятные эффекты",
            "Akshvedansha Chart(D45)": "Акшведамша Карта (D45)",
            "Character and couduct of the native": "Характер и поведение человека",
            "Shashtymsah Chart(D60)": "Шаштьямша Карта (D60)",
            "Shows general happiness": "Показывает общее счастье",
            "Degrees": "Градусы",
            "Sign Lord": "Управитель знака",
            "Nakshatra Lord": "Управитель накшатры",
            "Sub Lord": "Суб-управитель",
            "Sub Sub Lord": "Суб-суб-управитель",
            "Lord": "Управитель",
            "Symbol": "Символ",
            "Characteristics": "Характеристики",
            "Day of Fast": "День поста",
            "luchy Gems": "Счастливые камни",
            "Personality": "Личность",
            "Health": "Здоровье",
            "Relationships": "Отношения",
            "BHAVA KUNDLI": "БХАВА КУНДЛИ",
            "Bhramari": "Бхрамари",
            "Bhadrika": "Бхадрика",
            "Ulka": "Улка",
            "Siddha": "Сиддха",
            "Sankata": "Санката",
            "Mangala": "Мангала",
            "Pingala": "Пингала",
            "Dhanya": "Дханья",
            "Remedies Of Sadhesati": "Средства для Саде-Сати",
            "Saturn Sign": "Знак Сатурна",
            "Is Saturn Retro?": "Сатурн ретроградный?",
            "Phase": "Фаза",
            "Intensity": "Интенсивность",
            "Direction": "Направление",
            "Strength": "Сила",
            "Percentage": "Процент",
            "Zodiac Sign": "Знак зодиака",
            "Planet Degree": "Градус планеты",
            "Lord Of": "Управляет",
            "Combust/Aw...": "Сожжён/Ослаб...",
            "Lucky Stone": "Счастливый камень",
            "Life Stone": "Камень жизни",
            "Finger": "Палец",
            "Day": "День",
            "Time to Wear": "Время ношения",
            "Mantra": "Мантра",
            "Upagraha Longitude": "Долгота Упаграхи",
            "Rashi": "Раши",
            "Pada": "Пада",
            "Upagraha/Nakshatra/Sub Lord": "Упаграха/Накшатра/Суб-управитель",
            "Jamini Planets": "Планеты Джаймини",
            "Jamini Padas": "Пады Джаймини",
            "Code": "Код",
            "Jamini Karakara": "Каракара Джаймини",
            "Uchcha Bala": "Учча Бала",
            "Saptavarga Bala": "Саптаварга Бала",
            "Yugmayugma Bhamsha Bala": "Югмайугма Бхамша Бала",
            "Kendradi Bala": "Кендради Бала",
            "Drekkana Bala": "Дреккана Бала",
            "Total Sthana Bala": "Общая Стхана Бала",
            "Total Dig Bala": "Общая Диг Бала",
            "Nattunnata Bala": "Наттунната Бала",
            "Paksha Bala": "Пакша Бала",
            "Tribhaga Bala": "Трибхага Бала",
            "Varshadhipati": "Варшадхипати",
            "Maasadipati": "Маасадипати",
            "Vaaradhipati": "Ваарадхипати",
            "Horadhipati": "Хорадхипати",
            "Ayana Bala": "Аяна Бала",
            "Yuddha Bala": "Юддха Бала",
            "Total Kaal Bala": "Общая Каал Бала",
            "Naisargika Bala": "Найсаргика Бала",
            "Chestha Bala": "Чешта Бала",
            "Drik Bala": "Дрик Бала",
            "Total Shadbala": "Общая Шадбала",
            "Shadbala In Rupa": "Шадбала в Рупа",
            "Min Require": "Мин. требование",
            "Ratio": "Соотношение",
            "Rank": "Ранг",
            "Sun": "Солнце",
            "Moon": "Луна",
            "Mars": "Марс",
            "Mercury": "Меркурий",
            "Jupiter": "Юпитер",
            "Venus": "Венера",
            "Saturn": "Сатурн",
            "Ashtakvarga": "Аштакварга",
            "Sarvashtakava": "Сарваштакварга",
            "Prasthara Chakra": "Прастхара Чакра",
            "Ascendant": "Асцендент",
            "Total": "Итого",
            "Natural Friendship": "Естественная дружба",
            "Temporary Friendship": "Временная дружба",
            "Five Fold Friendship": "Пятикратная дружба",
            "Ketu": "Кету",
            "Rahu": "Раху",
            "Vimshottari Dasha P1": "Вимшоттари Даша P1",
            "Vimshottari Dasha P2": "Вимшоттари Даша P2",
            "AshtaKoot": "АштаКут",
            "Bhakut Dosha": "Бхакут Доша",
            "Nadi Dosha": "Нади Доша",
            "Ashtakoot Analysis": "Аштакут Анализ",
            "DashaKoot": "ДашаКут",
            "Personality Report": "Отчёт о личности",
            "Match Making Report": "Отчёт о совместимости",
            "Nav Pancham Yoga": "Нав Панчам Йога",
            "Charan": "Чаран",
            "Name Alphabet": "Алфавит имени",
            "Planetary Position": "Положение планет",
            "Lagna Chart (Birth Chart)": "Лагна Карта (Родильная карта)",
            "Moon Chart": "Лунная карта",
            "Navmansha Chart (D9)": "Навманша Карта (D9)",
            "Mahadasha": "Махадаша",
            "End": "Конец",
            "Is Recommended ??": "Рекомендуется ??",
            "Manglik Details": "Детали Манглика",
            "What is AshtaKoot ??": "Что такое Аштакут ??",
            "Attributes": "Атрибуты",
            "Description": "Описание",
            "Received": "Получено",
            "Graha Maitri": "Граха Майтри",
            "Bhakoota": "Бхакута",
            "What is BhaKoot Dosha ??": "Что такое Бхакут Доша ??",
            "What is Nadi Dosha ??": "Что такое Нади Доша ??",
            "Madhya": "Мадхья",
            "Nadi dosha is present": "Присутствует Нади Доша",
            "The": "The",
            "porutham considered for horoscope matching are as follows :": "Следующие порутхам учитываются при совместимости гороскопов:",
            "Dina": "Дина",
            "Rajju": "Раджу",
            "Rasyadhipati": "Расйадхипати",
            "Vedha": "Ведха",
            "Mahendra": "Махендра",
            "Streedargha": "Стридарга",
            "Uranus": "Уран",
            "Neptune": "Нептун",
            "Pluto": "Плутон",
            "Tara": "Тара",
            "Please fill boy's details !!": "Пожалуйста, заполните данные мальчика !!",
            "Please fill girl's details !!": "Пожалуйста, заполните данные девочки !!",
            "Please fill chart details !!": "Пожалуйста, заполните данные карты !!",
            "Kundli Matching": "Совмещение Кундли",
            "Find your right one, through matchmaking": "Найдите свою пару с помощью совместимости",
            "Open Kundli": "Открыть Кундли",
            "New Matching": "Новое совпадение",
            "View Kundli": "Посмотреть Кундли",
            "Boy's Details": "Данные мальчика",
            "Girl's Details": "Данные девочки",
            "Search city, state, country": "Поиск города, штата, страны",
            "Enter first name": "Введите имя",
            "Enter last name": "Введите фамилию",
            "Chart Style": "Стиль карты",
            "North Indian": "Северная Индия",
            "South Indian": "Южная Индия",
            "English": "Английский",
            "Hindi": "Хинди",
            "MATCH HOROSCOPE": "СОВМЕСТИМОСТЬ ГОРМОСКОПОВ",
            "My Profile": "Мой профиль",
            "Enter full name": "Введите полное имя",
            "Enter email address": "Введите адрес электронной почты",
            "Enter password": "Введите пароль",
            "Enter phone number": "Введите номер телефона",
            "Save Chanage": "Сохранить изменения",
            "Manage your astrologers recent post": "Управляйте последними публикациями астролога",
            "Show Less": "Показать меньше",
            "Show More": "Показать больше",
            "Total Balance": "Общий баланс",
            "Add Money": "Добавить деньги",
            "Extra": "Дополнительно",
            "Transaction History": "История транзакций",
            "Build better products with flexible tools, helpful documentation,": "Создавайте лучшие продукты с гибкими инструментами и полезной документацией,",
            "and a team that champions your growth.": "и командой, которая поддерживает ваш рост.",
            "Useful Link": "Полезная ссылка",
            "Socials": "Соцсети",
            "Logout Seccuessfuly !!": "Выход выполнен успешно !!",
            "Free Kundli": "Бесплатная Кундли",
            "Horoscope": "Гороскоп",
            "Dashboard": "Панель управления",
            "Enter your feedback !!": "Введите ваш отзыв !!",
            "Languages": "Языки",
            "incoming": "входящий",
            "request from": "запрос от",
            "Waitlist Joined !!": "Добавлено в список ожидания !!",
            "will start in": "начнётся через",
            "You will receive a": "Вы получите",
            "request when the": "запрос, когда",
            "astrologer is ready. Don’t worry! You will not be": "астролог будет готов. Не волнуйтесь! Вам не будет",
            "charged for missing this session.": "списана плата за пропуск этой сессии.",
            "Accept": "Принять",
            "Reject": "Отклонить",
            "Great, what did you like the mast? 😍": "Отлично, что вам понравилось больше всего? 😍",
            "Skip": "Пропустить",
            "Payment Information": "Информация о платеже",
            "Amount": "Сумма",
            "Tax": "Налог",
            "Payment": "Платёж",
            "Payment Method": "Способ оплаты",
        
            "AstroSpace": "AstroSpace",
            "Astrology Consultation Platform": "Astrology Consultation Platform",
            "INVOICE": "INVOICE",
            "Consultation Service Receipt": "Consultation Service Receipt",
            "Invoice Number": "Invoice Number",
            "Date Issued": "Date Issued",
            "PAID": "PAID",
            "From": "From",
            "Bill To": "Bill To",
            "Service": "Service",
            "Booking ID": "Booking ID",
            "Description": "Description",
            "Duration": "Duration",
            "Rate": "Rate",
            "Amount": "Amount",
            "Free Consultation Time": "Free Consultation Time",
            "Complimentary session minutes": "Complimentary session minutes",
            "Free": "Free",
            "Consultation Fee": "Consultation Fee",
            "Standard rate (first block)": "Standard rate (first block)",
            "Extended Consultation Fee": "Extended Consultation Fee",
            "Premium rate (extended block)": "Premium rate (extended block)",
            "Consultation Service": "Consultation Service",
            "Astrology consultation session": "Astrology consultation session",
            "Subtotal": "Subtotal",
            "Platform Fee": "Platform Fee",
            "Included": "Included",
            "Total Amount": "Total Amount",
            "DOB": "DOB",
            "Kundali Chart Used": "Kundali Chart Used",
            "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.": "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.",
            "For support, contact us at support@astrospace.com": "For support, contact us at support@astrospace.com",
            "Free Minute": "Free Minute",
            "Verified": "Verified",
            "End Session": "End Session",
            "Voice Call": "Voice Call",
            "typing...": "typing...",
            "CANCEL": "CANCEL",
            "OK": "OK",
            "Install Progressive Web Application": "Install Progressive Web Application",
            "This site has app functionality. Install it on your device for extensive experience and easy access.": "This site has app functionality. Install it on your device for extensive experience and easy access.",
            "Install": "Install",
            "Search location": "Search location",
            "Location not found !!": "Location not found !!",
            "Waiting for remote user to join...": "Waiting for remote user to join...",
            "End Video Session": "End Video Session",
            "Initializing WebRTC P2P...": "Initializing WebRTC P2P...",
            "Access Denied (Camera/Mic)": "Access Denied (Camera/Mic)",
            "Connection Failed": "Connection Failed",
            "Time Remaining": "Time Remaining",
            "Call ended": "Call ended",

            "Offline": "Offline",}
    },
    ja: {
        translation: {
            "Enter Mobile Number !!": "携帯番号を入力してください！！",
            "In Valid OTP !!": "無効なOTP！！",
            "Please enter password !!": "パスワードを入力してください！！",
            "Password not match !!": "パスワードが一致しません！！",
            "Reset Password": "パスワードをリセット",
            "Enter your phone number and new password": "電話番号と新しいパスワードを入力してください",
            "Phone Number": "電話番号",
            "Enter your number": "番号を入力してください",
            "Search": "検索",
            "Verify": "確認",
            "You will receive a 6 digit code for": "6桁のコードを受け取ります",
            "verification to": "確認用",
            "Submit": "送信",
            "Enter your password and new password": "パスワードと新しいパスワードを入力してください",
            "New Password": "新しいパスワード",
            "Enter new password": "新しいパスワードを入力してください",
            "Confirm New Password": "新しいパスワードを確認",
            "Confirm new password": "新しいパスワードを確認してください",
            "Back to Login": "ログインに戻る",
            "Back": "戻る",
            "Enter Login Details !!": "ログイン情報を入力してください！！",
            "Welcome Back!": "お帰りなさい！",
            "Sign in to your account": "アカウントにサインイン",
            "Password": "パスワード",
            "Enter your password": "パスワードを入力してください",
            "Forgot Password?": "パスワードを忘れた場合？",
            "Sign In": "サインイン",
            "Don't have an account?": "アカウントをお持ちでないですか？",
            "Sign Up": "サインアップ",
            "Please enter all details !!": "すべての詳細を入力してください！！",
            "Please enter valid email !!": "有効なメールアドレスを入力してください！！",
            "Please enter birth place !!": "出生地を入力してください！！",
            "Please select language !!": "言語を選択してください！！",
            "Step": "ステップ",
            "Enter Your Details": "詳細を入力",
            "Hey there! what is your name?": "こんにちは！お名前は何ですか？",
            "Full Name": "氏名",
            "Email Address": "メールアドレス",
            "Enter your Full Name": "氏名を入力してください",
            "Enter your email": "メールを入力してください",
            "What is your gender?": "性別は？",
            "Male": "男性",
            "Female": "女性",
            "Enter your birth date": "生年月日を入力してください",
            "Enter your birth time": "出生時刻を入力してください",
            "Enter your birth Place": "出生地を入力してください",
            "Do you know which languages?": "どの言語を知っていますか？",
            "Enter Your Place": "場所を入力してください",
            "Back to Step": "ステップに戻る",
            "Next": "次へ",
            "My Appointments": "マイ予約",
            "Manage your astrology consultations": "占星術相談を管理",
            "Upcoming": "今後の予定",
            "Past": "過去",
            "Pending": "保留中",
            "Accepted": "承認済み",
            "Start": "開始",
            "Completed": "完了",
            "Canceled": "キャンセル",
            "ID": "ID",
            "Chat": "チャット",
            "Audio Call": "音声通話",
            "Video Call": "ビデオ通話",
            "View Details": "詳細を見る",
            "Cancel": "キャンセル",
            "No Upcoming Appointment Found !!": "今後の予約はありません！！",
            "Currently you don't have any upcoming appointment.": "現在、今後の予約はありません。",
            "No Past Appointment Found !!": "過去の予約はありません！！",
            "Currently you don't have any past appointment.": "現在、過去の予約はありません。",
            "Status": "ステータス",
            "Service Type": "サービス種類",
            "Date": "日付",
            "Time": "時間",
            "Price": "料金",
            "Booked Person Details": "予約者情報",
            "name": "名前",
            "Date of Birth": "生年月日",
            "Birth Place": "出生地",
            "Gender": "性別",
            "Complete Details": "詳細",
            "Start Time": "開始時間",
            "End Time": "終了時間",
            "Total Duration": "合計時間",
            "Billable Time": "課金時間",
            "Billed Fee First": "先に請求された料金",
            "Billed Fee After": "後で請求された料金",
            "Total Consultation Fee": "合計相談料",
            "Kundali Details": "クンダリ詳細",
            "Name": "名前",
            "Send Notification": "通知を送る",
            "Continue Chat": "チャットを続ける",
            "Write message !!": "メッセージを書く！！",
            "Astrologer Ai Assistant": "占星術AIアシスタント",
            "Ask anything about your horoscope...": "ホロスコープについて何でも質問してください…",
            "Write message to assistant": "アシスタントにメッセージを書く",
            "Clear Chat?": "チャットを消去しますか？",
            "All messages will be deleted permanently.": "すべてのメッセージは完全に削除されます。",
            "Clear": "消去",
            "Payment faild !!": "支払いに失敗しました！！",
            "Please Complete Last Apointment !!": "前回の予約を完了してください！！",
            "Please enter comment !!": "コメントを入力してください！！",
            "Insufficient wallet balance !!": "ウォレット残高が不足しています！！",
            "Orders": "注文",
            "Experience": "経験",
            "Rating": "評価",
            "Unfollow": "フォロー解除",
            "Follow": "フォロー",
            "Send Gift": "ギフトを送る",
            "Start a Consultation": "相談を開始",
            "Chat with astrologer": "占星術師とチャット",
            "For new user": "新規ユーザー向け",
            "min free": "無料分",
            "Call with astrologer": "占星術師と通話",
            "Video call with astrologer": "占星術師とビデオ通話",
            "Astrologer Bio": "占星術師プロフィール",
            "Reviews": "レビュー",
            "Activity": "活動",
            "FAQ's": "よくある質問",
            "Media": "メディア",
            "Comment": "コメント",
            "No comment yet": "まだコメントはありません",
            "start the conversation": "会話を始める",
            "Poast your replay": "返信を投稿",
            "Delete comment": "コメントを削除",
            "Are you sure you want to delete this comment?": "このコメントを削除してもよろしいですか？",
            "Cancle": "キャンセル",
            "Delete": "削除",
            "Intro Audio": "イントロオーディオ",
            "Intro Video": "イントロビデオ",
            "Hear from": "からの声",
            "Please select user !!": "ユーザーを選択してください！！",
            "Please select amount !!": "金額を選択してください！！",
            "Please select payment method !!": "支払い方法を選択してください！！",
            "Select Kundli": "クンドリを選択",
            "Add Kundli": "クンドリを追加",
            "Minimum balance of": "最低残高",
            "minutes": "分",
            "is required to start chat with": "とのチャットを開始するには必要です",
            "Wallet Balance": "ウォレット残高",
            "Required": "必須",
            "Proceed to Pay": "支払いに進む",
            "extra in your": "あなたのウォレットに追加",
            "wallet with this": "このウォレットで",
            "Woohoo!": "やったー！",
            "Recharge Amount": "チャージ額",
            "GST": "消費税",
            "Wallet Amount": "ウォレット額",
            "Payble Amount": "支払金額",
            "Pay from Wallet": "ウォレットから支払う",
            "Available": "利用可能",
            "Payment Getway Method": "支払いゲートウェイ方法",
            "Continue": "続ける",
            "Fortune Cookie - Unveil Your Daily Wisdom": "フォーチュンクッキー - 今日の知恵をひも解く",
            "Crack open a fortune cookie to reveal a piece of daily wisdom. Let the message guide you through your day with positivity and insight.": "フォーチュンクッキーを開いて今日の知恵を受け取りましょう。メッセージがあなたの一日を前向きで洞察に満ちたものに導きます。",
            "Ask The Fortune Cookie": "フォーチュンクッキーに聞く",
            "Crack open your Fortune Cookie": "フォーチュンクッキーを開ける",
            "Crack another one open": "もう一つ開ける",
            "Love Compatibility": "恋愛相性",
            "Find out how compatible you are with your lover, friend, or colleague using our love compatibility calculator. Get your results now.": "恋人、友人、同僚との相性を恋愛相性計算機で確認しましょう。今すぐ結果を取得。",
            "Are Aries And Taurus Compatible": "おひつじ座とおうし座は相性が良いですか",
            "Aries And Taurus Strengths": "おひつじ座とおうし座の長所",
            "Aries And Taurus Weaknesses": "おひつじ座とおうし座の短所",
            "Aries And Taurus Elements": "おひつじ座とおうし座の元素",
            "Aries And Taurus Dates": "おひつじ座とおうし座の日付",
            "Are Aries And Taurus Compatibility Score": "おひつじ座とおうし座の相性スコア",
            "General": "一般",
            "Communication": "コミュニケーション",
            "Sex": "セックス",
            "Select Another": "別を選択",
            "Aries": "おひつじ座",
            "Taurus": "おうし座",
            "Gemini": "ふたご座",
            "Cancer": "かに座",
            "Leo": "しし座",
            "Virgo": "おとめ座",
            "Libra": "てんびん座",
            "Scorpio": "さそり座",
            "Sagittarius": "いて座",
            "Capricorn": "やぎ座",
            "Aquarius": "みずがめ座",
            "Pisces": "うお座",
            "Please select Your Partner Sign": "パートナーの星座を選択してください",
            "Please select Your Sign": "あなたの星座を選択してください",
            "Please fill all details !!": "すべての詳細を入力してください！！",
            "Discover Your Core Numbers That Define You": "あなたを形作るコアナンバーを発見",
            "Explore your core numbers like Life Path, Destiny, and Personal Year—complete with strengths, challenges, and meaningful interpretations.": "ライフパス、運命、個人年などのコアナンバーを探り、長所・課題・意味のある解釈を確認しましょう。",
            "Get Your Numbers": "ナンバーを取得",
            "First Name": "名",
            "Last Name": "姓",
            "Method": "方法",
            "Chaldean": "カルデア式",
            "Pythagorean": "ピタゴラス式",
            "Strengths": "長所",
            "Challenges": "課題",
            "Advice": "アドバイス",
            "Get Report": "レポートを取得",
            "Select Tarot One Card": "タロット1枚を選択",
            "Select Your Card": "カードを選択",
            "Get Another": "別のカードを引く",
            "Yes Or No Tarot": "イエス・ノータロット",
            "Get instant Yes or No answers to pressing questions.": "緊急の質問に対して即答でイエス・ノーの回答を取得。",
            "Daily Tarot": "デイリータロット",
            "Receive daily tarot readings on love, career, and finance.": "恋愛、仕事、金運に関する毎日のタロットリーディングを受け取る。",
            "In-Depth Love Reading": "詳細な恋愛リーディング",
            "Deep dive into your love life with relationship-specific readings.": "関係性に特化したリーディングで恋愛を深く理解。",
            "Flirt Love Reading": "フラート恋愛リーディング",
            "Reveal insights into playful and romantic connections.": "遊び心やロマンチックな関係の洞察を明らかにします。",
            "Erotic Love Reading": "エロティック恋愛リーディング",
            "Insights into intimate and personal love dynamics.": "親密で個人的な恋愛のダイナミクスに関する洞察。",
            "Egyptian Prediction": "エジプト占い",
            "Access ancient Egyptian insights beyond visible truths.": "目に見える真実を超えた古代エジプトの知見にアクセス。",
            "Ex-Flame Reading": "元恋人リーディング",
            "Explore the possibilities of rekindling with an ex-partner.": "元パートナーとの再燃の可能性を探る。",
            "Made For Each Other Or Not Reading": "お互いに運命の相手かリーディング",
            "Discover if your relationship has long-term potential.": "あなたの関係が長期的な可能性を持つかを発見。",
            "Power Life Reading": "パワーライフリーディング",
            "Take control of your destiny with life-changing tarot readings.": "人生を変えるタロットリーディングで運命をコントロール。",
            "Know Your Friend Reading": "友達リーディング",
            "Understand the true intentions of your friendships.": "友情の真意を理解。",
            "Divine Angel Reading": "神聖な天使リーディング",
            "Connect with divine guidance for clarity and spiritual insight.": "神の導きと霊的洞察にアクセス。",
            "Career Daily Reading": "仕事デイリーリーディング",
            "Elevate your career with daily tarot insights to achieve your professional goals.": "毎日のタロットでキャリアを高め、目標達成。",
            "Dream Come True Reading": "夢実現リーディング",
            "Gain insights into making your dreams and goals a reality.": "夢や目標を現実にするための洞察を得る。",
            "Past Lives Connection Reading": "前世リーディング",
            "Explore your journey across time to understand your path ahead.": "時間を超えた旅を探り、未来の道を理解。",
            "Yes or No Tarot - Find Clear and Immediate Answers": "イエス・ノータロット - 明確で即時の回答",
            "Daily Tarot - Gain Insights Across Love, Finance, and Career": "デイリータロット - 恋愛・金運・仕事の洞察",
            "In-Depth Love Tarot - Reveal the Realities of Your Relationship": "詳細な恋愛タロット - あなたの関係の現実を明らかに",
            "Flirt Love Tarot - Discover Your Romantic Potential": "フラート恋愛タロット - ロマンチックな可能性を発見",
            "Erotic Love Tarot - Explore Your Intimate Desires": "エロティック恋愛タロット - 親密な欲望を探る",
            "Discover the Secrets of Your Soul with Egyptian Tarot": "エジプトタロットで魂の秘密を発見",
            "Ex-Flame Tarot - Reignite or Release the Past": "元恋人タロット - 過去を再燃または解放",
            "Made For Each Other Tarot - Discover True Compatibility": "お互いに運命の相手タロット - 真の相性を発見",
            "Power Life Tarot - Take Control of Your Destiny": "パワーライフタロット - 運命をコントロール",
            "Know Your Friend Tarot Reading - Unveil the True Nature of Your Relationships": "友達タロットリーディング - 関係の本質を明らかに",
            "Divine Angel Tarot - Receive Angelic Guidance for Clarity and Relief": "神聖な天使タロット - 明確さと安心のための天使の導きを受ける",
            "Career Daily Tarot Reading - Navigate Your Workday with Confidence": "仕事デイリータロットリーディング - 自信を持って一日を過ごす",
            "Explore the Depths of Your Heart's Desires with a Dream Come True Tarot Reading": "夢実現タロットで心の欲望の深みを探る",
            "Delve into Your Past Lives - Unravel the Enigma of Your Previous Incarnations": "前世を探り、過去の転生の謎を解明",
            "The Yes or No Tarot widget offers quick, straightforward answers to your pressing questions, helping you make decisions with confidence in areas like love, finance, and career.": "イエス・ノータロットウィジェットは、恋愛・金運・仕事などの質問に対して迅速で明確な回答を提供し、自信を持って判断できるようにします。",
            "Daily Tarot provides readings that focus on three key areas of your life: Love, Finance, and Career. Discover the guidance you need for each aspect of your day.": "デイリータロットは、人生の3つの主要分野（恋愛、金運、仕事）に焦点を当てたリーディングを提供します。それぞれの一日の指針を見つけましょう。",
            "In-Depth Love Tarot provides comprehensive readings to bring clarity to your love life, help you make crucial decisions, and guide you toward understanding your soulmate and future partner.": "インデプス恋愛タロットは、恋愛の明確化、重要な判断の助け、ソウルメイトや将来のパートナーの理解を導く総合リーディングを提供します。",
            "The Flirt Love Tarot Reading provides playful insights into your romantic life. Whether it's a friendship, a new admirer, or a potential soulmate, this reading helps you navigate love with ease.": "フラート恋愛タロットは、遊び心のある恋愛洞察を提供します。友情、新しい好意者、または可能性のあるソウルメイトに対する恋愛をスムーズにナビゲート。",
            "This reading reveals insights into passion, love, and sexual chemistry, helping you understand your relationships and uncover hidden fantasies.": "このリーディングは情熱、愛、性的相性の洞察を明らかにし、関係を理解し隠れた願望を発見する手助けをします。",
            "Explore your twin flame, current struggles, ancestral roots, and past healing with the ancient wisdom of Egyptian Tarot": "エジプトタロットの古代の知恵で、ツインフレーム、現在の課題、先祖のルーツ、過去の癒しを探求。",
            "The Ex-Flame Tarot Reading provides clarity on whether to rekindle a past relationship or move on. Explore your ex’s feelings, the potential for a renewed connection, and the impact on your future.": "元恋人タロットリーディングは、過去の関係を再燃させるか前進すべきかを明確にします。元恋人の気持ち、再接続の可能性、将来への影響を探ります。",
            "This Tarot reading reveals whether your relationship is worth the effort, safe to pursue, and aligned with your life goals. Understand if you’re truly made for each other or if it’s time to move on.": "このリーディングは、関係が努力に値するか、安全か、人生の目標に合致しているかを明らかにします。本当にお互いの運命の相手か、それとも前に進む時かを理解。",
            "The Power Life Tarot Reading helps you plan your life, overcome struggles, create a clear vision, and take charge of your destiny. Unlock the guidance you need to steer your life towards success.": "パワーライフタロットは、人生の計画、課題の克服、明確なビジョン作り、運命のコントロールをサポート。成功への指針を提供。",
            "Divine Angel Tarot connects you with your guardian angels, offering guidance to overcome challenges and find peace in love, freedom, and resolution.": "神聖な天使タロットは守護天使とつながり、課題の克服や愛・自由・安らぎを見つける導きを提供。",
            "Career Daily Tarot offers insights to manage your workday, from handling your boss to staying proactive and managing tasks effectively. Let the Tarot guide you to a successful and stress-free day.": "キャリアデイリータロットは、上司への対応、積極性の維持、タスク管理など仕事の一日をナビゲート。成功でストレスフリーな日を導きます。",
            "The Dream Come True Tarot Reading helps you manifest your deepest wishes and aspirations. Whether it's love, material desires, or unfulfilled dreams, this reading offers clarity and guidance to turn your desires into reality.": "夢実現タロットは、最も深い願望や目標の実現をサポート。恋愛、物質的欲望、未達成の夢も明確化と指針で現実に。",
            "Explore your past lives to understand current fears, recurring patterns, and influences. Gain clarity on challenges rooted in your previous incarnations.": "前世を探り、現在の恐れ、繰り返すパターン、影響を理解。過去の転生に根ざす課題の明確化。",
            "Select Tarot Three Card": "タロット3枚を選択",
            "Heartbreak Reading": "失恋リーディング",
            "Find guidance and healing for a broken heart.": "傷ついた心を癒す指針とヒーリング。",
            "Wisdom Reading": "知恵リーディング",
            "Balance your energies and find mental peace through wisdom.": "知恵でエネルギーを整え、心の平穏を見つける。",
            "Divine Magic Reading": "神秘魔法リーディング",
            "Discover mystical insights with magical tarot guidance.": "魔法のタロットで神秘的洞察を発見。",
            "Heartbreak Tarot Reading - Find Closure and Guidance": "失恋タロット - 完結と指針を得る",
            "The Heartbreak Tarot Reading offers insight into the cause of your pain and provides advice on how to heal and move forward. This two-card reading delivers clarity and the necessary steps to mend your broken heart.": "失恋タロットは、痛みの原因を洞察し、癒しと前進のアドバイスを提供。2枚カードで明確化と心の回復ステップを示します。",
            "Wisdom Tarot - Find Balance with Yin and Yang": "知恵タロット - 陰陽のバランスを見つける",
            "Wisdom Tarot provides guidance by balancing the Yin and Yang energies in your life. Discover clarity, peace, and a path forward with this two-card reading.": "知恵タロットは、陰陽のエネルギーを整え、明確さ、平和、前進の道を示します。2枚カードでリーディング。",
            "Divine Magic Tarot Reading - Discover Cause and Remedy": "神秘魔法タロット - 原因と解決策を発見",
            "The Divine Magic Tarot Reading offers insights into the root cause of your problems and provides a remedy to guide you toward resolution. With this reading, discover the steps you need to take to transform challenges into solutions.": "神秘魔法タロットは問題の根本原因を洞察し、解決への指針を提供。課題を解決に変えるためのステップを明らかにします。",
            "Please pick your cards !!": "カードを選んでください！！",
            "Get Your Reading": "リーディングを取得",
            "Select Tarot Two Card": "タロット2枚を選択",
            "Love Triangle Reading": "三角関係リーディング",
            "Get clarity in choosing between multiple romantic interests.": "複数の恋愛対象の中から選ぶ際の明確化。",
            "Past-Present-Future Reading": "過去・現在・未来リーディング",
            "Love Triangle Tarot - Discover the Dynamics Between You, Lover 1, and Lover 2": "三角関係タロット - あなたと恋人1・恋人2の関係性を発見",
            "Love Triangle Tarot provides insights into the relationships and dynamics between you and your two lovers. Understand where you stand, and what each lover brings into your life, and make an informed decision guided by the cards.": "三角関係タロットは、あなたと2人の恋人の関係とダイナミクスを洞察。自分の立ち位置と各恋人がもたらすものを理解し、カードの導きで判断。",
            "Zodiac Gift Guru": "星座ギフトグル",
            "January": "1月",
            "February": "2月",
            "March": "3月",
            "April": "4月",
            "May": "5月",
            "June": "6月",
            "July": "7月",
            "August": "8月",
            "September": "9月",
            "October": "10月",
            "November": "11月",
            "December": "12月",
            "Yesterday": "昨日",
            "Today": "今日",
            "Tomorrow": "明日",
            "Gift Recommendations": "ギフトおすすめ",
            "insight": "洞察",
            "Career": "仕事",
            "Love": "恋愛",
            "Finance": "金運",
            "Popularity": "人気",
            "Experience: High to Low": "経験: 高→低",
            "Experience: Low to High": "経験: 低→高",
            "Orders: High to Low": "注文: 高→低",
            "Orders: Low to High": "注文: 低→高",
            "Price: High to Low": "価格: 高→低",
            "Price: Low to High": "価格: 低→高",
            "Rating: High to Low": "評価: 高→低",
            "Search name...": "名前検索...",
            "Online": "オンライン",
            "Busy": "忙しい",
            "Exp": "経験",
            "yrs": "年",
            "orders": "注文",
            "min": "分",
            "Chat Now": "チャット開始",
            "Wait": "待機",
            "There are no astrologers in this category.": "このカテゴリに占星術師はいません。",
            "Sort": "並び替え",
            "Filter": "フィルター",
            "Category": "カテゴリ",
            "All": "すべて",
            "Sort by": "並び替え",
            "Skill": "スキル",
            "Language": "言語",
            "Reset": "リセット",
            "Apply": "適用",
            "You have 30 seconds left. Please recharge immediately to continue the conversation.": "残り30秒です。会話を続けるにはすぐにチャージしてください。",
            "Free chat over! Next minutes will use wallet balance.": "無料チャット終了！次の分はウォレット残高を使用します。",
            "Complete": "完了",
            "End Chat": "チャット終了",
            "Message": "メッセージ",
            "Hi": "こんにちは",
            "lets continue this chat at discounted price of": "割引価格でチャットを続けましょう",
            "Are you sure you want to end tha chat to": "チャットを終了してもよろしいですか",
            "No": "いいえ",
            "Yes": "はい",
            "Chat With Astrologer": "占星術師とチャット",
            "Appointment List": "予約リスト",
            "My Following": "フォロー中",
            "Recent Post": "最近の投稿",
            "Welcome back": "お帰りなさい",
            "Manage your astrology services": "占星術サービスを管理",
            "Logout": "ログアウト",
            "Login": "ログイン",
            "My Profile (Member Since)": "マイプロフィール（会員登録日）",
            "My Followings": "フォロー中",
            "You are following": "フォロー中",
            "people": "人",
            "Years": "年",
            "No Following Found !!": "フォローが見つかりません！！",
            "Currently you don't have any follow.": "現在フォローしていません。",
            "Hey There!": "こんにちは！",
            "What is your name?": "お名前は？",
            "Enter your first Name": "名を入力",
            "Enter your last Name": "姓を入力",
            "male": "男性",
            "female": "女性",
            "Where wrer you bron?": "出生地は？",
            "Please Select Language": "言語を選択してください",
            "english": "英語",
            "hindi": "ヒンディー語",
            "north": "北",
            "south": "南",
            "Select Chart Type": "チャートタイプを選択",
            "Start chat with astrologer": "占星術師とチャット開始",
            "Search location": "場所を検索",
            "Location not found !!": "場所が見つかりません！！",
            "Enter bord state": "出生州を入力",
            "Search location...": "場所を検索...",
            "Astrologers": "占星術師",
            "Top Astrologers. 24 * 7 customer support. Happy to help": "トップ占星術師。24時間365日サポート。いつでもお手伝いします",
            "per min": "分あたり",
            "Top Astrologers": "トップ占星術師",
            "rate": "評価",
            "Top Rated Astrologers": "高評価占星術師",
            "No astrologers found !!": "占星術師が見つかりません！！",
            "FAQs": "よくある質問",
            "Raning": "ランキング",
            "Raning Apointment": "予約ランキング",
            "Select Other Sign": "別の星座を選択",
            "Horoscopes": "ホロスコープ",
            "Daily Horoscope": "今日のホロスコープ",
            "Weekly Horoscope": "今週のホロスコープ",
            "Monthly Horoscope": "今月のホロスコープ",
            "Yearly Horoscope": "今年のホロスコープ",
            "Composite Friendship Table": "複合友人表",
            "Kp Planetary Details": "KP惑星詳細",
            "Kp House Cusps And Chart": "KPハウスクスプとチャート",
            "Ascendant Report": "アセンダントレポート",
            "Bhava Kundli": "バヴァクンドリ",
            "Vimshottari Dasha": "ヴィムショッタリダシャ",
            "Yogini Dasha": "ヨギニダシャ",
            "Sadhesati Analysis": "サデサティ分析",
            "Sadhesati Life Analysis": "サデサティ人生分析",
            "Kalsarpa Dosha": "カルサルパドーシャ",
            "Manglik Analysis": "マンガリック分析",
            "Planet Profiles": "惑星プロフィール",
            "Gemstone Suggestions": "宝石の提案",
            "Upagraha": "ウパグラハ",
            "Jaimini Astrology": "ジャイミニ占星術",
            "Chara Dasha": "チャラダシャ",
            "Shadbala": "シャドバラ",
            "Sudarshana Chakra": "スダルシャナチャクラ",
            "Bhinnashtakvarga": "ビンナシュタクヴァルガ",
            "Yogas": "ヨーガ",
            "Introduction": "紹介",
            "Basic Astrological Details": "基本占星術詳細",
            "Planetary Positions": "惑星位置",
            "Horoscope Charts": "ホロスコープチャート",
            "House Cusps And Sandhi": "ハウスクスプとサンディ",
            "Divisional Charts": "分割チャート",
            "Basic Details": "基本詳細",
            "Ghat Chakra": "ガートチャクラ",
            "Panchange Details": "パンチャン詳細",
            "Astrological Details": "占星術詳細",
            "Time of Birth": "出生時間",
            "Place of Birth": "出生地",
            "Latitude": "緯度",
            "Longitude": "経度",
            "Timezone": "タイムゾーン",
            "Ayanamsa": "アヤナムシャ",
            "Sunrise": "日の出",
            "Sunset": "日没",
            "Month": "月",
            "Tithi": "ティティ",
            "Yoga": "ヨーガ",
            "Karana": "カラナ",
            "Moon Sign": "月の星座",
            "Moon Vaar": "月曜日",
            "Nakshatra": "ナクシャトラ",
            "Varna": "ヴァルナ",
            "Vashya": "ヴァシャ",
            "Yoni": "ヨニ",
            "Gana": "ガナ",
            "Nadi": "ナディ",
            "Sun Sign": "太陽星座",
            "Tatva": "タトヴァ",
            "Paya": "パヤ",
            "Yanja": "ヤンジャ",
            "Planets": "惑星",
            "Sign": "星座",
            "Sign No": "星座番号",
            "LAGNA CHART (BIRTH CHART)": "ラグナチャート（出生チャート）",
            "MOON CHART": "ムーンチャート",
            "NAVMANSHA CHART (D9)": "ナヴマンシャチャート（D9）",
            "House": "ハウス",
            "Bhav Madhya": "バヴァ中心",
            "Bhav Sandhi": "バヴァ接点",
            "Chalit Chart": "チャリットチャート",
            "Sun Chart": "太陽チャート",
            "Health, Constitution, Body": "健康・体質・身体",
            "Hora Chart(D2)": "ホラチャート(D2)",
            "Finance, Wealth, Prosperity": "財運・富・繁栄",
            "Dreshkan Chart(D3)": "ドレシュカンチャート(D3)",
            "Brothers, Sisters": "兄弟姉妹",
            "Chathurthamasha Chart(D4)": "チャトゥルタマシャチャート(D4)",
            "Fortunes, Luck of native": "出生者の運勢",
            "Saptamansha Chart(D7)": "サプタマンシャチャート(D7)",
            "Impregnation, Birth of the child": "受胎・出産",
            "Dashamansha Chart(D10)": "ダシャマンシャチャート(D10)",
            "livelihood, Profession": "生計・職業",
            "Dwadasha Chart(D12)": "ドワダーシャチャート(D12)",
            "Parents, paternal happiness": "両親・父方の幸福",
            "Shodashamsha Chart(D16)": "ショーダシャマンシャチャート(D16)",
            "Happiness, miseries, conveyance": "幸福・不幸・交通",
            "Vishamansha Chart(D20)": "ヴィシャマンシャチャート(D20)",
            "Spiritual progress, worship": "精神的成長・礼拝",
            "Chaturvimshamsha(D24)": "チャトゥルヴィムシャムシャ(D24)",
            "Academic achievement, education": "学業達成・教育",
            "Bhamsha Chart(D27)": "バムシャチャート(D27)",
            "Physical strength, stamina": "体力・スタミナ",
            "Trishamansha Chart(D30)": "トリシャマンシャチャート(D30)",
            "Evil, Adversities of life": "邪悪・人生の困難",
            "Khavedamsha Chart(D40)": "カヴェダムシャチャート(D40)",
            "Auspicious & inauspicious effect": "吉凶効果",
            "Akshvedansha Chart(D45)": "アクシュヴェダンシャチャート(D45)",
            "Character and couduct of the native": "出生者の性格と行動",
            "Shashtymsah Chart(D60)": "シャシュティマンシャチャート(D60)",
            "Shows general happiness": "一般的な幸福度を表示",
            "Degrees": "度数",
            "Sign Lord": "星座の支配星",
            "Nakshatra Lord": "ナクシャトラの支配星",
            "Sub Lord": "サブラード",
            "Sub Sub Lord": "サブサブラード",
            "Lord": "支配星",
            "Symbol": "シンボル",
            "Characteristics": "特徴",
            "Day of Fast": "断食日",
            "luchy Gems": "幸運の宝石",
            "Personality": "性格",
            "Health": "健康",
            "Relationships": "人間関係",
            "BHAVA KUNDLI": "バヴァクンドリ",
            "Bhramari": "ブラマリ",
            "Bhadrika": "バドリカ",
            "Ulka": "ウルカ",
            "Siddha": "シッダ",
            "Sankata": "サンカタ",
            "Mangala": "マンガラ",
            "Pingala": "ピンガラ",
            "Dhanya": "ダニャ",
            "Remedies Of Sadhesati": "サデサティの対策",
            "Saturn Sign": "土星の星座",
            "Is Saturn Retro?": "土星は逆行中ですか？",
            "Phase": "フェーズ",
            "Intensity": "強度",
            "Direction": "方向",
            "Strength": "強さ",
            "Percentage": "パーセンテージ",
            "Zodiac Sign": "黄道星座",
            "Planet Degree": "惑星の度数",
            "Lord Of": "支配するもの",
            "Combust/Aw...": "燃焼/不利…",
            "Lucky Stone": "幸運の石",
            "Life Stone": "生命の石",
            "Finger": "指",
            "Day": "曜日",
            "Time to Wear": "着用時間",
            "Mantra": "マントラ",
            "Upagraha Longitude": "ウパグラハ経度",
            "Rashi": "ラーシ",
            "Pada": "パダ",
            "Upagraha/Nakshatra/Sub Lord": "ウパグラハ/ナクシャトラ/サブラード",
            "Jamini Planets": "ジャイミニ惑星",
            "Jamini Padas": "ジャイミニパダ",
            "Code": "コード",
            "Jamini Karakara": "ジャイミニカラカ",
            "Uchcha Bala": "ウッチャバラ",
            "Saptavarga Bala": "サプタヴァルガバラ",
            "Yugmayugma Bhamsha Bala": "ユグマユグマバムシャバラ",
            "Kendradi Bala": "ケンドラディバラ",
            "Drekkana Bala": "ドレッカナバラ",
            "Total Sthana Bala": "総スタナバラ",
            "Total Dig Bala": "総ディグバラ",
            "Nattunnata Bala": "ナットゥンナタバラ",
            "Paksha Bala": "パクシャバラ",
            "Tribhaga Bala": "トリバガバラ",
            "Varshadhipati": "ヴァルシャディパティ",
            "Maasadipati": "マーサディパティ",
            "Vaaradhipati": "ヴァーラディパティ",
            "Horadhipati": "ホラディパティ",
            "Ayana Bala": "アヤナバラ",
            "Yuddha Bala": "ユッダバラ",
            "Total Kaal Bala": "総カールバラ",
            "Naisargika Bala": "ナイサルギカバラ",
            "Chestha Bala": "チェスタバラ",
            "Drik Bala": "ドリックバラ",
            "Total Shadbala": "総シャドバラ",
            "Shadbala In Rupa": "ルーパにおけるシャドバラ",
            "Min Require": "最小必要",
            "Ratio": "比率",
            "Rank": "ランク",
            "Sun": "太陽",
            "Moon": "月",
            "Mars": "火星",
            "Mercury": "水星",
            "Jupiter": "木星",
            "Venus": "金星",
            "Saturn": "土星",
            "Ashtakvarga": "アシュタクヴァルガ",
            "Sarvashtakava": "サルヴァシュタクヴァ",
            "Prasthara Chakra": "プラスタラチャクラ",
            "Ascendant": "アセンダント",
            "Total": "合計",
            "Natural Friendship": "自然な友情",
            "Temporary Friendship": "一時的な友情",
            "Five Fold Friendship": "五重の友情",
            "Ketu": "ケートゥ",
            "Rahu": "ラーフ",
            "Vimshottari Dasha P1": "ヴィムショッタリダシャ P1",
            "Vimshottari Dasha P2": "ヴィムショッタリダシャ P2",
            "AshtaKoot": "アシュタクート",
            "Bhakut Dosha": "バクートドーシャ",
            "Nadi Dosha": "ナディドーシャ",
            "Ashtakoot Analysis": "アシュタクート分析",
            "DashaKoot": "ダシャクート",
            "Personality Report": "性格レポート",
            "Match Making Report": "マッチメイキングレポート",
            "Nav Pancham Yoga": "ナヴパンチャムヨーガ",
            "Charan": "チャラン",
            "Name Alphabet": "名前のアルファベット",
            "Planetary Position": "惑星位置",
            "Lagna Chart (Birth Chart)": "ラグナチャート（出生チャート）",
            "Moon Chart": "ムーンチャート",
            "Navmansha Chart (D9)": "ナヴマンシャチャート（D9）",
            "Mahadasha": "マハダシャ",
            "End": "終了",
            "Is Recommended ??": "推奨されますか？",
            "Manglik Details": "マンガリック詳細",
            "What is AshtaKoot ??": "アシュタクートとは？",
            "Attributes": "属性",
            "Description": "説明",
            "Received": "受信",
            "Graha Maitri": "グラハマイトリ",
            "Bhakoota": "バクータ",
            "What is BhaKoot Dosha ??": "バクートドーシャとは？",
            "What is Nadi Dosha ??": "ナディドーシャとは？",
            "Madhya": "マディヤ",
            "Nadi dosha is present": "ナディドーシャがあります",
            "The": "この",
            "porutham considered for horoscope matching are as follows :": "相性鑑定で考慮されるポルタムは以下の通りです：",
            "Dina": "ディナ",
            "Rajju": "ラジュ",
            "Rasyadhipati": "ラーシャディパティ",
            "Vedha": "ヴェーダ",
            "Mahendra": "マヘンドラ",
            "Streedargha": "ストリーダルガ",
            "Uranus": "天王星",
            "Neptune": "海王星",
            "Pluto": "冥王星",
            "Tara": "タラ",
            "Please fill boy's details !!": "男性の詳細を入力してください！！",
            "Please fill girl's details !!": "女性の詳細を入力してください！！",
            "Please fill chart details !!": "チャートの詳細を入力してください！！",
            "Kundli Matching": "クンドリ相性診断",
            "Find your right one, through matchmaking": "マッチメイキングであなたにぴったりの相手を見つけましょう",
            "Open Kundli": "クンドリを開く",
            "New Matching": "新しい相性診断",
            "View Kundli": "クンドリを表示",
            "Boy's Details": "男性の詳細",
            "Girl's Details": "女性の詳細",
            "Search city, state, country": "都市・州・国を検索",
            "Enter first name": "名前を入力",
            "Enter last name": "姓を入力",
            "Chart Style": "チャートスタイル",
            "North Indian": "北インド式",
            "South Indian": "南インド式",
            "English": "英語",
            "Hindi": "ヒンディー語",
            "MATCH HOROSCOPE": "ホロスコープ相性診断",
            "My Profile": "マイプロフィール",
            "Enter full name": "氏名を入力",
            "Enter email address": "メールアドレスを入力",
            "Enter password": "パスワードを入力",
            "Enter phone number": "電話番号を入力",
            "Save Chanage": "変更を保存",
            "Manage your astrologers recent post": "占星術師の最近の投稿を管理",
            "Show Less": "少なく表示",
            "Show More": "もっと表示",
            "Total Balance": "合計残高",
            "Add Money": "入金",
            "Extra": "追加",
            "Transaction History": "取引履歴",
            "Build better products with flexible tools, helpful documentation,": "柔軟なツールと便利なドキュメントで、より良い製品を構築します、",
            "and a team that champions your growth.": "そして、あなたの成長を支援するチームと共に。",
            "Useful Link": "便利なリンク",
            "Socials": "ソーシャル",
            "Logout Seccuessfuly !!": "ログアウトに成功しました！！",
            "Free Kundli": "無料クンドリ",
            "Horoscope": "ホロスコープ",
            "Dashboard": "ダッシュボード",
            "Enter your feedback !!": "フィードバックを入力してください！！",
            "Languages": "言語",
            "incoming": "着信",
            "request from": "からのリクエスト",
            "Waitlist Joined !!": "ウェイトリストに参加しました！！",
            "will start in": "開始まで",
            "You will receive a": "あなたは次のものを受け取ります",
            "request when the": "リクエストは次のときに",
            "astrologer is ready. Don’t worry! You will not be": "占星術師が準備できたとき。心配はいりません！あなたは",
            "charged for missing this session.": "このセッションを逃しても料金は発生しません。",
            "Accept": "受け入れる",
            "Reject": "拒否",
            "Great, what did you like the mast? 😍": "素晴らしい！何が一番良かったですか？😍",
            "Skip": "スキップ",
            "Payment Information": "支払い情報",
            "Amount": "金額",
            "Tax": "税金",
            "Payment": "支払い",
            "Payment Method": "支払い方法",
        
            "AstroSpace": "AstroSpace",
            "Astrology Consultation Platform": "Astrology Consultation Platform",
            "INVOICE": "INVOICE",
            "Consultation Service Receipt": "Consultation Service Receipt",
            "Invoice Number": "Invoice Number",
            "Date Issued": "Date Issued",
            "PAID": "PAID",
            "From": "From",
            "Bill To": "Bill To",
            "Service": "Service",
            "Booking ID": "Booking ID",
            "Description": "Description",
            "Duration": "Duration",
            "Rate": "Rate",
            "Amount": "Amount",
            "Free Consultation Time": "Free Consultation Time",
            "Complimentary session minutes": "Complimentary session minutes",
            "Free": "Free",
            "Consultation Fee": "Consultation Fee",
            "Standard rate (first block)": "Standard rate (first block)",
            "Extended Consultation Fee": "Extended Consultation Fee",
            "Premium rate (extended block)": "Premium rate (extended block)",
            "Consultation Service": "Consultation Service",
            "Astrology consultation session": "Astrology consultation session",
            "Subtotal": "Subtotal",
            "Platform Fee": "Platform Fee",
            "Included": "Included",
            "Total Amount": "Total Amount",
            "DOB": "DOB",
            "Kundali Chart Used": "Kundali Chart Used",
            "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.": "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.",
            "For support, contact us at support@astrospace.com": "For support, contact us at support@astrospace.com",
            "Free Minute": "Free Minute",
            "Verified": "Verified",
            "End Session": "End Session",
            "Voice Call": "Voice Call",
            "typing...": "typing...",
            "CANCEL": "CANCEL",
            "OK": "OK",
            "Install Progressive Web Application": "Install Progressive Web Application",
            "This site has app functionality. Install it on your device for extensive experience and easy access.": "This site has app functionality. Install it on your device for extensive experience and easy access.",
            "Install": "Install",
            "Search location": "Search location",
            "Location not found !!": "Location not found !!",
            "Waiting for remote user to join...": "Waiting for remote user to join...",
            "End Video Session": "End Video Session",
            "Initializing WebRTC P2P...": "Initializing WebRTC P2P...",
            "Access Denied (Camera/Mic)": "Access Denied (Camera/Mic)",
            "Connection Failed": "Connection Failed",
            "Time Remaining": "Time Remaining",
            "Call ended": "Call ended",

            "Offline": "Offline",}
    },
    pa: {
        translation: {
            "Enter Mobile Number !!": "ਮੋਬਾਈਲ ਨੰਬਰ ਦਾਖਲ ਕਰੋ !!",
            "In Valid OTP !!": "ਗਲਤ OTP !!",
            "Please enter password !!": "ਕਿਰਪਾ ਕਰਕੇ ਪਾਸਵਰਡ ਦਾਖਲ ਕਰੋ !!",
            "Password not match !!": "ਪਾਸਵਰਡ ਮੇਲ ਨਹੀਂ ਖਾਂਦਾ !!",
            "Reset Password": "ਪਾਸਵਰਡ ਰੀਸੈੱਟ ਕਰੋ",
            "Enter your phone number and new password": "ਆਪਣਾ ਫ਼ੋਨ ਨੰਬਰ ਅਤੇ ਨਵਾਂ ਪਾਸਵਰਡ ਦਾਖਲ ਕਰੋ",
            "Phone Number": "ਫ਼ੋਨ ਨੰਬਰ",
            "Enter your number": "ਆਪਣਾ ਨੰਬਰ ਦਾਖਲ ਕਰੋ",
            "Search": "ਖੋਜੋ",
            "Verify": "ਪੁਸ਼ਟੀ ਕਰੋ",
            "You will receive a 6 digit code for": "ਤੁਹਾਨੂੰ 6 ਅੰਕਾਂ ਵਾਲਾ ਕੋਡ ਮਿਲੇਗਾ",
            "verification to": "ਸਰਟੀਫਿਕੇਸ਼ਨ ਲਈ",
            "Submit": "ਜਮ੍ਹਾ ਕਰੋ",
            "Enter your password and new password": "ਆਪਣਾ ਪਾਸਵਰਡ ਅਤੇ ਨਵਾਂ ਪਾਸਵਰਡ ਦਾਖਲ ਕਰੋ",
            "New Password": "ਨਵਾਂ ਪਾਸਵਰਡ",
            "Enter new password": "ਨਵਾਂ ਪਾਸਵਰਡ ਦਾਖਲ ਕਰੋ",
            "Confirm New Password": "ਨਵਾਂ ਪਾਸਵਰਡ ਪੁਸ਼ਟੀ ਕਰੋ",
            "Confirm new password": "ਨਵਾਂ ਪਾਸਵਰਡ ਪੁਸ਼ਟੀ ਕਰੋ",
            "Back to Login": "ਲੌਗਿਨ 'ਤੇ ਵਾਪਸ ਜਾਓ",
            "Back": "ਵਾਪਸ",
            "Enter Login Details !!": "ਲੌਗਿਨ ਵੇਰਵੇ ਦਾਖਲ ਕਰੋ !!",
            "Welcome Back!": "ਵਾਪਸੀ 'ਤੇ ਸੁਆਗਤ ਹੈ!",
            "Sign in to your account": "ਆਪਣੇ ਖਾਤੇ ਵਿੱਚ ਸਾਇਨ ਇਨ ਕਰੋ",
            "Password": "ਪਾਸਵਰਡ",
            "Enter your password": "ਆਪਣਾ ਪਾਸਵਰਡ ਦਾਖਲ ਕਰੋ",
            "Forgot Password?": "ਪਾਸਵਰਡ ਭੁੱਲ ਗਏ?",
            "Sign In": "ਸਾਇਨ ਇਨ",
            "Don't have an account?": "ਖਾਤਾ ਨਹੀਂ ਹੈ?",
            "Sign Up": "ਸਾਇਨ ਅਪ ਕਰੋ",
            "Please enter all details !!": "ਸਾਰੇ ਵੇਰਵੇ ਦਾਖਲ ਕਰੋ !!",
            "Please enter valid email !!": "ਮਾਨਯੋਗ ਈਮੇਲ ਦਾਖਲ ਕਰੋ !!",
            "Please enter birth place !!": "ਜਨਮ ਸਥਾਨ ਦਾਖਲ ਕਰੋ !!",
            "Please select language !!": "ਭਾਸ਼ਾ ਚੁਣੋ !!",
            "Step": "ਕਦਮ",
            "Enter Your Details": "ਆਪਣੇ ਵੇਰਵੇ ਦਾਖਲ ਕਰੋ",
            "Hey there! what is your name?": "ਹੈਲੋ! ਤੁਹਾਡਾ ਨਾਮ ਕੀ ਹੈ?",
            "Full Name": "ਪੂਰਾ ਨਾਮ",
            "Email Address": "ਈਮੇਲ ਐਡਰੈੱਸ",
            "Enter your Full Name": "ਆਪਣਾ ਪੂਰਾ ਨਾਮ ਦਾਖਲ ਕਰੋ",
            "Enter your email": "ਆਪਣੀ ਈਮੇਲ ਦਾਖਲ ਕਰੋ",
            "What is your gender?": "ਤੁਹਾਡਾ ਲਿੰਗ ਕੀ ਹੈ?",
            "Male": "ਪੁਰਸ਼",
            "Female": "ਮਹਿਲਾ",
            "Enter your birth date": "ਜਨਮ ਦੀ ਤਾਰੀਖ ਦਾਖਲ ਕਰੋ",
            "Enter your birth time": "ਜਨਮ ਦਾ ਸਮਾਂ ਦਾਖਲ ਕਰੋ",
            "Enter your birth Place": "ਜਨਮ ਸਥਾਨ ਦਾਖਲ ਕਰੋ",
            "Do you know which languages?": "ਤੁਸੀਂ ਕਿਹੜੀਆਂ ਭਾਸ਼ਾਵਾਂ ਜਾਣਦੇ ਹੋ?",
            "Enter Your Place": "ਆਪਣਾ ਸਥਾਨ ਦਾਖਲ ਕਰੋ",
            "Back to Step": "ਕਦਮ ਤੇ ਵਾਪਸ ਜਾਓ",
            "Next": "ਅਗਲਾ",
            "My Appointments": "ਮੇਰੀਆਂ ਮੁਲਾਕਾਤਾਂ",
            "Manage your astrology consultations": "ਆਪਣੀ ਅਸਟਰੋਲੋਜੀ ਸਲਾਹ ਮਸ਼ਵਰਾ ਸੰਭਾਲੋ",
            "Upcoming": "ਆਉਣ ਵਾਲੇ",
            "Past": "ਪਿਛਲੇ",
            "Pending": "ਬਾਕੀ",
            "Accepted": "ਸਵੀਕਾਰ ਕੀਤਾ",
            "Start": "ਸ਼ੁਰੂ ਕਰੋ",
            "Completed": "ਪੂਰਾ ਕੀਤਾ",
            "Canceled": "ਰੱਦ ਕੀਤਾ",
            "ID": "ਆਈਡੀ",
            "Chat": "ਚੈਟ",
            "Audio Call": "ਆਡੀਓ ਕਾਲ",
            "Video Call": "ਵੀਡੀਓ ਕਾਲ",
            "View Details": "ਵੇਰਵੇ ਵੇਖੋ",
            "Cancel": "ਰੱਦ ਕਰੋ",
            "No Upcoming Appointment Found !!": "ਕੋਈ ਆਉਣ ਵਾਲੀ ਮੁਲਾਕਾਤ ਨਹੀਂ ਮਿਲੀ !!",
            "Currently you don't have any upcoming appointment.": "ਤੁਹਾਡੇ ਕੋਲ ਇਸ ਸਮੇਂ ਕੋਈ ਆਉਣ ਵਾਲੀ ਮੁਲਾਕਾਤ ਨਹੀਂ ਹੈ।",
            "No Past Appointment Found !!": "ਕੋਈ ਪਿਛਲੀ ਮੁਲਾਕਾਤ ਨਹੀਂ ਮਿਲੀ !!",
            "Currently you don't have any past appointment.": "ਤੁਹਾਡੇ ਕੋਲ ਇਸ ਸਮੇਂ ਕੋਈ ਪਿਛਲੀ ਮੁਲਾਕਾਤ ਨਹੀਂ ਹੈ।",
            "Status": "ਸਥਿਤੀ",
            "Service Type": "ਸੇਵਾ ਦਾ ਕਿਸਮ",
            "Date": "ਤਾਰੀਖ",
            "Time": "ਸਮਾਂ",
            "Price": "ਕੀਮਤ",
            "Booked Person Details": "ਬੁੱਕ ਕੀਤੇ ਵਿਅਕਤੀ ਦੇ ਵੇਰਵੇ",
            "name": "ਨਾਮ",
            "Date of Birth": "ਜਨਮ ਤਾਰੀਖ",
            "Birth Place": "ਜਨਮ ਸਥਾਨ",
            "Gender": "ਲਿੰਗ",
            "Complete Details": "ਪੂਰੇ ਵੇਰਵੇ",
            "Start Time": "ਸ਼ੁਰੂ ਕਰਨ ਦਾ ਸਮਾਂ",
            "End Time": "ਅੰਤ ਸਮਾਂ",
            "Total Duration": "ਕੁੱਲ ਸਮਾਂ",
            "Billable Time": "ਬਿਲ ਯੋਗ ਸਮਾਂ",
            "Billed Fee First": "ਪਹਿਲਾ ਬਿਲ ਕੀਤਾ ਫੀਸ",
            "Billed Fee After": "ਬਾਅਦ ਵਿੱਚ ਬਿਲ ਕੀਤਾ ਫੀਸ",
            "Total Consultation Fee": "ਕੁੱਲ ਸਲਾਹਕਾਰ ਫੀਸ",
            "Kundali Details": "ਕੁੰਡਲੀ ਵੇਰਵੇ",
            "Name": "ਨਾਮ",
            "Send Notification": "ਸੂਚਨਾ ਭੇਜੋ",
            "Continue Chat": "ਚੈਟ ਜਾਰੀ ਰੱਖੋ",
            "Write message !!": "ਸੰਦਰਭ ਲਿਖੋ !!",
            "Astrologer Ai Assistant": "ਜੋਤਿਸ਼ੀ ਏਆਈ ਸਹਾਇਕ",
            "Ask anything about your horoscope...": "ਆਪਣੀ ਰਾਸ਼ੀਫਲ ਬਾਰੇ ਕੁਝ ਵੀ ਪੁੱਛੋ...",
            "Write message to assistant": "ਸਹਾਇਕ ਨੂੰ ਸੁਨੇਹਾ ਲਿਖੋ",
            "Clear Chat?": "ਚੈਟ ਸਾਫ਼ ਕਰਨੀ ਹੈ?",
            "All messages will be deleted permanently.": "ਸਾਰੇ ਸੁਨੇਹੇ ਸਥਾਈ ਤੌਰ 'ਤੇ ਹਟਾ ਦਿੱਤੇ ਜਾਣਗੇ।",
            "Clear": "ਸਾਫ਼ ਕਰੋ",
            "Payment faild !!": "ਭੁਗਤਾਨ ਅਸਫਲ !!",
            "Please Complete Last Apointment !!": "ਕਿਰਪਾ ਕਰਕੇ ਆਖਰੀ ਮੁਲਾਕਾਤ ਪੂਰੀ ਕਰੋ !!",
            "Please enter comment !!": "ਕਿਰਪਾ ਕਰਕੇ ਟਿੱਪਣੀ ਦਾਖਲ ਕਰੋ !!",
            "Insufficient wallet balance !!": "ਵਾਲਿਟ ਬਕਾਇਆ ਅਪਰਯਾਪਤ !!",
            "Orders": "ਆਰਡਰ",
            "Experience": "ਤਜਰਬਾ",
            "Rating": "ਰੇਟਿੰਗ",
            "Unfollow": "ਅਨਫਾਲੋ ਕਰੋ",
            "Follow": "ਫਾਲੋ ਕਰੋ",
            "Send Gift": "ਉਪਹਾਰ ਭੇਜੋ",
            "Start a Consultation": "ਸਲਾਹ ਮਸ਼ਵਰਾ ਸ਼ੁਰੂ ਕਰੋ",
            "Chat with astrologer": "ਜੋਤਿਸ਼ੀ ਨਾਲ ਚੈਟ ਕਰੋ",
            "For new user": "ਨਵੇਂ ਉਪਭੋਗਤਾ ਲਈ",
            "min free": "ਮਿੰਟ ਮੁਫ਼ਤ",
            "Call with astrologer": "ਜੋਤਿਸ਼ੀ ਨਾਲ ਕਾਲ",
            "Video call with astrologer": "ਜੋਤਿਸ਼ੀ ਨਾਲ ਵੀਡੀਓ ਕਾਲ",
            "Astrologer Bio": "ਜੋਤਿਸ਼ੀ ਬਾਇਓ",
            "Reviews": "ਸਮੀਖਿਆਵਾਂ",
            "Activity": "ਗਤੀਵਿਧੀ",
            "FAQ's": "ਅਕਸਰ ਪੁੱਛੇ ਜਾਣ ਵਾਲੇ ਸਵਾਲ",
            "Media": "ਮੀਡੀਆ",
            "Comment": "ਟਿੱਪਣੀ",
            "No comment yet": "ਹਾਲੇ ਤੱਕ ਕੋਈ ਟਿੱਪਣੀ ਨਹੀਂ",
            "start the conversation": "ਗੱਲਬਾਤ ਸ਼ੁਰੂ ਕਰੋ",
            "Poast your replay": "ਆਪਣਾ ਜਵਾਬ ਪੋਸਟ ਕਰੋ",
            "Delete comment": "ਟਿੱਪਣੀ ਹਟਾਓ",
            "Are you sure you want to delete this comment?": "ਕੀ ਤੁਸੀਂ ਪੱਕੇ ਤੌਰ 'ਤੇ ਇਹ ਟਿੱਪਣੀ ਹਟਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ?",
            "Cancle": "ਰੱਦ ਕਰੋ",
            "Delete": "ਹਟਾਓ",
            "Intro Audio": "ਪਰਿਚਯ ਆਡੀਓ",
            "Intro Video": "ਪਰਿਚਯ ਵੀਡੀਓ",
            "Hear from": "ਸੁਣੋ",
            "Please select user !!": "ਕਿਰਪਾ ਕਰਕੇ ਉਪਭੋਗਤਾ ਚੁਣੋ !!",
            "Please select amount !!": "ਕਿਰਪਾ ਕਰਕੇ ਰਕਮ ਚੁਣੋ !!",
            "Please select payment method !!": "ਕਿਰਪਾ ਕਰਕੇ ਭੁਗਤਾਨ ਦਾ ਤਰੀਕਾ ਚੁਣੋ !!",
            "Select Kundli": "ਕੁੰਡਲੀ ਚੁਣੋ",
            "Add Kundli": "ਕੁੰਡਲੀ ਸ਼ਾਮਲ ਕਰੋ",
            "Minimum balance of": "ਘੱਟੋ ਘੱਟ ਬਕਾਇਆ",
            "minutes": "ਮਿੰਟ",
            "is required to start chat with": "ਨਾਲ ਚੈਟ ਸ਼ੁਰੂ ਕਰਨ ਲਈ ਲੋੜੀਂਦਾ ਹੈ",
            "Wallet Balance": "ਵਾਲਿਟ ਬਕਾਇਆ",
            "Required": "ਲੋੜੀਂਦਾ",
            "Proceed to Pay": "ਭੁਗਤਾਨ ਜਾਰੀ ਰੱਖੋ",
            "extra in your": "ਤੁਹਾਡੇ ਵਿੱਚ ਵਾਧੂ",
            "wallet with this": "ਵਾਲਿਟ ਇਸ ਨਾਲ",
            "Woohoo!": "ਵਾਹ ਜੀ ਵਾਹ!",
            "Recharge Amount": "ਰੀਚਾਰਜ ਰਕਮ",
            "GST": "GST",
            "Wallet Amount": "ਵਾਲਿਟ ਰਕਮ",
            "Payble Amount": "ਭੁਗਤਾਨ ਯੋਗ ਰਕਮ",
            "Pay from Wallet": "ਵਾਲਿਟ ਤੋਂ ਭੁਗਤਾਨ ਕਰੋ",
            "Available": "ਉਪਲਬਧ",
            "Payment Getway Method": "ਭੁਗਤਾਨ ਗੇਟਵੇ ਤਰੀਕਾ",
            "Continue": "ਜਾਰੀ ਰੱਖੋ",
            "Fortune Cookie - Unveil Your Daily Wisdom": "ਫ਼ਾਰਚੂਨ ਕੁਕੀ - ਆਪਣੀ ਰੋਜ਼ਾਨਾ ਬੁੱਧੀ ਖੋਲ੍ਹੋ",
            "Crack open a fortune cookie to reveal a piece of daily wisdom. Let the message guide you through your day with positivity and insight.": "ਇੱਕ ਫ਼ਾਰਚੂਨ ਕੁਕੀ ਖੋਲ੍ਹੋ ਅਤੇ ਰੋਜ਼ਾਨਾ ਬੁੱਧੀ ਦੇ ਟੁਕੜੇ ਨੂੰ ਵੇਖੋ। ਸੁਨੇਹਾ ਤੁਹਾਡੇ ਦਿਨ ਨੂੰ ਸਕਾਰਾਤਮਕਤਾ ਅਤੇ ਜਾਨਕਾਰੀ ਨਾਲ ਮਾਰਗਦਰਸ਼ਨ ਕਰੇ।",
            "Ask The Fortune Cookie": "ਫ਼ਾਰਚੂਨ ਕੁਕੀ ਪੁੱਛੋ",
            "Crack open your Fortune Cookie": "ਆਪਣੀ ਫ਼ਾਰਚੂਨ ਕੁਕੀ ਖੋਲ੍ਹੋ",
            "Crack another one open": "ਹੋਰ ਇੱਕ ਖੋਲ੍ਹੋ",
            "Love Compatibility": "ਪਿਆਰ ਅਨੁਕੂਲਤਾ",
            "Find out how compatible you are with your lover, friend, or colleague using our love compatibility calculator. Get your results now.": "ਸਾਡੇ ਪਿਆਰ ਅਨੁਕੂਲਤਾ ਕੈਲਕੂਲੇਟਰ ਦੀ ਵਰਤੋਂ ਕਰਕੇ ਦੇਖੋ ਕਿ ਤੁਸੀਂ ਆਪਣੇ ਪ੍ਰੇਮੀ, ਮਿੱਤਰ ਜਾਂ ਸਹਿਯੋਗੀ ਨਾਲ ਕਿੰਨੇ ਅਨੁਕੂਲ ਹੋ। ਹੁਣ ਆਪਣੇ ਨਤੀਜੇ ਪ੍ਰਾਪਤ ਕਰੋ।",
            "Are Aries And Taurus Compatible": "ਕੀ ਮੇਸ਼ ਅਤੇ ਵृषਭ ਅਨੁਕੂਲ ਹਨ?",
            "Aries And Taurus Strengths": "ਮੇਸ਼ ਅਤੇ ਵृषਭ ਦੀਆਂ ਤਾਕਤਾਂ",
            "Aries And Taurus Weaknesses": "ਮੇਸ਼ ਅਤੇ ਵृषਭ ਦੀਆਂ ਕਮਜ਼ੋਰੀਆਂ",
            "Aries And Taurus Elements": "ਮੇਸ਼ ਅਤੇ ਵृषਭ ਦੇ ਤੱਤ",
            "Aries And Taurus Dates": "ਮੇਸ਼ ਅਤੇ ਵೃಷਭ ਦੀਆਂ ਤਾਰਿਖਾਂ",
            "Are Aries And Taurus Compatibility Score": "ਮੇਸ਼ ਅਤੇ ਵृषਭ ਦੀ ਅਨੁਕੂਲਤਾ ਸਕੋਰ",
            "General": "ਸਧਾਰਨ",
            "Communication": "ਸੰਚਾਰ",
            "Sex": "ਲਿੰਗ",
            "Select Another": "ਹੋਰ ਚੁਣੋ",
            "Aries": "ਮੇਸ਼",
            "Taurus": "ਵृषਭ",
            "Gemini": "ਮਿਥੁਨ",
            "Cancer": "ਕਰਕ",
            "Leo": "ਸਿੰਘ",
            "Virgo": "ਕੰਨਿਆ",
            "Libra": "ਤੁਲਾ",
            "Scorpio": "ਵ੍ਰਿਸ਼ਚਿਕ",
            "Sagittarius": "ਧਨੁ",
            "Capricorn": "ਮਕਰ",
            "Aquarius": "ਕੁੰਭ",
            "Pisces": "ਮੀਨ",
            "Please select Your Partner Sign": "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੇ ਸਾਥੀ ਦੀ ਰਾਸ਼ੀ ਚੁਣੋ",
            "Please select Your Sign": "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੀ ਰਾਸ਼ੀ ਚੁਣੋ",
            "Please fill all details !!": "ਕਿਰਪਾ ਕਰਕੇ ਸਾਰੇ ਵੇਰਵੇ ਭਰੋ !!",
            "Discover Your Core Numbers That Define You": "ਆਪਣੇ ਮੁੱਖ ਨੰਬਰ ਜਾਨੋ ਜੋ ਤੁਹਾਨੂੰ ਪਰਿਭਾਸ਼ਿਤ ਕਰਦੇ ਹਨ",
            "Explore your core numbers like Life Path, Destiny, and Personal Year—complete with strengths, challenges, and meaningful interpretations.": "ਆਪਣੇ ਮੁੱਖ ਨੰਬਰਾਂ ਨੂੰ ਜਾਣੋ ਜਿਵੇਂ ਜੀਵਨ ਮਾਰਗ, ਕਿਸਮਤ ਅਤੇ ਨਿੱਜੀ ਸਾਲ—ਤਾਕਤਾਂ, ਚੁਣੌਤੀਆਂ ਅਤੇ ਅਰਥਪੂਰਣ ਵਿਵਚਨ ਸਮੇਤ।",
            "Get Your Numbers": "ਆਪਣੇ ਨੰਬਰ ਪ੍ਰਾਪਤ ਕਰੋ",
            "First Name": "ਪਹਿਲਾ ਨਾਮ",
            "Last Name": "ਆਖਰੀ ਨਾਮ",
            "Method": "ਤਰੀਕਾ",
            "Chaldean": "ਚਲਡੀਅਨ",
            "Pythagorean": "ਪਾਇਥਾਗੋਰਿਆਈ",
            "Strengths": "ਤਾਕਤਾਂ",
            "Challenges": "ਚੁਣੌਤੀਆਂ",
            "Advice": "ਸਲਾਹ",
            "Get Report": "ਰਿਪੋਰਟ ਪ੍ਰਾਪਤ ਕਰੋ",
            "Select Tarot One Card": "ਟੈਰੋ ਕਾਰਡ ਚੁਣੋ",
            "Select Your Card": "ਆਪਣਾ ਕਾਰਡ ਚੁਣੋ",
            "Get Another": "ਹੋਰ ਪ੍ਰਾਪਤ ਕਰੋ",
            "Yes Or No Tarot": "ਹਾਂ ਜਾਂ ਨਾ ਟੈਰੋ",
            "Get instant Yes or No answers to pressing questions.": "ਤੁਰੰਤ ਹਾਂ ਜਾਂ ਨਾ ਦੇ ਜਵਾਬ ਪ੍ਰਾਪਤ ਕਰੋ।",
            "Daily Tarot": "ਰੋਜ਼ਾਨਾ ਟੈਰੋ",
            "Receive daily tarot readings on love, career, and finance.": "ਪਿਆਰ, ਕਰੀਅਰ ਅਤੇ ਵਿੱਤ ਬਾਰੇ ਰੋਜ਼ਾਨਾ ਟੈਰੋ ਪੜ੍ਹਾਈ ਪ੍ਰਾਪਤ ਕਰੋ।",
            "In-Depth Love Reading": "ਗਹਿਰਾਈ ਨਾਲ ਪਿਆਰ ਪੜ੍ਹਾਈ",
            "Deep dive into your love life with relationship-specific readings.": "ਰਿਸ਼ਤੇ-ਵਿਸ਼ੇਸ਼ ਪੜ੍ਹਾਈ ਨਾਲ ਆਪਣੇ ਪਿਆਰ ਜੀਵਨ ਵਿਚ ਡੁੱਬੋ।",
            "Flirt Love Reading": "ਚਲਾਕ ਪਿਆਰ ਪੜ੍ਹਾਈ",
            "Reveal insights into playful and romantic connections.": "ਮਨੋਰੰਜਕ ਅਤੇ ਰੋਮਾਂਟਿਕ ਸੰਬੰਧਾਂ ਬਾਰੇ ਜਾਣਕਾਰੀ ਪ੍ਰਗਟ ਕਰੋ।",
            "Erotic Love Reading": "ਇਰੋਟਿਕ ਪਿਆਰ ਪੜ੍ਹਾਈ",
            "Insights into intimate and personal love dynamics.": "ਘੁਪਤ ਅਤੇ ਨਿੱਜੀ ਪਿਆਰ ਗਤੀਵਿਧੀਆਂ ਬਾਰੇ ਜਾਣਕਾਰੀ।",
            "Egyptian Prediction": "ਮਿਸਰੀ ਅਨੁਮਾਨ",
            "Access ancient Egyptian insights beyond visible truths.": "ਦਿੱਖਣ ਯੋਗ ਸੱਚਾਈ ਤੋਂ ਅੱਗੇ ਪ੍ਰਾਚੀਨ ਮਿਸਰੀ ਜਾਣਕਾਰੀ ਪ੍ਰਾਪਤ ਕਰੋ।",
            "Ex-Flame Reading": "ਪੁਰਾਣੇ ਪਿਆਰ ਦੀ ਪੜ੍ਹਾਈ",
            "Explore the possibilities of rekindling with an ex-partner.": "ਪੁਰਾਣੇ ਸਾਥੀ ਨਾਲ ਮੁੜ ਸੰਬੰਧ ਬਣਾਉਣ ਦੇ ਅਸਰਾਂ ਨੂੰ ਖੋਜੋ।",
            "Made For Each Other Or Not Reading": "ਕੀ ਇੱਕ ਦੂਜੇ ਲਈ ਬਣੇ ਹੋਏ ਹਨ ਜਾਂ ਨਹੀਂ",
            "Discover if your relationship has long-term potential.": "ਜਾਣੋ ਕਿ ਤੁਹਾਡੇ ਰਿਸ਼ਤੇ ਵਿੱਚ ਲੰਬੇ ਸਮੇਂ ਲਈ ਸੰਭਾਵਨਾ ਹੈ ਜਾਂ ਨਹੀਂ।",
            "Power Life Reading": "ਪਾਵਰ ਲਾਈਫ ਪੜ੍ਹਾਈ",
            "Take control of your destiny with life-changing tarot readings.": "ਜੀਵਨ-ਬਦਲਣ ਵਾਲੀ ਟੈਰੋ ਪੜ੍ਹਾਈ ਨਾਲ ਆਪਣੀ ਕਿਸਮਤ 'ਤੇ ਕਾਬੂ ਪਾਓ।",
            "Know Your Friend Reading": "ਆਪਣੇ ਮਿੱਤਰ ਨੂੰ ਜਾਣੋ",
            "Understand the true intentions of your friendships.": "ਆਪਣੀ ਮਿੱਤਰਤਾ ਦੀਆਂ ਅਸਲ ਨੀਤੀਆਂ ਨੂੰ ਸਮਝੋ।",
            "Divine Angel Reading": "ਦਿਵਿਆ ਫਰਿਸ਼ਤੇ ਦੀ ਪੜ੍ਹਾਈ",
            "Connect with divine guidance for clarity and spiritual insight.": "ਸਪਸ਼ਟਤਾ ਅਤੇ ਆਤਮਿਕ ਗਿਆਨ ਲਈ ਦਿਵਿਆ ਮਾਰਗਦਰਸ਼ਨ ਨਾਲ ਜੁੜੋ।",
            "Career Daily Reading": "ਕਰੀਅਰ ਰੋਜ਼ਾਨਾ ਪੜ੍ਹਾਈ",
            "Elevate your career with daily tarot insights to achieve your professional goals.": "ਆਪਣੇ ਕਰੀਅਰ ਨੂੰ ਰੋਜ਼ਾਨਾ ਟੈਰੋ ਗਿਆਨ ਨਾਲ ਉੱਚਾ ਕਰੋ।",
            "Dream Come True Reading": "ਸਪਨਾ ਸੱਚ ਪੜ੍ਹਾਈ",
            "Gain insights into making your dreams and goals a reality.": "ਆਪਣੇ ਸਪਨੇ ਅਤੇ ਲਕੜੀਆਂ ਨੂੰ ਹਕੀਕਤ ਵਿੱਚ ਬਦਲਣ ਬਾਰੇ ਜਾਣਕਾਰੀ ਪ੍ਰਾਪਤ ਕਰੋ।",
            "Past Lives Connection Reading": "ਪਿਛਲੇ ਜਨਮ ਕਨੈਕਸ਼ਨ ਪੜ੍ਹਾਈ",
            "Explore your journey across time to understand your path ahead.": "ਆਪਣੇ ਸਮੇਂ ਦੇ ਸਫ਼ਰ ਨੂੰ ਖੋਜੋ ਅਤੇ ਆਪਣਾ ਰਸਤਾ ਸਮਝੋ।",
            "In-Depth Love Tarot provides comprehensive readings to bring clarity to your love life, help you make crucial decisions, and guide you toward understanding your soulmate and future partner.": "ਗਹਿਰਾਈ ਨਾਲ ਪਿਆਰ ਟੈਰੋ ਤੁਹਾਡੇ ਪਿਆਰ ਜੀਵਨ ਨੂੰ ਸਪਸ਼ਟਤਾ ਦੇਣ, ਮਹੱਤਵਪੂਰਨ ਫੈਸਲੇ ਕਰਨ ਵਿੱਚ ਮਦਦ ਕਰਨ ਅਤੇ ਤੁਹਾਡੇ ਸੌਲਮੇਟ ਅਤੇ ਭਵਿੱਖ ਦੇ ਸਾਥੀ ਨੂੰ ਸਮਝਣ ਲਈ ਵਿਸਤ੍ਰਿਤ ਪੜ੍ਹਾਈ ਪ੍ਰਦਾਨ ਕਰਦਾ ਹੈ।",
            "The Flirt Love Tarot Reading provides playful insights into your romantic life. Whether it's a friendship, a new admirer, or a potential soulmate, this reading helps you navigate love with ease.": "ਚਲਾਕ ਪਿਆਰ ਟੈਰੋ ਪੜ੍ਹਾਈ ਤੁਹਾਡੇ ਰੋਮਾਂਟਿਕ ਜੀਵਨ ਬਾਰੇ ਮਨੋਰੰਜਕ ਜਾਣਕਾਰੀ ਦਿੰਦੀ ਹੈ। ਚਾਹੇ ਇਹ ਦੋਸਤੀ, ਨਵਾਂ ਪ੍ਰਸ਼ੰਸਕ, ਜਾਂ ਸੰਭਾਵਤ ਸੌਲਮੇਟ ਹੋਵੇ, ਇਹ ਪੜ੍ਹਾਈ ਤੁਹਾਨੂੰ ਪਿਆਰ ਵਿੱਚ ਆਸਾਨੀ ਨਾਲ ਮਾਰਗਦਰਸ਼ਨ ਕਰਦੀ ਹੈ।",
            "This reading reveals insights into passion, love, and sexual chemistry, helping you understand your relationships and uncover hidden fantasies.": "ਇਹ ਪੜ੍ਹਾਈ ਜੋਸ਼, ਪਿਆਰ ਅਤੇ ਲਿੰਗਕ ਰਸਾਇਣ ਬਾਰੇ ਜਾਣਕਾਰੀ ਪ੍ਰਗਟ ਕਰਦੀ ਹੈ, ਤੁਹਾਨੂੰ ਆਪਣੇ ਸੰਬੰਧਾਂ ਨੂੰ ਸਮਝਣ ਅਤੇ ਲੁਕਵੇਂ ਫੈਂਟਸੀ ਨੂੰ ਖੋਜਣ ਵਿੱਚ ਮਦਦ ਕਰਦੀ ਹੈ।",
            "Explore your twin flame, current struggles, ancestral roots, and past healing with the ancient wisdom of Egyptian Tarot": "ਮਿਸਰੀ ਟੈਰੋ ਦੀ ਪ੍ਰਾਚੀਨ ਬੁੱਧੀ ਨਾਲ ਆਪਣੇ ਟਵਿਨ ਫਲੇਮ, ਮੌਜੂਦਾ ਮੁਸ਼ਕਲਾਂ, ਵੰਸ਼ਜ ਰੂੜ੍ਹੀਆਂ ਅਤੇ ਪਿਛਲੇ ਚੰਗੇ ਕਰਨ ਦਾ ਅਧਿਐਨ ਕਰੋ।",
            "The Ex-Flame Tarot Reading provides clarity on whether to rekindle a past relationship or move on. Explore your ex’s feelings, the potential for a renewed connection, and the impact on your future.": "ਪੁਰਾਣੇ ਪਿਆਰ ਦੀ ਟੈਰੋ ਪੜ੍ਹਾਈ ਇਹ ਸਪਸ਼ਟ ਕਰਦੀ ਹੈ ਕਿ ਪਿਛਲੇ ਸੰਬੰਧ ਨੂੰ ਦੁਬਾਰਾ ਸ਼ੁਰੂ ਕਰਨਾ ਚਾਹੀਦਾ ਹੈ ਜਾਂ ਅੱਗੇ ਵਧਣਾ ਚਾਹੀਦਾ ਹੈ। ਆਪਣੇ ਪੁਰਾਣੇ ਸਾਥੀ ਦੇ ਭਾਵਨਾ, ਮੁੜ ਸੰਬੰਧ ਬਣਾਉਣ ਦੀ ਸੰਭਾਵਨਾ ਅਤੇ ਭਵਿੱਖ 'ਤੇ ਪ੍ਰਭਾਵ ਦੀ ਜਾਂਚ ਕਰੋ।",
            "This Tarot reading reveals whether your relationship is worth the effort, safe to pursue, and aligned with your life goals. Understand if you’re truly made for each other or if it’s time to move on.": "ਇਹ ਟੈਰੋ ਪੜ੍ਹਾਈ ਦਿਖਾਉਂਦੀ ਹੈ ਕਿ ਤੁਹਾਡਾ ਸੰਬੰਧ ਕੋਸ਼ਿਸ਼ ਕਰਨ ਲਾਇਕ ਹੈ, ਪਿਛੇ ਲੱਗਣ ਲਈ ਸੁਰੱਖਿਅਤ ਹੈ, ਅਤੇ ਜੀਵਨ ਦੇ ਲਕੜੀਆਂ ਨਾਲ ਮਿਲਦਾ ਹੈ। ਸਮਝੋ ਕਿ ਤੁਸੀਂ ਸੱਚਮੁੱਚ ਇਕ ਦੂਜੇ ਲਈ ਬਣੇ ਹੋ ਜਾਂ ਅੱਗੇ ਵਧਣ ਦਾ ਸਮਾਂ ਹੈ।",
            "The Power Life Tarot Reading helps you plan your life, overcome struggles, create a clear vision, and take charge of your destiny. Unlock the guidance you need to steer your life towards success.": "ਪਾਵਰ ਲਾਈਫ ਟੈਰੋ ਪੜ੍ਹਾਈ ਤੁਹਾਡੇ ਜੀਵਨ ਦੀ ਯੋਜਨਾ ਬਣਾਉਣ, ਮੁਸ਼ਕਲਾਂ ਨੂੰ ਜਿੱਤਣ, ਸਪਸ਼ਟ ਦ੍ਰਿਸ਼ਟੀ ਬਣਾਉਣ ਅਤੇ ਆਪਣੀ ਕਿਸਮਤ 'ਤੇ ਕਾਬੂ ਪਾਉਣ ਵਿੱਚ ਮਦਦ ਕਰਦੀ ਹੈ। ਆਪਣੀ ਜੀਵਨ ਨੂੰ ਸਫਲਤਾ ਵੱਲ ਲੈ ਜਾਣ ਲਈ ਲੋੜੀਂਦਾ ਮਾਰਗਦਰਸ਼ਨ ਪ੍ਰਾਪਤ ਕਰੋ।",
            "Divine Angel Tarot connects you with your guardian angels, offering guidance to overcome challenges and find peace in love, freedom, and resolution.": "ਦਿਵਿਆ ਫਰਿਸ਼ਤੇ ਟੈਰੋ ਤੁਹਾਨੂੰ ਆਪਣੇ ਰੱਖਿਆ ਫਰਿਸ਼ਤਿਆਂ ਨਾਲ ਜੋੜਦਾ ਹੈ, ਚੁਣੌਤੀਆਂ ਨੂੰ ਪਾਰ ਕਰਨ ਅਤੇ ਪਿਆਰ, ਆਜ਼ਾਦੀ ਅਤੇ ਸੁਲਹ ਵਿੱਚ ਸ਼ਾਂਤੀ ਲੱਭਣ ਲਈ ਮਾਰਗਦਰਸ਼ਨ ਦਿੰਦਾ ਹੈ।",
            "Career Daily Tarot offers insights to manage your workday, from handling your boss to staying proactive and managing tasks effectively. Let the Tarot guide you to a successful and stress-free day.": "ਕਰੀਅਰ ਰੋਜ਼ਾਨਾ ਟੈਰੋ ਤੁਹਾਡੇ ਕੰਮ ਦੇ ਦਿਨ ਨੂੰ ਸੰਭਾਲਣ ਲਈ ਜਾਣਕਾਰੀ ਦਿੰਦਾ ਹੈ, ਆਪਣੇ ਬਾਸ਼ ਨਾਲ ਨਿਪਟਣ ਤੋਂ ਲੈ ਕੇ ਪੂਰਕ ਰਹਿਣ ਅਤੇ ਕਾਰਜ ਪ੍ਰਭਾਵਸ਼ਾਲੀ ਤਰੀਕੇ ਨਾਲ ਸੰਭਾਲਣ ਤੱਕ। ਟੈਰੋ ਤੁਹਾਨੂੰ ਸਫਲ ਅਤੇ ਤਣਾਵ-ਮੁਕਤ ਦਿਨ ਵੱਲ ਮਾਰਗਦਰਸ਼ਨ ਕਰੇ।",
            "The Dream Come True Tarot Reading helps you manifest your deepest wishes and aspirations. Whether it's love, material desires, or unfulfilled dreams, this reading offers clarity and guidance to turn your desires into reality.": "ਸਪਨਾ ਸੱਚ ਪੜ੍ਹਾਈ ਤੁਹਾਡੇ ਸਭ ਤੋਂ ਡੂੰਘੇ ਇੱਛਾਵਾਂ ਅਤੇ ਲਕੜੀਆਂ ਨੂੰ ਅਸਲੀਅਤ ਵਿੱਚ ਬਦਲਣ ਵਿੱਚ ਮਦਦ ਕਰਦੀ ਹੈ। ਚਾਹੇ ਪਿਆਰ, ਭੌਤਿਕ ਇੱਛਾਵਾਂ, ਜਾਂ ਅਧੂਰੇ ਸਪਨੇ ਹੋਣ, ਇਹ ਪੜ੍ਹਾਈ ਸਪਸ਼ਟਤਾ ਅਤੇ ਮਾਰਗਦਰਸ਼ਨ ਦਿੰਦੀ ਹੈ।",
            "Explore your past lives to understand current fears, recurring patterns, and influences. Gain clarity on challenges rooted in your previous incarnations.": "ਆਪਣੇ ਪਿਛਲੇ ਜਨਮਾਂ ਦਾ ਅਧਿਐਨ ਕਰੋ, ਮੌਜੂਦਾ ਡਰ, ਦੁਹਰਾਏ ਜਾਣ ਵਾਲੇ ਨਮੂਨੇ ਅਤੇ ਪ੍ਰਭਾਵ ਸਮਝਣ ਲਈ। ਪਿਛਲੇ ਜਨਮਾਂ ਵਿੱਚ ਜੜ੍ਹੀਆਂ ਚੁਣੌਤੀਆਂ ਬਾਰੇ ਸਪਸ਼ਟਤਾ ਪ੍ਰਾਪਤ ਕਰੋ।",
            "Select Tarot Three Card": "ਟੈਰੋ ਤਿੰਨ ਕਾਰਡ ਚੁਣੋ",
            "Heartbreak Reading": "ਦਿਲ ਟੁੱਟਣ ਪੜ੍ਹਾਈ",
            "Find guidance and healing for a broken heart.": "ਟੁੱਟੇ ਦਿਲ ਲਈ ਮਾਰਗਦਰਸ਼ਨ ਅਤੇ ਚੰਗਾ ਕਰਨ ਦੇ ਤਰੀਕੇ ਲੱਭੋ।",
            "Wisdom Reading": "ਬੁੱਧੀ ਪੜ੍ਹਾਈ",
            "Balance your energies and find mental peace through wisdom.": "ਆਪਣੀ ਸ਼ਕਤੀ ਨੂੰ ਸੰਤੁਲਿਤ ਕਰੋ ਅਤੇ ਬੁੱਧੀ ਰਾਹੀਂ ਮਾਨਸਿਕ ਸ਼ਾਂਤੀ ਲੱਭੋ।",
            "Divine Magic Reading": "ਦਿਵਿਆ ਜਾਦੂਈ ਪੜ੍ਹਾਈ",
            "Discover mystical insights with magical tarot guidance.": "ਜਾਦੂਈ ਟੈਰੋ ਮਾਰਗਦਰਸ਼ਨ ਨਾਲ ਰਾਜਸੀ ਜਾਣਕਾਰੀ ਖੋਜੋ।",
            "Heartbreak Tarot Reading - Find Closure and Guidance": "ਦਿਲ ਟੁੱਟਣ ਟੈਰੋ ਪੜ੍ਹਾਈ - ਬੰਦ ਕਰਨ ਅਤੇ ਮਾਰਗਦਰਸ਼ਨ ਲੱਭੋ",
            "The Heartbreak Tarot Reading offers insight into the cause of your pain and provides advice on how to heal and move forward. This two-card reading delivers clarity and the necessary steps to mend your broken heart.": "ਦਿਲ ਟੁੱਟਣ ਟੈਰੋ ਪੜ੍ਹਾਈ ਤੁਹਾਡੇ ਦਰਦ ਦੇ ਕਾਰਨ ਬਾਰੇ ਜਾਣਕਾਰੀ ਦਿੰਦੀ ਹੈ ਅਤੇ ਚੰਗਾ ਹੋਣ ਅਤੇ ਅੱਗੇ ਵਧਣ ਦੇ ਤਰੀਕੇ ਬਾਰੇ ਸਲਾਹ ਦਿੰਦੀ ਹੈ। ਇਹ ਦੋ-ਕਾਰਡ ਪੜ੍ਹਾਈ ਸਪਸ਼ਟਤਾ ਅਤੇ ਟੁੱਟੇ ਦਿਲ ਨੂੰ ਠੀਕ ਕਰਨ ਲਈ ਜ਼ਰੂਰੀ ਕਦਮ ਦਿੰਦੀ ਹੈ।",
            "Wisdom Tarot - Find Balance with Yin and Yang": "ਬੁੱਧੀ ਟੈਰੋ - ਯਿਨ ਅਤੇ ਯਾਂਗ ਨਾਲ ਸੰਤੁਲਨ ਲੱਭੋ",
            "Wisdom Tarot provides guidance by balancing the Yin and Yang energies in your life. Discover clarity, peace, and a path forward with this two-card reading.": "ਬੁੱਧੀ ਟੈਰੋ ਤੁਹਾਡੇ ਜੀਵਨ ਵਿੱਚ ਯਿਨ ਅਤੇ ਯਾਂਗ ਊਰਜਾਵਾਂ ਨੂੰ ਸੰਤੁਲਿਤ ਕਰਕੇ ਮਾਰਗਦਰਸ਼ਨ ਦਿੰਦਾ ਹੈ। ਦੋ-ਕਾਰਡ ਪੜ੍ਹਾਈ ਨਾਲ ਸਪਸ਼ਟਤਾ, ਸ਼ਾਂਤੀ ਅਤੇ ਅੱਗੇ ਦਾ ਰਸਤਾ ਖੋਜੋ।",
            "Divine Magic Tarot Reading - Discover Cause and Remedy": "ਦਿਵਿਆ ਜਾਦੂਈ ਟੈਰੋ ਪੜ੍ਹਾਈ - ਕਾਰਨ ਅਤੇ ਉਪਚਾਰ ਖੋਜੋ",
            "The Divine Magic Tarot Reading offers insights into the root cause of your problems and provides a remedy to guide you toward resolution. With this reading, discover the steps you need to take to transform challenges into solutions.": "ਦਿਵਿਆ ਜਾਦੂਈ ਟੈਰੋ ਪੜ੍ਹਾਈ ਤੁਹਾਡੇ ਸਮੱਸਿਆਵਾਂ ਦੇ ਮੁੱਖ ਕਾਰਨ ਬਾਰੇ ਜਾਣਕਾਰੀ ਦਿੰਦੀ ਹੈ ਅਤੇ ਸਮਾਧਾਨ ਵੱਲ ਮਾਰਗਦਰਸ਼ਨ ਲਈ ਉਪਚਾਰ ਦਿੰਦੀ ਹੈ। ਇਸ ਪੜ੍ਹਾਈ ਨਾਲ, ਚੁਣੌਤੀਆਂ ਨੂੰ ਹੱਲ ਵਿੱਚ ਬਦਲਣ ਲਈ ਜਰੂਰੀ ਕਦਮ ਖੋਜੋ।",
            "Please pick your cards !!": "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੇ ਕਾਰਡ ਚੁਣੋ !!",
            "Get Your Reading": "ਆਪਣੀ ਪੜ੍ਹਾਈ ਪ੍ਰਾਪਤ ਕਰੋ",
            "Select Tarot Two Card": "ਟੈਰੋ ਦੋ ਕਾਰਡ ਚੁਣੋ",
            "Love Triangle Reading": "ਪਿਆਰ ਤਿਕੋਣ ਪੜ੍ਹਾਈ",
            "Get clarity in choosing between multiple romantic interests.": "ਕਈ ਰੋਮਾਂਟਿਕ ਰੁਚੀਆਂ ਵਿਚੋਂ ਚੁਣਨ ਵਿੱਚ ਸਪਸ਼ਟਤਾ ਪ੍ਰਾਪਤ ਕਰੋ।",
            "Past-Present-Future Reading": "ਪਿਛਲਾ-ਮੌਜੂਦਾ-ਭਵਿੱਖ ਪੜ੍ਹਾਈ",
            "Love Triangle Tarot - Discover the Dynamics Between You, Lover 1, and Lover 2": "ਪਿਆਰ ਤਿਕੋਣ ਟੈਰੋ - ਤੁਹਾਡੇ, ਪ੍ਰੇਮੀ 1 ਅਤੇ ਪ੍ਰੇਮੀ 2 ਵਿਚਕਾਰ ਗਤੀਵਿਧੀਆਂ ਦੀ ਖੋਜ ਕਰੋ",
            "Love Triangle Tarot provides insights into the relationships and dynamics between you and your two lovers. Understand where you stand, and what each lover brings into your life, and make an informed decision guided by the cards.": "ਪਿਆਰ ਤਿਕੋਣ ਟੈਰੋ ਤੁਹਾਡੇ ਅਤੇ ਤੁਹਾਡੇ ਦੋ ਪ੍ਰੇਮੀਆਂ ਵਿਚਕਾਰ ਸੰਬੰਧਾਂ ਅਤੇ ਗਤੀਵਿਧੀਆਂ ਬਾਰੇ ਜਾਣਕਾਰੀ ਦਿੰਦਾ ਹੈ। ਸਮਝੋ ਕਿ ਤੁਸੀਂ ਕਿੱਥੇ ਖੜੇ ਹੋ, ਹਰ ਪ੍ਰੇਮੀ ਤੁਹਾਡੇ ਜੀਵਨ ਵਿੱਚ ਕੀ ਲਿਆਉਂਦਾ ਹੈ, ਅਤੇ ਕਾਰਡਾਂ ਦੇ ਮਾਰਗਦਰਸ਼ਨ ਨਾਲ ਸੋਚ-ਵਿਚਾਰ ਕਰਕੇ ਫੈਸਲਾ ਕਰੋ।",
            "Zodiac Gift Guru": "ਰਾਸ਼ੀ ਗਿਫਟ ਗੁਰੂ",
            "January": "ਜਨਵਰੀ",
            "February": "ਫ਼ਰਵਰੀ",
            "March": "ਮਾਰਚ",
            "April": "ਅਪ੍ਰੈਲ",
            "May": "ਮਈ",
            "June": "ਜੂਨ",
            "July": "ਜੁਲਾਈ",
            "August": "ਅਗਸਤ",
            "September": "ਸਤੰਬਰ",
            "October": "ਅਕਤੂਬਰ",
            "November": "ਨਵੰਬਰ",
            "December": "ਦਸੰਬਰ",
            "Yesterday": "ਕੱਲ੍ਹ",
            "Today": "ਅੱਜ",
            "Tomorrow": "ਕਲ੍ਹ",
            "Gift Recommendations": "ਉਪਹਾਰ ਸਿਫਾਰਸ਼ਾਂ",
            "insight": "ਜਾਣਕਾਰੀ",
            "Career": "ਕਰੀਅਰ",
            "Love": "ਪਿਆਰ",
            "Finance": "ਵਿੱਤ",
            "Popularity": "ਲੋਕਪ੍ਰਿਯਤਾ",
            "Experience: High to Low": "ਅਨੁਭਵ: ਵੱਧ ਤੋਂ ਘੱਟ",
            "Experience: Low to High": "ਅਨੁਭਵ: ਘੱਟ ਤੋਂ ਵੱਧ",
            "Orders: High to Low": "ਆਰਡਰ: ਵੱਧ ਤੋਂ ਘੱਟ",
            "Orders: Low to High": "ਆਰਡਰ: ਘੱਟ ਤੋਂ ਵੱਧ",
            "Price: High to Low": "ਕੀਮਤ: ਵੱਧ ਤੋਂ ਘੱਟ",
            "Price: Low to High": "ਕੀਮਤ: ਘੱਟ ਤੋਂ ਵੱਧ",
            "Rating: High to Low": "ਰੇਟਿੰਗ: ਵੱਧ ਤੋਂ ਘੱਟ",
            "Search name...": "ਨਾਮ ਖੋਜੋ...",
            "Online": "ਆਨਲਾਈਨ",
            "Busy": "ਵਿਆਸਤ",
            "Exp": "ਅਨੁਭਵ",
            "yrs": "ਸਾਲ",
            "orders": "ਆਰਡਰ",
            "min": "ਮਿੰਟ",
            "Chat Now": "ਹੁਣ ਚੈਟ ਕਰੋ",
            "Wait": "ਰੁਕੋ",
            "Top Astrologers": "ਸਰਵੋੱਚ ਜ਼ਰਿਫ਼ਾ",
            "rate": "ਰੇਟ",
            "Top Rated Astrologers": "ਸਰਵੋੱਚ ਰੇਟ ਵਾਲੇ ਜ਼ਰਿਫ਼ਾ",
            "No astrologers found !!": "ਕੋਈ ਜ਼ਰਿਫ਼ਾ ਨਹੀਂ ਮਿਲੇ !!",
            "FAQs": "ਅਕਸਰ ਪੁੱਛੇ ਜਾਂਦੇ ਸਵਾਲ",
            "Raning": "ਰੈਂਕਿੰਗ",
            "Raning Apointment": "ਰੈਂਕਿੰਗ ਮੁਲਾਕਾਤ",
            "Select Other Sign": "ਹੋਰ ਰਾਸ਼ੀ ਚੁਣੋ",
            "Horoscopes": "ਕੁੰਡਲੀ",
            "Daily Horoscope": "ਰੋਜ਼ਾਨਾ ਕੁੰਡਲੀ",
            "Weekly Horoscope": "ਹਫਤਾਵਾਰੀ ਕੁੰਡਲੀ",
            "Monthly Horoscope": "ਮਾਸਿਕ ਕੁੰਡਲੀ",
            "Yearly Horoscope": "ਸਾਲਾਨਾ ਕੁੰਡਲੀ",
            "Composite Friendship Table": "ਸੰਯੁਕਤ ਦੋਸਤੀ ਟੇਬਲ",
            "Kp Planetary Details": "ਕੇ.ਪੀ. ਗ੍ਰਹਿ ਵੇਰਵੇ",
            "Kp House Cusps And Chart": "ਕੇ.ਪੀ. ਘਰ ਕਸਪ ਅਤੇ ਚਾਰਟ",
            "Ascendant Report": "ਲਗਨ ਰਿਪੋਰਟ",
            "Bhava Kundli": "ਭਾਵ ਕੁੰਡਲੀ",
            "Vimshottari Dasha": "ਵਿੰਸ਼ੋਤਰੀ ਦਸ਼ਾ",
            "Yogini Dasha": "ਯੋਗਿਨੀ ਦਸ਼ਾ",
            "Sadhesati Analysis": "ਸਾਢੇਸਾਤੀ ਵਿਸ਼ਲੇਸ਼ਣ",
            "Sadhesati Life Analysis": "ਸਾਢੇਸਾਤੀ ਜੀਵਨ ਵਿਸ਼ਲੇਸ਼ਣ",
            "Kalsarpa Dosha": "ਕਾਲਸਰਪ ਦੋਸ਼",
            "Manglik Analysis": "ਮੰਗਲਿਕ ਵਿਸ਼ਲੇਸ਼ਣ",
            "Planet Profiles": "ਗ੍ਰਹਿ ਪ੍ਰੋਫਾਈਲ",
            "Gemstone Suggestions": "ਰਤਨ ਸੁਝਾਅ",
            "Upagraha": "ਉਪਗ੍ਰਹ",
            "Jaimini Astrology": "ਜੈਮੀਨੀ ਜ਼ਰਿਫ਼ਾ",
            "Chara Dasha": "ਚਰ ਦਸ਼ਾ",
            "Shadbala": "ਸ਼ਡਬਲ",
            "Sudarshana Chakra": "ਸੁਦਰਸ਼ਨ ਚੱਕਰ",
            "Bhinnashtakvarga": "ਭਿੰਨ ਅਸ਼ਟਕ ਵਰਗ",
            "Yogas": "ਯੋਗ",
            "Introduction": "ਪਰਿਚਯ",
            "Basic Astrological Details": "ਮੂਲ ਜ਼ਰਿਫ਼ਾ ਵੇਰਵੇ",
            "Planetary Positions": "ਗ੍ਰਹਿ ਸਥਿਤੀਆਂ",
            "Horoscope Charts": "ਕੁੰਡਲੀ ਚਾਰਟ",
            "House Cusps And Sandhi": "ਘਰ ਕਸਪ ਅਤੇ ਸੰਧੀ",
            "Divisional Charts": "ਵਿਭਾਗੀ ਚਾਰਟ",
            "Basic Details": "ਮੂਲ ਵੇਰਵੇ",
            "Ghat Chakra": "ਘੱਟ ਚੱਕਰ",
            "Panchange Details": "ਪੰਜਾਂਚ ਵੇਰਵੇ",
            "Astrological Details": "ਜੋਤਿਸ਼ ਵੇਰਵੇ",
            "Time of Birth": "ਜਨਮ ਸਮਾਂ",
            "Place of Birth": "ਜਨਮ ਸਥਾਨ",
            "Latitude": "ਅක්ෂਾਂਸ਼",
            "Longitude": "ਰੇਖਾਂਸ਼",
            "Timezone": "ਸਮਾਂ ਖੇਤਰ",
            "Ayanamsa": "ਅਯਨਾਮਸਾ",
            "Sunrise": "ਸੂਰਜ ਉਦੈ",
            "Sunset": "ਸੂਰਜ ਅਸਤ",
            "Month": "ਮਹੀਨਾ",
            "Tithi": "ਤਿੱਥੀ",
            "Yoga": "ਯੋਗ",
            "Karana": "ਕਰਣ",
            "Moon Sign": "ਚੰਦਰਮਾਂ ਰਾਸ਼ੀ",
            "Moon Vaar": "ਚੰਦ੍ਰ ਵਾਰ",
            "Nakshatra": "ਨਕਸ਼ਤਰ",
            "Varna": "ਵਰਣ",
            "Vashya": "ਵਾਸ਼੍ਯ",
            "Yoni": "ਯੋਨੀ",
            "Gana": "ਗਣ",
            "Nadi": "ਨਾਡੀ",
            "Sun Sign": "ਸੂਰਜ ਰਾਸ਼ੀ",
            "Tatva": "ਤੱਤਵ",
            "Paya": "ਪਾਇਆ",
            "Yanja": "ਯੰਜਾ",
            "Planets": "ਗ੍ਰਹਿ",
            "Sign": "ਰਾਸ਼ੀ",
            "Sign No": "ਰਾਸ਼ੀ ਨੰਬਰ",
            "LAGNA CHART (BIRTH CHART)": "ਲਗਨ ਚਾਰਟ (ਜਨਮ ਕੁੰਡਲੀ)",
            "MOON CHART": "ਚੰਦਰ ਚਾਰਟ",
            "NAVMANSHA CHART (D9)": "ਨਵਮੰਸ਼ ਚਾਰਟ (D9)",
            "House": "ਘਰ",
            "Bhav Madhya": "ਭਾਵ ਮੱਧ",
            "Bhav Sandhi": "ਭਾਵ ਸੰਧੀ",
            "Chalit Chart": "ਚਲਿਤ ਚਾਰਟ",
            "Sun Chart": "ਸੂਰਜ ਚਾਰਟ",
            "Health, Constitution, Body": "ਸਿਹਤ, ਸੰਵਿਧਾਨ, ਸਰੀਰ",
            "Hora Chart(D2)": "ਹੋਰ ਚਾਰਟ(D2)",
            "Finance, Wealth, Prosperity": "ਵਿੱਤ, ਧਨ, ਖੁਸ਼ਹਾਲੀ",
            "Dreshkan Chart(D3)": "ਦ੍ਰੇਸ਼ਕਾਨ ਚਾਰਟ(D3)",
            "Brothers, Sisters": "ਭਰਾ, ਭੈਣ",
            "Chathurthamasha Chart(D4)": "ਚਤੁਰਥਮਾਸ਼ਾ ਚਾਰਟ(D4)",
            "Fortunes, Luck of native": "ਨਿਵਾਸੀ ਦੀ ਕਿਸਮਤ ਅਤੇ ਭਾਗ",
            "Saptamansha Chart(D7)": "ਸਪਤਮਾਂਸ਼ ਚਾਰਟ(D7)",
            "Impregnation, Birth of the child": "ਗਰਭਧਾਰਣ, ਬੱਚੇ ਦਾ ਜਨਮ",
            "Dashamansha Chart(D10)": "ਦਸ਼ਮਾਂਸ਼ ਚਾਰਟ(D10)",
            "livelihood, Profession": "ਰੋਜ਼ਗਾਰ, ਪੇਸ਼ਾ",
            "Dwadasha Chart(D12)": "ਦਵਾਦਸ਼ ਚਾਰਟ(D12)",
            "Parents, paternal happiness": "ਮਾਪੇ, ਪਿਤਾ ਦੀ ਖੁਸ਼ਹਾਲੀ",
            "Shodashamsha Chart(D16)": "ਸ਼ੋਡਸ਼ਮਾਂਸ਼ ਚਾਰਟ(D16)",
            "Happiness, miseries, conveyance": "ਖੁਸ਼ਹਾਲੀ, ਦੁੱਖ, ਆਵਾਜਾਈ",
            "Vishamansha Chart(D20)": "ਵਿਸ਼ਮਾਂਸ਼ ਚਾਰਟ(D20)",
            "Spiritual progress, worship": "ਆਧਿਆਤਮਿਕ ਤਰੱਕੀ, ਪੂਜਾ",
            "Chaturvimshamsha(D24)": "ਚਤੁਰਵਿਮਸ਼ਮਾਂਸ਼(D24)",
            "Academic achievement, education": "ਅਕਾਦਮਿਕ ਪ੍ਰਾਪਤੀ, ਸਿੱਖਿਆ",
            "Bhamsha Chart(D27)": "ਭਮਸ਼ਾ ਚਾਰਟ(D27)",
            "Physical strength, stamina": "ਸ਼ਾਰੀਰੀਕ ਤਾਕਤ, ਸਹਨਸ਼ੀਲਤਾ",
            "Trishamansha Chart(D30)": "ਤ੍ਰਿਸ਼ਮਾਂਸ਼ ਚਾਰਟ(D30)",
            "Evil, Adversities of life": "ਬੁਰਾਈ, ਜੀਵਨ ਦੀਆਂ ਮੁਸ਼ਕਲਾਂ",
            "Khavedamsha Chart(D40)": "ਖਾਵੇਦਮਾਂਸ਼ ਚਾਰਟ(D40)",
            "Auspicious & inauspicious effect": "ਸ਼ੁਭ ਅਤੇ ਅਸ਼ੁਭ ਪ੍ਰਭਾਵ",
            "Akshvedansha Chart(D45)": "ਅਕਸ਼ਵੇਦਾਂਸ਼ ਚਾਰਟ(D45)",
            "Character and couduct of the native": "ਨਿਵਾਸੀ ਦਾ ਚਰਿੱਤਰ ਅਤੇ ਵਰਤਾਓ",
            "Shashtymsah Chart(D60)": "ਸ਼ਾਸ਼ਟਯੰਸ਼ ਚਾਰਟ(D60)",
            "Shows general happiness": "ਸਧਾਰਨ ਖੁਸ਼ਹਾਲੀ ਦਿਖਾਉਂਦਾ ਹੈ",
            "Degrees": "ਡਿਗਰੀ",
            "Sign Lord": "ਰਾਸ਼ੀ ਦੇ ਪ੍ਰਭੂ",
            "Nakshatra Lord": "ਨਕਸ਼ਤਰ ਦੇ ਪ੍ਰਭੂ",
            "Sub Lord": "ਸਬ-ਲਾਰਡ",
            "Sub Sub Lord": "ਸਬ-ਸਬ-ਲਾਰਡ",
            "Lord": "ਪ੍ਰਭੂ",
            "Symbol": "ਚਿੰਨ੍ਹ",
            "Characteristics": "ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ",
            "Day of Fast": "ਉਪਵਾਸ ਦਾ ਦਿਨ",
            "luchy Gems": "ਸੌਭਾਗ੍ਯਸ਼ਾਲੀ ਰਤਨ",
            "Personality": "ਪ੍ਰਕਿਰਤੀ",
            "Health": "ਸਿਹਤ",
            "Relationships": "ਰਿਸ਼ਤੇ",
            "BHAVA KUNDLI": "ਭਾਵ ਕੁੰਡਲੀ",
            "Bhramari": "ਭ੍ਰਮਰੀ",
            "Bhadrika": "ਭਦ੍ਰਿਕਾ",
            "Ulka": "ਉਲਕਾ",
            "Siddha": "ਸਿੱਧ",
            "Sankata": "ਸੰਕਟ",
            "Mangala": "ਮੰਗਲ",
            "Pingala": "ਪਿੰਗਲਾ",
            "Dhanya": "ਧਨਿਆ",
            "Remedies Of Sadhesati": "ਸਾਢੇਸਾਤੀ ਦੇ ਉਪਾਅ",
            "Saturn Sign": "ਸ਼ਨੀ ਰਾਸ਼ੀ",
            "Is Saturn Retro?": "ਕੀ ਸ਼ਨੀ ਰਿਟ੍ਰੋਗ੍ਰੇਡ ਹੈ?",
            "Phase": "ਚਰਣ",
            "Intensity": "ਤੀਬਰਤਾ",
            "Direction": "ਦਿਸ਼ਾ",
            "Strength": "ਤਾਕਤ",
            "Percentage": "ਪਰਤੀਸ਼ਤ",
            "Zodiac Sign": "ਰਾਸ਼ੀ ਚਿੰਨ੍ਹ",
            "Planet Degree": "ਗ੍ਰਹਿ ਡਿਗਰੀ",
            "Lord Of": "ਦੇ ਪ੍ਰਭੂ",
            "Combust/Aw...": "ਕੰਬਸਟ/ਆਵ...",
            "Lucky Stone": "ਕਿਸਮਤ ਰਤਨ",
            "Life Stone": "ਜੀਵਨ ਰਤਨ",
            "Finger": "ਅੰਗੂਠਾ",
            "Day": "ਦਿਨ",
            "Time to Wear": "ਪਹਿਨਣ ਦਾ ਸਮਾਂ",
            "Mantra": "ਮੰਤਰ",
            "Upagraha Longitude": "ਉਪਗ੍ਰਹ ਰੇਖਾਂਸ਼",
            "Rashi": "ਰਾਸ਼ੀ",
            "Pada": "ਪਦ",
            "Upagraha/Nakshatra/Sub Lord": "ਉਪਗ੍ਰਹ/ਨਕਸ਼ਤਰ/ਸਬ ਲਾਰਡ",
            "Jamini Planets": "ਜੈਮੀਨੀ ਗ੍ਰਹਿ",
            "Jamini Padas": "ਜੈਮੀਨੀ ਪਦ",
            "Code": "ਕੋਡ",
            "Jamini Karakara": "ਜੈਮੀਨੀ ਕਾਰਕ",
            "Uchcha Bala": "ਉੱਚ ਬਲ",
            "Saptavarga Bala": "ਸਪਤਵਰਗ ਬਲ",
            "Yugmayugma Bhamsha Bala": "ਯੁਗਮਯੁਗਮਾ ਭਮਸ਼ਾ ਬਲ",
            "Kendradi Bala": "ਕੇਂਦਰਬਾਲ ਬਲ",
            "Drekkana Bala": "ਦ੍ਰੇਕਕਾਨਾ ਬਲ",
            "Total Sthana Bala": "ਕੁੱਲ ਸਥਾਨ ਬਲ",
            "Total Dig Bala": "ਕੁੱਲ ਦਿਸ਼ਾ ਬਲ",
            "Nattunnata Bala": "ਨਟੁੰਨਤਾ ਬਲ",
            "Paksha Bala": "ਪੱਖ ਬਲ",
            "Tribhaga Bala": "ਤ੍ਰਿਭਾਗ ਬਲ",
            "Varshadhipati": "ਵਰਸ਼ਾਧਿਪਤੀ",
            "Maasadipati": "ਮਾਸਾਧਿਪਤੀ",
            "Vaaradhipati": "ਵਾਰਾਧਿਪਤੀ",
            "Horadhipati": "ਹੋਰਾਧਿਪਤੀ",
            "Ayana Bala": "ਅਯਾਨਾ ਬਲ",
            "Yuddha Bala": "ਯੁੱਧ ਬਲ",
            "Total Kaal Bala": "ਕੁੱਲ ਕਾਲ ਬਲ",
            "Naisargika Bala": "ਨੈਸਰਗੀਕ ਬਲ",
            "Chestha Bala": "ਚੇਸਥਾ ਬਲ",
            "Drik Bala": "ਦ੍ਰਿਕ ਬਲ",
            "Total Shadbala": "ਕੁੱਲ ਸ਼ਡਬਲ",
            "Shadbala In Rupa": "ਰੂਪ ਵਿੱਚ ਸ਼ਡਬਲ",
            "Min Require": "ਘੱਟੋ-ਘੱਟ ਲੋੜ",
            "Ratio": "ਅਨੁਪਾਤ",
            "Rank": "ਰੈਂਕ",
            "Sun": "ਸੂਰਜ",
            "Moon": "ਚੰਦ੍ਰਮਾ",
            "Mars": "ਮੰਗਲ",
            "Mercury": "ਬੁਧ",
            "Jupiter": "ਗੁਰੂ",
            "Venus": "ਸ਼ੁੱਕਰ",
            "Saturn": "ਸ਼ਨੀ",
            "Ashtakvarga": "ਅਸ਼ਟਕ ਵਰਗ",
            "Sarvashtakava": "ਸਰਵ ਅਸ਼ਟਕ ਵਰਗ",
            "Prasthara Chakra": "ਪ੍ਰਸਥਾਰਾ ਚੱਕਰ",
            "Ascendant": "ਲਗਨ",
            "Total": "ਕੁੱਲ",
            "Natural Friendship": "ਕੁਦਰਤੀ ਦੋਸਤੀ",
            "Temporary Friendship": "ਅਸਥਾਈ ਦੋਸਤੀ",
            "Five Fold Friendship": "ਪੰਜ ਗੁਣਾ ਦੋਸਤੀ",
            "Ketu": "ਕੇਤੂ",
            "Rahu": "ਰਾਹੂ",
            "Vimshottari Dasha P1": "ਵਿੰਸ਼ੋਤਰੀ ਦਸ਼ਾ ਪੀ1",
            "Vimshottari Dasha P2": "ਵਿੰਸ਼ੋਤਰੀ ਦਸ਼ਾ ਪੀ2",
            "AshtaKoot": "ਅਸ਼ਟਕੂਟ",
            "Bhakut Dosha": "ਭਾਕੂਟ ਦੋਸ਼",
            "Nadi Dosha": "ਨਾਡੀ ਦੋਸ਼",
            "Ashtakoot Analysis": "ਅਸ਼ਟਕੂਟ ਵਿਸ਼ਲੇਸ਼ਣ",
            "DashaKoot": "ਦਸ਼ਾਕੂਟ",
            "Personality Report": "ਪ੍ਰਕਿਰਤੀ ਰਿਪੋਰਟ",
            "Match Making Report": "ਮੈਚ ਮੇਕਿੰਗ ਰਿਪੋਰਟ",
            "Nav Pancham Yoga": "ਨਵ ਪੰਚਮ ਯੋਗ",
            "Charan": "ਚਰਨ",
            "Name Alphabet": "ਨਾਂ ਅੱਖਰ",
            "Planetary Position": "ਗ੍ਰਹਿ ਸਥਿਤੀ",
            "Lagna Chart (Birth Chart)": "ਲਗਨ ਚਾਰਟ (ਜਨਮ ਕੁੰਡਲੀ)",
            "Moon Chart": "ਚੰਦਰ ਚਾਰਟ",
            "Navmansha Chart (D9)": "ਨਵਮਾਂਸ਼ ਚਾਰਟ (D9)",
            "Mahadasha": "ਮਹਾ ਦਸ਼ਾ",
            "End": "ਅੰਤ",
            "Is Recommended ??": "ਕੀ ਸਿਫਾਰਸ਼ ਕੀਤੀ ਗਈ ??",
            "Manglik Details": "ਮੰਗਲਿਕ ਵੇਰਵੇ",
            "What is AshtaKoot ??": "ਅਸ਼ਟਕੂਟ ਕੀ ਹੈ ??",
            "Attributes": "ਲੱਛਣ",
            "Description": "ਵੇਰਵਾ",
            "Received": "ਪ੍ਰਾਪਤ",
            "Graha Maitri": "ਗ੍ਰਹਿ ਮੈਤਰੀ",
            "Bhakoota": "ਭਾਕੂਟਾ",
            "What is BhaKoot Dosha ??": "ਭਾਕੂਟ ਦੋਸ਼ ਕੀ ਹੈ ??",
            "What is Nadi Dosha ??": "ਨਾਡੀ ਦੋਸ਼ ਕੀ ਹੈ ??",
            "Madhya": "ਮੱਧ",
            "Nadi dosha is present": "ਨਾਡੀ ਦੋਸ਼ ਮੌਜੂਦ ਹੈ",
            "The": "ਦ",

            "porutham considered for horoscope matching are as follows :": "ਜੋ ਪੁੜਥਮ ਕੁੰਡਲੀ ਮਿਲਾਪ ਲਈ ਵਿਚਾਰ ਕੀਤੇ ਜਾਂਦੇ ਹਨ, ਉਹ ਹੇਠਾਂ ਦਿੱਤੇ ਗਏ ਹਨ :",
            "Dina": "ਦਿਨਾ",
            "Rajju": "ਰਾਜੂ",
            "Rasyadhipati": "ਰਾਸ਼ੀ ਅਧਿਪਤੀ",
            "Vedha": "ਵੇਧਾ",
            "Mahendra": "ਮਹੇੰਦਰ",
            "Streedargha": "ਸ੍ਰੀਦਰਘਾ",
            "Uranus": "ਯੂਰਾਨਸ",
            "Neptune": "ਨੇਪਚੂਨ",
            "Pluto": "ਪਲੂਟੋ",
            "Tara": "ਤਾਰਾ",
            "Please fill boy's details !!": "ਕਿਰਪਾ ਕਰਕੇ ਮੁੰਡੇ ਦੇ ਵੇਰਵੇ ਭਰੋ !!",
            "Please fill girl's details !!": "ਕਿਰਪਾ ਕਰਕੇ ਕੁੜੀ ਦੇ ਵੇਰਵੇ ਭਰੋ !!",
            "Please fill chart details !!": "ਕਿਰਪਾ ਕਰਕੇ ਚਾਰਟ ਵੇਰਵੇ ਭਰੋ !!",
            "Kundli Matching": "ਕੁੰਡਲੀ ਮਿਲਾਪ",
            "Find your right one, through matchmaking": "ਮੈਚਮੈਕਿੰਗ ਰਾਹੀਂ ਆਪਣਾ ਸਹੀ ਜੋੜਾ ਲੱਭੋ",
            "Open Kundli": "ਕੁੰਡਲੀ ਖੋਲ੍ਹੋ",
            "New Matching": "ਨਵਾਂ ਮਿਲਾਪ",
            "View Kundli": "ਕੁੰਡਲੀ ਵੇਖੋ",
            "Boy's Details": "ਮੁੰਡੇ ਦੇ ਵੇਰਵੇ",
            "Girl's Details": "ਕੁੜੀ ਦੇ ਵੇਰਵੇ",
            "Search city, state, country": "ਸ਼ਹਿਰ, ਰਾਜ, ਦੇਸ਼ ਖੋਜੋ",
            "Enter first name": "ਪਹਿਲਾ ਨਾਮ ਦਾਖਲ ਕਰੋ",
            "Enter last name": "ਆਖਰੀ ਨਾਮ ਦਾਖਲ ਕਰੋ",
            "Chart Style": "ਚਾਰਟ ਅੰਦਾਜ਼",
            "North Indian": "ਉੱਤਰੀ ਭਾਰਤੀ",
            "South Indian": "ਦੱਖਣੀ ਭਾਰਤੀ",
            "English": "ਅੰਗ੍ਰੇਜ਼ੀ",
            "Hindi": "ਹਿੰਦੀ",
            "MATCH HOROSCOPE": "ਕੁੰਡਲੀ ਮਿਲਾਓ",
            "My Profile": "ਮੇਰਾ ਪ੍ਰੋਫਾਈਲ",
            "Enter full name": "ਪੂਰਾ ਨਾਮ ਦਾਖਲ ਕਰੋ",
            "Enter email address": "ਈਮੇਲ ਪਤਾ ਦਾਖਲ ਕਰੋ",
            "Enter password": "ਪਾਸਵਰਡ ਦਾਖਲ ਕਰੋ",
            "Enter phone number": "ਫੋਨ ਨੰਬਰ ਦਾਖਲ ਕਰੋ",
            "Save Chanage": "ਬਦਲਾਅ ਸੇਵ ਕਰੋ",
            "Manage your astrologers recent post": "ਆਪਣੇ ਜੋਤਿਸ਼ੀ ਦੇ ਹਾਲੀਆ ਪੋਸਟ ਦਾ ਪ੍ਰਬੰਧ ਕਰੋ",
            "Show Less": "ਘੱਟ ਦਿਖਾਓ",
            "Show More": "ਹੋਰ ਦਿਖਾਓ",
            "Total Balance": "ਕੁੱਲ ਬੈਲੰਸ",
            "Add Money": "ਪੈਸਾ ਸ਼ਾਮਲ ਕਰੋ",
            "Extra": "ਵਾਧੂ",
            "Transaction History": "ਟ੍ਰਾਂਜ਼ੈਕਸ਼ਨ ਇਤਿਹਾਸ",
            "Build better products with flexible tools, helpful documentation,": "ਲਚਕੀਲੇ ਸੰਦਾਂ ਅਤੇ ਸਹਾਇਕ ਦਸਤਾਵੇਜ਼ਾਂ ਨਾਲ ਬਿਹਤਰ ਉਤਪਾਦ ਬਣਾਓ,",
            "and a team that champions your growth.": "ਅਤੇ ਇੱਕ ਟੀਮ ਜੋ ਤੁਹਾਡੇ ਵਿਕਾਸ ਨੂੰ ਸਮਰਥਨ ਦਿੰਦੀ ਹੈ।",
            "Useful Link": "ਉਪਯੋਗੀ ਲਿੰਕ",
            "Socials": "ਸੋਸ਼ਲ ਮੀਡੀਆ",
            "Logout Seccuessfuly !!": "ਲਾਗਆਊਟ ਸਫਲਤਾਪੂਰਵਕ !!",
            "Free Kundli": "ਮੁਫ਼ਤ ਕੁੰਡਲੀ",
            "Horoscope": "ਕੁੰਡਲੀ",
            "Dashboard": "ਡੈਸ਼ਬੋਰਡ",
            "Enter your feedback !!": "ਆਪਣੀ ਫੀਡਬੈਕ ਦਾਖਲ ਕਰੋ !!",
            "Languages": "ਭਾਸ਼ਾਵਾਂ",
            "incoming": "ਆ ਰਹੀ ਹੈ",
            "request from": "ਨਮਰੋੜ ਤੋਂ ਬੇਨਤੀ",
            "Waitlist Joined !!": "ਵੈਟਲਿਸਟ ਵਿੱਚ ਸ਼ਾਮਲ ਹੋਇਆ !!",
            "will start in": "ਸ਼ੁਰੂ ਹੋਵੇਗਾ",
            "You will receive a": "ਤੁਹਾਨੂੰ ਮਿਲੇਗੀ",
            "request when the": "ਬੇਨਤੀ ਜਦੋਂ",
            "astrologer is ready. Don’t worry! You will not be": "ਜੋਤਿਸ਼ੀ ਤਿਆਰ ਹੈ। ਚਿੰਤਾ ਨਾ ਕਰੋ! ਤੁਹਾਨੂੰ ਨਹੀਂ ਲਿਆ ਜਾਵੇਗਾ",
            "charged for missing this session.": "ਇਸ ਸੈਸ਼ਨ ਨੂੰ ਮਿਸ ਕਰਨ ਲਈ ਚਾਰਜ।",
            "Accept": "ਸਵੀਕਾਰ ਕਰੋ",
            "Reject": "ਅਸਵੀਕਾਰ ਕਰੋ",
            "Great, what did you like the mast? 😍": "ਸ਼ਾਨਦਾਰ, ਤੁਹਾਨੂੰ ਸਭ ਤੋਂ ਵਧੀਆ ਕੀ ਲੱਗਿਆ? 😍",
            "Skip": "ਛੱਡੋ",
            "Payment Information": "ਭੁਗਤਾਨ ਜਾਣਕਾਰੀ",
            "Amount": "ਰਾਸ਼ੀ",
            "Tax": "ਟੈਕਸ",
            "Payment": "ਭੁਗਤਾਨ",
            "Payment Method": "ਭੁਗਤਾਨ ਦਾ ਤਰੀਕਾ",
        
            "AstroSpace": "AstroSpace",
            "Astrology Consultation Platform": "Astrology Consultation Platform",
            "INVOICE": "INVOICE",
            "Consultation Service Receipt": "Consultation Service Receipt",
            "Invoice Number": "Invoice Number",
            "Date Issued": "Date Issued",
            "PAID": "PAID",
            "From": "From",
            "Bill To": "Bill To",
            "Service": "Service",
            "Booking ID": "Booking ID",
            "Description": "Description",
            "Duration": "Duration",
            "Rate": "Rate",
            "Amount": "Amount",
            "Free Consultation Time": "Free Consultation Time",
            "Complimentary session minutes": "Complimentary session minutes",
            "Free": "Free",
            "Consultation Fee": "Consultation Fee",
            "Standard rate (first block)": "Standard rate (first block)",
            "Extended Consultation Fee": "Extended Consultation Fee",
            "Premium rate (extended block)": "Premium rate (extended block)",
            "Consultation Service": "Consultation Service",
            "Astrology consultation session": "Astrology consultation session",
            "Subtotal": "Subtotal",
            "Platform Fee": "Platform Fee",
            "Included": "Included",
            "Total Amount": "Total Amount",
            "DOB": "DOB",
            "Kundali Chart Used": "Kundali Chart Used",
            "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.": "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.",
            "For support, contact us at support@astrospace.com": "For support, contact us at support@astrospace.com",
            "Free Minute": "Free Minute",
            "Verified": "Verified",
            "End Session": "End Session",
            "Voice Call": "Voice Call",
            "typing...": "typing...",
            "CANCEL": "CANCEL",
            "OK": "OK",
            "Install Progressive Web Application": "Install Progressive Web Application",
            "This site has app functionality. Install it on your device for extensive experience and easy access.": "This site has app functionality. Install it on your device for extensive experience and easy access.",
            "Install": "Install",
            "Search location": "Search location",
            "Location not found !!": "Location not found !!",
            "Waiting for remote user to join...": "Waiting for remote user to join...",
            "End Video Session": "End Video Session",
            "Initializing WebRTC P2P...": "Initializing WebRTC P2P...",
            "Access Denied (Camera/Mic)": "Access Denied (Camera/Mic)",
            "Connection Failed": "Connection Failed",
            "Time Remaining": "Time Remaining",
            "Call ended": "Call ended",

            "Offline": "Offline",}
    },
    ge: {
        translation: {
            "Enter Mobile Number !!": "Telefonnummer eingeben!!",
            "In Valid OTP !!": "Ungültiger OTP!!",
            "Please enter password !!": "Bitte Passwort eingeben!!",
            "Password not match !!": "Passwort stimmt nicht überein!!",
            "Reset Password": "Passwort zurücksetzen",
            "Enter your phone number and new password": "Geben Sie Ihre Telefonnummer und ein neues Passwort ein",
            "Phone Number": "Telefonnummer",
            "Enter your number": "Geben Sie Ihre Nummer ein",
            "Search": "Suchen",
            "Verify": "Verifizieren",
            "You will receive a 6 digit code for": "Sie erhalten einen 6-stelligen Code für",
            "verification to": "Verifizierung an",
            "Submit": "Absenden",
            "Enter your password and new password": "Geben Sie Ihr Passwort und das neue Passwort ein",
            "New Password": "Neues Passwort",
            "Enter new password": "Neues Passwort eingeben",
            "Confirm New Password": "Neues Passwort bestätigen",
            "Confirm new password": "Neues Passwort bestätigen",
            "Back to Login": "Zurück zur Anmeldung",
            "Back": "Zurück",
            "Enter Login Details !!": "Login-Daten eingeben!!",
            "Welcome Back!": "Willkommen zurück!",
            "Sign in to your account": "Melden Sie sich bei Ihrem Konto an",
            "Password": "Passwort",
            "Enter your password": "Passwort eingeben",
            "Forgot Password?": "Passwort vergessen?",
            "Sign In": "Anmelden",
            "Don't have an account?": "Sie haben noch kein Konto?",
            "Sign Up": "Registrieren",
            "Please enter all details !!": "Bitte alle Details eingeben!!",
            "Please enter valid email !!": "Bitte gültige E-Mail eingeben!!",
            "Please enter birth place !!": "Bitte Geburtsort eingeben!!",
            "Please select language !!": "Bitte Sprache auswählen!!",
            "Step": "Schritt",
            "Enter Your Details": "Geben Sie Ihre Daten ein",
            "Hey there! what is your name?": "Hallo! Wie ist Ihr Name?",
            "Full Name": "Vollständiger Name",
            "Email Address": "E-Mail-Adresse",
            "Enter your Full Name": "Vollständigen Namen eingeben",
            "Enter your email": "E-Mail eingeben",
            "What is your gender?": "Welches Geschlecht haben Sie?",
            "Male": "Männlich",
            "Female": "Weiblich",
            "Enter your birth date": "Geburtsdatum eingeben",
            "Enter your birth time": "Geburtszeit eingeben",
            "Enter your birth Place": "Geburtsort eingeben",
            "Do you know which languages?": "Welche Sprachen sprechen Sie?",
            "Enter Your Place": "Ort eingeben",
            "Back to Step": "Zurück zum Schritt",
            "Next": "Weiter",
            "My Appointments": "Meine Termine",
            "Manage your astrology consultations": "Verwalten Sie Ihre astrologischen Beratungen",
            "Upcoming": "Bevorstehend",
            "Past": "Vergangen",
            "Pending": "Ausstehend",
            "Accepted": "Akzeptiert",
            "Start": "Starten",
            "Completed": "Abgeschlossen",
            "Canceled": "Abgesagt",
            "ID": "ID",
            "Chat": "Chat",
            "Audio Call": "Audioanruf",
            "Video Call": "Videoanruf",
            "View Details": "Details anzeigen",
            "Cancel": "Abbrechen",
            "No Upcoming Appointment Found !!": "Kein bevorstehender Termin gefunden!!",
            "Currently you don't have any upcoming appointment.": "Derzeit haben Sie keine bevorstehenden Termine.",
            "No Past Appointment Found !!": "Keine vergangenen Termine gefunden!!",
            "Currently you don't have any past appointment.": "Derzeit haben Sie keine vergangenen Termine.",
            "Status": "Status",
            "Service Type": "Dienstleistung",
            "Date": "Datum",
            "Time": "Uhrzeit",
            "Price": "Preis",
            "Booked Person Details": "Details der gebuchten Person",
            "name": "Name",
            "Date of Birth": "Geburtsdatum",
            "Birth Place": "Geburtsort",
            "Gender": "Geschlecht",
            "Complete Details": "Vollständige Details",
            "Start Time": "Startzeit",
            "End Time": "Endzeit",
            "Total Duration": "Gesamtdauer",
            "Billable Time": "Abrechenbare Zeit",
            "Billed Fee First": "Gebühr zuerst berechnet",
            "Billed Fee After": "Gebühr danach berechnet",
            "Total Consultation Fee": "Gesamtgebühr der Beratung",
            "Kundali Details": "Kundali-Details",
            "Name": "Name",
            "Send Notification": "Benachrichtigung senden",
            "Continue Chat": "Chat fortsetzen",
            "Write message !!": "Nachricht schreiben!!",
            "Astrologer Ai Assistant": "Astrologe KI-Assistent",
            "Ask anything about your horoscope...": "Fragen Sie alles zu Ihrem Horoskop...",
            "Write message to assistant": "Nachricht an Assistenten schreiben",
            "Clear Chat?": "Chat löschen?",
            "All messages will be deleted permanently.": "Alle Nachrichten werden dauerhaft gelöscht.",
            "Clear": "Löschen",
            "Payment faild !!": "Zahlung fehlgeschlagen!!",
            "Please Complete Last Apointment !!": "Bitte letzten Termin abschließen!!",
            "Please enter comment !!": "Bitte Kommentar eingeben!!",
            "Insufficient wallet balance !!": "Unzureichendes Wallet-Guthaben!!",
            "Orders": "Bestellungen",
            "Experience": "Erfahrung",
            "Rating": "Bewertung",
            "Unfollow": "Nicht mehr folgen",
            "Follow": "Folgen",
            "Send Gift": "Geschenk senden",
            "Start a Consultation": "Beratung starten",
            "Chat with astrologer": "Mit Astrologen chatten",
            "For new user": "Für neue Benutzer",
            "min free": "min kostenlos",
            "Call with astrologer": "Mit Astrologen anrufen",
            "Video call with astrologer": "Videoanruf mit Astrologen",
            "Astrologer Bio": "Astrologen-Bio",
            "Reviews": "Bewertungen",
            "Activity": "Aktivität",
            "FAQ's": "FAQ",
            "Media": "Medien",
            "Comment": "Kommentar",
            "No comment yet": "Noch kein Kommentar",
            "start the conversation": "Gespräch starten",
            "Poast your replay": "Antwort posten",
            "Delete comment": "Kommentar löschen",
            "Are you sure you want to delete this comment?": "Sind Sie sicher, dass Sie diesen Kommentar löschen möchten?",
            "Cancle": "Abbrechen",
            "Delete": "Löschen",
            "Intro Audio": "Intro-Audio",
            "Intro Video": "Intro-Video",
            "Hear from": "Hören von",
            "Please select user !!": "Bitte Benutzer auswählen!!",
            "Please select amount !!": "Bitte Betrag auswählen!!",
            "Please select payment method !!": "Bitte Zahlungsmethode auswählen!!",
            "Select Kundli": "Kundli auswählen",
            "Add Kundli": "Kundli hinzufügen",
            "Minimum balance of": "Mindestguthaben von",
            "minutes": "Minuten",
            "is required to start chat with": "ist erforderlich, um den Chat mit zu starten",
            "Wallet Balance": "Wallet-Guthaben",
            "Required": "Erforderlich",
            "Proceed to Pay": "Zur Zahlung fortfahren",
            "extra in your": "extra in Ihrem",
            "wallet with this": "Wallet mit diesem",
            "Woohoo!": "Juhu!",
            "Recharge Amount": "Aufladebetrag",
            "GST": "MwSt",
            "Wallet Amount": "Wallet-Betrag",
            "Payble Amount": "Zu zahlender Betrag",
            "Pay from Wallet": "Vom Wallet bezahlen",
            "Available": "Verfügbar",
            "Payment Getway Method": "Zahlungsgateway-Methode",
            "Continue": "Weiter",
            "Fortune Cookie - Unveil Your Daily Wisdom": "Glückskeks - Enthülle deine tägliche Weisheit",
            "Crack open a fortune cookie to reveal a piece of daily wisdom. Let the message guide you through your day with positivity and insight.": "Öffne einen Glückskeks, um ein Stück täglicher Weisheit zu enthüllen. Lass die Botschaft dich positiv durch den Tag begleiten.",
            "Ask The Fortune Cookie": "Frag den Glückskeks",
            "Crack open your Fortune Cookie": "Öffne deinen Glückskeks",
            "Crack another one open": "Öffne einen weiteren",
            "Love Compatibility": "Liebeskompatibilität",
            "Find out how compatible you are with your lover, friend, or colleague using our love compatibility calculator. Get your results now.": "Finde heraus, wie kompatibel du mit deinem Partner, Freund oder Kollegen bist, mit unserem Liebeskompatibilitätsrechner. Erhalte jetzt dein Ergebnis.",
            "Are Aries And Taurus Compatible": "Sind Widder und Stier kompatibel",
            "Aries And Taurus Strengths": "Stärken von Widder und Stier",
            "Aries And Taurus Weaknesses": "Schwächen von Widder und Stier",
            "Aries And Taurus Elements": "Elemente von Widder und Stier",
            "Aries And Taurus Dates": "Daten von Widder und Stier",
            "Are Aries And Taurus Compatibility Score": "Kompatibilitätswert von Widder und Stier",
            "General": "Allgemein",
            "Communication": "Kommunikation",
            "Sex": "Sex",
            "Select Another": "Anderen auswählen",
            "Aries": "Widder",
            "Taurus": "Stier",
            "Gemini": "Zwillinge",
            "Cancer": "Krebs",
            "Leo": "Löwe",
            "Virgo": "Jungfrau",
            "Libra": "Waage",
            "Scorpio": "Skorpion",
            "Sagittarius": "Schütze",
            "Capricorn": "Steinbock",
            "Aquarius": "Wassermann",
            "Pisces": "Fische",
            "Please select Your Partner Sign": "Bitte Partnerzeichen auswählen",
            "Please select Your Sign": "Bitte dein Sternzeichen auswählen",
            "Please fill all details !!": "Bitte alle Details ausfüllen!!",
            "Discover Your Core Numbers That Define You": "Entdecke deine Kernzahlen, die dich definieren",
            "Explore your core numbers like Life Path, Destiny, and Personal Year—complete with strengths, challenges, and meaningful interpretations.": "Erkunde deine Kernzahlen wie Lebensweg, Schicksal und persönliches Jahr – mit Stärken, Herausforderungen und bedeutsamen Interpretationen.",
            "Get Your Numbers": "Erhalte deine Zahlen",
            "First Name": "Vorname",
            "Last Name": "Nachname",
            "Method": "Methode",
            "Chaldean": "Chaldäisch",
            "Pythagorean": "Pythagoreisch",
            "Strengths": "Stärken",
            "Challenges": "Herausforderungen",
            "Advice": "Ratschlag",
            "Get Report": "Bericht erhalten",
            "Select Tarot One Card": "Wähle eine Tarotkarte",
            "Select Your Card": "Wähle deine Karte",
            "Get Another": "Eine weitere ziehen",
            "Yes Or No Tarot": "Ja-oder-Nein-Tarot",
            "Get instant Yes or No answers to pressing questions.": "Erhalte sofortige Ja- oder Nein-Antworten auf dringende Fragen.",
            "Daily Tarot": "Tägliches Tarot",
            "Receive daily tarot readings on love, career, and finance.": "Erhalte tägliche Tarot-Lesungen zu Liebe, Karriere und Finanzen.",
            "In-Depth Love Reading": "Tiefgehende Liebeslesung",
            "Deep dive into your love life with relationship-specific readings.": "Tauche tief in dein Liebesleben mit beziehungsbezogenen Lesungen ein.",
            "Flirt Love Reading": "Flirt-Lesung",
            "Reveal insights into playful and romantic connections.": "Erhalte Einblicke in spielerische und romantische Verbindungen.",
            "Erotic Love Reading": "Erotische Liebeslesung",
            "Insights into intimate and personal love dynamics.": "Einblicke in intime und persönliche Liebesdynamiken.",
            "Egyptian Prediction": "Ägyptische Vorhersage",
            "Access ancient Egyptian insights beyond visible truths.": "Greife auf alte ägyptische Weisheiten jenseits sichtbarer Wahrheiten zu.",
            "Ex-Flame Reading": "Ex-Flamme-Lesung",
            "Explore the possibilities of rekindling with an ex-partner.": "Erkunde die Möglichkeiten, eine Beziehung mit einem Ex-Partner wiederzubeleben.",
            "Made For Each Other Or Not Reading": "Füreinander bestimmt oder nicht Lesung",
            "Discover if your relationship has long-term potential.": "Finde heraus, ob deine Beziehung langfristiges Potenzial hat.",
            "Power Life Reading": "Power Life-Lesung",
            "Take control of your destiny with life-changing tarot readings.": "Übernimm die Kontrolle über dein Schicksal mit lebensverändernden Tarot-Lesungen.",
            "Know Your Friend Reading": "Erkenne deinen Freund Lesung",
            "Understand the true intentions of your friendships.": "Verstehe die wahren Absichten deiner Freundschaften.",
            "Divine Angel Reading": "Göttliche Engel-Lesung",
            "Connect with divine guidance for clarity and spiritual insight.": "Verbinde dich mit göttlicher Führung für Klarheit und spirituelle Einsichten.",
            "Career Daily Reading": "Tägliche Karriere-Lesung",
            "Elevate your career with daily tarot insights to achieve your professional goals.": "Steigere deine Karriere mit täglichen Tarot-Einsichten, um deine beruflichen Ziele zu erreichen.",
            "Dream Come True Reading": "Traum-Erfüllung-Lesung",
            "Gain insights into making your dreams and goals a reality.": "Erhalte Einblicke, wie du deine Träume und Ziele verwirklichen kannst.",
            "Past Lives Connection Reading": "Vergangene Leben Verbindungs-Lesung",
            "Explore your journey across time to understand your path ahead.": "Erkunde deine Reise durch die Zeit, um deinen zukünftigen Weg zu verstehen.",
            "Yes or No Tarot - Find Clear and Immediate Answers": "Ja-oder-Nein-Tarot - Finde klare und sofortige Antworten",
            "Daily Tarot - Gain Insights Across Love, Finance, and Career": "Tägliches Tarot - Erhalte Einblicke zu Liebe, Finanzen und Karriere",
            "In-Depth Love Tarot - Reveal the Realities of Your Relationship": "Tiefgehendes Liebes-Tarot - Enthülle die Realität deiner Beziehung",
            "Flirt Love Tarot - Discover Your Romantic Potential": "Flirt-Liebes-Tarot - Entdecke dein romantisches Potenzial",
            "Erotic Love Tarot - Explore Your Intimate Desires": "Erotisches Liebes-Tarot - Erforsche deine intimen Wünsche",
            "Discover the Secrets of Your Soul with Egyptian Tarot": "Entdecke die Geheimnisse deiner Seele mit ägyptischem Tarot",
            "Ex-Flame Tarot - Reignite or Release the Past": "Ex-Flamme-Tarot - Vergangenes wieder entfachen oder loslassen",
            "Made For Each Other Tarot - Discover True Compatibility": "Füreinander bestimmt Tarot - Entdecke wahre Kompatibilität",
            "Power Life Tarot - Take Control of Your Destiny": "Power Life Tarot - Übernimm die Kontrolle über dein Schicksal",
            "Know Your Friend Tarot Reading - Unveil the True Nature of Your Relationships": "Erkenne deinen Freund Tarot-Lesung - Enthülle die wahre Natur deiner Beziehungen",
            "Divine Angel Tarot - Receive Angelic Guidance for Clarity and Relief": "Göttliche Engel-Tarot - Erhalte Engel-Führung für Klarheit und Erleichterung",
            "Career Daily Tarot Reading - Navigate Your Workday with Confidence": "Tägliche Karriere-Tarot-Lesung - Meistere deinen Arbeitstag mit Vertrauen",
            "Explore the Depths of Your Heart's Desires with a Dream Come True Tarot Reading": "Erkunde die Tiefen deiner Herzenswünsche mit einer Traum-Erfüllung Tarot-Lesung",
            "Delve into Your Past Lives - Unravel the Enigma of Your Previous Incarnations": "Tauche in deine vergangenen Leben ein - Entschlüssele das Rätsel deiner früheren Inkarnationen",
            "The Yes or No Tarot widget offers quick, straightforward answers to your pressing questions, helping you make decisions with confidence in areas like love, finance, and career.": "Das Ja-oder-Nein-Tarot-Widget bietet schnelle, direkte Antworten auf deine dringenden Fragen und hilft dir, Entscheidungen mit Vertrauen in Bereichen wie Liebe, Finanzen und Karriere zu treffen.",
            "Daily Tarot provides readings that focus on three key areas of your life: Love, Finance, and Career. Discover the guidance you need for each aspect of your day.": "Tägliches Tarot bietet Lesungen, die sich auf drei zentrale Bereiche deines Lebens konzentrieren: Liebe, Finanzen und Karriere. Entdecke die Anleitung, die du für jeden Aspekt deines Tages benötigst.",
            "In-Depth Love Tarot provides comprehensive readings to bring clarity to your love life, help you make crucial decisions, and guide you toward understanding your soulmate and future partner.": "Das Tiefgehende Liebes-Tarot bietet umfassende Lesungen, um Klarheit in dein Liebesleben zu bringen, dir bei wichtigen Entscheidungen zu helfen und dich dabei zu unterstützen, deinen Seelenverwandten und zukünftigen Partner besser zu verstehen.",
            "The Flirt Love Tarot Reading provides playful insights into your romantic life. Whether it's a friendship, a new admirer, or a potential soulmate, this reading helps you navigate love with ease.": "Die Flirt-Liebes-Tarot-Lesung bietet spielerische Einblicke in dein romantisches Leben. Ob Freundschaft, neuer Verehrer oder potenzieller Seelenverwandter – diese Lesung hilft dir, die Liebe mühelos zu navigieren.",
            "This reading reveals insights into passion, love, and sexual chemistry, helping you understand your relationships and uncover hidden fantasies.": "Diese Lesung gibt Einblicke in Leidenschaft, Liebe und sexuelle Chemie und hilft dir, deine Beziehungen zu verstehen und verborgene Fantasien zu entdecken.",
            "Explore your twin flame, current struggles, ancestral roots, and past healing with the ancient wisdom of Egyptian Tarot": "Erkunde deine Zwillingsseele, aktuelle Herausforderungen, Ahnenwurzeln und vergangene Heilungen mit der alten Weisheit des Ägyptischen Tarots.",
            "The Ex-Flame Tarot Reading provides clarity on whether to rekindle a past relationship or move on. Explore your ex’s feelings, the potential for a renewed connection, and the impact on your future.": "Die Ex-Flamme-Tarot-Lesung verschafft Klarheit, ob du eine vergangene Beziehung wiederbeleben oder weitermachen solltest. Erkunde die Gefühle deines Ex, die Chancen für eine erneute Verbindung und die Auswirkungen auf deine Zukunft.",
            "This Tarot reading reveals whether your relationship is worth the effort, safe to pursue, and aligned with your life goals. Understand if you’re truly made for each other or if it’s time to move on.": "Diese Tarot-Lesung zeigt, ob deine Beziehung die Mühe wert ist, sicher verfolgt werden kann und mit deinen Lebenszielen übereinstimmt. Erfahre, ob ihr wirklich füreinander bestimmt seid oder ob es Zeit ist, weiterzugehen.",
            "The Power Life Tarot Reading helps you plan your life, overcome struggles, create a clear vision, and take charge of your destiny. Unlock the guidance you need to steer your life towards success.": "Die Power Life-Tarot-Lesung hilft dir, dein Leben zu planen, Herausforderungen zu meistern, eine klare Vision zu schaffen und dein Schicksal in die Hand zu nehmen. Erhalte die Orientierung, die du benötigst, um dein Leben erfolgreich zu gestalten.",
            "Divine Angel Tarot connects you with your guardian angels, offering guidance to overcome challenges and find peace in love, freedom, and resolution.": "Das Göttliche Engel-Tarot verbindet dich mit deinen Schutzengeln und bietet Orientierung, um Herausforderungen zu meistern und Frieden in Liebe, Freiheit und Lösungen zu finden.",
            "Career Daily Tarot offers insights to manage your workday, from handling your boss to staying proactive and managing tasks effectively. Let the Tarot guide you to a successful and stress-free day.": "Das Tägliche Karriere-Tarot bietet Einblicke, um deinen Arbeitstag zu meistern – vom Umgang mit deinem Chef bis zur proaktiven Aufgabenbewältigung. Lass das Tarot dich zu einem erfolgreichen und stressfreien Tag führen.",
            "The Dream Come True Tarot Reading helps you manifest your deepest wishes and aspirations. Whether it's love, material desires, or unfulfilled dreams, this reading offers clarity and guidance to turn your desires into reality.": "Die Traum-Erfüllung-Tarot-Lesung hilft dir, deine tiefsten Wünsche und Ziele zu manifestieren. Ob Liebe, materielle Wünsche oder unerfüllte Träume – diese Lesung bietet Klarheit und Orientierung, um deine Wünsche Wirklichkeit werden zu lassen.",
            "Explore your past lives to understand current fears, recurring patterns, and influences. Gain clarity on challenges rooted in your previous incarnations.": "Erkunde deine vergangenen Leben, um aktuelle Ängste, wiederkehrende Muster und Einflüsse zu verstehen. Erhalte Klarheit über Herausforderungen, die in früheren Inkarnationen verwurzelt sind.",
            "Select Tarot Three Card": "Wähle drei Tarotkarten",
            "Heartbreak Reading": "Liebeskummer-Lesung",
            "Find guidance and healing for a broken heart.": "Finde Orientierung und Heilung für ein gebrochenes Herz.",
            "Wisdom Reading": "Weisheits-Lesung",
            "Balance your energies and find mental peace through wisdom.": "Balance deine Energien und finde geistigen Frieden durch Weisheit.",
            "Divine Magic Reading": "Göttliche Magie-Lesung",
            "Discover mystical insights with magical tarot guidance.": "Entdecke mystische Einblicke mit magischer Tarot-Führung.",
            "Heartbreak Tarot Reading - Find Closure and Guidance": "Liebeskummer-Tarot-Lesung – Finde Abschluss und Orientierung",
            "The Heartbreak Tarot Reading offers insight into the cause of your pain and provides advice on how to heal and move forward. This two-card reading delivers clarity and the necessary steps to mend your broken heart.": "Die Liebeskummer-Tarot-Lesung gibt Einblicke in die Ursache deines Schmerzes und bietet Ratschläge, wie du heilen und weitermachen kannst. Diese Zwei-Karten-Lesung liefert Klarheit und die notwendigen Schritte, um dein gebrochenes Herz zu heilen.",
            "Wisdom Tarot - Find Balance with Yin and Yang": "Weisheits-Tarot – Finde Balance mit Yin und Yang",
            "Wisdom Tarot provides guidance by balancing the Yin and Yang energies in your life. Discover clarity, peace, and a path forward with this two-card reading.": "Das Weisheits-Tarot bietet Orientierung, indem es die Yin- und Yang-Energien in deinem Leben ausgleicht. Entdecke Klarheit, Frieden und einen Weg nach vorn mit dieser Zwei-Karten-Lesung.",
            "Divine Magic Tarot Reading - Discover Cause and Remedy": "Göttliche Magie-Tarot-Lesung – Ursache und Lösung entdecken",
            "The Divine Magic Tarot Reading offers insights into the root cause of your problems and provides a remedy to guide you toward resolution. With this reading, discover the steps you need to take to transform challenges into solutions.": "Die Göttliche Magie-Tarot-Lesung bietet Einblicke in die Wurzel deiner Probleme und liefert eine Lösung, die dich zur Klärung führt. Mit dieser Lesung entdeckst du die Schritte, die notwendig sind, um Herausforderungen in Lösungen zu verwandeln.",
            "Please pick your cards !!": "Bitte wähle deine Karten!!",
            "Get Your Reading": "Erhalte deine Lesung",
            "Select Tarot Two Card": "Wähle zwei Tarotkarten",
            "Love Triangle Reading": "Liebesdreieck-Lesung",
            "Get clarity in choosing between multiple romantic interests.": "Erhalte Klarheit bei der Wahl zwischen mehreren romantischen Interessen.",
            "Past-Present-Future Reading": "Vergangenheit-Gegenwart-Zukunft-Lesung",
            "Love Triangle Tarot - Discover the Dynamics Between You, Lover 1, and Lover 2": "Liebesdreieck-Tarot – Entdecke die Dynamik zwischen dir, Liebhaber 1 und Liebhaber 2",
            "Love Triangle Tarot provides insights into the relationships and dynamics between you and your two lovers. Understand where you stand, and what each lover brings into your life, and make an informed decision guided by the cards.": "Das Liebesdreieck-Tarot bietet Einblicke in die Beziehungen und Dynamiken zwischen dir und deinen beiden Liebhabern. Verstehe, wo du stehst, was jeder Liebhaber in dein Leben bringt, und treffe eine informierte Entscheidung anhand der Karten.",
            "Zodiac Gift Guru": "Tierkreis-Geschenk-Guru",
            "January": "Januar",
            "February": "Februar",
            "March": "März",
            "April": "April",
            "May": "Mai",
            "June": "Juni",
            "July": "Juli",
            "August": "August",
            "September": "September",
            "October": "Oktober",
            "November": "November",
            "December": "Dezember",
            "Yesterday": "Gestern",
            "Today": "Heute",
            "Tomorrow": "Morgen",
            "Gift Recommendations": "Geschenkempfehlungen",
            "insight": "Einblick",
            "Career": "Karriere",
            "Love": "Liebe",
            "Finance": "Finanzen",
            "Popularity": "Beliebtheit",
            "Experience: High to Low": "Erfahrung: Hoch bis Niedrig",
            "Experience: Low to High": "Erfahrung: Niedrig bis Hoch",
            "Orders: High to Low": "Bestellungen: Hoch bis Niedrig",
            "Orders: Low to High": "Bestellungen: Niedrig bis Hoch",
            "Price: High to Low": "Preis: Hoch bis Niedrig",
            "Price: Low to High": "Preis: Niedrig bis Hoch",
            "Rating: High to Low": "Bewertung: Hoch bis Niedrig",
            "Search name...": "Name suchen...",
            "Online": "Online",
            "Busy": "Beschäftigt",
            "Exp": "Erf",
            "yrs": "Jahre",
            "orders": "Bestellungen",
            "min": "Min",
            "Chat Now": "Jetzt chatten",
            "Wait": "Warten",
            "There are no astrologers in this category.": "In dieser Kategorie gibt es keine Astrologen.",
            "Sort": "Sortieren",
            "Filter": "Filter",
            "Category": "Kategorie",
            "All": "Alle",
            "Sort by": "Sortieren nach",
            "Skill": "Fähigkeit",
            "Language": "Sprache",
            "Reset": "Zurücksetzen",
            "Apply": "Anwenden",
            "You have 30 seconds left. Please recharge immediately to continue the conversation.": "Du hast noch 30 Sekunden. Bitte lade sofort auf, um das Gespräch fortzusetzen.",
            "Free chat over! Next minutes will use wallet balance.": "Gratis-Chat vorbei! Die nächsten Minuten werden vom Wallet-Guthaben abgezogen.",
            "Complete": "Abschließen",
            "End Chat": "Chat beenden",
            "Message": "Nachricht",
            "Hi": "Hi",
            "lets continue this chat at discounted price of": "Lass uns den Chat zum vergünstigten Preis fortsetzen von",
            "Are you sure you want to end tha chat to": "Bist du sicher, dass du den Chat beenden möchtest zu",
            "No": "Nein",
            "Yes": "Ja",
            "Chat With Astrologer": "Mit Astrologen chatten",
            "Appointment List": "Terminliste",
            "My Following": "Meine Abonnements",
            "Recent Post": "Neuester Beitrag",
            "Welcome back": "Willkommen zurück",
            "Manage your astrology services": "Verwalte deine astrologischen Dienste",
            "Logout": "Abmelden",
            "Login": "Anmelden",
            "My Profile (Member Since)": "Mein Profil (Mitglied seit)",
            "My Followings": "Meine Abonnements",
            "You are following": "Du folgst",
            "people": "Personen",
            "Years": "Jahre",
            "No Following Found !!": "Keine Abonnements gefunden!!",
            "Currently you don't have any follow.": "Derzeit folgst du niemandem.",
            "Hey There!": "Hallo!",
            "What is your name?": "Wie ist dein Name?",
            "Enter your first Name": "Gib deinen Vornamen ein",
            "Enter your last Name": "Gib deinen Nachnamen ein",
            "male": "männlich",
            "female": "weiblich",
            "Where wrer you bron?": "Wo wurdest du geboren?",
            "Please Select Language": "Bitte Sprache auswählen",
            "english": "Englisch",
            "hindi": "Hindi",
            "north": "Norden",
            "south": "Süden",
            "Select Chart Type": "Diagrammtyp auswählen",
            "Start chat with astrologer": "Chat mit Astrologen starten",
            "Search location": "Ort suchen",
            "Location not found !!": "Ort nicht gefunden!!",
            "Enter bord state": "Geburtsstaat eingeben",
            "Search location...": "Ort suchen...",
            "Astrologers": "Astrologen",
            "Top Astrologers. 24 * 7 customer support. Happy to help": "Top-Astrologen. 24/7 Kundenservice. Wir helfen gern",
            "per min": "pro Min",
            "Top Astrologers": "Top-Astrologen",
            "rate": "Bewertung",
            "Top Rated Astrologers": "Bestbewertete Astrologen",
            "No astrologers found !!": "Keine Astrologen gefunden!!",
            "FAQs": "FAQs",
            "Raning": "Rangliste",
            "Raning Apointment": "Ranglisten-Termine",
            "Select Other Sign": "Anderes Sternzeichen auswählen",
            "Horoscopes": "Horoskope",
            "Daily Horoscope": "Tageshoroskop",
            "Weekly Horoscope": "Wochenhoroskop",
            "Monthly Horoscope": "Monatshoroskop",
            "Yearly Horoscope": "Jahreshoroskop",
            "Composite Friendship Table": "Zusammengesetzte Freundschaftstabelle",
            "Kp Planetary Details": "KP Planeten-Details",
            "Kp House Cusps And Chart": "KP Hausspitzen und Diagramm",
            "Ascendant Report": "Aszendenten-Bericht",
            "Bhava Kundli": "Bhava Kundli",
            "Vimshottari Dasha": "Vimshottari Dasha",
            "Yogini Dasha": "Yogini Dasha",
            "Sadhesati Analysis": "Sadhesati-Analyse",
            "Sadhesati Life Analysis": "Sadhesati-Lebensanalyse",
            "Kalsarpa Dosha": "Kalsarpa Dosha",
            "Manglik Analysis": "Manglik-Analyse",
            "Planet Profiles": "Planetenprofile",
            "Gemstone Suggestions": "Edelstein-Vorschläge",
            "Upagraha": "Upagraha",
            "Jaimini Astrology": "Jaimini-Astrologie",
            "Chara Dasha": "Chara Dasha",
            "Shadbala": "Shadbala",
            "Sudarshana Chakra": "Sudarshana Chakra",
            "Bhinnashtakvarga": "Bhinnashtakvarga",
            "Yogas": "Yogas",
            "Introduction": "Einführung",
            "Basic Astrological Details": "Grundlegende astrologische Details",
            "Planetary Positions": "Planetenpositionen",
            "Horoscope Charts": "Horoskop-Diagramme",
            "House Cusps And Sandhi": "Hausspitzen und Sandhi",
            "Divisional Charts": "Teilungsdiagramme",
            "Basic Details": "Grundlegende Details",
            "Ghat Chakra": "Ghat Chakra",
            "Panchange Details": "Panchang-Details",
            "Astrological Details": "Astrologische Details",
            "Time of Birth": "Geburtszeit",
            "Place of Birth": "Geburtsort",
            "Latitude": "Breitengrad",
            "Longitude": "Längengrad",
            "Timezone": "Zeitzone",
            "Ayanamsa": "Ayanamsa",
            "Sunrise": "Sonnenaufgang",
            "Sunset": "Sonnenuntergang",
            "Month": "Monat",
            "Tithi": "Tithi",
            "Yoga": "Yoga",
            "Karana": "Karana",
            "Moon Sign": "Mondzeichen",
            "Moon Vaar": "Mondtag",
            "Nakshatra": "Nakshatra",
            "Varna": "Varna",
            "Vashya": "Vashya",
            "Yoni": "Yoni",
            "Gana": "Gana",
            "Nadi": "Nadi",
            "Sun Sign": "Sonnenzeichen",
            "Tatva": "Tatva",
            "Paya": "Paya",
            "Yanja": "Yanja",
            "Planets": "Planeten",
            "Sign": "Sternzeichen",
            "Sign No": "Zeichen-Nr.",
            "LAGNA CHART (BIRTH CHART)": "LAGNA-Diagramm (Geburtsdiagramm)",
            "MOON CHART": "MOND-Diagramm",
            "NAVMANSHA CHART (D9)": "NAVAMSHA-Diagramm (D9)",
            "House": "Haus",
            "Bhav Madhya": "Bhav Madhya",
            "Bhav Sandhi": "Bhav Sandhi",
            "Chalit Chart": "Chalit-Diagramm",
            "Sun Chart": "Sonnen-Diagramm",
            "Health, Constitution, Body": "Gesundheit, Konstitution, Körper",
            "Hora Chart(D2)": "Hora-Diagramm (D2)",
            "Finance, Wealth, Prosperity": "Finanzen, Reichtum, Wohlstand",
            "Dreshkan Chart(D3)": "Dreshkan-Diagramm (D3)",
            "Brothers, Sisters": "Brüder, Schwestern",
            "Chathurthamasha Chart(D4)": "Chaturthamsha-Diagramm (D4)",
            "Fortunes, Luck of native": "Glück und Schicksal des Geburtshoroskops",
            "Saptamansha Chart(D7)": "Saptamansha-Diagramm (D7)",
            "Impregnation, Birth of the child": "Empfängnis, Geburt des Kindes",
            "Dashamansha Chart(D10)": "Dashamansha-Diagramm (D10)",
            "livelihood, Profession": "Lebensunterhalt, Beruf",
            "Dwadasha Chart(D12)": "Dwadasha-Diagramm (D12)",
            "Parents, paternal happiness": "Eltern, väterliches Glück",
            "Shodashamsha Chart(D16)": "Shodashamsha-Diagramm (D16)",
            "Happiness, miseries, conveyance": "Glück, Leid, Transport",
            "Vishamansha Chart(D20)": "Vishamansha-Diagramm (D20)",
            "Spiritual progress, worship": "Spiritueller Fortschritt, Verehrung",
            "Chaturvimshamsha(D24)": "Chaturvimshamsha-Diagramm (D24)",
            "Academic achievement, education": "Akademische Leistung, Bildung",
            "Bhamsha Chart(D27)": "Bhamsha-Diagramm (D27)",
            "Physical strength, stamina": "Körperliche Stärke, Ausdauer",
            "Trishamansha Chart(D30)": "Trishamansha-Diagramm (D30)",
            "Evil, Adversities of life": "Böses, Widrigkeiten des Lebens",
            "Khavedamsha Chart(D40)": "Khavedamsha-Diagramm (D40)",
            "Auspicious & inauspicious effect": "Günstige und ungünstige Wirkung",
            "Akshvedansha Chart(D45)": "Akshvedansha-Diagramm (D45)",
            "Character and couduct of the native": "Charakter und Verhalten der Person",
            "Shashtymsah Chart(D60)": "Shashtyamsa-Diagramm (D60)",
            "Shows general happiness": "Zeigt allgemeines Glück",
            "Degrees": "Grad",
            "Sign Lord": "Zeichenherrscher",
            "Nakshatra Lord": "Nakshatra-Herrscher",
            "Sub Lord": "Unterherrscher",
            "Sub Sub Lord": "Unterunterherrscher",
            "Lord": "Herrscher",
            "Symbol": "Symbol",
            "Characteristics": "Eigenschaften",
            "Day of Fast": "Fastentag",
            "luchy Gems": "Glückssteine",
            "Personality": "Persönlichkeit",
            "Health": "Gesundheit",
            "Relationships": "Beziehungen",
            "BHAVA KUNDLI": "BHAVA KUNDLI",
            "Bhramari": "Bhramari",
            "Bhadrika": "Bhadrika",
            "Ulka": "Ulka",
            "Siddha": "Siddha",
            "Sankata": "Sankata",
            "Mangala": "Mangala",
            "Pingala": "Pingala",
            "Dhanya": "Dhanya",
            "Remedies Of Sadhesati": "Heilmittel für Sadhesati",
            "Saturn Sign": "Saturn-Zeichen",
            "Is Saturn Retro?": "Ist Saturn rückläufig?",
            "Phase": "Phase",
            "Intensity": "Intensität",
            "Direction": "Richtung",
            "Strength": "Stärke",
            "Percentage": "Prozentsatz",
            "Zodiac Sign": "Sternzeichen",
            "Planet Degree": "Planeten-Grad",
            "Lord Of": "Herrscher von",
            "Combust/Aw...": "Verbrannt/Auf...",
            "Lucky Stone": "Glücksstein",
            "Life Stone": "Lebensstein",
            "Finger": "Finger",
            "Day": "Tag",
            "Time to Wear": "Zeit zum Tragen",
            "Mantra": "Mantra",
            "Upagraha Longitude": "Upagraha-Längengrad",
            "Rashi": "Rashi",
            "Pada": "Pada",
            "Upagraha/Nakshatra/Sub Lord": "Upagraha/Nakshatra/Unterherrscher",
            "Jamini Planets": "Jamini-Planeten",
            "Jamini Padas": "Jamini-Padas",
            "Code": "Code",
            "Jamini Karakara": "Jamini Karakara",
            "Uchcha Bala": "Uchcha Bala",
            "Saptavarga Bala": "Saptavarga Bala",
            "Yugmayugma Bhamsha Bala": "Yugmayugma Bhamsha Bala",
            "Kendradi Bala": "Kendradi Bala",
            "Drekkana Bala": "Drekkana Bala",
            "Total Sthana Bala": "Gesamt Sthana Bala",
            "Total Dig Bala": "Gesamt Dig Bala",
            "Nattunnata Bala": "Nattunnata Bala",
            "Paksha Bala": "Paksha Bala",
            "Tribhaga Bala": "Tribhaga Bala",
            "Varshadhipati": "Varshadhipati",
            "Maasadipati": "Maasadipati",
            "Vaaradhipati": "Vaaradhipati",
            "Horadhipati": "Horadhipati",
            "Ayana Bala": "Ayana Bala",
            "Yuddha Bala": "Yuddha Bala",
            "Total Kaal Bala": "Gesamt Kaal Bala",
            "Naisargika Bala": "Naisargika Bala",
            "Chestha Bala": "Chestha Bala",
            "Drik Bala": "Drik Bala",
            "Total Shadbala": "Gesamt Shadbala",
            "Shadbala In Rupa": "Shadbala in Rupa",
            "Min Require": "Min. erforderlich",
            "Ratio": "Verhältnis",
            "Rank": "Rang",
            "Sun": "Sonne",
            "Moon": "Mond",
            "Mars": "Mars",
            "Mercury": "Merkur",
            "Jupiter": "Jupiter",
            "Venus": "Venus",
            "Saturn": "Saturn",
            "Ashtakvarga": "Ashtakvarga",
            "Sarvashtakava": "Sarvashtakava",
            "Prasthara Chakra": "Prasthara Chakra",
            "Ascendant": "Aszendent",
            "Total": "Gesamt",
            "Natural Friendship": "Natürliche Freundschaft",
            "Temporary Friendship": "Temporäre Freundschaft",
            "Five Fold Friendship": "Fünffache Freundschaft",
            "Ketu": "Ketu",
            "Rahu": "Rahu",
            "Vimshottari Dasha P1": "Vimshottari Dasha P1",
            "Vimshottari Dasha P2": "Vimshottari Dasha P2",
            "AshtaKoot": "AshtaKoot",
            "Bhakut Dosha": "Bhakut Dosha",
            "Nadi Dosha": "Nadi Dosha",
            "Ashtakoot Analysis": "Ashtakoot-Analyse",
            "DashaKoot": "DashaKoot",
            "Personality Report": "Persönlichkeitsbericht",
            "Match Making Report": "Partnervergleichsbericht",
            "Nav Pancham Yoga": "Nav Pancham Yoga",
            "Charan": "Charan",
            "Name Alphabet": "Namensalphabet",
            "Planetary Position": "Planetenposition",
            "Lagna Chart (Birth Chart)": "Lagna-Diagramm (Geburtsdiagramm)",
            "Moon Chart": "Mond-Diagramm",
            "Navmansha Chart (D9)": "Navmansha-Diagramm (D9)",
            "Mahadasha": "Mahadasha",
            "End": "Ende",
            "Is Recommended ??": "Ist empfohlen??",
            "Manglik Details": "Manglik-Details",
            "What is AshtaKoot ??": "Was ist AshtaKoot??",
            "Attributes": "Attribute",
            "Description": "Beschreibung",
            "Received": "Erhalten",
            "Graha Maitri": "Graha Maitri",
            "Bhakoota": "Bhakoota",
            "What is BhaKoot Dosha ??": "Was ist Bhakut Dosha??",
            "What is Nadi Dosha ??": "Was ist Nadi Dosha??",
            "Madhya": "Madhya",
            "Nadi dosha is present": "Nadi Dosha ist vorhanden",
            "The": "Der",
            "porutham considered for horoscope matching are as follows :": "Die für die Horoskop-Abstimmung berücksichtigten Poruthams sind wie folgt:",
            "Dina": "Dina",
            "Rajju": "Rajju",
            "Rasyadhipati": "Rasyadhipati",
            "Vedha": "Vedha",
            "Mahendra": "Mahendra",
            "Streedargha": "Streedargha",
            "Uranus": "Uranus",
            "Neptune": "Neptun",
            "Pluto": "Pluto",
            "Tara": "Tara",
            "Please fill boy's details !!": "Bitte füllen Sie die Angaben des Jungen aus!!",
            "Please fill girl's details !!": "Bitte füllen Sie die Angaben des Mädchens aus!!",
            "Please fill chart details !!": "Bitte füllen Sie die Diagrammdetails aus!!",
            "Kundli Matching": "Kundli-Abstimmung",
            "Find your right one, through matchmaking": "Finde deinen Richtigen durch Partnervergleich",
            "Open Kundli": "Kundli öffnen",
            "New Matching": "Neue Abstimmung",
            "View Kundli": "Kundli ansehen",
            "Boy's Details": "Angaben des Jungen",
            "Girl's Details": "Angaben des Mädchens",
            "Search city, state, country": "Stadt, Bundesland, Land suchen",
            "Enter first name": "Vorname eingeben",
            "Enter last name": "Nachname eingeben",
            "Chart Style": "Diagramm-Stil",
            "North Indian": "Nordindisch",
            "South Indian": "Südindisch",
            "English": "Englisch",
            "Hindi": "Hindi",
            "MATCH HOROSCOPE": "HOROSKOP ABGLEICHEN",
            "My Profile": "Mein Profil",
            "Enter full name": "Vollständigen Namen eingeben",
            "Enter email address": "E-Mail-Adresse eingeben",
            "Enter password": "Passwort eingeben",
            "Enter phone number": "Telefonnummer eingeben",
            "Save Chanage": "Änderung speichern",
            "Manage your astrologers recent post": "Verwalte die neuesten Beiträge deines Astrologen",
            "Show Less": "Weniger anzeigen",
            "Show More": "Mehr anzeigen",
            "Total Balance": "Gesamtguthaben",
            "Add Money": "Geld hinzufügen",
            "Extra": "Extra",
            "Transaction History": "Transaktionsverlauf",
            "Build better products with flexible tools, helpful documentation,": "Bessere Produkte mit flexiblen Tools, hilfreicher Dokumentation entwickeln,",
            "and a team that champions your growth.": "und einem Team, das dein Wachstum unterstützt.",
            "Useful Link": "Nützlicher Link",
            "Socials": "Soziale Netzwerke",
            "Logout Seccuessfuly !!": "Erfolgreich abgemeldet!!",
            "Free Kundli": "Kostenlose Kundli",
            "Horoscope": "Horoskop",
            "Dashboard": "Dashboard",
            "Enter your feedback !!": "Gib dein Feedback ein!!",
            "Languages": "Sprachen",
            "incoming": "eingehend",
            "request from": "Anfrage von",
            "Waitlist Joined !!": "Warteliste beigetreten!!",
            "will start in": "beginnt in",
            "You will receive a": "Du wirst eine",
            "request when the": "Anfrage erhalten, wenn der",
            "astrologer is ready. Don’t worry! You will not be": "Astrologe bereit ist. Keine Sorge! Dir wird nicht berechnet",
            "charged for missing this session.": "für das Verpassen dieser Sitzung.",
            "Accept": "Akzeptieren",
            "Reject": "Ablehnen",
            "Great, what did you like the mast? 😍": "Super, was hat dir am besten gefallen? 😍",
            "Skip": "Überspringen",
            "Payment Information": "Zahlungsinformationen",
            "Amount": "Betrag",
            "Tax": "Steuer",
            "Payment": "Zahlung",
            "Payment Method": "Zahlungsmethode",
        
            "AstroSpace": "AstroSpace",
            "Astrology Consultation Platform": "Astrology Consultation Platform",
            "INVOICE": "INVOICE",
            "Consultation Service Receipt": "Consultation Service Receipt",
            "Invoice Number": "Invoice Number",
            "Date Issued": "Date Issued",
            "PAID": "PAID",
            "From": "From",
            "Bill To": "Bill To",
            "Service": "Service",
            "Booking ID": "Booking ID",
            "Description": "Description",
            "Duration": "Duration",
            "Rate": "Rate",
            "Amount": "Amount",
            "Free Consultation Time": "Free Consultation Time",
            "Complimentary session minutes": "Complimentary session minutes",
            "Free": "Free",
            "Consultation Fee": "Consultation Fee",
            "Standard rate (first block)": "Standard rate (first block)",
            "Extended Consultation Fee": "Extended Consultation Fee",
            "Premium rate (extended block)": "Premium rate (extended block)",
            "Consultation Service": "Consultation Service",
            "Astrology consultation session": "Astrology consultation session",
            "Subtotal": "Subtotal",
            "Platform Fee": "Platform Fee",
            "Included": "Included",
            "Total Amount": "Total Amount",
            "DOB": "DOB",
            "Kundali Chart Used": "Kundali Chart Used",
            "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.": "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.",
            "For support, contact us at support@astrospace.com": "For support, contact us at support@astrospace.com",
            "Free Minute": "Free Minute",
            "Verified": "Verified",
            "End Session": "End Session",
            "Voice Call": "Voice Call",
            "typing...": "typing...",
            "CANCEL": "CANCEL",
            "OK": "OK",
            "Install Progressive Web Application": "Install Progressive Web Application",
            "This site has app functionality. Install it on your device for extensive experience and easy access.": "This site has app functionality. Install it on your device for extensive experience and easy access.",
            "Install": "Install",
            "Search location": "Search location",
            "Location not found !!": "Location not found !!",
            "Waiting for remote user to join...": "Waiting for remote user to join...",
            "End Video Session": "End Video Session",
            "Initializing WebRTC P2P...": "Initializing WebRTC P2P...",
            "Access Denied (Camera/Mic)": "Access Denied (Camera/Mic)",
            "Connection Failed": "Connection Failed",
            "Time Remaining": "Time Remaining",
            "Call ended": "Call ended",

            "Offline": "Offline",}
    },
    fr: {
        translation: {
            "Enter Mobile Number !!": "Entrez le numéro de mobile !!",
            "In Valid OTP !!": "OTP invalide !!",
            "Please enter password !!": "Veuillez entrer le mot de passe !!",
            "Password not match !!": "Le mot de passe ne correspond pas !!",
            "Reset Password": "Réinitialiser le mot de passe",
            "Enter your phone number and new password": "Entrez votre numéro de téléphone et un nouveau mot de passe",
            "Phone Number": "Numéro de téléphone",
            "Enter your number": "Entrez votre numéro",
            "Search": "Rechercher",
            "Verify": "Vérifier",
            "You will receive a 6 digit code for": "Vous recevrez un code à 6 chiffres pour",
            "verification to": "vérification vers",
            "Submit": "Soumettre",
            "Enter your password and new password": "Entrez votre mot de passe et un nouveau mot de passe",
            "New Password": "Nouveau mot de passe",
            "Enter new password": "Entrez le nouveau mot de passe",
            "Confirm New Password": "Confirmer le nouveau mot de passe",
            "Confirm new password": "Confirmer le nouveau mot de passe",
            "Back to Login": "Retour à la connexion",
            "Back": "Retour",
            "Enter Login Details !!": "Entrez les détails de connexion !!",
            "Welcome Back!": "Bon retour !",
            "Sign in to your account": "Connectez-vous à votre compte",
            "Password": "Mot de passe",
            "Enter your password": "Entrez votre mot de passe",
            "Forgot Password?": "Mot de passe oublié ?",
            "Sign In": "Se connecter",
            "Don't have an account?": "Vous n'avez pas de compte ?",
            "Sign Up": "S'inscrire",
            "Please enter all details !!": "Veuillez remplir tous les champs !!",
            "Please enter valid email !!": "Veuillez entrer un email valide !!",
            "Please enter birth place !!": "Veuillez entrer le lieu de naissance !!",
            "Please select language !!": "Veuillez sélectionner une langue !!",
            "Step": "Étape",
            "Enter Your Details": "Entrez vos informations",
            "Hey there! what is your name?": "Salut ! Quel est votre nom ?",
            "Full Name": "Nom complet",
            "Email Address": "Adresse e-mail",
            "Enter your Full Name": "Entrez votre nom complet",
            "Enter your email": "Entrez votre e-mail",
            "What is your gender?": "Quel est votre sexe ?",
            "Male": "Homme",
            "Female": "Femme",
            "Enter your birth date": "Entrez votre date de naissance",
            "Enter your birth time": "Entrez votre heure de naissance",
            "Enter your birth Place": "Entrez votre lieu de naissance",
            "Do you know which languages?": "Quelles langues parlez-vous ?",
            "Enter Your Place": "Entrez votre lieu",
            "Back to Step": "Retour à l'étape",
            "Next": "Suivant",
            "My Appointments": "Mes rendez-vous",
            "Manage your astrology consultations": "Gérez vos consultations d'astrologie",
            "Upcoming": "À venir",
            "Past": "Passé",
            "Pending": "En attente",
            "Accepted": "Accepté",
            "Start": "Commencer",
            "Completed": "Terminé",
            "Canceled": "Annulé",
            "ID": "ID",
            "Chat": "Chat",
            "Audio Call": "Appel audio",
            "Video Call": "Appel vidéo",
            "View Details": "Voir les détails",
            "Cancel": "Annuler",
            "No Upcoming Appointment Found !!": "Aucun rendez-vous à venir trouvé !!",
            "Currently you don't have any upcoming appointment.": "Vous n'avez actuellement aucun rendez-vous à venir.",
            "No Past Appointment Found !!": "Aucun rendez-vous passé trouvé !!",
            "Currently you don't have any past appointment.": "Vous n'avez actuellement aucun rendez-vous passé.",
            "Status": "Statut",
            "Service Type": "Type de service",
            "Date": "Date",
            "Time": "Heure",
            "Price": "Prix",
            "Booked Person Details": "Détails de la personne réservée",
            "name": "Nom",
            "Date of Birth": "Date de naissance",
            "Birth Place": "Lieu de naissance",
            "Gender": "Sexe",
            "Complete Details": "Détails complets",
            "Start Time": "Heure de début",
            "End Time": "Heure de fin",
            "Total Duration": "Durée totale",
            "Billable Time": "Temps facturable",
            "Billed Fee First": "Frais facturés d'abord",
            "Billed Fee After": "Frais facturés après",
            "Total Consultation Fee": "Frais totaux de consultation",
            "Kundali Details": "Détails du Kundali",
            "Name": "Nom",
            "Send Notification": "Envoyer une notification",
            "Continue Chat": "Continuer le chat",
            "Write message !!": "Écrire un message !!",
            "Astrologer Ai Assistant": "Assistant IA Astrologue",
            "Ask anything about your horoscope...": "Demandez n'importe quoi sur votre horoscope...",
            "Write message to assistant": "Écrire un message à l'assistant",
            "Clear Chat?": "Effacer le chat ?",
            "All messages will be deleted permanently.": "Tous les messages seront supprimés définitivement.",
            "Clear": "Effacer",
            "Payment faild !!": "Paiement échoué !!",
            "Please Complete Last Apointment !!": "Veuillez compléter le dernier rendez-vous !!",
            "Please enter comment !!": "Veuillez entrer un commentaire !!",
            "Insufficient wallet balance !!": "Solde du portefeuille insuffisant !!",
            "Orders": "Commandes",
            "Experience": "Expérience",
            "Rating": "Évaluation",
            "Unfollow": "Ne plus suivre",
            "Follow": "Suivre",
            "Send Gift": "Envoyer un cadeau",
            "Start a Consultation": "Commencer une consultation",
            "Chat with astrologer": "Chat avec l'astrologue",
            "For new user": "Pour les nouveaux utilisateurs",
            "min free": "min gratuit",
            "Call with astrologer": "Appeler l'astrologue",
            "Video call with astrologer": "Appel vidéo avec l'astrologue",
            "Astrologer Bio": "Bio de l'astrologue",
            "Reviews": "Avis",
            "Activity": "Activité",
            "FAQ's": "FAQ",
            "Media": "Médias",
            "Comment": "Commentaire",
            "No comment yet": "Aucun commentaire pour le moment",
            "start the conversation": "commencer la conversation",
            "Poast your replay": "Publier votre réponse",
            "Delete comment": "Supprimer le commentaire",
            "Are you sure you want to delete this comment?": "Êtes-vous sûr de vouloir supprimer ce commentaire ?",
            "Cancle": "Annuler",
            "Delete": "Supprimer",
            "Intro Audio": "Audio d'introduction",
            "Intro Video": "Vidéo d'introduction",
            "Hear from": "Écoutez de",
            "Please select user !!": "Veuillez sélectionner un utilisateur !!",
            "Please select amount !!": "Veuillez sélectionner un montant !!",
            "Please select payment method !!": "Veuillez sélectionner un mode de paiement !!",
            "Select Kundli": "Sélectionner Kundli",
            "Add Kundli": "Ajouter Kundli",
            "Minimum balance of": "Solde minimum de",
            "minutes": "minutes",
            "is required to start chat with": "est requis pour commencer le chat avec",
            "Wallet Balance": "Solde du portefeuille",
            "Required": "Requis",
            "Proceed to Pay": "Procéder au paiement",
            "extra in your": "supplément dans votre",
            "wallet with this": "portefeuille avec ceci",
            "Woohoo!": "Hourra !",
            "Recharge Amount": "Montant de recharge",
            "GST": "TVA",
            "Wallet Amount": "Montant du portefeuille",
            "Payble Amount": "Montant à payer",
            "Pay from Wallet": "Payer depuis le portefeuille",
            "Available": "Disponible",
            "Payment Getway Method": "Méthode de passerelle de paiement",
            "Continue": "Continuer",
            "Fortune Cookie - Unveil Your Daily Wisdom": "Biscuit de fortune - Découvrez votre sagesse quotidienne",
            "Crack open a fortune cookie to reveal a piece of daily wisdom. Let the message guide you through your day with positivity and insight.": "Ouvrez un biscuit de fortune pour révéler un message de sagesse quotidienne. Laissez-le guider votre journée avec positivité et clairvoyance.",
            "Ask The Fortune Cookie": "Demandez au biscuit de fortune",
            "Crack open your Fortune Cookie": "Ouvrez votre biscuit de fortune",
            "Crack another one open": "Ouvrez-en un autre",
            "Love Compatibility": "Compatibilité amoureuse",
            "Find out how compatible you are with your lover, friend, or colleague using our love compatibility calculator. Get your results now.": "Découvrez votre compatibilité avec votre partenaire, ami ou collègue grâce à notre calculateur de compatibilité amoureuse. Obtenez vos résultats maintenant.",
            "Are Aries And Taurus Compatible": "Bélier et Taureau sont-ils compatibles ?",
            "Aries And Taurus Strengths": "Forces du Bélier et du Taureau",
            "Aries And Taurus Weaknesses": "Faiblesses du Bélier et du Taureau",
            "Aries And Taurus Elements": "Éléments du Bélier et du Taureau",
            "Aries And Taurus Dates": "Dates du Bélier et du Taureau",
            "Are Aries And Taurus Compatibility Score": "Score de compatibilité Bélier et Taureau",
            "General": "Général",
            "Communication": "Communication",
            "Sex": "Sexe",
            "Select Another": "Sélectionner un autre",
            "Aries": "Bélier",
            "Taurus": "Taureau",
            "Gemini": "Gémeaux",
            "Cancer": "Cancer",
            "Leo": "Lion",
            "Virgo": "Vierge",
            "Libra": "Balance",
            "Scorpio": "Scorpion",
            "Sagittarius": "Sagittaire",
            "Capricorn": "Capricorne",
            "Aquarius": "Verseau",
            "Pisces": "Poissons",
            "Please select Your Partner Sign": "Veuillez sélectionner le signe de votre partenaire",
            "Please select Your Sign": "Veuillez sélectionner votre signe",
            "Please fill all details !!": "Veuillez remplir tous les détails !!",
            "Discover Your Core Numbers That Define You": "Découvrez vos chiffres essentiels qui vous définissent",
            "Explore your core numbers like Life Path, Destiny, and Personal Year—complete with strengths, challenges, and meaningful interpretations.": "Explorez vos chiffres essentiels comme le chemin de vie, le destin et l'année personnelle — avec forces, défis et interprétations significatives.",
            "Get Your Numbers": "Obtenez vos chiffres",
            "First Name": "Prénom",
            "Last Name": "Nom",
            "Method": "Méthode",
            "Chaldean": "Chaldéen",
            "Pythagorean": "Pythagoricien",
            "Strengths": "Forces",
            "Challenges": "Défis",
            "Advice": "Conseils",
            "Get Report": "Obtenir le rapport",
            "Select Tarot One Card": "Sélectionner une carte de tarot",
            "Select Your Card": "Sélectionnez votre carte",
            "Get Another": "Obtenir une autre",
            "Yes Or No Tarot": "Tarot Oui ou Non",
            "Get instant Yes or No answers to pressing questions.": "Obtenez des réponses instantanées Oui ou Non à vos questions pressantes.",
            "Daily Tarot": "Tarot quotidien",
            "Receive daily tarot readings on love, career, and finance.": "Recevez des lectures de tarot quotidiennes sur l'amour, la carrière et les finances.",
            "In-Depth Love Reading": "Lecture approfondie de l'amour",
            "Deep dive into your love life with relationship-specific readings.": "Plongez dans votre vie amoureuse avec des lectures spécifiques aux relations.",
            "Flirt Love Reading": "Lecture d'amour flirt",
            "Reveal insights into playful and romantic connections.": "Découvrez des aperçus sur les relations ludiques et romantiques.",
            "Erotic Love Reading": "Lecture d'amour érotique",
            "Insights into intimate and personal love dynamics.": "Aperçus sur les dynamiques intimes et personnelles de l'amour.",
            "Egyptian Prediction": "Prédiction égyptienne",
            "Access ancient Egyptian insights beyond visible truths.": "Accédez aux connaissances égyptiennes anciennes au-delà des vérités visibles.",
            "Ex-Flame Reading": "Lecture sur les ex",
            "Explore the possibilities of rekindling with an ex-partner.": "Explorez les possibilités de renouer avec un ex-partenaire.",
            "Made For Each Other Or Not Reading": "Lecture : faits l'un pour l'autre ou pas",
            "Discover if your relationship has long-term potential.": "Découvrez si votre relation a un potentiel à long terme.",
            "Power Life Reading": "Lecture Puissance de Vie",
            "Take control of your destiny with life-changing tarot readings.": "Prenez le contrôle de votre destin avec des lectures de tarot transformantes.",
            "Know Your Friend Reading": "Lecture Connaissez votre ami",
            "Understand the true intentions of your friendships.": "Comprenez les véritables intentions de vos amitiés.",
            "Divine Angel Reading": "Lecture ange divin",
            "Connect with divine guidance for clarity and spiritual insight.": "Connectez-vous à la guidance divine pour clarté et inspiration spirituelle.",
            "Career Daily Reading": "Lecture quotidienne carrière",
            "Elevate your career with daily tarot insights to achieve your professional goals.": "Améliorez votre carrière avec des insights quotidiens de tarot pour atteindre vos objectifs professionnels.",
            "Dream Come True Reading": "Lecture rêves réalisés",
            "Gain insights into making your dreams and goals a reality.": "Obtenez des aperçus pour transformer vos rêves et objectifs en réalité.",
            "Past Lives Connection Reading": "Lecture sur les vies antérieures",
            "Explore your journey across time to understand your path ahead.": "Explorez votre parcours à travers le temps pour comprendre votre chemin à venir.",
            "Yes or No Tarot - Find Clear and Immediate Answers": "Tarot Oui ou Non - Obtenez des réponses claires et immédiates",
            "Daily Tarot - Gain Insights Across Love, Finance, and Career": "Tarot quotidien - Obtenez des insights sur l'amour, les finances et la carrière",
            "In-Depth Love Tarot - Reveal the Realities of Your Relationship": "Tarot approfondi de l'amour - Découvrez les réalités de votre relation",
            "Flirt Love Tarot - Discover Your Romantic Potential": "Tarot flirt amoureux - Découvrez votre potentiel romantique",
            "Erotic Love Tarot - Explore Your Intimate Desires": "Tarot érotique - Explorez vos désirs intimes",
            "Discover the Secrets of Your Soul with Egyptian Tarot": "Découvrez les secrets de votre âme avec le tarot égyptien",
            "Ex-Flame Tarot - Reignite or Release the Past": "Tarot Ex-Flamme - Rallumez ou libérez le passé",
            "Made For Each Other Tarot - Discover True Compatibility": "Tarot Faits l'un pour l'autre - Découvrez la véritable compatibilité",
            "Power Life Tarot - Take Control of Your Destiny": "Tarot Puissance de Vie - Prenez le contrôle de votre destin",
            "Know Your Friend Tarot Reading - Unveil the True Nature of Your Relationships": "Lecture Tarot Connaissez votre ami - Découvrez la vraie nature de vos relations",
            "Divine Angel Tarot - Receive Angelic Guidance for Clarity and Relief": "Tarot Ange Divin - Recevez la guidance angélique pour clarté et soulagement",
            "Career Daily Tarot Reading - Navigate Your Workday with Confidence": "Lecture Tarot quotidien carrière - Gérez votre journée de travail avec confiance",
            "Explore the Depths of Your Heart's Desires with a Dream Come True Tarot Reading": "Explorez les profondeurs des désirs de votre cœur avec une lecture Tarot Rêve Réalisé",
            "Delve into Your Past Lives - Unravel the Enigma of Your Previous Incarnations": "Plongez dans vos vies passées - Déchiffrez l'énigme de vos incarnations précédentes",
            "The Yes or No Tarot widget offers quick, straightforward answers to your pressing questions, helping you make decisions with confidence in areas like love, finance, and career.": "Le widget Tarot Oui ou Non offre des réponses rapides et claires à vos questions pressantes, vous aidant à prendre des décisions avec confiance dans des domaines comme l'amour, les finances et la carrière.",
            "Daily Tarot provides readings that focus on three key areas of your life: Love, Finance, and Career. Discover the guidance you need for each aspect of your day.": "Le Tarot quotidien fournit des lectures qui se concentrent sur trois domaines clés de votre vie : Amour, Finances et Carrière. Découvrez les conseils dont vous avez besoin pour chaque aspect de votre journée.",
            "In-Depth Love Tarot provides comprehensive readings to bring clarity to your love life, help you make crucial decisions, and guide you toward understanding your soulmate and future partner.": "Le Tarot Amour Approfondi fournit des lectures complètes pour clarifier votre vie amoureuse, vous aider à prendre des décisions importantes et vous guider vers la compréhension de votre âme sœur et futur partenaire.",
            "The Flirt Love Tarot Reading provides playful insights into your romantic life. Whether it's a friendship, a new admirer, or a potential soulmate, this reading helps you navigate love with ease.": "La lecture Tarot Amour Flirt offre des aperçus ludiques sur votre vie amoureuse. Qu'il s'agisse d'une amitié, d'un nouvel admirateur ou d'une âme sœur potentielle, cette lecture vous aide à naviguer dans l'amour avec aisance.",
            "This reading reveals insights into passion, love, and sexual chemistry, helping you understand your relationships and uncover hidden fantasies.": "Cette lecture révèle des aperçus sur la passion, l'amour et la chimie sexuelle, vous aidant à comprendre vos relations et à découvrir des fantasmes cachés.",
            "Explore your twin flame, current struggles, ancestral roots, and past healing with the ancient wisdom of Egyptian Tarot": "Explorez votre flamme jumelle, vos luttes actuelles, vos racines ancestrales et vos guérisons passées grâce à la sagesse ancienne du Tarot égyptien",
            "The Ex-Flame Tarot Reading provides clarity on whether to rekindle a past relationship or move on. Explore your ex’s feelings, the potential for a renewed connection, and the impact on your future.": "La lecture Tarot Ex-Flamme apporte de la clarté pour savoir s'il faut raviver une relation passée ou passer à autre chose. Explorez les sentiments de votre ex, le potentiel d'une reconnection et l'impact sur votre futur.",
            "This Tarot reading reveals whether your relationship is worth the effort, safe to pursue, and aligned with your life goals. Understand if you’re truly made for each other or if it’s time to move on.": "Cette lecture Tarot révèle si votre relation vaut l'effort, si elle est sûre à poursuivre et si elle est alignée avec vos objectifs de vie. Comprenez si vous êtes vraiment faits l'un pour l'autre ou s'il est temps de passer à autre chose.",
            "The Power Life Tarot Reading helps you plan your life, overcome struggles, create a clear vision, and take charge of your destiny. Unlock the guidance you need to steer your life towards success.": "La lecture Tarot Puissance de Vie vous aide à planifier votre vie, surmonter les difficultés, créer une vision claire et prendre en main votre destin. Découvrez les conseils nécessaires pour orienter votre vie vers le succès.",
            "Divine Angel Tarot connects you with your guardian angels, offering guidance to overcome challenges and find peace in love, freedom, and resolution.": "Le Tarot Ange Divin vous connecte avec vos anges gardiens, offrant des conseils pour surmonter les défis et trouver la paix dans l'amour, la liberté et la résolution.",
            "Career Daily Tarot offers insights to manage your workday, from handling your boss to staying proactive and managing tasks effectively. Let the Tarot guide you to a successful and stress-free day.": "Le Tarot quotidien Carrière offre des conseils pour gérer votre journée de travail, de la gestion de votre supérieur à rester proactif et gérer vos tâches efficacement. Laissez le Tarot vous guider vers une journée réussie et sans stress.",
            "The Dream Come True Tarot Reading helps you manifest your deepest wishes and aspirations. Whether it's love, material desires, or unfulfilled dreams, this reading offers clarity and guidance to turn your desires into reality.": "La lecture Tarot Rêve Réalisé vous aide à manifester vos souhaits et aspirations les plus profonds. Qu'il s'agisse d'amour, de désirs matériels ou de rêves inassouvis, cette lecture offre clarté et conseils pour transformer vos désirs en réalité.",
            "Explore your past lives to understand current fears, recurring patterns, and influences. Gain clarity on challenges rooted in your previous incarnations.": "Explorez vos vies passées pour comprendre vos peurs actuelles, vos schémas récurrents et vos influences. Obtenez de la clarté sur les défis enracinés dans vos incarnations précédentes.",
            "Select Tarot Three Card": "Sélectionner trois cartes de Tarot",
            "Heartbreak Reading": "Lecture du cœur brisé",
            "Find guidance and healing for a broken heart.": "Trouvez des conseils et une guérison pour un cœur brisé.",
            "Wisdom Reading": "Lecture de sagesse",
            "Balance your energies and find mental peace through wisdom.": "Équilibrez vos énergies et trouvez la paix mentale grâce à la sagesse.",
            "Divine Magic Reading": "Lecture de magie divine",
            "Discover mystical insights with magical tarot guidance.": "Découvrez des aperçus mystiques grâce à la guidance du tarot magique.",
            "Heartbreak Tarot Reading - Find Closure and Guidance": "Lecture Tarot du cœur brisé - Trouver clôture et conseils",
            "The Heartbreak Tarot Reading offers insight into the cause of your pain and provides advice on how to heal and move forward. This two-card reading delivers clarity and the necessary steps to mend your broken heart.": "La lecture Tarot du cœur brisé offre des aperçus sur la cause de votre douleur et des conseils pour guérir et aller de l'avant. Cette lecture à deux cartes apporte clarté et étapes nécessaires pour réparer votre cœur brisé.",
            "Wisdom Tarot - Find Balance with Yin and Yang": "Tarot de sagesse - Trouvez l'équilibre entre Yin et Yang",
            "Wisdom Tarot provides guidance by balancing the Yin and Yang energies in your life. Discover clarity, peace, and a path forward with this two-card reading.": "Le Tarot de sagesse offre des conseils en équilibrant les énergies Yin et Yang dans votre vie. Découvrez clarté, paix et un chemin à suivre avec cette lecture à deux cartes.",
            "Divine Magic Tarot Reading - Discover Cause and Remedy": "Lecture Tarot Magie Divine - Découvrez cause et remède",
            "The Divine Magic Tarot Reading offers insights into the root cause of your problems and provides a remedy to guide you toward resolution. With this reading, discover the steps you need to take to transform challenges into solutions.": "La lecture Tarot Magie Divine offre des aperçus sur la cause profonde de vos problèmes et propose un remède pour vous guider vers la résolution. Découvrez les étapes nécessaires pour transformer les défis en solutions.",
            "Please pick your cards !!": "Veuillez choisir vos cartes !!",
            "Get Your Reading": "Obtenez votre lecture",
            "Select Tarot Two Card": "Sélectionner deux cartes de Tarot",
            "Love Triangle Reading": "Lecture Triangle Amoureux",
            "Get clarity in choosing between multiple romantic interests.": "Obtenez de la clarté pour choisir entre plusieurs intérêts amoureux.",
            "Past-Present-Future Reading": "Lecture Passé-Présent-Futur",
            "Love Triangle Tarot - Discover the Dynamics Between You, Lover 1, and Lover 2": "Tarot Triangle Amoureux - Découvrez la dynamique entre vous, Amant 1 et Amant 2",
            "Love Triangle Tarot provides insights into the relationships and dynamics between you and your two lovers. Understand where you stand, and what each lover brings into your life, and make an informed decision guided by the cards.": "Le Tarot Triangle Amoureux offre des aperçus sur les relations et dynamiques entre vous et vos deux amants. Comprenez votre position, ce que chaque amant apporte dans votre vie et prenez une décision éclairée guidée par les cartes.",
            "Zodiac Gift Guru": "Guru des cadeaux du zodiaque",
            "January": "Janvier",
            "February": "Février",
            "March": "Mars",
            "April": "Avril",
            "May": "Mai",
            "June": "Juin",
            "July": "Juillet",
            "August": "Août",
            "September": "Septembre",
            "October": "Octobre",
            "November": "Novembre",
            "December": "Décembre",
            "Yesterday": "Hier",
            "Today": "Aujourd'hui",
            "Tomorrow": "Demain",
            "Gift Recommendations": "Recommandations de cadeaux",
            "insight": "aperçu",
            "Career": "Carrière",
            "Love": "Amour",
            "Finance": "Finance",
            "Popularity": "Popularité",
            "Experience: High to Low": "Expérience : du plus élevé au plus bas",
            "Experience: Low to High": "Expérience : du plus bas au plus élevé",
            "Orders: High to Low": "Commandes : du plus élevé au plus bas",
            "Orders: Low to High": "Commandes : du plus bas au plus élevé",
            "Price: High to Low": "Prix : du plus élevé au plus bas",
            "Price: Low to High": "Prix : du plus bas au plus élevé",
            "Rating: High to Low": "Évaluation : du plus élevé au plus bas",
            "Search name...": "Rechercher un nom...",
            "Online": "En ligne",
            "Busy": "Occupé",
            "Exp": "Exp",
            "yrs": "ans",
            "orders": "commandes",
            "min": "min",
            "Chat Now": "Discuter maintenant",
            "Wait": "Attendre",
            "There are no astrologers in this category.": "Il n'y a pas d'astrologues dans cette catégorie.",
            "Sort": "Trier",
            "Filter": "Filtrer",
            "Category": "Catégorie",
            "All": "Tout",
            "Sort by": "Trier par",
            "Skill": "Compétence",
            "Language": "Langue",
            "Reset": "Réinitialiser",
            "Apply": "Appliquer",
            "You have 30 seconds left. Please recharge immediately to continue the conversation.": "Il vous reste 30 secondes. Veuillez recharger immédiatement pour continuer la conversation.",
            "Free chat over! Next minutes will use wallet balance.": "Chat gratuit terminé ! Les prochaines minutes utiliseront le solde du portefeuille.",
            "Complete": "Terminer",
            "End Chat": "Terminer le chat",
            "Message": "Message",
            "Hi": "Salut",
            "lets continue this chat at discounted price of": "continuons cette discussion au prix réduit de",
            "Are you sure you want to end tha chat to": "Êtes-vous sûr de vouloir terminer le chat avec",
            "No": "Non",
            "Yes": "Oui",
            "Chat With Astrologer": "Discuter avec un astrologue",
            "Appointment List": "Liste des rendez-vous",
            "My Following": "Mes abonnements",
            "Recent Post": "Publication récente",
            "Welcome back": "Bon retour",
            "Manage your astrology services": "Gérez vos services d'astrologie",
            "Logout": "Se déconnecter",
            "Login": "Se connecter",
            "My Profile (Member Since)": "Mon profil (membre depuis)",
            "My Followings": "Mes abonnements",
            "You are following": "Vous suivez",
            "people": "personnes",
            "Years": "Années",
            "No Following Found !!": "Aucun abonnement trouvé !!",
            "Currently you don't have any follow.": "Vous n'avez actuellement aucun abonnement.",
            "Hey There!": "Salut !",
            "What is your name?": "Quel est votre nom ?",
            "Enter your first Name": "Entrez votre prénom",
            "Enter your last Name": "Entrez votre nom de famille",
            "male": "homme",
            "female": "femme",
            "Where wrer you bron?": "Où êtes-vous né ?",
            "Please Select Language": "Veuillez sélectionner la langue",
            "english": "anglais",
            "hindi": "hindi",
            "north": "nord",
            "south": "sud",
            "Select Chart Type": "Sélectionner le type de carte",
            "Start chat with astrologer": "Commencer le chat avec un astrologue",
            "Search location": "Rechercher un lieu",
            "Location not found !!": "Lieu non trouvé !!",
            "Enter bord state": "Entrez l'état de naissance",
            "Search location...": "Rechercher un lieu...",
            "Astrologers": "Astrologues",
            "Top Astrologers. 24 * 7 customer support. Happy to help": "Meilleurs astrologues. Support client 24/7. Heureux d'aider",
            "per min": "par min",
            "Top Astrologers": "Meilleurs astrologues",
            "rate": "évaluer",
            "Top Rated Astrologers": "Astrologues les mieux notés",
            "No astrologers found !!": "Aucun astrologue trouvé !!",
            "FAQs": "FAQ",
            "Raning": "Classement",
            "Raning Apointment": "Rendez-vous classés",
            "Select Other Sign": "Sélectionner un autre signe",
            "Horoscopes": "Horoscopes",
            "Daily Horoscope": "Horoscope quotidien",
            "Weekly Horoscope": "Horoscope hebdomadaire",
            "Monthly Horoscope": "Horoscope mensuel",
            "Yearly Horoscope": "Horoscope annuel",
            "Composite Friendship Table": "Table d'amitié composite",
            "Kp Planetary Details": "Détails planétaires KP",
            "Kp House Cusps And Chart": "Cusps de maisons et carte KP",
            "Ascendant Report": "Rapport Ascendant",
            "Bhava Kundli": "Bhava Kundli",
            "Vimshottari Dasha": "Dasha Vimshottari",
            "Yogini Dasha": "Dasha Yogini",
            "Sadhesati Analysis": "Analyse Sadhesati",
            "Sadhesati Life Analysis": "Analyse de vie Sadhesati",
            "Kalsarpa Dosha": "Dosha Kalsarpa",
            "Manglik Analysis": "Analyse Manglik",
            "Planet Profiles": "Profils planétaires",
            "Gemstone Suggestions": "Suggestions de pierres précieuses",
            "Upagraha": "Upagraha",
            "Jaimini Astrology": "Astrologie Jaimini",
            "Chara Dasha": "Dasha Chara",
            "Shadbala": "Shadbala",
            "Sudarshana Chakra": "Sudarshana Chakra",
            "Bhinnashtakvarga": "Bhinnashtakvarga",
            "Yogas": "Yogas",
            "Introduction": "Introduction",
            "Basic Astrological Details": "Détails astrologiques de base",
            "Planetary Positions": "Positions planétaires",
            "Horoscope Charts": "Cartes d'horoscope",
            "House Cusps And Sandhi": "Cusps de maisons et Sandhi",
            "Divisional Charts": "Cartes divisionales",
            "Basic Details": "Détails de base",
            "Ghat Chakra": "Ghat Chakra",
            "Panchange Details": "Détails Panchang",
            "Astrological Details": "Détails astrologiques",
            "Time of Birth": "Heure de naissance",
            "Place of Birth": "Lieu de naissance",
            "Latitude": "Latitude",
            "Longitude": "Longitude",
            "Timezone": "Fuseau horaire",
            "Ayanamsa": "Ayanamsa",
            "Sunrise": "Lever du soleil",
            "Sunset": "Coucher du soleil",
            "Month": "Mois",
            "Tithi": "Tithi",
            "Yoga": "Yoga",
            "Karana": "Karana",
            "Moon Sign": "Signe lunaire",
            "Moon Vaar": "Jour de la lune",
            "Nakshatra": "Nakshatra",
            "Varna": "Varna",
            "Vashya": "Vashya",
            "Yoni": "Yoni",
            "Gana": "Gana",
            "Nadi": "Nadi",
            "Sun Sign": "Signe solaire",
            "Tatva": "Tatva",
            "Paya": "Paya",
            "Yanja": "Yanja",
            "Planets": "Planètes",
            "Sign": "Signe",
            "Sign No": "Numéro du signe",
            "LAGNA CHART (BIRTH CHART)": "CARTE LAGNA (CARTE DE NAISSANCE)",
            "MOON CHART": "CARTE LUNAIRE",
            "NAVMANSHA CHART (D9)": "CARTE NAVMANSHA (D9)",
            "House": "Maison",
            "Bhav Madhya": "Bhav Madhya",
            "Bhav Sandhi": "Bhav Sandhi",
            "Chalit Chart": "Carte Chalit",
            "Sun Chart": "Carte du Soleil",
            "Health, Constitution, Body": "Santé, constitution, corps",
            "Hora Chart(D2)": "Carte Hora (D2)",
            "Finance, Wealth, Prosperity": "Finance, richesse, prospérité",
            "Dreshkan Chart(D3)": "Carte Dreshkan (D3)",
            "Brothers, Sisters": "Frères, sœurs",
            "Chathurthamasha Chart(D4)": "Carte Chathurthamasha (D4)",
            "Fortunes, Luck of native": "Fortunes, chance du natif",
            "Saptamansha Chart(D7)": "Carte Saptamansha (D7)",
            "Impregnation, Birth of the child": "Grossesse, naissance de l'enfant",
            "Dashamansha Chart(D10)": "Carte Dashamansha (D10)",
            "livelihood, Profession": "Moyens de subsistance, profession",
            "Dwadasha Chart(D12)": "Carte Dwadasha (D12)",
            "Parents, paternal happiness": "Parents, bonheur paternel",
            "Shodashamsha Chart(D16)": "Carte Shodashamsha (D16)",
            "Happiness, miseries, conveyance": "Bonheur, malheurs, déplacements",
            "Vishamansha Chart(D20)": "Carte Vishamansha (D20)",
            "Spiritual progress, worship": "Progrès spirituel, adoration",
            "Chaturvimshamsha(D24)": "Carte Chaturvimshamsha (D24)",
            "Academic achievement, education": "Réussite académique, éducation",
            "Bhamsha Chart(D27)": "Carte Bhamsha (D27)",
            "Physical strength, stamina": "Force physique, endurance",
            "Trishamansha Chart(D30)": "Carte Trishamansha (D30)",
            "Evil, Adversities of life": "Maux, adversités de la vie",
            "Khavedamsha Chart(D40)": "Carte Khavedamsha (D40)",
            "Auspicious & inauspicious effect": "Effet favorable et défavorable",
            "Akshvedansha Chart(D45)": "Carte Akshvedansha (D45)",
            "Character and couduct of the native": "Caractère et conduite du natif",
            "Shashtymsah Chart(D60)": "Carte Shashtyamsa (D60)",
            "Shows general happiness": "Montre le bonheur général",
            "Degrees": "Degrés",
            "Sign Lord": "Maître du signe",
            "Nakshatra Lord": "Maître du Nakshatra",
            "Sub Lord": "Sous-maître",
            "Sub Sub Lord": "Sous-sous-maître",
            "Lord": "Maître",
            "Symbol": "Symbole",
            "Characteristics": "Caractéristiques",
            "Day of Fast": "Jour de jeûne",
            "luchy Gems": "Pierres chanceuses",
            "Personality": "Personnalité",
            "Health": "Santé",
            "Relationships": "Relations",
            "BHAVA KUNDLI": "BHAVA KUNDLI",
            "Bhramari": "Bhramari",
            "Bhadrika": "Bhadrika",
            "Ulka": "Ulka",
            "Siddha": "Siddha",
            "Sankata": "Sankata",
            "Mangala": "Mangala",
            "Pingala": "Pingala",
            "Dhanya": "Dhanya",
            "Remedies Of Sadhesati": "Remèdes du Sadhesati",
            "Saturn Sign": "Signe de Saturne",
            "Is Saturn Retro?": "Saturne est-elle rétrograde ?",
            "Phase": "Phase",
            "Intensity": "Intensité",
            "Direction": "Direction",
            "Strength": "Force",
            "Percentage": "Pourcentage",
            "Zodiac Sign": "Signe du zodiaque",
            "Planet Degree": "Degré de la planète",
            "Lord Of": "Maître de",
            "Combust/Aw...": "Combustion/Aw...",
            "Lucky Stone": "Pierre porte-bonheur",
            "Life Stone": "Pierre de vie",
            "Finger": "Doigt",
            "Day": "Jour",
            "Time to Wear": "Moment pour porter",
            "Mantra": "Mantra",
            "Upagraha Longitude": "Longitude de l'Upagraha",
            "Rashi": "Rashi",
            "Pada": "Pada",
            "Upagraha/Nakshatra/Sub Lord": "Upagraha/Nakshatra/Sous-maître",
            "Jamini Planets": "Planètes Jamini",
            "Jamini Padas": "Padas Jamini",
            "Code": "Code",
            "Jamini Karakara": "Karakara Jamini",
            "Uchcha Bala": "Uchcha Bala",
            "Saptavarga Bala": "Saptavarga Bala",
            "Yugmayugma Bhamsha Bala": "Yugmayugma Bhamsha Bala",
            "Kendradi Bala": "Kendradi Bala",
            "Drekkana Bala": "Drekkana Bala",
            "Total Sthana Bala": "Total Sthana Bala",
            "Total Dig Bala": "Total Dig Bala",
            "Nattunnata Bala": "Nattunnata Bala",
            "Paksha Bala": "Paksha Bala",
            "Tribhaga Bala": "Tribhaga Bala",
            "Varshadhipati": "Varshadhipati",
            "Maasadipati": "Maasadipati",
            "Vaaradhipati": "Vaaradhipati",
            "Horadhipati": "Horadhipati",
            "Ayana Bala": "Ayana Bala",
            "Yuddha Bala": "Yuddha Bala",
            "Total Kaal Bala": "Total Kaal Bala",
            "Naisargika Bala": "Naisargika Bala",
            "Chestha Bala": "Chestha Bala",
            "Drik Bala": "Drik Bala",
            "Total Shadbala": "Total Shadbala",
            "Shadbala In Rupa": "Shadbala en Rupa",
            "Min Require": "Minimum requis",
            "Ratio": "Ratio",
            "Rank": "Rang",
            "Sun": "Soleil",
            "Moon": "Lune",
            "Mars": "Mars",
            "Mercury": "Mercure",
            "Jupiter": "Jupiter",
            "Venus": "Vénus",
            "Saturn": "Saturne",
            "Ashtakvarga": "Ashtakvarga",
            "Sarvashtakava": "Sarvashtakava",
            "Prasthara Chakra": "Prasthara Chakra",
            "Ascendant": "Ascendant",
            "Total": "Total",
            "Natural Friendship": "Amitié naturelle",
            "Temporary Friendship": "Amitié temporaire",
            "Five Fold Friendship": "Amitié à cinq volets",
            "Ketu": "Ketu",
            "Rahu": "Rahu",
            "Vimshottari Dasha P1": "Vimshottari Dasha P1",
            "Vimshottari Dasha P2": "Vimshottari Dasha P2",
            "AshtaKoot": "AshtaKoot",
            "Bhakut Dosha": "Dosha Bhakut",
            "Nadi Dosha": "Dosha Nadi",
            "Ashtakoot Analysis": "Analyse Ashtakoot",
            "DashaKoot": "DashaKoot",
            "Personality Report": "Rapport de personnalité",
            "Match Making Report": "Rapport de compatibilité",
            "Nav Pancham Yoga": "Yoga Nav Pancham",
            "Charan": "Charan",
            "Name Alphabet": "Alphabet du nom",
            "Planetary Position": "Position planétaire",
            "Lagna Chart (Birth Chart)": "Carte Lagna (Carte de naissance)",
            "Moon Chart": "Carte de la lune",
            "Navmansha Chart (D9)": "Carte Navmansha (D9)",
            "Mahadasha": "Mahadasha",
            "End": "Fin",
            "Is Recommended ??": "Est-ce recommandé ?",
            "Manglik Details": "Détails Manglik",
            "What is AshtaKoot ??": "Qu'est-ce que AshtaKoot ?",
            "Attributes": "Attributs",
            "Description": "Description",
            "Received": "Reçu",
            "Graha Maitri": "Graha Maitri",
            "Bhakoota": "Bhakoota",
            "What is BhaKoot Dosha ??": "Qu'est-ce que le Dosha BhaKoot ?",
            "What is Nadi Dosha ??": "Qu'est-ce que le Dosha Nadi ?",
            "Madhya": "Madhya",
            "Nadi dosha is present": "Dosha Nadi présent",
            "The": "Le",
            "porutham considered for horoscope matching are as follows :": "Les poruthams considérés pour la compatibilité des horoscopes sont les suivants :",
            "Dina": "Dina",
            "Rajju": "Rajju",
            "Rasyadhipati": "Rasyadhipati",
            "Vedha": "Vedha",
            "Mahendra": "Mahendra",
            "Streedargha": "Streedargha",
            "Uranus": "Uranus",
            "Neptune": "Neptune",
            "Pluto": "Pluton",
            "Tara": "Tara",
            "Please fill boy's details !!": "Veuillez remplir les informations du garçon !!",
            "Please fill girl's details !!": "Veuillez remplir les informations de la fille !!",
            "Please fill chart details !!": "Veuillez remplir les détails du tableau !!",
            "Kundli Matching": "Compatibilité Kundli",
            "Find your right one, through matchmaking": "Trouvez la bonne personne grâce à la compatibilité",
            "Open Kundli": "Ouvrir Kundli",
            "New Matching": "Nouvelle compatibilité",
            "View Kundli": "Voir Kundli",
            "Boy's Details": "Détails du garçon",
            "Girl's Details": "Détails de la fille",
            "Search city, state, country": "Rechercher ville, État, pays",
            "Enter first name": "Entrez le prénom",
            "Enter last name": "Entrez le nom de famille",
            "Chart Style": "Style du tableau",
            "North Indian": "Indien du Nord",
            "South Indian": "Indien du Sud",
            "English": "Anglais",
            "Hindi": "Hindi",
            "MATCH HOROSCOPE": "COMPATIBILITÉ HOROSCOPE",
            "My Profile": "Mon profil",
            "Enter full name": "Entrez le nom complet",
            "Enter email address": "Entrez l'adresse e-mail",
            "Enter password": "Entrez le mot de passe",
            "Enter phone number": "Entrez le numéro de téléphone",
            "Save Chanage": "Enregistrer les modifications",
            "Manage your astrologers recent post": "Gérer les publications récentes de vos astrologues",
            "Show Less": "Afficher moins",
            "Show More": "Afficher plus",
            "Total Balance": "Solde total",
            "Add Money": "Ajouter de l'argent",
            "Extra": "Supplémentaire",
            "Transaction History": "Historique des transactions",
            "Build better products with flexible tools, helpful documentation,": "Créez de meilleurs produits avec des outils flexibles et une documentation utile,",
            "and a team that champions your growth.": "et une équipe qui soutient votre croissance.",
            "Useful Link": "Lien utile",
            "Socials": "Réseaux sociaux",
            "Logout Seccuessfuly !!": "Déconnexion réussie !!",
            "Free Kundli": "Kundli gratuit",
            "Horoscope": "Horoscope",
            "Dashboard": "Tableau de bord",
            "Enter your feedback !!": "Entrez votre avis !!",
            "Languages": "Langues",
            "incoming": "entrant",
            "request from": "demande de",
            "Waitlist Joined !!": "Liste d'attente rejointe !!",
            "will start in": "commencera dans",
            "You will receive a": "Vous recevrez une",
            "request when the": "demande lorsque le",
            "astrologer is ready. Don’t worry! You will not be": "l'astrologue sera prêt. Ne vous inquiétez pas ! Vous ne serez pas",
            "charged for missing this session.": "facturé pour avoir manqué cette session.",
            "Accept": "Accepter",
            "Reject": "Refuser",
            "Great, what did you like the mast? 😍": "Super, qu'avez-vous le plus aimé ? 😍",
            "Skip": "Passer",
            "Payment Information": "Informations de paiement",
            "Amount": "Montant",
            "Tax": "Taxe",
            "Payment": "Paiement",
            "Payment Method": "Méthode de paiement",
        
            "AstroSpace": "AstroSpace",
            "Astrology Consultation Platform": "Astrology Consultation Platform",
            "INVOICE": "INVOICE",
            "Consultation Service Receipt": "Consultation Service Receipt",
            "Invoice Number": "Invoice Number",
            "Date Issued": "Date Issued",
            "PAID": "PAID",
            "From": "From",
            "Bill To": "Bill To",
            "Service": "Service",
            "Booking ID": "Booking ID",
            "Description": "Description",
            "Duration": "Duration",
            "Rate": "Rate",
            "Amount": "Amount",
            "Free Consultation Time": "Free Consultation Time",
            "Complimentary session minutes": "Complimentary session minutes",
            "Free": "Free",
            "Consultation Fee": "Consultation Fee",
            "Standard rate (first block)": "Standard rate (first block)",
            "Extended Consultation Fee": "Extended Consultation Fee",
            "Premium rate (extended block)": "Premium rate (extended block)",
            "Consultation Service": "Consultation Service",
            "Astrology consultation session": "Astrology consultation session",
            "Subtotal": "Subtotal",
            "Platform Fee": "Platform Fee",
            "Included": "Included",
            "Total Amount": "Total Amount",
            "DOB": "DOB",
            "Kundali Chart Used": "Kundali Chart Used",
            "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.": "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.",
            "For support, contact us at support@astrospace.com": "For support, contact us at support@astrospace.com",
            "Free Minute": "Free Minute",
            "Verified": "Verified",
            "End Session": "End Session",
            "Voice Call": "Voice Call",
            "typing...": "typing...",
            "CANCEL": "CANCEL",
            "OK": "OK",
            "Install Progressive Web Application": "Install Progressive Web Application",
            "This site has app functionality. Install it on your device for extensive experience and easy access.": "This site has app functionality. Install it on your device for extensive experience and easy access.",
            "Install": "Install",
            "Search location": "Search location",
            "Location not found !!": "Location not found !!",
            "Waiting for remote user to join...": "Waiting for remote user to join...",
            "End Video Session": "End Video Session",
            "Initializing WebRTC P2P...": "Initializing WebRTC P2P...",
            "Access Denied (Camera/Mic)": "Access Denied (Camera/Mic)",
            "Connection Failed": "Connection Failed",
            "Time Remaining": "Time Remaining",
            "Call ended": "Call ended",

            "Offline": "Offline",}
    },
    ur: {
        translation: {
            "Enter Mobile Number !!": "موبائل نمبر درج کریں !!",
            "In Valid OTP !!": "غلط OTP !!",
            "Please enter password !!": "براہ کرم پاس ورڈ درج کریں !!",
            "Password not match !!": "پاس ورڈ میل نہیں کھاتا !!",
            "Reset Password": "پاس ورڈ ری سیٹ کریں",
            "Enter your phone number and new password": "اپنا فون نمبر اور نیا پاس ورڈ درج کریں",
            "Phone Number": "فون نمبر",
            "Enter your number": "اپنا نمبر درج کریں",
            "Search": "تلاش کریں",
            "Verify": "تصدیق کریں",
            "You will receive a 6 digit code for": "آپ کو 6 ہندسوں کا کوڈ موصول ہوگا",
            "verification to": "تصدیق کے لیے",
            "Submit": "جمع کریں",
            "Enter your password and new password": "اپنا پاس ورڈ اور نیا پاس ورڈ درج کریں",
            "New Password": "نیا پاس ورڈ",
            "Enter new password": "نیا پاس ورڈ درج کریں",
            "Confirm New Password": "نیا پاس ورڈ تصدیق کریں",
            "Confirm new password": "نیا پاس ورڈ تصدیق کریں",
            "Back to Login": "لاگ ان پر واپس جائیں",
            "Back": "پیچھے",
            "Enter Login Details !!": "لاگ ان کی تفصیلات درج کریں !!",
            "Welcome Back!": "خوش آمدید!",
            "Sign in to your account": "اپنے اکاؤنٹ میں سائن ان کریں",
            "Password": "پاس ورڈ",
            "Enter your password": "اپنا پاس ورڈ درج کریں",
            "Forgot Password?": "پاس ورڈ بھول گئے؟",
            "Sign In": "سائن ان کریں",
            "Don't have an account?": "اکاؤنٹ نہیں ہے؟",
            "Sign Up": "سائن اپ کریں",
            "Please enter all details !!": "براہ کرم تمام تفصیلات درج کریں !!",
            "Please enter valid email !!": "براہ کرم درست ای میل درج کریں !!",
            "Please enter birth place !!": "براہ کرم پیدائش کی جگہ درج کریں !!",
            "Please select language !!": "براہ کرم زبان منتخب کریں !!",
            "Step": "مرحلہ",
            "Enter Your Details": "اپنی تفصیلات درج کریں",
            "Hey there! what is your name?": "ہیلو! آپ کا نام کیا ہے؟",
            "Full Name": "پورا نام",
            "Email Address": "ای میل ایڈریس",
            "Enter your Full Name": "اپنا پورا نام درج کریں",
            "Enter your email": "اپنی ای میل درج کریں",
            "What is your gender?": "آپ کی جنس کیا ہے؟",
            "Male": "مرد",
            "Female": "عورت",
            "Enter your birth date": "اپنی تاریخ پیدائش درج کریں",
            "Enter your birth time": "اپنا وقت پیدائش درج کریں",
            "Enter your birth Place": "اپنی پیدائش کی جگہ درج کریں",
            "Do you know which languages?": "آپ کون سی زبانیں جانتے ہیں؟",
            "Enter Your Place": "اپنی جگہ درج کریں",
            "Back to Step": "مرحلہ پر واپس جائیں",
            "Next": "اگلا",
            "My Appointments": "میری ملاقاتیں",
            "Manage your astrology consultations": "اپنی علم نجوم کی مشاورت کا انتظام کریں",
            "Upcoming": "آنے والی",
            "Past": "گزشتہ",
            "Pending": "زیر التوا",
            "Accepted": "قبول شدہ",
            "Start": "شروع کریں",
            "Completed": "مکمل",
            "Canceled": "منسوخ",
            "ID": "شناخت",
            "Chat": "چیٹ",
            "Audio Call": "آڈیو کال",
            "Video Call": "ویڈیو کال",
            "View Details": "تفصیلات دیکھیں",
            "Cancel": "منسوخ کریں",
            "No Upcoming Appointment Found !!": "کوئی آنے والی ملاقات نہیں ملی !!",
            "Currently you don't have any upcoming appointment.": "اس وقت آپ کے پاس کوئی آنے والی ملاقات نہیں ہے۔",
            "No Past Appointment Found !!": "کوئی پچھلی ملاقات نہیں ملی !!",
            "Currently you don't have any past appointment.": "اس وقت آپ کے پاس کوئی پچھلی ملاقات نہیں ہے۔",
            "Status": "حالت",
            "Service Type": "سروس کی قسم",
            "Date": "تاریخ",
            "Time": "وقت",
            "Price": "قیمت",
            "Booked Person Details": "بک شدہ شخص کی تفصیلات",
            "name": "نام",
            "Date of Birth": "تاریخ پیدائش",
            "Birth Place": "جگہ پیدائش",
            "Gender": "جنس",
            "Complete Details": "مکمل تفصیلات",
            "Start Time": "شروع ہونے کا وقت",
            "End Time": "ختم ہونے کا وقت",
            "Total Duration": "کل دورانیہ",
            "Billable Time": "بل کرنے کا وقت",
            "Billed Fee First": "پہلے بل شدہ فیس",
            "Billed Fee After": "بعد میں بل شدہ فیس",
            "Total Consultation Fee": "کل مشاورت کی فیس",
            "Kundali Details": "کندلی کی تفصیلات",
            "Name": "نام",
            "Send Notification": "نوٹیفکیشن بھیجیں",
            "Continue Chat": "چیٹ جاری رکھیں",
            "Write message !!": "پیغام لکھیں !!",
            "Astrologer Ai Assistant": "علم نجوم AI معاون",
            "Ask anything about your horoscope...": "اپنے ہوروسکوپ کے بارے میں کچھ بھی پوچھیں...",
            "Write message to assistant": "معاون کو پیغام لکھیں",
            "Clear Chat?": "چیٹ صاف کریں؟",
            "All messages will be deleted permanently.": "تمام پیغامات مستقل طور پر حذف ہو جائیں گے۔",
            "Clear": "صاف کریں",
            "Payment faild !!": "ادائیگی ناکام !!",
            "Please Complete Last Apointment !!": "براہ کرم آخری ملاقات مکمل کریں !!",
            "Please enter comment !!": "براہ کرم تبصرہ درج کریں !!",
            "Insufficient wallet balance !!": "والیٹ میں بیلنس ناکافی !!",
            "Orders": "آرڈرز",
            "Experience": "تجربہ",
            "Rating": "درجہ بندی",
            "Unfollow": "ان فالو کریں",
            "Follow": "فالو کریں",
            "Send Gift": "تحفہ بھیجیں",
            "Start a Consultation": "مشاورت شروع کریں",
            "Chat with astrologer": "علم نجوم کے ساتھ چیٹ کریں",
            "For new user": "نئے صارف کے لیے",
            "min free": "منٹ مفت",
            "Call with astrologer": "علم نجوم کے ساتھ کال کریں",
            "Video call with astrologer": "علم نجوم کے ساتھ ویڈیو کال",
            "Astrologer Bio": "علم نجوم کی سوانح حیات",
            "Reviews": "جائزے",
            "Activity": "سرگرمی",
            "FAQ's": "عمومی سوالات",
            "Media": "میڈیا",
            "Comment": "تبصرہ",
            "No comment yet": "ابھی تک کوئی تبصرہ نہیں",
            "start the conversation": "گفتگو شروع کریں",
            "Poast your replay": "اپنا جواب پوسٹ کریں",
            "Delete comment": "تبصرہ حذف کریں",
            "Are you sure you want to delete this comment?": "کیا آپ واقعی اس تبصرے کو حذف کرنا چاہتے ہیں؟",
            "Cancle": "منسوخ کریں",
            "Delete": "حذف کریں",
            "Intro Audio": "تعارفی آڈیو",
            "Intro Video": "تعارفی ویڈیو",
            "Hear from": "سنو",
            "Please select user !!": "براہ کرم صارف منتخب کریں !!",
            "Please select amount !!": "براہ کرم رقم منتخب کریں !!",
            "Please select payment method !!": "براہ کرم ادائیگی کا طریقہ منتخب کریں !!",
            "Select Kundli": "کُنڈلی منتخب کریں",
            "Add Kundli": "کُنڈلی شامل کریں",
            "Minimum balance of": "کم از کم بیلنس",
            "minutes": "منٹ",
            "is required to start chat with": "کے ساتھ چیٹ شروع کرنے کے لیے ضروری ہے",
            "Wallet Balance": "والیٹ بیلنس",
            "Required": "ضروری",
            "Proceed to Pay": "ادائیگی کے لیے آگے بڑھیں",
            "extra in your": "آپ کے",
            "wallet with this": "والیٹ میں اضافی",
            "Woohoo!": "واہ!",
            "Recharge Amount": "رقم ریچارج کریں",
            "GST": "جی ایس ٹی",
            "Wallet Amount": "والیٹ رقم",
            "Payble Amount": "ادا کرنے والی رقم",
            "Pay from Wallet": "والیٹ سے ادائیگی کریں",
            "Available": "دستیاب",
            "Payment Getway Method": "ادائیگی کا گیٹ وے طریقہ",
            "Continue": "جاری رکھیں",
            "Fortune Cookie - Unveil Your Daily Wisdom": "فورچون کوکی - اپنی روزانہ کی حکمت دریافت کریں",
            "Crack open a fortune cookie to reveal a piece of daily wisdom. Let the message guide you through your day with positivity and insight.": "فورچون کوکی کھولیں اور روزانہ کی حکمت کا ٹکڑا دریافت کریں۔ یہ پیغام آپ کے دن کو مثبت اور بصیرت کے ساتھ رہنمائی دے گا۔",
            "Ask The Fortune Cookie": "فورچون کوکی سے پوچھیں",
            "Crack open your Fortune Cookie": "اپنی فورچون کوکی کھولیں",
            "Crack another one open": "ایک اور کھولیں",
            "Love Compatibility": "محبت کی مطابقت",
            "Find out how compatible you are with your lover, friend, or colleague using our love compatibility calculator. Get your results now.": "ہمارے محبت کی مطابقت کیلکولیٹر سے جانیں کہ آپ اپنے محبوب، دوست، یا ساتھی کے ساتھ کتنے ہم آہنگ ہیں۔ ابھی اپنے نتائج حاصل کریں۔",
            "Are Aries And Taurus Compatible": "کیا میش اور وृष بھید مطابقت رکھتے ہیں؟",
            "Aries And Taurus Strengths": "میش اور وृष کے مضبوط پہلو",
            "Aries And Taurus Weaknesses": "میش اور وृष کی کمزوریاں",
            "Aries And Taurus Elements": "میش اور وृष کے عناصر",
            "Aries And Taurus Dates": "میش اور وृष کی تاریخیں",
            "Are Aries And Taurus Compatibility Score": "میش اور وृष کی مطابقت کا اسکور",
            "General": "عام",
            "Communication": "رابطہ",
            "Sex": "جنسی تعلق",
            "Select Another": "دوسرا منتخب کریں",
            "Aries": "میش",
            "Taurus": "وृष",
            "Gemini": "جوزا",
            "Cancer": "سرطان",
            "Leo": "اسد",
            "Virgo": "سنبلہ",
            "Libra": "میزان",
            "Scorpio": "عقرب",
            "Sagittarius": "قوس",
            "Capricorn": "جدی",
            "Aquarius": "دلو",
            "Pisces": "حوت",
            "Please select Your Partner Sign": "براہ کرم اپنے پارٹنر کا نشان منتخب کریں",
            "Please select Your Sign": "براہ کرم اپنا نشان منتخب کریں",
            "Please fill all details !!": "براہ کرم تمام تفصیلات پُر کریں !!",
            "Discover Your Core Numbers That Define You": "اپنے بنیادی نمبر دریافت کریں جو آپ کی تعریف کرتے ہیں",
            "Explore your core numbers like Life Path, Destiny, and Personal Year—complete with strengths, challenges, and meaningful interpretations.": "اپنے بنیادی نمبرز جیسے لائف پاتھ، تقدیر، اور پرسنل ایئر دریافت کریں—مضبوطیوں، چیلنجز، اور معنی خیز وضاحتوں کے ساتھ۔",
            "Get Your Numbers": "اپنے نمبر حاصل کریں",
            "First Name": "پہلا نام",
            "Last Name": "آخری نام",
            "Method": "طریقہ",
            "Chaldean": "کلیدیان",
            "Pythagorean": "فیثاغورث",
            "Strengths": "مضبوطیاں",
            "Challenges": "چیلنجز",
            "Advice": "مشورہ",
            "Get Report": "رپورٹ حاصل کریں",
            "Select Tarot One Card": "ایک ٹارٹ کارڈ منتخب کریں",
            "Select Your Card": "اپنا کارڈ منتخب کریں",
            "Get Another": "دوسرا حاصل کریں",
            "Yes Or No Tarot": "ہاں یا نہیں ٹارٹ",
            "Get instant Yes or No answers to pressing questions.": "فوری ہاں یا نہیں کے جوابات حاصل کریں۔",
            "Daily Tarot": "روزانہ ٹارٹ",
            "Receive daily tarot readings on love, career, and finance.": "محبت، کیریئر، اور مالیات پر روزانہ ٹارٹ ریڈنگ حاصل کریں۔",
            "In-Depth Love Reading": "محبت کی جامع ریڈنگ",
            "Deep dive into your love life with relationship-specific readings.": "رشتوں کی مخصوص ریڈنگز کے ذریعے اپنی محبت کی زندگی کا تفصیلی جائزہ لیں۔",
            "Flirt Love Reading": "فلاڑٹ محبت کی ریڈنگ",
            "Reveal insights into playful and romantic connections.": "دلچسپ اور رومانوی تعلقات کی بصیرت ظاہر کریں۔",
            "Erotic Love Reading": "ایروٹک محبت کی ریڈنگ",
            "Insights into intimate and personal love dynamics.": "قریبی اور ذاتی محبت کی حرکیات کی بصیرت۔",
            "Egyptian Prediction": "مصری پیش گوئی",
            "Access ancient Egyptian insights beyond visible truths.": "قدیم مصری بصیرت تک رسائی حاصل کریں جو ظاہری حقائق سے آگے ہے۔",
            "Ex-Flame Reading": "سابق محبت کی ریڈنگ",
            "Explore the possibilities of rekindling with an ex-partner.": "سابق ساتھی کے ساتھ تعلق دوبارہ شروع کرنے کے امکانات دریافت کریں۔",
            "Made For Each Other Or Not Reading": "ایک دوسرے کے لیے ہیں یا نہیں ریڈنگ",
            "Discover if your relationship has long-term potential.": "دریافت کریں کہ آپ کے رشتے میں طویل مدتی صلاحیت ہے یا نہیں۔",
            "Power Life Reading": "طاقتور زندگی کی ریڈنگ",
            "Take control of your destiny with life-changing tarot readings.": "زندگی بدل دینے والی ٹارٹ ریڈنگز کے ساتھ اپنی تقدیر پر قابو پائیں۔",
            "Know Your Friend Reading": "اپنے دوست کو جانیں ریڈنگ",
            "Understand the true intentions of your friendships.": "اپنے دوستوں کی حقیقی نیت کو سمجھیں۔",
            "Divine Angel Reading": "دیوی فرشتہ ریڈنگ",
            "Connect with divine guidance for clarity and spiritual insight.": "واضح اور روحانی بصیرت کے لیے الہی رہنمائی سے رابطہ کریں۔",
            "Career Daily Reading": "کیریئر روزانہ ریڈنگ",
            "Elevate your career with daily tarot insights to achieve your professional goals.": "اپنے پیشہ ورانہ مقاصد حاصل کرنے کے لیے روزانہ ٹارٹ بصیرت کے ساتھ اپنے کیریئر کو بلند کریں۔",
            "Dream Come True Reading": "خواب پورا ہونے کی ریڈنگ",
            "Gain insights into making your dreams and goals a reality.": "اپنے خواب اور اہداف حقیقت بنانے کے لیے بصیرت حاصل کریں۔",
            "Past Lives Connection Reading": "گزشتہ زندگیوں کا کنکشن ریڈنگ",
            "Explore your journey across time to understand your path ahead.": "اپنے وقت کے سفر کو دریافت کریں تاکہ اپنے آئندہ راستے کو سمجھ سکیں۔",
            "In-Depth Love Tarot provides comprehensive readings to bring clarity to your love life, help you make crucial decisions, and guide you toward understanding your soulmate and future partner.": "ڈیپ ان ڈپتھ لوو ٹارٹ محبت کی زندگی کو واضح کرنے، اہم فیصلے کرنے میں مدد دینے اور آپ کے ہم نفس اور مستقبل کے ساتھی کو سمجھنے کی رہنمائی فراہم کرتا ہے۔",
            "The Flirt Love Tarot Reading provides playful insights into your romantic life. Whether it's a friendship, a new admirer, or a potential soulmate, this reading helps you navigate love with ease.": "فلرٹ لوو ٹارٹ ریڈنگ آپ کی رومانوی زندگی میں دلچسپ بصیرت فراہم کرتی ہے۔ چاہے یہ دوستی ہو، نیا چاہنے والا ہو، یا ممکنہ ہم نفس، یہ ریڈنگ محبت کو آسانی سے سمجھنے میں مدد دیتی ہے۔",
            "This reading reveals insights into passion, love, and sexual chemistry, helping you understand your relationships and uncover hidden fantasies.": "یہ ریڈنگ جوش، محبت، اور جنسی ہم آہنگی کے بارے میں بصیرت فراہم کرتی ہے، آپ کو اپنے رشتوں کو سمجھنے اور چھپی ہوئی فینٹسیز دریافت کرنے میں مدد دیتی ہے۔",
            "Explore your twin flame, current struggles, ancestral roots, and past healing with the ancient wisdom of Egyptian Tarot": "مصری ٹارٹ کی قدیم حکمت کے ساتھ اپنے جڑواں شعلے، موجودہ مشکلات، آبا و اجداد کی جڑیں اور ماضی کی شفا کو دریافت کریں۔",
            "The Ex-Flame Tarot Reading provides clarity on whether to rekindle a past relationship or move on. Explore your ex’s feelings, the potential for a renewed connection, and the impact on your future.": "سابق محبت ٹارٹ ریڈنگ یہ واضح کرتی ہے کہ آیا پچھلا رشتہ دوبارہ شروع کرنا ہے یا آگے بڑھنا ہے۔ اپنے سابق کے جذبات، دوبارہ جڑنے کے امکانات، اور آپ کے مستقبل پر اثرات دریافت کریں۔",
            "This Tarot reading reveals whether your relationship is worth the effort, safe to pursue, and aligned with your life goals. Understand if you’re truly made for each other or if it’s time to move on.": "یہ ٹارٹ ریڈنگ یہ ظاہر کرتی ہے کہ آیا آپ کا رشتہ کوشش کے قابل ہے، اس کی پیروی کرنا محفوظ ہے، اور آپ کے زندگی کے مقاصد سے ہم آہنگ ہے۔ سمجھیں کہ آیا آپ واقعی ایک دوسرے کے لیے بنے ہیں یا آگے بڑھنے کا وقت ہے۔",
            "The Power Life Tarot Reading helps you plan your life, overcome struggles, create a clear vision, and take charge of your destiny. Unlock the guidance you need to steer your life towards success.": "پاور لائف ٹارٹ ریڈنگ آپ کو اپنی زندگی کی منصوبہ بندی کرنے، مشکلات پر قابو پانے، واضح وژن بنانے اور اپنی تقدیر کا کنٹرول سنبھالنے میں مدد دیتی ہے۔ اپنی زندگی کو کامیابی کی طرف موڑنے کے لیے رہنمائی حاصل کریں۔",
            "Divine Angel Tarot connects you with your guardian angels, offering guidance to overcome challenges and find peace in love, freedom, and resolution.": "ڈائیوائن اینجل ٹارٹ آپ کو آپ کے نگہبان فرشتوں سے جوڑتا ہے، مشکلات پر قابو پانے اور محبت، آزادی، اور حل میں سکون تلاش کرنے کے لیے رہنمائی فراہم کرتا ہے۔",
            "Career Daily Tarot offers insights to manage your workday, from handling your boss to staying proactive and managing tasks effectively. Let the Tarot guide you to a successful and stress-free day.": "کیریئر ڈیلے ٹارٹ آپ کے کام کے دن کو سنبھالنے کے لیے بصیرت فراہم کرتا ہے، اپنے باس کو ہینڈل کرنے سے لے کر فعال رہنے اور کام کو مؤثر طریقے سے منظم کرنے تک۔ ٹارٹ کی رہنمائی کے ساتھ کامیاب اور تناؤ سے پاک دن گزاریں۔",
            "The Dream Come True Tarot Reading helps you manifest your deepest wishes and aspirations. Whether it's love, material desires, or unfulfilled dreams, this reading offers clarity and guidance to turn your desires into reality.": "ڈریم کم ٹرو ٹارٹ ریڈنگ آپ کی گہری خواہشات اور آرزوؤں کو حقیقت میں بدلنے میں مدد کرتی ہے۔ چاہے یہ محبت ہو، مادی خواہشات، یا پوری نہ ہونے والی خواب، یہ ریڈنگ وضاحت اور رہنمائی فراہم کرتی ہے۔",
            "Explore your past lives to understand current fears, recurring patterns, and influences. Gain clarity on challenges rooted in your previous incarnations.": "اپنی پچھلی زندگیوں کو دریافت کریں تاکہ موجودہ خوف، بار بار آنے والے نمونے اور اثرات کو سمجھ سکیں۔ اپنی پچھلی زندگیوں کی بنیاد پر چیلنجز کی وضاحت حاصل کریں۔",
            "Select Tarot Three Card": "ٹارٹ تین کارڈ منتخب کریں",
            "Heartbreak Reading": "دل ٹوٹنے کی ریڈنگ",
            "Find guidance and healing for a broken heart.": "ٹوٹے دل کے لیے رہنمائی اور شفا حاصل کریں۔",
            "Wisdom Reading": "حکمت کی ریڈنگ",
            "Balance your energies and find mental peace through wisdom.": "اپنی توانائیوں کو متوازن کریں اور حکمت کے ذریعے ذہنی سکون حاصل کریں۔",
            "Divine Magic Reading": "الہی جادو کی ریڈنگ",
            "Discover mystical insights with magical tarot guidance.": "جادوئی ٹارٹ کی رہنمائی کے ساتھ روحانی بصیرت دریافت کریں۔",
            "Heartbreak Tarot Reading - Find Closure and Guidance": "دل ٹوٹنے کی ٹارٹ ریڈنگ - اختتام اور رہنمائی حاصل کریں",
            "The Heartbreak Tarot Reading offers insight into the cause of your pain and provides advice on how to heal and move forward. This two-card reading delivers clarity and the necessary steps to mend your broken heart.": "دل ٹوٹنے کی ٹارٹ ریڈنگ آپ کے درد کی وجہ کی بصیرت فراہم کرتی ہے اور شفا پانے اور آگے بڑھنے کے مشورے دیتی ہے۔ یہ دو کارڈز کی ریڈنگ آپ کے ٹوٹے دل کو درست کرنے کے لیے وضاحت اور ضروری اقدامات فراہم کرتی ہے۔",
            "Wisdom Tarot - Find Balance with Yin and Yang": "حکمت ٹارٹ - ین اور یان کے ساتھ توازن حاصل کریں",
            "Wisdom Tarot provides guidance by balancing the Yin and Yang energies in your life. Discover clarity, peace, and a path forward with this two-card reading.": "حکمت ٹارٹ آپ کی زندگی میں ین اور یان توانائیوں کے توازن کے ذریعے رہنمائی فراہم کرتا ہے۔ اس دو کارڈ ریڈنگ کے ذریعے وضاحت، سکون اور آگے کا راستہ دریافت کریں۔",
            "Divine Magic Tarot Reading - Discover Cause and Remedy": "الہی جادو ٹارٹ ریڈنگ - وجہ اور حل دریافت کریں",
            "The Divine Magic Tarot Reading offers insights into the root cause of your problems and provides a remedy to guide you toward resolution. With this reading, discover the steps you need to take to transform challenges into solutions.": "الہی جادو ٹارٹ ریڈنگ آپ کے مسائل کی جڑ کی بصیرت فراہم کرتی ہے اور حل کی رہنمائی کے لیے علاج پیش کرتی ہے۔ اس ریڈنگ کے ذریعے ان چیلنجز کو حل میں تبدیل کرنے کے اقدامات دریافت کریں۔",
            "Please pick your cards !!": "براہ کرم اپنے کارڈز منتخب کریں !!",
            "Get Your Reading": "اپنی ریڈنگ حاصل کریں",
            "Select Tarot Two Card": "ٹارٹ دو کارڈ منتخب کریں",
            "Love Triangle Reading": "محبت مثلث ریڈنگ",
            "Get clarity in choosing between multiple romantic interests.": "متعدد رومانوی دلچسپیوں میں انتخاب کرنے میں وضاحت حاصل کریں۔",
            "Past-Present-Future Reading": "ماضی-حال-مستقبل ریڈنگ",
            "Love Triangle Tarot - Discover the Dynamics Between You, Lover 1, and Lover 2": "محبت مثلث ٹارٹ - آپ، محبوب 1، اور محبوب 2 کے درمیان حرکیات دریافت کریں",
            "Love Triangle Tarot provides insights into the relationships and dynamics between you and your two lovers. Understand where you stand, and what each lover brings into your life, and make an informed decision guided by the cards.": "محبت مثلث ٹارٹ آپ اور آپ کے دو محبوبوں کے درمیان رشتوں اور حرکیات کے بارے میں بصیرت فراہم کرتا ہے۔ سمجھیں کہ آپ کہاں کھڑے ہیں، اور ہر محبوب آپ کی زندگی میں کیا لاتا ہے، اور کارڈز کی رہنمائی میں باخبر فیصلہ کریں۔",
            "Zodiac Gift Guru": "زودیک گفٹ گرو",
            "January": "جنوری",
            "February": "فروری",
            "March": "مارچ",
            "April": "اپریل",
            "May": "مئی",
            "June": "جون",
            "July": "جولائی",
            "August": "اگست",
            "September": "ستمبر",
            "October": "اکتوبر",
            "November": "نومبر",
            "December": "دسمبر",
            "Yesterday": "کل",
            "Today": "آج",
            "Tomorrow": "کل",
            "Gift Recommendations": "تحفے کی سفارشات",
            "insight": "بصیرت",
            "Career": "کیریئر",
            "Love": "محبت",
            "Finance": "مالیات",
            "Popularity": "مشہوری",
            "Experience: High to Low": "تجربہ: زیادہ سے کم",
            "Experience: Low to High": "تجربہ: کم سے زیادہ",
            "Orders: High to Low": "آرڈرز: زیادہ سے کم",
            "Orders: Low to High": "آرڈرز: کم سے زیادہ",
            "Price: High to Low": "قیمت: زیادہ سے کم",
            "Price: Low to High": "قیمت: کم سے زیادہ",
            "Rating: High to Low": "درجہ بندی: زیادہ سے کم",
            "Search name...": "نام تلاش کریں...",
            "Online": "آن لائن",
            "Busy": "مصروف",
            "Exp": "تجربہ",
            "yrs": "سال",
            "orders": "آرڈرز",
            "min": "منٹ",
            "Chat Now": "اب چیٹ کریں",
            "Wait": "انتظار کریں",
            "There are no astrologers in this category.": "اس زمرے میں کوئی ماہر نجوم نہیں ہیں۔",
            "Sort": "ترتیب دیں",
            "Filter": "فلٹر",
            "Category": "زمرہ",
            "All": "سب",
            "Sort by": "کے لحاظ سے ترتیب دیں",
            "Skill": "مہارت",
            "Language": "زبان",
            "Reset": "ری سیٹ",
            "Apply": "لاگو کریں",
            "You have 30 seconds left. Please recharge immediately to continue the conversation.": "آپ کے پاس 30 سیکنڈ باقی ہیں۔ براہ کرم گفتگو جاری رکھنے کے لیے فوری طور پر ریچارج کریں۔",
            "Free chat over! Next minutes will use wallet balance.": "مفت چیٹ ختم! اگلے منٹ والیٹ بیلنس استعمال کریں گے۔",
            "Complete": "مکمل کریں",
            "End Chat": "چیٹ ختم کریں",
            "Message": "پیغام",
            "Hi": "ہیلو",
            "lets continue this chat at discounted price of": "آئیے اس چیٹ کو رعایتی قیمت پر جاری رکھیں",
            "Are you sure you want to end tha chat to": "کیا آپ واقعی چیٹ ختم کرنا چاہتے ہیں",
            "No": "نہیں",
            "Yes": "جی ہاں",
            "Chat With Astrologer": "ماہر نجوم سے چیٹ کریں",
            "Appointment List": "اپائنٹمنٹ کی فہرست",
            "My Following": "میری فالوئنگ",
            "Recent Post": "حالیہ پوسٹ",
            "Welcome back": "خوش آمدید",
            "Manage your astrology services": "اپنی نجومی خدمات کا انتظام کریں",
            "Logout": "لاگ آؤٹ",
            "Login": "لاگ ان",
            "My Profile (Member Since)": "میرا پروفائل (رکن از)",
            "My Followings": "میری فالوئنگز",
            "You are following": "آپ فالو کر رہے ہیں",
            "people": "افراد",
            "Years": "سال",
            "No Following Found !!": "کوئی فالوئنگ نہیں ملی !!",
            "Currently you don't have any follow.": "فی الحال آپ کے پاس کوئی فالو نہیں ہے۔",
            "Hey There!": "ہیلو!",
            "What is your name?": "آپ کا نام کیا ہے؟",
            "Enter your first Name": "اپنا پہلا نام درج کریں",
            "Enter your last Name": "اپنا آخری نام درج کریں",
            "male": "مرد",
            "female": "عورت",
            "Where wrer you bron?": "آپ کہاں پیدا ہوئے تھے؟",
            "Please Select Language": "براہ کرم زبان منتخب کریں",
            "english": "انگریزی",
            "hindi": "ہندی",
            "north": "شمال",
            "south": "جنوب",
            "Select Chart Type": "چارٹ کی قسم منتخب کریں",
            "Start chat with astrologer": "ماہر نجوم سے چیٹ شروع کریں",
            "Search location": "مقام تلاش کریں",
            "Location not found !!": "مقام نہیں ملا !!",
            "Enter bord state": "بورڈ ریاست درج کریں",
            "Search location...": "مقام تلاش کریں...",
            "Astrologers": "ماہر نجوم",
            "Top Astrologers. 24 * 7 customer support. Happy to help": "سرفہرست ماہر نجوم۔ 24*7 کسٹمر سپورٹ۔ خوشی سے مدد کریں",
            "per min": "فی منٹ",
            "Top Astrologers": "سرفہرست ماہر نجوم",
            "rate": "درجہ",
            "Top Rated Astrologers": "اعلیٰ درجہ والے ماہر نجوم",
            "No astrologers found !!": "کوئی ماہر نجوم نہیں ملا !!",
            "FAQs": "عمومی سوالات",
            "Raning": "رننگ",
            "Raning Apointment": "رننگ اپائنٹمنٹ",
            "Select Other Sign": "دیگر نشان منتخب کریں",
            "Horoscopes": "علم نجوم",
            "Daily Horoscope": "روزانہ علم نجوم",
            "Weekly Horoscope": "ہفتہ وار علم نجوم",
            "Monthly Horoscope": "ماہانہ علم نجوم",
            "Yearly Horoscope": "سالانہ علم نجوم",
            "Composite Friendship Table": "مرکب دوستی کا جدول",
            "Kp Planetary Details": "کے پی سیاروی تفصیلات",
            "Kp House Cusps And Chart": "کے پی گھر کے سرحد اور چارٹ",
            "Ascendant Report": "آسنڈنٹ رپورٹ",
            "Bhava Kundli": "بھوا کنڈلی",
            "Vimshottari Dasha": "ویمشوٹی دشا",
            "Yogini Dasha": "یوگنی دشا",
            "Sadhesati Analysis": "سادھی ساتی تجزیہ",
            "Sadhesati Life Analysis": "سادھی ساتی زندگی کا تجزیہ",
            "Kalsarpa Dosha": "کل سرپا دوشا",
            "Manglik Analysis": "منگلیک تجزیہ",
            "Planet Profiles": "سیاروں کی پروفائلز",
            "Gemstone Suggestions": "قیمتی پتھروں کی سفارشات",
            "Upagraha": "اوپر گراہ",
            "Jaimini Astrology": "جمینی علم نجوم",
            "Chara Dasha": "چارا دشا",
            "Shadbala": "شادبالا",
            "Sudarshana Chakra": "سدارشنا چکر",
            "Bhinnashtakvarga": "بھِن اشتاک وارگا",
            "Yogas": "یوگ",
            "Introduction": "تعارف",
            "Basic Astrological Details": "بنیادی نجومی تفصیلات",
            "Planetary Positions": "سیاروی پوزیشنز",
            "Horoscope Charts": "علم نجوم کے چارٹس",
            "House Cusps And Sandhi": "گھر کے سرحد اور سنڌی",
            "Divisional Charts": "تقسیمی چارٹس",
            "Basic Details": "بنیادی تفصیلات",
            "Ghat Chakra": "گھاٹ چکر",
            "Panchange Details": "پنج چن تفصیلات",
            "Astrological Details": "نجومی تفصیلات",
            "Time of Birth": "وقت پیدائش",
            "Place of Birth": "جگہ پیدائش",
            "Latitude": "عرض البلد",
            "Longitude": "طول البلد",
            "Timezone": "ٹائم زون",
            "Ayanamsa": "ایانامسا",
            "Sunrise": "طلوع آفتاب",
            "Sunset": "غروب آفتاب",
            "Month": "مہینہ",
            "Tithi": "تِتھی",
            "Yoga": "یوگا",
            "Karana": "کرن",
            "Moon Sign": "چاند کا نشان",
            "Moon Vaar": "چاند وار",
            "Nakshatra": "نکشترہ",
            "Varna": "ورنا",
            "Vashya": "وشیا",
            "Yoni": "یونی",
            "Gana": "گنا",
            "Nadi": "نڈی",
            "Sun Sign": "سورج کا نشان",
            "Tatva": "تتوا",
            "Paya": "پایا",
            "Yanja": "یانجا",
            "Planets": "سیارے",
            "Sign": "نشان",
            "Sign No": "نشان نمبر",
            "LAGNA CHART (BIRTH CHART)": "لگن چارٹ (چارٹ پیدائش)",
            "MOON CHART": "چاند چارٹ",
            "NAVMANSHA CHART (D9)": "نومانشا چارٹ (D9)",
            "House": "گھر",
            "Bhav Madhya": "بھوا مدھیہ",
            "Bhav Sandhi": "بھوا سنڌی",
            "Chalit Chart": "چالِت چارٹ",
            "Sun Chart": "سورج چارٹ",
            "Health, Constitution, Body": "صحت، مزاج، جسم",
            "Hora Chart(D2)": "ہورا چارٹ(D2)",
            "Finance, Wealth, Prosperity": "مالیات، دولت، خوشحالی",
            "Dreshkan Chart(D3)": "ڈریشکان چارٹ(D3)",
            "Brothers, Sisters": "بھائی، بہنیں",
            "Chathurthamasha Chart(D4)": "چتورتھمیشہ چارٹ(D4)",
            "Fortunes, Luck of native": "قوم کے قسمت، خوش قسمتی",
            "Saptamansha Chart(D7)": "سپتمانشا چارٹ(D7)",
            "Impregnation, Birth of the child": "حمل، بچے کی پیدائش",
            "Dashamansha Chart(D10)": "داشمانشا چارٹ(D10)",
            "livelihood, Profession": "روزگار، پیشہ",
            "Dwadasha Chart(D12)": "دواداشا چارٹ(D12)",
            "Parents, paternal happiness": "والدین، والد کی خوشی",
            "Shodashamsha Chart(D16)": "شوداشمانشا چارٹ(D16)",
            "Happiness, miseries, conveyance": "خوشی، مصائب، آمد و رفت",
            "Vishamansha Chart(D20)": "وشامانشا چارٹ(D20)",
            "Spiritual progress, worship": "روحانی ترقی، عبادت",
            "Chaturvimshamsha(D24)": "چتوروم وشامشا(D24)",
            "Academic achievement, education": "تعلیمی کامیابی، تعلیم",
            "Bhamsha Chart(D27)": "بھامشا چارٹ(D27)",
            "Physical strength, stamina": "جسمانی طاقت، برداشت",
            "Trishamansha Chart(D30)": "تریشمانشا چارٹ(D30)",
            "Evil, Adversities of life": "شیطانی اثرات، زندگی کی مشکلات",
            "Khavedamsha Chart(D40)": "خواودامشا چارٹ(D40)",
            "Auspicious & inauspicious effect": "مبارک اور نامبارک اثرات",
            "Akshvedansha Chart(D45)": "اکش ویدانشا چارٹ(D45)",
            "Character and couduct of the native": "قوم کی شخصیت اور رویہ",
            "Shashtymsah Chart(D60)": "ششتمشا چارٹ(D60)",
            "Shows general happiness": "عمومی خوشی دکھاتا ہے",
            "Degrees": "ڈگریز",
            "Sign Lord": "نشان کا خداوند",
            "Nakshatra Lord": "نکشترہ کا خداوند",
            "Sub Lord": "ذیلی خداوند",
            "Sub Sub Lord": "ذیلی ذیلی خداوند",
            "Lord": "خداوند",
            "Symbol": "علامت",
            "Characteristics": "خصوصیات",
            "Day of Fast": "روزہ کا دن",
            "luchy Gems": "مبارک جواہرات",
            "Personality": "شخصیت",
            "Health": "صحت",
            "Relationships": "رشتے",
            "BHAVA KUNDLI": "بھوا کنڈلی",
            "Bhramari": "بھرامری",
            "Bhadrika": "بھادریکا",
            "Ulka": "الکا",
            "Siddha": "سدھا",
            "Sankata": "سنکات",
            "Mangala": "منگلا",
            "Pingala": "پنگلا",
            "Dhanya": "دھانیا",
            "Remedies Of Sadhesati": "سادھی ساتی کے علاج",
            "Saturn Sign": "شنی کا نشان",
            "Is Saturn Retro?": "کیا شنی ریٹرو ہے؟",
            "Phase": "مرحلہ",
            "Intensity": "شدت",
            "Direction": "سمت",
            "Strength": "طاقت",
            "Percentage": "فیصد",
            "Zodiac Sign": "برج کا نشان",
            "Planet Degree": "سیارے کی ڈگری",
            "Lord Of": "خداوند",
            "Combust/Aw...": "جلنا / آگ...",
            "Lucky Stone": "مبارک پتھر",
            "Life Stone": "زندگی کا پتھر",
            "Finger": "انگلی",
            "Day": "دن",
            "Time to Wear": "پہننے کا وقت",
            "Mantra": "منا",
            "Upagraha Longitude": "اوپر گراہ طول البلد",
            "Rashi": "راشی",
            "Pada": "پادہ",
            "Upagraha/Nakshatra/Sub Lord": "اوپر گراہ / نشسترہ / ذیلی خداوند",
            "Jamini Planets": "جمینی سیارے",
            "Jamini Padas": "جمینی پاڈا",
            "Code": "کوڈ",
            "Jamini Karakara": "جمینی کردار",
            "Uchcha Bala": "اُچھا بالا",
            "Saptavarga Bala": "سپتو وارگا بالا",
            "Yugmayugma Bhamsha Bala": "یوگ مایوگما بھامشا بالا",
            "Kendradi Bala": "کندری بالا",
            "Drekkana Bala": "ڈریکانہ بالا",
            "Total Sthana Bala": "کل ستھانا بالا",
            "Total Dig Bala": "کل ڈِگ بالا",
            "Nattunnata Bala": "ناتننتا بالا",
            "Paksha Bala": "پاکشا بالا",
            "Tribhaga Bala": "تریبھاگا بالا",
            "Varshadhipati": "وارشادھیپتی",
            "Maasadipati": "ماسادیپتی",
            "Vaaradhipati": "وارادھیپتی",
            "Horadhipati": "ہورادھیپتی",
            "Ayana Bala": "ایانا بالا",
            "Yuddha Bala": "یودھا بالا",
            "Total Kaal Bala": "کل کال بالا",
            "Naisargika Bala": "نیسارگیکا بالا",
            "Chestha Bala": "چیشتھا بالا",
            "Drik Bala": "ڈریک بالا",
            "Total Shadbala": "کل شادبالا",
            "Shadbala In Rupa": "شادبالا روپ میں",
            "Min Require": "کم از کم ضرورت",
            "Ratio": "تناسب",
            "Rank": "درجہ",
            "Sun": "سورج",
            "Moon": "چاند",
            "Mars": "مریخ",
            "Mercury": "عطارد",
            "Jupiter": "مشتری",
            "Venus": "زہرہ",
            "Saturn": "شنی",
            "Ashtakvarga": "اشتاکوارگا",
            "Sarvashtakava": "سرو اشتاکاوا",
            "Prasthara Chakra": "پراستھرا چکر",
            "Ascendant": "آسنڈنٹ",
            "Total": "کل",
            "Natural Friendship": "قدرتی دوستی",
            "Temporary Friendship": "عارضی دوستی",
            "Five Fold Friendship": "پانچ گنا دوستی",
            "Ketu": "کیتو",
            "Rahu": "راہو",
            "Vimshottari Dasha P1": "ویمشوٹی دشا P1",
            "Vimshottari Dasha P2": "ویمشوٹی دشا P2",
            "AshtaKoot": "اشتاکوٹ",
            "Bhakut Dosha": "بھاکوٹ دوشا",
            "Nadi Dosha": "نڈی دوشا",
            "Ashtakoot Analysis": "اشتاکوٹ تجزیہ",
            "DashaKoot": "دشا کوٹ",
            "Personality Report": "شخصیت کی رپورٹ",
            "Match Making Report": "میچ میکنگ رپورٹ",
            "Nav Pancham Yoga": "نو پانچم یوگا",
            "Charan": "چرن",
            "Name Alphabet": "نام کا حرف",
            "Planetary Position": "سیاروی پوزیشن",
            "Lagna Chart (Birth Chart)": "لگن چارٹ (چارٹ پیدائش)",
            "Moon Chart": "چاند چارٹ",
            "Navmansha Chart (D9)": "نومانشا چارٹ (D9)",
            "Mahadasha": "مہادشا",
            "End": "اختتام",
            "Is Recommended ??": "کیا سفارش کی جاتی ہے؟",
            "Manglik Details": "منگلیک تفصیلات",
            "What is AshtaKoot ??": "اشتاکوٹ کیا ہے؟",
            "Attributes": "خصوصیات",
            "Description": "تفصیل",
            "Received": "موصول شدہ",
            "Graha Maitri": "گراہا مائتری",
            "Bhakoota": "بھاکوٹا",
            "What is BhaKoot Dosha ??": "بھاکوٹ دوشا کیا ہے؟",
            "What is Nadi Dosha ??": "نڈی دوشا کیا ہے؟",
            "Madhya": "مدھیہ",
            "Nadi dosha is present": "نڈی دوشا موجود ہے",
            "The": "یہ",
            "porutham considered for horoscope matching are as follows :": "ہم آسمانی میچنگ کے لیے غور کیے جانے والے پوروتھم درج ذیل ہیں:",
            "Dina": "دینا",
            "Rajju": "راجو",
            "Rasyadhipati": "راشی ادھیپتی",
            "Vedha": "ودھا",
            "Mahendra": "مہندر",
            "Streedargha": "ستری درگھا",
            "Uranus": "یورینس",
            "Neptune": "نیپچون",
            "Pluto": "پلوٹو",
            "Tara": "تارا",
            "Please fill boy's details !!": "براہ کرم لڑکے کی تفصیلات درج کریں!!",
            "Please fill girl's details !!": "براہ کرم لڑکی کی تفصیلات درج کریں!!",
            "Please fill chart details !!": "براہ کرم چارٹ کی تفصیلات درج کریں!!",
            "Kundli Matching": "کنڈلی میچنگ",
            "Find your right one, through matchmaking": "میچ میکنگ کے ذریعے اپنا صحیح ساتھی تلاش کریں",
            "Open Kundli": "کنڈلی کھولیں",
            "New Matching": "نیا میچنگ",
            "View Kundli": "کنڈلی دیکھیں",
            "Boy's Details": "لڑکے کی تفصیلات",
            "Girl's Details": "لڑکی کی تفصیلات",
            "Search city, state, country": "شہر، ریاست، ملک تلاش کریں",
            "Enter first name": "پہلا نام درج کریں",
            "Enter last name": "آخری نام درج کریں",
            "Chart Style": "چارٹ اسٹائل",
            "North Indian": "شمالی بھارتی",
            "South Indian": "جنوبی بھارتی",
            "English": "انگریزی",
            "Hindi": "ہندی",
            "MATCH HOROSCOPE": "حوروشکوپ میچ کریں",
            "My Profile": "میرا پروفائل",
            "Enter full name": "پورا نام درج کریں",
            "Enter email address": "ای میل ایڈریس درج کریں",
            "Enter password": "پاس ورڈ درج کریں",
            "Enter phone number": "فون نمبر درج کریں",
            "Save Chanage": "تبدیلی محفوظ کریں",
            "Manage your astrologers recent post": "اپنے ماہر فلکیات کی حالیہ پوسٹس کا انتظام کریں",
            "Show Less": "کم دکھائیں",
            "Show More": "مزید دکھائیں",
            "Total Balance": "کل بیلنس",
            "Add Money": "رقم شامل کریں",
            "Extra": "اضافی",
            "Transaction History": "ٹرانزیکشن ہسٹری",
            "Build better products with flexible tools, helpful documentation,": "لچکدار ٹولز اور مددگار دستاویزات کے ساتھ بہتر مصنوعات بنائیں،",
            "and a team that champions your growth.": "اور ایک ٹیم جو آپ کی ترقی کی سرپرستی کرتی ہے۔",
            "Useful Link": "مفید لنک",
            "Socials": "سوشل میڈیا",
            "Logout Seccuessfuly !!": "کامیابی کے ساتھ لاگ آؤٹ!!",
            "Free Kundli": "مفت کنڈلی",
            "Horoscope": "حوروشکوپ",
            "Dashboard": "ڈیش بورڈ",
            "Enter your feedback !!": "اپنی رائے درج کریں!!",
            "Languages": "زبانیں",
            "incoming": "آنے والی",
            "request from": "درخواست سے",
            "Waitlist Joined !!": "ویٹ لسٹ میں شامل!!",
            "will start in": "شروع ہوگا",
            "You will receive a": "آپ کو موصول ہوگا",
            "request when the": "درخواست جب",
            "astrologer is ready. Don’t worry! You will not be": "ماہر فلکیات تیار ہو۔ فکر نہ کریں! آپ نہیں ہوں گے",
            "charged for missing this session.": "اس سیشن سے غیر حاضری پر چارج کیا جائے گا۔",
            "Accept": "قبول کریں",
            "Reject": "رد کریں",
            "Great, what did you like the mast? 😍": "زبردست! آپ کو سب سے زیادہ کیا پسند آیا؟ 😍",
            "Skip": "چھوڑ دیں",
            "Payment Information": "ادائیگی کی معلومات",
            "Amount": "رقم",
            "Tax": "ٹیکس",
            "Payment": "ادائیگی",
            "Payment Method": "ادائیگی کا طریقہ",
        
            "AstroSpace": "AstroSpace",
            "Astrology Consultation Platform": "Astrology Consultation Platform",
            "INVOICE": "INVOICE",
            "Consultation Service Receipt": "Consultation Service Receipt",
            "Invoice Number": "Invoice Number",
            "Date Issued": "Date Issued",
            "PAID": "PAID",
            "From": "From",
            "Bill To": "Bill To",
            "Service": "Service",
            "Booking ID": "Booking ID",
            "Description": "Description",
            "Duration": "Duration",
            "Rate": "Rate",
            "Amount": "Amount",
            "Free Consultation Time": "Free Consultation Time",
            "Complimentary session minutes": "Complimentary session minutes",
            "Free": "Free",
            "Consultation Fee": "Consultation Fee",
            "Standard rate (first block)": "Standard rate (first block)",
            "Extended Consultation Fee": "Extended Consultation Fee",
            "Premium rate (extended block)": "Premium rate (extended block)",
            "Consultation Service": "Consultation Service",
            "Astrology consultation session": "Astrology consultation session",
            "Subtotal": "Subtotal",
            "Platform Fee": "Platform Fee",
            "Included": "Included",
            "Total Amount": "Total Amount",
            "DOB": "DOB",
            "Kundali Chart Used": "Kundali Chart Used",
            "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.": "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.",
            "For support, contact us at support@astrospace.com": "For support, contact us at support@astrospace.com",
            "Free Minute": "Free Minute",
            "Verified": "Verified",
            "End Session": "End Session",
            "Voice Call": "Voice Call",
            "typing...": "typing...",
            "CANCEL": "CANCEL",
            "OK": "OK",
            "Install Progressive Web Application": "Install Progressive Web Application",
            "This site has app functionality. Install it on your device for extensive experience and easy access.": "This site has app functionality. Install it on your device for extensive experience and easy access.",
            "Install": "Install",
            "Search location": "Search location",
            "Location not found !!": "Location not found !!",
            "Waiting for remote user to join...": "Waiting for remote user to join...",
            "End Video Session": "End Video Session",
            "Initializing WebRTC P2P...": "Initializing WebRTC P2P...",
            "Access Denied (Camera/Mic)": "Access Denied (Camera/Mic)",
            "Connection Failed": "Connection Failed",
            "Time Remaining": "Time Remaining",
            "Call ended": "Call ended",

            "Offline": "Offline",}
    },
    in: {
        translation: {
            "Enter Mobile Number !!": "Masukkan Nomor Ponsel !!",
            "In Valid OTP !!": "OTP Tidak Valid !!",
            "Please enter password !!": "Silakan masukkan kata sandi !!",
            "Password not match !!": "Kata sandi tidak cocok !!",
            "Reset Password": "Setel Ulang Kata Sandi",
            "Enter your phone number and new password": "Masukkan nomor ponsel dan kata sandi baru Anda",
            "Phone Number": "Nomor Ponsel",
            "Enter your number": "Masukkan nomor Anda",
            "Search": "Cari",
            "Verify": "Verifikasi",
            "You will receive a 6 digit code for": "Anda akan menerima kode 6 digit untuk",
            "verification to": "verifikasi ke",
            "Submit": "Kirim",
            "Enter your password and new password": "Masukkan kata sandi dan kata sandi baru Anda",
            "New Password": "Kata Sandi Baru",
            "Enter new password": "Masukkan kata sandi baru",
            "Confirm New Password": "Konfirmasi Kata Sandi Baru",
            "Confirm new password": "Konfirmasi kata sandi baru",
            "Back to Login": "Kembali ke Login",
            "Back": "Kembali",
            "Enter Login Details !!": "Masukkan Detail Login !!",
            "Welcome Back!": "Selamat Datang Kembali!",
            "Sign in to your account": "Masuk ke akun Anda",
            "Password": "Kata Sandi",
            "Enter your password": "Masukkan kata sandi Anda",
            "Forgot Password?": "Lupa Kata Sandi?",
            "Sign In": "Masuk",
            "Don't have an account?": "Belum punya akun?",
            "Sign Up": "Daftar",
            "Please enter all details !!": "Silakan masukkan semua detail !!",
            "Please enter valid email !!": "Silakan masukkan email yang valid !!",
            "Please enter birth place !!": "Silakan masukkan tempat lahir !!",
            "Please select language !!": "Silakan pilih bahasa !!",
            "Step": "Langkah",
            "Enter Your Details": "Masukkan Detail Anda",
            "Hey there! what is your name?": "Hai! Siapa nama Anda?",
            "Full Name": "Nama Lengkap",
            "Email Address": "Alamat Email",
            "Enter your Full Name": "Masukkan Nama Lengkap Anda",
            "Enter your email": "Masukkan email Anda",
            "What is your gender?": "Apa jenis kelamin Anda?",
            "Male": "Pria",
            "Female": "Wanita",
            "Enter your birth date": "Masukkan tanggal lahir Anda",
            "Enter your birth time": "Masukkan waktu lahir Anda",
            "Enter your birth Place": "Masukkan tempat lahir Anda",
            "Do you know which languages?": "Bahasa apa yang Anda ketahui?",
            "Enter Your Place": "Masukkan Tempat Anda",
            "Back to Step": "Kembali ke Langkah",
            "Next": "Berikutnya",
            "My Appointments": "Janji Saya",
            "Manage your astrology consultations": "Kelola konsultasi astrologi Anda",
            "Upcoming": "Akan Datang",
            "Past": "Sebelumnya",
            "Pending": "Menunggu",
            "Accepted": "Diterima",
            "Start": "Mulai",
            "Completed": "Selesai",
            "Canceled": "Dibatalkan",
            "ID": "ID",
            "Chat": "Obrolan",
            "Audio Call": "Panggilan Audio",
            "Video Call": "Panggilan Video",
            "View Details": "Lihat Detail",
            "Cancel": "Batal",
            "No Upcoming Appointment Found !!": "Tidak ada Janji yang Akan Datang !!",
            "Currently you don't have any upcoming appointment.": "Saat ini Anda tidak memiliki janji yang akan datang.",
            "No Past Appointment Found !!": "Tidak ada Janji Sebelumnya !!",
            "Currently you don't have any past appointment.": "Saat ini Anda tidak memiliki janji sebelumnya.",
            "Status": "Status",
            "Service Type": "Jenis Layanan",
            "Date": "Tanggal",
            "Time": "Waktu",
            "Price": "Harga",
            "Booked Person Details": "Detail Orang yang Memesan",
            "name": "nama",
            "Date of Birth": "Tanggal Lahir",
            "Birth Place": "Tempat Lahir",
            "Gender": "Jenis Kelamin",
            "Complete Details": "Detail Lengkap",
            "Start Time": "Waktu Mulai",
            "End Time": "Waktu Selesai",
            "Total Duration": "Total Durasi",
            "Billable Time": "Waktu yang Dikenakan Biaya",
            "Billed Fee First": "Biaya Ditagihkan Pertama",
            "Billed Fee After": "Biaya Ditagihkan Setelah",
            "Total Consultation Fee": "Total Biaya Konsultasi",
            "Kundali Details": "Detail Kundali",
            "Name": "Nama",
            "Send Notification": "Kirim Notifikasi",
            "Continue Chat": "Lanjutkan Obrolan",
            "Write message !!": "Tulis pesan !!",
            "Astrologer Ai Assistant": "Asisten AI Astrolog",
            "Ask anything about your horoscope...": "Tanyakan apa saja tentang horoskop Anda...",
            "Write message to assistant": "Tulis pesan ke asisten",
            "Clear Chat?": "Hapus Obrolan?",
            "All messages will be deleted permanently.": "Semua pesan akan dihapus secara permanen.",
            "Clear": "Hapus",
            "Payment faild !!": "Pembayaran gagal !!",
            "Please Complete Last Apointment !!": "Silakan Selesaikan Janji Terakhir !!",
            "Please enter comment !!": "Silakan masukkan komentar !!",
            "Insufficient wallet balance !!": "Saldo dompet tidak mencukupi !!",
            "Orders": "Pesanan",
            "Experience": "Pengalaman",
            "Rating": "Rating",
            "Unfollow": "Berhenti Mengikuti",
            "Follow": "Ikuti",
            "Send Gift": "Kirim Hadiah",
            "Start a Consultation": "Mulai Konsultasi",
            "Chat with astrologer": "Obrolan dengan Astrolog",
            "For new user": "Untuk pengguna baru",
            "min free": "menit gratis",
            "Call with astrologer": "Panggilan dengan Astrolog",
            "Video call with astrologer": "Panggilan Video dengan Astrolog",
            "Astrologer Bio": "Bio Astrolog",
            "Reviews": "Ulasan",
            "Activity": "Aktivitas",
            "FAQ's": "Pertanyaan Umum",
            "Media": "Media",
            "Comment": "Komentar",
            "No comment yet": "Belum ada komentar",
            "start the conversation": "mulai percakapan",
            "Poast your replay": "Kirim balasan Anda",
            "Delete comment": "Hapus komentar",
            "Are you sure you want to delete this comment?": "Apakah Anda yakin ingin menghapus komentar ini?",
            "Cancle": "Batal",
            "Delete": "Hapus",
            "Intro Audio": "Audio Intro",
            "Intro Video": "Video Intro",
            "Hear from": "Dengar dari",
            "Please select user !!": "Silakan pilih pengguna !!",
            "Please select amount !!": "Silakan pilih jumlah !!",
            "Please select payment method !!": "Silakan pilih metode pembayaran !!",
            "Select Kundli": "Pilih Kundli",
            "Add Kundli": "Tambahkan Kundli",
            "Minimum balance of": "Saldo minimum sebesar",
            "minutes": "menit",
            "is required to start chat with": "diperlukan untuk memulai obrolan dengan",
            "Wallet Balance": "Saldo Dompet",
            "Required": "Diperlukan",
            "Proceed to Pay": "Lanjutkan Pembayaran",
            "extra in your": "ekstra di",
            "wallet with this": "dompet dengan ini",
            "Woohoo!": "Asyik!",
            "Recharge Amount": "Jumlah Isi Ulang",
            "GST": "PPN",
            "Wallet Amount": "Jumlah Dompet",
            "Payble Amount": "Jumlah yang Harus Dibayar",
            "Pay from Wallet": "Bayar dari Dompet",
            "Available": "Tersedia",
            "Payment Getway Method": "Metode Gerbang Pembayaran",
            "Continue": "Lanjutkan",
            "Fortune Cookie - Unveil Your Daily Wisdom": "Kue Keberuntungan - Ungkap Kebijaksanaan Harian Anda",
            "Crack open a fortune cookie to reveal a piece of daily wisdom. Let the message guide you through your day with positivity and insight.": "Pecahkan kue keberuntungan untuk menemukan sepotong kebijaksanaan harian. Biarkan pesan ini membimbing hari Anda dengan positif dan wawasan.",
            "Ask The Fortune Cookie": "Tanyakan pada Kue Keberuntungan",
            "Crack open your Fortune Cookie": "Pecahkan Kue Keberuntungan Anda",
            "Crack another one open": "Pecahkan satu lagi",
            "Love Compatibility": "Kecocokan Cinta",
            "Find out how compatible you are with your lover, friend, or colleague using our love compatibility calculator. Get your results now.": "Cari tahu seberapa cocok Anda dengan pasangan, teman, atau rekan kerja menggunakan kalkulator kecocokan cinta kami. Dapatkan hasilnya sekarang.",
            "Are Aries And Taurus Compatible": "Apakah Aries dan Taurus Cocok",
            "Aries And Taurus Strengths": "Kekuatan Aries dan Taurus",
            "Aries And Taurus Weaknesses": "Kelemahan Aries dan Taurus",
            "Aries And Taurus Elements": "Elemen Aries dan Taurus",
            "Aries And Taurus Dates": "Tanggal Aries dan Taurus",
            "Are Aries And Taurus Compatibility Score": "Skor Kecocokan Aries dan Taurus",
            "General": "Umum",
            "Communication": "Komunikasi",
            "Sex": "Hubungan Intim",
            "Select Another": "Pilih Lainnya",
            "Aries": "Aries",
            "Taurus": "Taurus",
            "Gemini": "Gemini",
            "Cancer": "Cancer",
            "Leo": "Leo",
            "Virgo": "Virgo",
            "Libra": "Libra",
            "Scorpio": "Scorpio",
            "Sagittarius": "Sagittarius",
            "Capricorn": "Capricorn",
            "Aquarius": "Aquarius",
            "Pisces": "Pisces",
            "Please select Your Partner Sign": "Silakan pilih tanda pasangan Anda",
            "Please select Your Sign": "Silakan pilih tanda Anda",
            "Please fill all details !!": "Silakan isi semua detail !!",
            "Discover Your Core Numbers That Define You": "Temukan Angka Inti yang Mendifinisikan Anda",
            "Explore your core numbers like Life Path, Destiny, and Personal Year—complete with strengths, challenges, and meaningful interpretations.": "Jelajahi angka inti Anda seperti Jalan Hidup, Takdir, dan Tahun Pribadi—lengkap dengan kekuatan, tantangan, dan interpretasi bermakna.",
            "Get Your Numbers": "Dapatkan Angka Anda",
            "First Name": "Nama Depan",
            "Last Name": "Nama Belakang",
            "Method": "Metode",
            "Chaldean": "Chaldean",
            "Pythagorean": "Pythagorean",
            "Strengths": "Kekuatan",
            "Challenges": "Tantangan",
            "Advice": "Saran",
            "Get Report": "Dapatkan Laporan",
            "Select Tarot One Card": "Pilih Satu Kartu Tarot",
            "Select Your Card": "Pilih Kartu Anda",
            "Get Another": "Ambil Lainnya",
            "Yes Or No Tarot": "Tarot Ya atau Tidak",
            "Get instant Yes or No answers to pressing questions.": "Dapatkan jawaban Ya atau Tidak secara instan untuk pertanyaan penting.",
            "Daily Tarot": "Tarot Harian",
            "Receive daily tarot readings on love, career, and finance.": "Terima pembacaan tarot harian tentang cinta, karier, dan keuangan.",
            "In-Depth Love Reading": "Pembacaan Cinta Mendalam",
            "Deep dive into your love life with relationship-specific readings.": "Selami kehidupan cinta Anda dengan pembacaan khusus hubungan.",
            "Flirt Love Reading": "Pembacaan Cinta Menggoda",
            "Reveal insights into playful and romantic connections.": "Ungkap wawasan tentang hubungan yang penuh permainan dan romantis.",
            "Erotic Love Reading": "Pembacaan Cinta Intim",
            "Insights into intimate and personal love dynamics.": "Wawasan tentang dinamika cinta yang intim dan pribadi.",
            "Egyptian Prediction": "Prediksi Mesir",
            "Access ancient Egyptian insights beyond visible truths.": "Akses wawasan kuno Mesir di luar kebenaran yang terlihat.",
            "Ex-Flame Reading": "Pembacaan Mantan",
            "Explore the possibilities of rekindling with an ex-partner.": "Jelajahi kemungkinan untuk kembali dengan mantan pasangan.",
            "Made For Each Other Or Not Reading": "Pembacaan Cocok atau Tidak",
            "Discover if your relationship has long-term potential.": "Temukan apakah hubungan Anda memiliki potensi jangka panjang.",
            "Power Life Reading": "Pembacaan Kehidupan Berkekuatan",
            "Take control of your destiny with life-changing tarot readings.": "Ambil kendali atas takdir Anda dengan pembacaan tarot yang mengubah hidup.",
            "Know Your Friend Reading": "Pembacaan Kenali Teman Anda",
            "Understand the true intentions of your friendships.": "Pahami niat sebenarnya dari persahabatan Anda.",
            "Divine Angel Reading": "Pembacaan Malaikat Ilahi",
            "Connect with divine guidance for clarity and spiritual insight.": "Terhubung dengan panduan ilahi untuk kejernihan dan wawasan spiritual.",
            "Career Daily Reading": "Pembacaan Karier Harian",
            "Elevate your career with daily tarot insights to achieve your professional goals.": "Tingkatkan karier Anda dengan wawasan tarot harian untuk mencapai tujuan profesional Anda.",
            "Dream Come True Reading": "Pembacaan Impian Terwujud",
            "Gain insights into making your dreams and goals a reality.": "Dapatkan wawasan untuk mewujudkan impian dan tujuan Anda.",
            "Past Lives Connection Reading": "Pembacaan Koneksi Kehidupan Lalu",
            "Explore your journey across time to understand your path ahead.": "Jelajahi perjalanan Anda melintasi waktu untuk memahami jalan ke depan Anda.",
            "Yes or No Tarot - Find Clear and Immediate Answers": "Tarot Ya atau Tidak - Temukan Jawaban Jelas dan Cepat",
            "Daily Tarot - Gain Insights Across Love, Finance, and Career": "Tarot Harian - Dapatkan Wawasan tentang Cinta, Keuangan, dan Karier",
            "In-Depth Love Tarot - Reveal the Realities of Your Relationship": "Tarot Cinta Mendalam - Ungkap Realitas Hubungan Anda",
            "Flirt Love Tarot - Discover Your Romantic Potential": "Tarot Cinta Menggoda - Temukan Potensi Romantis Anda",
            "Erotic Love Tarot - Explore Your Intimate Desires": "Tarot Cinta Intim - Jelajahi Keinginan Intim Anda",
            "Discover the Secrets of Your Soul with Egyptian Tarot": "Temukan Rahasia Jiwa Anda dengan Tarot Mesir",
            "Ex-Flame Tarot - Reignite or Release the Past": "Tarot Mantan - Nyalakan Kembali atau Lepaskan Masa Lalu",
            "Made For Each Other Tarot - Discover True Compatibility": "Tarot Cocok untuk Satu Sama Lain - Temukan Kecocokan Sejati",
            "Power Life Tarot - Take Control of Your Destiny": "Tarot Kehidupan Berkekuatan - Ambil Kendali atas Takdir Anda",
            "Know Your Friend Tarot Reading - Unveil the True Nature of Your Relationships": "Pembacaan Tarot Kenali Teman Anda - Ungkap Sifat Sebenarnya dari Hubungan Anda",
            "Divine Angel Tarot - Receive Angelic Guidance for Clarity and Relief": "Tarot Malaikat Ilahi - Terima Panduan Malaikat untuk Kejernihan dan Ketenangan",
            "Career Daily Tarot Reading - Navigate Your Workday with Confidence": "Pembacaan Tarot Karier Harian - Jalani Hari Kerja Anda dengan Percaya Diri",
            "Explore the Depths of Your Heart's Desires with a Dream Come True Tarot Reading": "Jelajahi Kedalaman Keinginan Hati Anda dengan Pembacaan Tarot Impian Terwujud",
            "Delve into Your Past Lives - Unravel the Enigma of Your Previous Incarnations": "Selami Kehidupan Lalu Anda - Ungkap Misteri Inkarnasi Sebelumnya",
            "The Yes or No Tarot widget offers quick, straightforward answers to your pressing questions, helping you make decisions with confidence in areas like love, finance, and career.": "Widget Tarot Ya atau Tidak menawarkan jawaban cepat dan jelas untuk pertanyaan mendesak Anda, membantu Anda membuat keputusan dengan percaya diri dalam bidang cinta, keuangan, dan karier.",
            "Daily Tarot provides readings that focus on three key areas of your life: Love, Finance, and Career. Discover the guidance you need for each aspect of your day.": "Tarot Harian memberikan pembacaan yang fokus pada tiga area penting dalam hidup Anda: Cinta, Keuangan, dan Karier. Temukan panduan yang Anda butuhkan untuk setiap aspek hari Anda.",
            "In-Depth Love Tarot provides comprehensive readings to bring clarity to your love life, help you make crucial decisions, and guide you toward understanding your soulmate and future partner.": "Tarot Cinta Mendalam memberikan pembacaan menyeluruh untuk menghadirkan kejelasan dalam kehidupan cinta Anda, membantu Anda membuat keputusan penting, dan membimbing Anda memahami belahan jiwa serta pasangan masa depan Anda.",
            "The Flirt Love Tarot Reading provides playful insights into your romantic life. Whether it's a friendship, a new admirer, or a potential soulmate, this reading helps you navigate love with ease.": "Pembacaan Tarot Cinta Menggoda memberikan wawasan bermain-main dalam kehidupan romantis Anda. Baik itu persahabatan, pengagum baru, atau calon belahan jiwa, pembacaan ini membantu Anda menavigasi cinta dengan mudah.",
            "This reading reveals insights into passion, love, and sexual chemistry, helping you understand your relationships and uncover hidden fantasies.": "Pembacaan ini mengungkap wawasan tentang gairah, cinta, dan chemistry seksual, membantu Anda memahami hubungan dan mengungkap fantasi tersembunyi.",
            "Explore your twin flame, current struggles, ancestral roots, and past healing with the ancient wisdom of Egyptian Tarot": "Jelajahi belahan jiwa Anda, tantangan saat ini, akar leluhur, dan penyembuhan masa lalu dengan kebijaksanaan kuno Tarot Mesir",
            "The Ex-Flame Tarot Reading provides clarity on whether to rekindle a past relationship or move on. Explore your ex’s feelings, the potential for a renewed connection, and the impact on your future.": "Pembacaan Tarot Mantan memberikan kejelasan apakah Anda harus menyalakan kembali hubungan masa lalu atau melanjutkan. Jelajahi perasaan mantan Anda, potensi hubungan yang diperbarui, dan dampaknya pada masa depan Anda.",
            "This Tarot reading reveals whether your relationship is worth the effort, safe to pursue, and aligned with your life goals. Understand if you’re truly made for each other or if it’s time to move on.": "Pembacaan Tarot ini mengungkap apakah hubungan Anda layak diperjuangkan, aman untuk dilanjutkan, dan sejalan dengan tujuan hidup Anda. Pahami apakah kalian benar-benar ditakdirkan untuk satu sama lain atau saatnya melanjutkan.",
            "The Power Life Tarot Reading helps you plan your life, overcome struggles, create a clear vision, and take charge of your destiny. Unlock the guidance you need to steer your life towards success.": "Pembacaan Tarot Kehidupan Berkekuatan membantu Anda merencanakan hidup, mengatasi kesulitan, menciptakan visi yang jelas, dan mengendalikan takdir Anda. Dapatkan panduan yang Anda butuhkan untuk mengarahkan hidup menuju kesuksesan.",
            "Divine Angel Tarot connects you with your guardian angels, offering guidance to overcome challenges and find peace in love, freedom, and resolution.": "Tarot Malaikat Ilahi menghubungkan Anda dengan malaikat pelindung, menawarkan panduan untuk mengatasi tantangan dan menemukan kedamaian dalam cinta, kebebasan, dan penyelesaian masalah.",
            "Career Daily Tarot offers insights to manage your workday, from handling your boss to staying proactive and managing tasks effectively. Let the Tarot guide you to a successful and stress-free day.": "Tarot Karier Harian memberikan wawasan untuk mengelola hari kerja Anda, dari menghadapi atasan hingga tetap proaktif dan mengelola tugas secara efektif. Biarkan Tarot membimbing Anda menuju hari yang sukses dan bebas stres.",
            "The Dream Come True Tarot Reading helps you manifest your deepest wishes and aspirations. Whether it's love, material desires, or unfulfilled dreams, this reading offers clarity and guidance to turn your desires into reality.": "Pembacaan Tarot Impian Terwujud membantu mewujudkan keinginan dan aspirasi terdalam Anda. Baik itu cinta, keinginan materi, atau impian yang belum terpenuhi, pembacaan ini menawarkan kejelasan dan panduan untuk mewujudkan keinginan Anda.",
            "Explore your past lives to understand current fears, recurring patterns, and influences. Gain clarity on challenges rooted in your previous incarnations.": "Jelajahi kehidupan masa lalu Anda untuk memahami ketakutan saat ini, pola yang berulang, dan pengaruhnya. Dapatkan kejelasan tentang tantangan yang berakar dari inkarnasi sebelumnya.",
            "Select Tarot Three Card": "Pilih Tiga Kartu Tarot",
            "Heartbreak Reading": "Pembacaan Patah Hati",
            "Find guidance and healing for a broken heart.": "Temukan panduan dan penyembuhan untuk hati yang patah.",
            "Wisdom Reading": "Pembacaan Kebijaksanaan",
            "Balance your energies and find mental peace through wisdom.": "Seimbangkan energi Anda dan temukan ketenangan pikiran melalui kebijaksanaan.",
            "Divine Magic Reading": "Pembacaan Sihir Ilahi",
            "Discover mystical insights with magical tarot guidance.": "Temukan wawasan mistis melalui panduan tarot magis.",
            "Heartbreak Tarot Reading - Find Closure and Guidance": "Pembacaan Tarot Patah Hati - Temukan Penutupan dan Panduan",
            "The Heartbreak Tarot Reading offers insight into the cause of your pain and provides advice on how to heal and move forward. This two-card reading delivers clarity and the necessary steps to mend your broken heart.": "Pembacaan Tarot Patah Hati menawarkan wawasan tentang penyebab rasa sakit Anda dan memberikan saran bagaimana menyembuhkan dan melanjutkan hidup. Pembacaan dua kartu ini memberikan kejelasan dan langkah-langkah yang diperlukan untuk memperbaiki hati Anda yang terluka.",
            "Wisdom Tarot - Find Balance with Yin and Yang": "Tarot Kebijaksanaan - Temukan Keseimbangan Yin dan Yang",
            "Wisdom Tarot provides guidance by balancing the Yin and Yang energies in your life. Discover clarity, peace, and a path forward with this two-card reading.": "Tarot Kebijaksanaan memberikan panduan dengan menyeimbangkan energi Yin dan Yang dalam hidup Anda. Temukan kejelasan, kedamaian, dan jalan ke depan melalui pembacaan dua kartu ini.",
            "Divine Magic Tarot Reading - Discover Cause and Remedy": "Pembacaan Tarot Sihir Ilahi - Temukan Penyebab dan Solusi",
            "The Divine Magic Tarot Reading offers insights into the root cause of your problems and provides a remedy to guide you toward resolution. With this reading, discover the steps you need to take to transform challenges into solutions.": "Pembacaan Tarot Sihir Ilahi memberikan wawasan tentang akar masalah Anda dan menyediakan solusi untuk membimbing Anda menuju penyelesaian. Dengan pembacaan ini, temukan langkah-langkah yang perlu Anda ambil untuk mengubah tantangan menjadi solusi.",
            "Please pick your cards !!": "Silakan pilih kartu Anda !!",
            "Get Your Reading": "Dapatkan Pembacaan Anda",
            "Select Tarot Two Card": "Pilih Dua Kartu Tarot",
            "Love Triangle Reading": "Pembacaan Segitiga Cinta",
            "Get clarity in choosing between multiple romantic interests.": "Dapatkan kejelasan dalam memilih di antara beberapa minat romantis.",
            "Past-Present-Future Reading": "Pembacaan Masa Lalu-Sekarang-Masa Depan",
            "Love Triangle Tarot - Discover the Dynamics Between You, Lover 1, and Lover 2": "Tarot Segitiga Cinta - Temukan Dinamika antara Anda, Pasangan 1, dan Pasangan 2",
            "Love Triangle Tarot provides insights into the relationships and dynamics between you and your two lovers. Understand where you stand, and what each lover brings into your life, and make an informed decision guided by the cards.": "Tarot Segitiga Cinta memberikan wawasan tentang hubungan dan dinamika antara Anda dan dua pasangan Anda. Pahami posisi Anda, apa yang dibawa masing-masing pasangan ke hidup Anda, dan buat keputusan yang tepat berdasarkan panduan kartu.",
            "Zodiac Gift Guru": "Zodiac Gift Guru",
            "January": "Januari",
            "February": "Februari",
            "March": "Maret",
            "April": "April",
            "May": "Mei",
            "June": "Juni",
            "July": "Juli",
            "August": "Agustus",
            "September": "September",
            "October": "Oktober",
            "November": "November",
            "December": "Desember",
            "Yesterday": "Kemarin",
            "Today": "Hari ini",
            "Tomorrow": "Besok",
            "Gift Recommendations": "Rekomendasi Hadiah",
            "insight": "wawasan",
            "Career": "Karier",
            "Love": "Cinta",
            "Finance": "Keuangan",
            "Popularity": "Popularitas",
            "Experience: High to Low": "Pengalaman: Tinggi ke Rendah",
            "Experience: Low to High": "Pengalaman: Rendah ke Tinggi",
            "Orders: High to Low": "Pesanan: Tinggi ke Rendah",
            "Orders: Low to High": "Pesanan: Rendah ke Tinggi",
            "Price: High to Low": "Harga: Tinggi ke Rendah",
            "Price: Low to High": "Harga: Rendah ke Tinggi",
            "Rating: High to Low": "Rating: Tinggi ke Rendah",
            "Search name...": "Cari nama...",
            "Online": "Online",
            "Busy": "Sibuk",
            "Exp": "Pengalaman",
            "yrs": "tahun",
            "orders": "pesanan",
            "min": "menit",
            "Chat Now": "Obrolan Sekarang",
            "Wait": "Tunggu",
            "There are no astrologers in this category.": "Tidak ada astrolog yang tersedia di kategori ini.",
            "Sort": "Urutkan",
            "Filter": "Filter",
            "Category": "Kategori",
            "All": "Semua",
            "Sort by": "Urutkan berdasarkan",
            "Skill": "Keahlian",
            "Language": "Bahasa",
            "Reset": "Reset",
            "Apply": "Terapkan",
            "You have 30 seconds left. Please recharge immediately to continue the conversation.": "Anda memiliki sisa 30 detik. Silakan isi ulang segera untuk melanjutkan percakapan.",
            "Free chat over! Next minutes will use wallet balance.": "Obrolan gratis selesai! Menit berikutnya akan menggunakan saldo dompet.",
            "Complete": "Selesai",
            "End Chat": "Akhiri Obrolan",
            "Message": "Pesan",
            "Hi": "Hai",
            "lets continue this chat at discounted price of": "mari lanjutkan obrolan ini dengan harga diskon sebesar",
            "Are you sure you want to end tha chat to": "Apakah Anda yakin ingin mengakhiri obrolan dengan",
            "No": "Tidak",
            "Yes": "Ya",
            "Chat With Astrologer": "Obrolan dengan Astrolog",
            "Appointment List": "Daftar Janji",
            "My Following": "Daftar Ikutan Saya",
            "Recent Post": "Postingan Terbaru",
            "Welcome back": "Selamat datang kembali",
            "Manage your astrology services": "Kelola layanan astrologi Anda",
            "Logout": "Keluar",
            "Login": "Masuk",
            "My Profile (Member Since)": "Profil Saya (Member Sejak)",
            "My Followings": "Orang yang Saya Ikuti",
            "You are following": "Anda mengikuti",
            "people": "orang",
            "Years": "Tahun",
            "No Following Found !!": "Tidak ada orang yang diikuti !!",
            "Currently you don't have any follow.": "Saat ini Anda tidak mengikuti siapa pun.",
            "Hey There!": "Hai!",
            "What is your name?": "Siapa nama Anda?",
            "Enter your first Name": "Masukkan nama depan Anda",
            "Enter your last Name": "Masukkan nama belakang Anda",
            "male": "laki-laki",
            "female": "perempuan",
            "Where wrer you bron?": "Di mana Anda lahir?",
            "Please Select Language": "Silakan pilih bahasa",
            "english": "Inggris",
            "hindi": "Hindi",
            "north": "Utara",
            "south": "Selatan",
            "Select Chart Type": "Pilih Jenis Bagian",
            "Start chat with astrologer": "Mulai obrolan dengan astrolog",
            "Search location": "Cari lokasi",
            "Location not found !!": "Lokasi tidak ditemukan !!",
            "Enter bord state": "Masukkan negara bagian kelahiran",
            "Search location...": "Cari lokasi...",
            "Astrologers": "Astrolog",
            "Top Astrologers. 24 * 7 customer support. Happy to help": "Astrolog Terbaik. Layanan pelanggan 24/7. Senang membantu",
            "per min": "per menit",
            "Top Astrologers": "Astrolog Terbaik",
            "rate": "peringkat",
            "Top Rated Astrologers": "Astrolog dengan Peringkat Tertinggi",
            "No astrologers found !!": "Tidak ada astrolog yang ditemukan !!",
            "FAQs": "Tanya Jawab",
            "Raning": "Peringkat",
            "Raning Apointment": "Janji Peringkat",
            "Select Other Sign": "Pilih Tanda Lain",
            "Horoscopes": "Ramalan Bintang",
            "Daily Horoscope": "Ramalan Harian",
            "Weekly Horoscope": "Ramalan Mingguan",
            "Monthly Horoscope": "Ramalan Bulanan",
            "Yearly Horoscope": "Ramalan Tahunan",
            "Composite Friendship Table": "Tabel Persahabatan Gabungan",
            "Kp Planetary Details": "Detail Planet KP",
            "Kp House Cusps And Chart": "Cusps Rumah dan Grafik KP",
            "Ascendant Report": "Laporan Ascendant",
            "Bhava Kundli": "Bhava Kundli",
            "Vimshottari Dasha": "Vimshottari Dasha",
            "Yogini Dasha": "Yogini Dasha",
            "Sadhesati Analysis": "Analisis Sadhesati",
            "Sadhesati Life Analysis": "Analisis Kehidupan Sadhesati",
            "Kalsarpa Dosha": "Kalsarpa Dosha",
            "Manglik Analysis": "Analisis Manglik",
            "Planet Profiles": "Profil Planet",
            "Gemstone Suggestions": "Saran Batu Permata",
            "Upagraha": "Upagraha",
            "Jaimini Astrology": "Astrologi Jaimini",
            "Chara Dasha": "Chara Dasha",
            "Shadbala": "Shadbala",
            "Sudarshana Chakra": "Sudarshana Chakra",
            "Bhinnashtakvarga": "Bhinnashtakvarga",
            "Yogas": "Yogas",
            "Introduction": "Pengantar",
            "Basic Astrological Details": "Detail Astrologi Dasar",
            "Planetary Positions": "Posisi Planet",
            "Horoscope Charts": "Grafik Ramalan",
            "House Cusps And Sandhi": "Cusps Rumah dan Sandhi",
            "Divisional Charts": "Grafik Divisi",
            "Basic Details": "Detail Dasar",
            "Ghat Chakra": "Ghat Chakra",
            "Panchange Details": "Detail Panca",
            "Astrological Details": "Detail Astrologi",
            "Time of Birth": "Waktu Lahir",
            "Place of Birth": "Tempat Lahir",
            "Latitude": "Lintang",
            "Longitude": "Bujur",
            "Timezone": "Zona Waktu",
            "Ayanamsa": "Ayanamsa",
            "Sunrise": "Matahari Terbit",
            "Sunset": "Matahari Terbenam",
            "Month": "Bulan",
            "Tithi": "Tithi",
            "Yoga": "Yoga",
            "Karana": "Karana",
            "Moon Sign": "Zodiak Bulan",
            "Moon Vaar": "Hari Bulan",
            "Nakshatra": "Nakshatra",
            "Varna": "Varna",
            "Vashya": "Vashya",
            "Yoni": "Yoni",
            "Gana": "Gana",
            "Nadi": "Nadi",
            "Sun Sign": "Zodiak Matahari",
            "Tatva": "Tatva",
            "Paya": "Paya",
            "Yanja": "Yanja",
            "Planets": "Planet",
            "Sign": "Tanda",
            "Sign No": "Nomor Tanda",
            "LAGNA CHART (BIRTH CHART)": "GRAFIK LAGNA (GRAFIK KELAHIRAN)",
            "MOON CHART": "GRAFIK BULAN",
            "NAVMANSHA CHART (D9)": "GRAFIK NAVMANSHA (D9)",
            "House": "Rumah",
            "Bhav Madhya": "Bhav Madhya",
            "Bhav Sandhi": "Bhav Sandhi",
            "Chalit Chart": "Grafik Chalit",
            "Sun Chart": "Grafik Matahari",
            "Health, Constitution, Body": "Kesehatan, Konstitusi, Tubuh",
            "Hora Chart(D2)": "Grafik Hora (D2)",
            "Finance, Wealth, Prosperity": "Keuangan, Kekayaan, Kemakmuran",
            "Dreshkan Chart(D3)": "Grafik Dreshkan (D3)",
            "Brothers, Sisters": "Saudara Laki-laki, Perempuan",
            "Chathurthamasha Chart(D4)": "Grafik Chathurthamasha (D4)",
            "Fortunes, Luck of native": "Keberuntungan, Nasib",
            "Saptamansha Chart(D7)": "Grafik Saptamansha (D7)",
            "Impregnation, Birth of the child": "Pembuahan, Kelahiran Anak",
            "Dashamansha Chart(D10)": "Grafik Dashamansha (D10)",
            "livelihood, Profession": "Mata pencaharian, Profesi",
            "Dwadasha Chart(D12)": "Grafik Dwadasha (D12)",
            "Parents, paternal happiness": "Orang tua, kebahagiaan ayah",
            "Shodashamsha Chart(D16)": "Grafik Shodashamsha (D16)",
            "Happiness, miseries, conveyance": "Kebahagiaan, kesusahan, perjalanan",
            "Vishamansha Chart(D20)": "Grafik Vishamansha (D20)",
            "Spiritual progress, worship": "Kemajuan spiritual, ibadah",
            "Chaturvimshamsha(D24)": "Chaturvimshamsha (D24)",
            "Academic achievement, education": "Prestasi akademik, pendidikan",
            "Bhamsha Chart(D27)": "Grafik Bhamsha (D27)",
            "Physical strength, stamina": "Kekuatan fisik, daya tahan",
            "Trishamansha Chart(D30)": "Grafik Trishamansha (D30)",
            "Evil, Adversities of life": "Kejelekan, Kesulitan hidup",
            "Khavedamsha Chart(D40)": "Grafik Khavedamsha (D40)",
            "Auspicious & inauspicious effect": "Efek menguntungkan & merugikan",
            "Akshvedansha Chart(D45)": "Grafik Akshvedansha (D45)",
            "Character and couduct of the native": "Karakter dan perilaku",
            "Shashtymsah Chart(D60)": "Grafik Shashtyamsa (D60)",
            "Shows general happiness": "Menunjukkan kebahagiaan umum",
            "Degrees": "Derajat",
            "Sign Lord": "Penguasa Zodiak",
            "Nakshatra Lord": "Penguasa Nakshatra",
            "Sub Lord": "Sub Penguasa",
            "Sub Sub Lord": "Sub Sub Penguasa",
            "Lord": "Penguasa",
            "Symbol": "Simbol",
            "Characteristics": "Karakteristik",
            "Day of Fast": "Hari Puasa",
            "luchy Gems": "Batu Keberuntungan",
            "Personality": "Kepribadian",
            "Health": "Kesehatan",
            "Relationships": "Hubungan",
            "BHAVA KUNDLI": "BHAVA KUNDLI",
            "Bhramari": "Bhramari",
            "Bhadrika": "Bhadrika",
            "Ulka": "Ulka",
            "Siddha": "Siddha",
            "Sankata": "Sankata",
            "Mangala": "Mangala",
            "Pingala": "Pingala",
            "Dhanya": "Dhanya",
            "Remedies Of Sadhesati": "Remedinya Sadhesati",
            "Saturn Sign": "Zodiak Saturnus",
            "Is Saturn Retro?": "Apakah Saturnus Retro?",
            "Phase": "Fase",
            "Intensity": "Intensitas",
            "Direction": "Arah",
            "Strength": "Kekuatan",
            "Percentage": "Persentase",
            "Zodiac Sign": "Tanda Zodiak",
            "Planet Degree": "Derajat Planet",
            "Lord Of": "Penguasa dari",
            "Combust/Aw...": "Terbakar/Aw...",
            "Lucky Stone": "Batu Keberuntungan",
            "Life Stone": "Batu Kehidupan",
            "Finger": "Jari",
            "Day": "Hari",
            "Time to Wear": "Waktu Memakai",
            "Mantra": "Mantra",
            "Upagraha Longitude": "Bujur Upagraha",
            "Rashi": "Rashi",
            "Pada": "Pada",
            "Upagraha/Nakshatra/Sub Lord": "Upagraha/Nakshatra/Sub Penguasa",
            "Jamini Planets": "Planet Jamini",
            "Jamini Padas": "Padas Jamini",
            "Code": "Kode",
            "Jamini Karakara": "Jamini Karakara",
            "Uchcha Bala": "Uchcha Bala",
            "Saptavarga Bala": "Saptavarga Bala",
            "Yugmayugma Bhamsha Bala": "Yugmayugma Bhamsha Bala",
            "Kendradi Bala": "Kendradi Bala",
            "Drekkana Bala": "Drekkana Bala",
            "Total Sthana Bala": "Total Sthana Bala",
            "Total Dig Bala": "Total Dig Bala",
            "Nattunnata Bala": "Nattunnata Bala",
            "Paksha Bala": "Paksha Bala",
            "Tribhaga Bala": "Tribhaga Bala",
            "Varshadhipati": "Varshadhipati",
            "Maasadipati": "Maasadipati",
            "Vaaradhipati": "Vaaradhipati",
            "Horadhipati": "Horadhipati",
            "Ayana Bala": "Ayana Bala",
            "Yuddha Bala": "Yuddha Bala",
            "Total Kaal Bala": "Total Kaal Bala",
            "Naisargika Bala": "Naisargika Bala",
            "Chestha Bala": "Chestha Bala",
            "Drik Bala": "Drik Bala",
            "Total Shadbala": "Total Shadbala",
            "Shadbala In Rupa": "Shadbala Dalam Rupa",
            "Min Require": "Minimal Diperlukan",
            "Ratio": "Rasio",
            "Rank": "Peringkat",
            "Sun": "Matahari",
            "Moon": "Bulan",
            "Mars": "Mars",
            "Mercury": "Merkurius",
            "Jupiter": "Yupiter",
            "Venus": "Venus",
            "Saturn": "Saturnus",
            "Ashtakvarga": "Ashtakvarga",
            "Sarvashtakava": "Sarvashtakava",
            "Prasthara Chakra": "Prasthara Chakra",
            "Ascendant": "Ascendant",
            "Total": "Total",
            "Natural Friendship": "Persahabatan Alami",
            "Temporary Friendship": "Persahabatan Sementara",
            "Five Fold Friendship": "Persahabatan Lima Kali Lipat",
            "Ketu": "Ketu",
            "Rahu": "Rahu",
            "Vimshottari Dasha P1": "Vimshottari Dasha P1",
            "Vimshottari Dasha P2": "Vimshottari Dasha P2",
            "AshtaKoot": "AshtaKoot",
            "Bhakut Dosha": "Bhakut Dosha",
            "Nadi Dosha": "Nadi Dosha",
            "Ashtakoot Analysis": "Analisis Ashtakoot",
            "DashaKoot": "DashaKoot",
            "Personality Report": "Laporan Kepribadian",
            "Match Making Report": "Laporan Kecocokan",
            "Nav Pancham Yoga": "Nav Pancham Yoga",
            "Charan": "Charan",
            "Name Alphabet": "Huruf Nama",
            "Planetary Position": "Posisi Planet",
            "Lagna Chart (Birth Chart)": "Grafik Lagna (Grafik Kelahiran)",
            "Moon Chart": "Grafik Bulan",
            "Navmansha Chart (D9)": "Grafik Navmansha (D9)",
            "Mahadasha": "Mahadasha",
            "End": "Akhir",
            "Is Recommended ??": "Apakah Disarankan ??",
            "Manglik Details": "Detail Manglik",
            "What is AshtaKoot ??": "Apa itu AshtaKoot ??",
            "Attributes": "Atribut",
            "Description": "Deskripsi",
            "Received": "Diterima",
            "Graha Maitri": "Graha Maitri",
            "Bhakoota": "Bhakoota",
            "What is BhaKoot Dosha ??": "Apa itu BhaKoot Dosha ??",
            "What is Nadi Dosha ??": "Apa itu Nadi Dosha ??",
            "Madhya": "Madhya",
            "Nadi dosha is present": "Nadi Dosha ada",
            "The": "The",
            "porutham considered for horoscope matching are as follows :": "Porutham yang dipertimbangkan untuk kecocokan horoskop adalah sebagai berikut:",
            "Dina": "Dina",
            "Rajju": "Rajju",
            "Rasyadhipati": "Rasyadhipati",
            "Vedha": "Vedha",
            "Mahendra": "Mahendra",
            "Streedargha": "Streedargha",
            "Uranus": "Uranus",
            "Neptune": "Neptunus",
            "Pluto": "Pluto",
            "Tara": "Tara",
            "Please fill boy's details !!": "Silakan isi data anak laki-laki !!",
            "Please fill girl's details !!": "Silakan isi data anak perempuan !!",
            "Please fill chart details !!": "Silakan isi detail grafik !!",
            "Kundli Matching": "Kecocokan Kundli",
            "Find your right one, through matchmaking": "Temukan pasangan yang tepat melalui kecocokan horoskop",
            "Open Kundli": "Buka Kundli",
            "New Matching": "Kecocokan Baru",
            "View Kundli": "Lihat Kundli",
            "Boy's Details": "Data Anak Laki-laki",
            "Girl's Details": "Data Anak Perempuan",
            "Search city, state, country": "Cari kota, provinsi, negara",
            "Enter first name": "Masukkan nama depan",
            "Enter last name": "Masukkan nama belakang",
            "Chart Style": "Gaya Grafik",
            "North Indian": "India Utara",
            "South Indian": "India Selatan",
            "English": "Bahasa Inggris",
            "Hindi": "Bahasa Hindi",
            "MATCH HOROSCOPE": "COCOKKAN HOROSKOP",
            "My Profile": "Profil Saya",
            "Enter full name": "Masukkan nama lengkap",
            "Enter email address": "Masukkan alamat email",
            "Enter password": "Masukkan kata sandi",
            "Enter phone number": "Masukkan nomor telepon",
            "Save Chanage": "Simpan Perubahan",
            "Manage your astrologers recent post": "Kelola postingan terbaru astrolog Anda",
            "Show Less": "Tampilkan Lebih Sedikit",
            "Show More": "Tampilkan Lebih Banyak",
            "Total Balance": "Saldo Total",
            "Add Money": "Tambahkan Uang",
            "Extra": "Tambahan",
            "Transaction History": "Riwayat Transaksi",
            "Build better products with flexible tools, helpful documentation,": "Bangun produk yang lebih baik dengan alat fleksibel dan dokumentasi yang membantu,",
            "and a team that champions your growth.": "dan tim yang mendukung pertumbuhan Anda.",
            "Useful Link": "Tautan Berguna",
            "Socials": "Media Sosial",
            "Logout Seccuessfuly !!": "Logout Berhasil !!",
            "Free Kundli": "Kundli Gratis",
            "Horoscope": "Horoskop",
            "Dashboard": "Dasbor",
            "Enter your feedback !!": "Masukkan masukan Anda !!",
            "Languages": "Bahasa",
            "incoming": "masuk",
            "request from": "permintaan dari",
            "Waitlist Joined !!": "Daftar tunggu bergabung !!",
            "will start in": "akan dimulai dalam",
            "You will receive a": "Anda akan menerima",
            "request when the": "permintaan ketika",
            "astrologer is ready. Don’t worry! You will not be": "astrolog siap. Jangan khawatir! Anda tidak akan",
            "charged for missing this session.": "dikenakan biaya karena melewatkan sesi ini.",
            "Accept": "Terima",
            "Reject": "Tolak",
            "Great, what did you like the mast? 😍": "Hebat, apa yang paling Anda sukai? 😍",
            "Skip": "Lewati",
            "Payment Information": "Informasi Pembayaran",
            "Amount": "Jumlah",
            "Tax": "Pajak",
            "Payment": "Pembayaran",
            "Payment Method": "Metode Pembayaran",
        
            "AstroSpace": "AstroSpace",
            "Astrology Consultation Platform": "Astrology Consultation Platform",
            "INVOICE": "INVOICE",
            "Consultation Service Receipt": "Consultation Service Receipt",
            "Invoice Number": "Invoice Number",
            "Date Issued": "Date Issued",
            "PAID": "PAID",
            "From": "From",
            "Bill To": "Bill To",
            "Service": "Service",
            "Booking ID": "Booking ID",
            "Description": "Description",
            "Duration": "Duration",
            "Rate": "Rate",
            "Amount": "Amount",
            "Free Consultation Time": "Free Consultation Time",
            "Complimentary session minutes": "Complimentary session minutes",
            "Free": "Free",
            "Consultation Fee": "Consultation Fee",
            "Standard rate (first block)": "Standard rate (first block)",
            "Extended Consultation Fee": "Extended Consultation Fee",
            "Premium rate (extended block)": "Premium rate (extended block)",
            "Consultation Service": "Consultation Service",
            "Astrology consultation session": "Astrology consultation session",
            "Subtotal": "Subtotal",
            "Platform Fee": "Platform Fee",
            "Included": "Included",
            "Total Amount": "Total Amount",
            "DOB": "DOB",
            "Kundali Chart Used": "Kundali Chart Used",
            "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.": "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.",
            "For support, contact us at support@astrospace.com": "For support, contact us at support@astrospace.com",
            "Free Minute": "Free Minute",
            "Verified": "Verified",
            "End Session": "End Session",
            "Voice Call": "Voice Call",
            "typing...": "typing...",
            "CANCEL": "CANCEL",
            "OK": "OK",
            "Install Progressive Web Application": "Install Progressive Web Application",
            "This site has app functionality. Install it on your device for extensive experience and easy access.": "This site has app functionality. Install it on your device for extensive experience and easy access.",
            "Install": "Install",
            "Search location": "Search location",
            "Location not found !!": "Location not found !!",
            "Waiting for remote user to join...": "Waiting for remote user to join...",
            "End Video Session": "End Video Session",
            "Initializing WebRTC P2P...": "Initializing WebRTC P2P...",
            "Access Denied (Camera/Mic)": "Access Denied (Camera/Mic)",
            "Connection Failed": "Connection Failed",
            "Time Remaining": "Time Remaining",
            "Call ended": "Call ended",

            "Offline": "Offline",}
    },
    mr: {
        translation: {
            "Enter Mobile Number !!": "मोबाईल नंबर टाका !!",
            "In Valid OTP !!": "अवैध OTP !!",
            "Please enter password !!": "कृपया पासवर्ड टाका !!",
            "Password not match !!": "पासवर्ड जुळत नाही !!",
            "Reset Password": "पासवर्ड रीसेट करा",
            "Enter your phone number and new password": "आपला फोन नंबर आणि नवीन पासवर्ड टाका",
            "Phone Number": "फोन नंबर",
            "Enter your number": "आपला नंबर टाका",
            "Search": "शोधा",
            "Verify": "तपासा",
            "You will receive a 6 digit code for": "आपणास ६ अंकी कोड मिळेल",
            "verification to": "सत्यापनासाठी",
            "Submit": "सबमिट करा",
            "Enter your password and new password": "आपला पासवर्ड आणि नवीन पासवर्ड टाका",
            "New Password": "नवीन पासवर्ड",
            "Enter new password": "नवीन पासवर्ड टाका",
            "Confirm New Password": "नवीन पासवर्ड पुष्टी करा",
            "Confirm new password": "नवीन पासवर्ड पुष्टी करा",
            "Back to Login": "लॉगिनकडे परत जा",
            "Back": "मागे",
            "Enter Login Details !!": "लॉगिन तपशील भरा !!",
            "Welcome Back!": "पुन्हा स्वागत आहे!",
            "Sign in to your account": "आपल्या खात्यात साइन इन करा",
            "Password": "पासवर्ड",
            "Enter your password": "आपला पासवर्ड टाका",
            "Forgot Password?": "पासवर्ड विसरलात?",
            "Sign In": "साइन इन करा",
            "Don't have an account?": "खाते नाही का?",
            "Sign Up": "नोंदणी करा",
            "Please enter all details !!": "कृपया सर्व तपशील भरा !!",
            "Please enter valid email !!": "कृपया वैध ईमेल टाका !!",
            "Please enter birth place !!": "जन्मस्थान टाका !!",
            "Please select language !!": "कृपया भाषा निवडा !!",
            "Step": "पायरी",
            "Enter Your Details": "आपले तपशील भरा",
            "Hey there! what is your name?": "हॅलो! तुमचे नाव काय आहे?",
            "Full Name": "पूर्ण नाव",
            "Email Address": "ईमेल पत्ता",
            "Enter your Full Name": "आपले पूर्ण नाव टाका",
            "Enter your email": "आपला ईमेल टाका",
            "What is your gender?": "तुमचा लिंग काय आहे?",
            "Male": "पुरुष",
            "Female": "महिला",
            "Enter your birth date": "आपला जन्म तारीख टाका",
            "Enter your birth time": "आपला जन्म वेळ टाका",
            "Enter your birth Place": "आपले जन्मस्थान टाका",
            "Do you know which languages?": "आपल्याला कोणत्या भाषा येतात?",
            "Enter Your Place": "आपले ठिकाण टाका",
            "Back to Step": "पायरीकडे परत जा",
            "Next": "पुढे",
            "My Appointments": "माझ्या अपॉइंटमेंट्स",
            "Manage your astrology consultations": "आपल्या ज्योतिष सल्ल्यांचे व्यवस्थापन करा",
            "Upcoming": "येत आहेत",
            "Past": "मागील",
            "Pending": "प्रलंबित",
            "Accepted": "स्वीकारले",
            "Start": "सुरू करा",
            "Completed": "पूर्ण",
            "Canceled": "रद्द केले",
            "ID": "ओळख क्रमांक",
            "Chat": "चॅट",
            "Audio Call": "ऑडिओ कॉल",
            "Video Call": "व्हिडिओ कॉल",
            "View Details": "तपशील पहा",
            "Cancel": "रद्द करा",
            "No Upcoming Appointment Found !!": "कोणतीही येणारी अपॉइंटमेंट सापडली नाही !!",
            "Currently you don't have any upcoming appointment.": "सध्या आपल्याकडे कोणतीही येणारी अपॉइंटमेंट नाही.",
            "No Past Appointment Found !!": "कोणतीही मागील अपॉइंटमेंट सापडली नाही !!",
            "Currently you don't have any past appointment.": "सध्या आपल्याकडे कोणतीही मागील अपॉइंटमेंट नाही.",
            "Status": "स्थिती",
            "Service Type": "सेवेचा प्रकार",
            "Date": "तारीख",
            "Time": "वेळ",
            "Price": "किंमत",
            "Booked Person Details": "बुक केलेल्या व्यक्तीचे तपशील",
            "name": "नाव",
            "Date of Birth": "जन्म तारीख",
            "Birth Place": "जन्मस्थान",
            "Gender": "लिंग",
            "Complete Details": "पूर्ण तपशील",
            "Start Time": "सुरुवातीची वेळ",
            "End Time": "समाप्तीची वेळ",
            "Total Duration": "एकूण कालावधी",
            "Billable Time": "बिल करण्यायोग्य वेळ",
            "Billed Fee First": "पहिले बिल केलेले शुल्क",
            "Billed Fee After": "नंतर बिल केलेले शुल्क",
            "Total Consultation Fee": "एकूण सल्ला शुल्क",
            "Kundali Details": "कुंडली तपशील",
            "Name": "नाव",
            "Send Notification": "सूचना पाठवा",
            "Continue Chat": "चॅट सुरू ठेवा",
            "Write message !!": "संदेश लिहा !!",
            "Astrologer Ai Assistant": "ज्योतिष AI सहाय्यक",
            "Ask anything about your horoscope...": "आपल्या राशीबद्दल काहीही विचारा...",
            "Write message to assistant": "सहाय्यकाला संदेश लिहा",
            "Clear Chat?": "चॅट साफ करायचे?",
            "All messages will be deleted permanently.": "सर्व संदेश कायमचे हटवले जातील.",
            "Clear": "साफ करा",
            "Payment faild !!": "देयक अयशस्वी !!",
            "Please Complete Last Apointment !!": "कृपया मागील अपॉइंटमेंट पूर्ण करा !!",
            "Please enter comment !!": "कृपया टिप्पणी टाका !!",
            "Insufficient wallet balance !!": "वॉलेटमध्ये पुरेसे शिल्लक नाही !!",
            "Orders": "ऑर्डर्स",
            "Experience": "अनुभव",
            "Rating": "रेटिंग",
            "Unfollow": "अनफॉलो करा",
            "Follow": "फॉलो करा",
            "Send Gift": "भेट पाठवा",
            "Start a Consultation": "सल्ला सुरू करा",
            "Chat with astrologer": "ज्योतिषाशी चॅट करा",
            "For new user": "नवीन वापरकर्त्यासाठी",
            "min free": "मिनिट मोफत",
            "Call with astrologer": "ज्योतिषाशी कॉल करा",
            "Video call with astrologer": "ज्योतिषाशी व्हिडिओ कॉल",
            "Astrologer Bio": "ज्योतिषाचे परिचय",
            "Reviews": "पुनरावलोकने",
            "Activity": "क्रियाकलाप",
            "FAQ's": "सामान्य प्रश्न",
            "Media": "माध्यमे",
            "Comment": "टिप्पणी",
            "No comment yet": "अजून टिप्पणी नाही",
            "start the conversation": "संवाद सुरू करा",
            "Poast your replay": "आपला प्रतिसाद पोस्ट करा",
            "Delete comment": "टिप्पणी हटवा",
            "Are you sure you want to delete this comment?": "तुम्हाला नक्की ही टिप्पणी हटवायची आहे का?",
            "Cancle": "रद्द करा",
            "Delete": "हटवा",
            "Intro Audio": "परिचय ऑडिओ",
            "Intro Video": "परिचय व्हिडिओ",
            "Hear from": "ऐका",
            "Please select user !!": "कृपया वापरकर्ता निवडा !!",
            "Please select amount !!": "कृपया रक्कम निवडा !!",
            "Please select payment method !!": "कृपया पेमेंट पद्धत निवडा !!",
            "Select Kundli": "कुंडली निवडा",
            "Add Kundli": "कुंडली जोडा",
            "Minimum balance of": "किमान शिल्लक",
            "minutes": "मिनिटे",
            "is required to start chat with": "बरोबर चॅट सुरू करण्यासाठी आवश्यक आहे",
            "Wallet Balance": "पर्स शिल्लक",
            "Required": "आवश्यक",
            "Proceed to Pay": "भरण्यास पुढे जा",
            "extra in your": "तुमच्या मध्ये अतिरिक्त",
            "wallet with this": "पर्ससह याचा",
            "Woohoo!": "वाउ!",
            "Recharge Amount": "रीचार्ज रक्कम",
            "GST": "जीएसटी",
            "Wallet Amount": "पर्स रक्कम",
            "Payble Amount": "देय रक्कम",
            "Pay from Wallet": "पर्समधून भरा",
            "Available": "उपलब्ध",
            "Payment Getway Method": "पेमेंट गेटवे पद्धत",
            "Continue": "सुरू ठेवा",
            "Fortune Cookie - Unveil Your Daily Wisdom": "फॉर्च्यून कुकी - तुमची दैनिक शहाणपण उघडा",
            "Crack open a fortune cookie to reveal a piece of daily wisdom. Let the message guide you through your day with positivity and insight.": "फॉर्च्यून कुकी उघडा आणि दररोजच्या शहाणपणाचा तुकडा शोधा. संदेश तुम्हाला सकारात्मकतेने आणि अंतर्दृष्टीने तुमचा दिवस मार्गदर्शन करेल.",
            "Ask The Fortune Cookie": "फॉर्च्यून कुकीला विचारा",
            "Crack open your Fortune Cookie": "तुमची फॉर्च्यून कुकी उघडा",
            "Crack another one open": "दुसरी एक उघडा",
            "Love Compatibility": "प्रेम सुसंगतता",
            "Find out how compatible you are with your lover, friend, or colleague using our love compatibility calculator. Get your results now.": "आपण तुमच्या प्रियकर/प्रेमिका, मित्र किंवा सहकर्मच्याशी किती सुसंगत आहात हे आमच्या प्रेम सुसंगतता कॅल्क्युलेटर वापरून शोधा. आता तुमचे निकाल मिळवा.",
            "Are Aries And Taurus Compatible": "मेष आणि वृषभ सुसंगत आहेत का?",
            "Aries And Taurus Strengths": "मेष आणि वृषभाचे सामर्थ्य",
            "Aries And Taurus Weaknesses": "मेष आणि वृषभाची कमकुवत बाजू",
            "Aries And Taurus Elements": "मेष आणि वृषभ घटक",
            "Aries And Taurus Dates": "मेष आणि वृषभ तारीख",
            "Are Aries And Taurus Compatibility Score": "मेष आणि वृषभ सुसंगततेचा गुण",
            "General": "सामान्य",
            "Communication": "संपर्क",
            "Sex": "लैंगिकता",
            "Select Another": "दुसरे निवडा",
            "Aries": "मेष",
            "Taurus": "वृषभ",
            "Gemini": "मिथुन",
            "Cancer": "कर्क",
            "Leo": "सिंह",
            "Virgo": "कन्या",
            "Libra": "तुला",
            "Scorpio": "वृश्चिक",
            "Sagittarius": "धनु",
            "Capricorn": "मकर",
            "Aquarius": "कुंभ",
            "Pisces": "मीन",
            "Please select Your Partner Sign": "कृपया तुमचा जोडीदाराचा राशी चिन्ह निवडा",
            "Please select Your Sign": "कृपया तुमचा राशी चिन्ह निवडा",
            "Please fill all details !!": "कृपया सर्व तपशील भरा !!",
            "Discover Your Core Numbers That Define You": "तुमची मुख्य संख्या शोधा जी तुम्हाला परिभाषित करते",
            "Explore your core numbers like Life Path, Destiny, and Personal Year—complete with strengths, challenges, and meaningful interpretations.": "तुमच्या मुख्य संख्यांचा शोध घ्या जसे की जीवन मार्ग, भाग्य, आणि वैयक्तिक वर्ष—सामर्थ्य, आव्हाने, आणि अर्थपूर्ण अर्थांसह.",
            "Get Your Numbers": "तुमच्या संख्या मिळवा",
            "First Name": "पहिले नाव",
            "Last Name": "आडनाव",
            "Method": "पद्धत",
            "Chaldean": "कालडियन",
            "Pythagorean": "पायथागोरियन",
            "Strengths": "सामर्थ्य",
            "Challenges": "आव्हाने",
            "Advice": "सल्ला",
            "Get Report": "अहवाल मिळवा",
            "Select Tarot One Card": "टॅरो एक कार्ड निवडा",
            "Select Your Card": "तुमचे कार्ड निवडा",
            "Get Another": "दुसरे मिळवा",
            "Yes Or No Tarot": "हो की नाही टॅरो",
            "Get instant Yes or No answers to pressing questions.": "तात्काळ हो किंवा नाही उत्तर मिळवा महत्त्वाच्या प्रश्नांसाठी.",
            "Daily Tarot": "दैनिक टॅरो",
            "Receive daily tarot readings on love, career, and finance.": "प्रेम, करिअर, आणि वित्तावर दैनिक टॅरो वाचन मिळवा.",
            "In-Depth Love Reading": "सखोल प्रेम वाचन",
            "Deep dive into your love life with relationship-specific readings.": "तुमच्या प्रेम जीवनात संबंध-विशिष्ट वाचनांसह सखोल जाणून घ्या.",
            "Flirt Love Reading": "फ्लर्ट प्रेम वाचन",
            "Reveal insights into playful and romantic connections.": "खेळकर आणि रोमँटिक संबंधातील अंतर्दृष्टी उघडा.",
            "Erotic Love Reading": "कामुक प्रेम वाचन",
            "Insights into intimate and personal love dynamics.": "खाजगी आणि वैयक्तिक प्रेम गतीतील अंतर्दृष्टी.",
            "Egyptian Prediction": "इजिप्शियन भविष्यवाणी",
            "Access ancient Egyptian insights beyond visible truths.": "दृश्यमान सत्याच्या पलीकडे प्राचीन इजिप्शियन अंतर्दृष्टी मिळवा.",
            "Ex-Flame Reading": "पूर्वीच्या प्रेम वाचन",
            "Explore the possibilities of rekindling with an ex-partner.": "पूर्वीच्या जोडीदारासोबत पुन्हा जुळण्याच्या शक्यता शोधा.",
            "Made For Each Other Or Not Reading": "एकमेकांसाठी बनलेले की नाही वाचन",
            "Discover if your relationship has long-term potential.": "तुमच्या नात्याची दीर्घकालीन क्षमता आहे का ते शोधा.",
            "Power Life Reading": "शक्तिशाली जीवन वाचन",
            "Take control of your destiny with life-changing tarot readings.": "जीवन बदलणाऱ्या टॅरो वाचनांसह तुमच्या भाग्याचे नियंत्रण घ्या.",
            "Know Your Friend Reading": "तुमचा मित्र ओळखा वाचन",
            "Understand the true intentions of your friendships.": "तुमच्या मैत्रीच्या खरी उद्दिष्टे समजून घ्या.",
            "Divine Angel Reading": "दिव्य देवदूत वाचन",
            "Connect with divine guidance for clarity and spiritual insight.": "स्पष्टता आणि आध्यात्मिक अंतर्दृष्टीसाठी दैवी मार्गदर्शनाशी संपर्क साधा.",
            "Career Daily Reading": "करिअर दैनिक वाचन",
            "Elevate your career with daily tarot insights to achieve your professional goals.": "दैनिक टॅरो अंतर्दृष्टीसह तुमच्या करिअरला पुढे नेऊन व्यावसायिक लक्ष्य साधा.",
            "Dream Come True Reading": "स्वप्न पूर्ण वाचन",
            "Gain insights into making your dreams and goals a reality.": "तुमच्या स्वप्नांना आणि उद्दिष्टांना वास्तवात बदलण्याबाबत अंतर्दृष्टी मिळवा.",
            "Past Lives Connection Reading": "भूतकाळातील जीवन संबंध वाचन",
            "Explore your journey across time to understand your path ahead.": "तुमच्या भूतकाळातील प्रवासाचा शोध घ्या आणि पुढील मार्ग समजून घ्या.",
            "Delve into Your Past Lives - Unravel the Enigma of Your Previous Incarnations": "तुमच्या भूतकाळातील जीवनात शिरा – मागील जन्मांची गूढता उलगडा करा",
            "The Yes or No Tarot widget offers quick, straightforward answers to your pressing questions, helping you make decisions with confidence in areas like love, finance, and career.": "हो की नाही टॅरो विजेट तुमच्या तातडीच्या प्रश्नांची जलद आणि थेट उत्तरं देते, प्रेम, वित्त, आणि करिअरसारख्या क्षेत्रांमध्ये आत्मविश्वासाने निर्णय घेण्यास मदत करते.",
            "Daily Tarot provides readings that focus on three key areas of your life: Love, Finance, and Career. Discover the guidance you need for each aspect of your day.": "दैनिक टॅरो तुमच्या जीवनातील तीन प्रमुख क्षेत्रांवर लक्ष केंद्रित करून वाचन प्रदान करते: प्रेम, वित्त आणि करिअर. तुमच्या दिवसाच्या प्रत्येक पैलूवर आवश्यक मार्गदर्शन शोधा.",
            "In-Depth Love Tarot provides comprehensive readings to bring clarity to your love life, help you make crucial decisions, and guide you toward understanding your soulmate and future partner.": "सखोल प्रेम टॅरो तुमच्या प्रेम जीवनात स्पष्टता आणण्यासाठी व्यापक वाचन देते, महत्त्वाचे निर्णय घेण्यास मदत करते, आणि तुमच्या जीवनसाथी व भावी जोडीदारास समजून घेण्यास मार्गदर्शन करते.",
            "The Flirt Love Tarot Reading provides playful insights into your romantic life. Whether it's a friendship, a new admirer, or a potential soulmate, this reading helps you navigate love with ease.": "फ्लर्ट प्रेम टॅरो वाचन तुमच्या रोमँटिक जीवनातील खेळकर अंतर्दृष्टी देते. हे मैत्री, नवीन प्रशंसक किंवा संभाव्य जीवनसाथीसाठी असो, हे वाचन प्रेम सुलभतेने समजून घेण्यास मदत करते.",
            "This reading reveals insights into passion, love, and sexual chemistry, helping you understand your relationships and uncover hidden fantasies.": "हे वाचन तुमच्या उत्कटता, प्रेम, आणि लैंगिक रसायनशास्त्राबद्दल अंतर्दृष्टी देते, तुमच्या संबंधांना समजून घेण्यास आणि लपलेल्या फँटेसी शोधण्यास मदत करते.",
            "Explore your twin flame, current struggles, ancestral roots, and past healing with the ancient wisdom of Egyptian Tarot": "प्राचीन इजिप्शियन टॅरोच्या ज्ञानासह तुमच्या ट्विन फ्लेम, वर्तमान संघर्ष, पूर्वजांच्या मूळांचा शोध घ्या आणि भूतकाळातील उपचार शोधा",
            "The Ex-Flame Tarot Reading provides clarity on whether to rekindle a past relationship or move on. Explore your ex’s feelings, the potential for a renewed connection, and the impact on your future.": "पूर्वीच्या प्रेम टॅरो वाचन हे स्पष्ट करते की मागील नातं पुन्हा जुळवायचं की पुढे जायचं. तुमच्या माजीची भावना, पुन्हा जुळण्याची शक्यता, आणि भविष्यातील परिणाम शोधा.",
            "This Tarot reading reveals whether your relationship is worth the effort, safe to pursue, and aligned with your life goals. Understand if you’re truly made for each other or if it’s time to move on.": "हे टॅरो वाचन स्पष्ट करते की तुमचं नातं प्रयत्न करण्यास योग्य आहे की नाही, सुरक्षित आहे की नाही, आणि जीवनाच्या उद्दिष्टांसोबत सुसंगत आहे की नाही. खरंच एकमेकांसाठी बनलेले आहात की पुढे जाण्याची वेळ आहे हे समजून घ्या.",
            "The Power Life Tarot Reading helps you plan your life, overcome struggles, create a clear vision, and take charge of your destiny. Unlock the guidance you need to steer your life towards success.": "शक्तिशाली जीवन टॅरो वाचन तुमच्या जीवनाची योजना बनवायला, संघर्ष पार करायला, स्पष्ट दृष्टिकोन तयार करायला, आणि तुमच्या भाग्याचे नियंत्रण घ्यायला मदत करते. यशाकडे तुमच्या जीवनाचे मार्गदर्शन करण्यासाठी आवश्यक मार्गदर्शन मिळवा.",
            "Divine Angel Tarot connects you with your guardian angels, offering guidance to overcome challenges and find peace in love, freedom, and resolution.": "दिव्य देवदूत टॅरो तुम्हाला तुमच्या संरक्षक देवदूतांशी जोडते, आव्हाने पार करण्यास आणि प्रेम, स्वातंत्र्य आणि समाधानामध्ये शांती शोधण्यास मार्गदर्शन देते.",
            "Career Daily Tarot offers insights to manage your workday, from handling your boss to staying proactive and managing tasks effectively. Let the Tarot guide you to a successful and stress-free day.": "करिअर दैनिक टॅरो तुमच्या कामाच्या दिवसाचे व्यवस्थापन करण्यासाठी अंतर्दृष्टी देते, बॉस हाताळण्यापासून ते प्रगत राहणे आणि कार्ये प्रभावीपणे व्यवस्थापित करण्यापर्यंत. टॅरोला तुमचा दिवस यशस्वी आणि तणावमुक्त करण्यास मार्गदर्शन करा.",
            "The Dream Come True Tarot Reading helps you manifest your deepest wishes and aspirations. Whether it's love, material desires, or unfulfilled dreams, this reading offers clarity and guidance to turn your desires into reality.": "ड्रीम कम ट्रू टॅरो वाचन तुमच्या खोल इच्छा आणि आकांक्षा पूर्ण करण्यात मदत करते. प्रेम, भौतिक इच्छा, किंवा अपूर्ण स्वप्न असो, हे वाचन स्पष्टता आणि मार्गदर्शन देते ज्यामुळे तुमच्या इच्छांना वास्तवात रूपांतर करता येईल.",
            "Explore your past lives to understand current fears, recurring patterns, and influences. Gain clarity on challenges rooted in your previous incarnations.": "सध्याच्या भिती, पुनरावृत्ती होणारे नमुने आणि प्रभाव समजून घेण्यासाठी तुमच्या भूतकाळातील जीवनाचा शोध घ्या. मागील जन्मांतून आलेल्या आव्हानांबाबत स्पष्टता मिळवा.",
            "Select Tarot Three Card": "टॅरो तीन कार्ड निवडा",
            "Heartbreak Reading": "दिल तोडलेले वाचन",
            "Find guidance and healing for a broken heart.": "भंगलेल्या हृदयासाठी मार्गदर्शन आणि उपचार शोधा",
            "Wisdom Reading": "शहाणपण वाचन",
            "Balance your energies and find mental peace through wisdom.": "तुमच्या ऊर्जा संतुलित करा आणि शहाणपणाद्वारे मानसिक शांती मिळवा",
            "Divine Magic Reading": "दिव्य जादू वाचन",
            "Discover mystical insights with magical tarot guidance.": "जादुई टॅरो मार्गदर्शनासह रहस्यमय अंतर्दृष्टी शोधा",
            "Heartbreak Tarot Reading - Find Closure and Guidance": "दिल तोडलेले टॅरो वाचन - समाधान आणि मार्गदर्शन शोधा",
            "The Heartbreak Tarot Reading offers insight into the cause of your pain and provides advice on how to heal and move forward. This two-card reading delivers clarity and the necessary steps to mend your broken heart.": "दिल तोडलेले टॅरो वाचन तुमच्या वेदनेच्या कारणाबद्दल अंतर्दृष्टी देते आणि कसे बरे व्हावे व पुढे जायचे यावर सल्ला देते. हे दोन कार्डांचे वाचन स्पष्टता आणि भंगलेल्या हृदयाचे उपचार करण्यासाठी आवश्यक पावले देते.",
            "Wisdom Tarot - Find Balance with Yin and Yang": "शहाणपण टॅरो - यिन आणि यांगसह संतुलन शोधा",
            "Wisdom Tarot provides guidance by balancing the Yin and Yang energies in your life. Discover clarity, peace, and a path forward with this two-card reading.": "शहाणपण टॅरो तुमच्या जीवनातील यिन आणि यांग ऊर्जा संतुलित करून मार्गदर्शन देते. या दोन कार्डांच्या वाचनासह स्पष्टता, शांती आणि पुढील मार्ग शोधा",
            "Divine Magic Tarot Reading - Discover Cause and Remedy": "दिव्य जादू टॅरो वाचन - कारण आणि उपाय शोधा",
            "The Divine Magic Tarot Reading offers insights into the root cause of your problems and provides a remedy to guide you toward resolution. With this reading, discover the steps you need to take to transform challenges into solutions.": "दिव्य जादू टॅरो वाचन तुमच्या समस्यांच्या मूळ कारणांची अंतर्दृष्टी देते आणि समाधानाकडे मार्गदर्शन करणारा उपाय प्रदान करते. या वाचनासह, आव्हाने सोडवण्यासाठी आवश्यक पावले शोधा.",
            "Please pick your cards !!": "कृपया तुमची कार्डे निवडा !!",
            "Get Your Reading": "तुमचे वाचन मिळवा",
            "Select Tarot Two Card": "टॅरो दोन कार्ड निवडा",
            "Love Triangle Reading": "प्रेम त्रिकोण वाचन",
            "Get clarity in choosing between multiple romantic interests.": "अनेक रोमँटिक आवडींमधून निवड करताना स्पष्टता मिळवा",
            "Past-Present-Future Reading": "भूत-वरत-भविष्य वाचन",
            "Love Triangle Tarot - Discover the Dynamics Between You, Lover 1, and Lover 2": "प्रेम त्रिकोण टॅरो - तुम्ही, प्रेमी 1 आणि प्रेमी 2 यांच्यातील गती शोधा",
            "Love Triangle Tarot provides insights into the relationships and dynamics between you and your two lovers. Understand where you stand, and what each lover brings into your life, and make an informed decision guided by the cards.": "प्रेम त्रिकोण टॅरो तुमच्यात आणि तुमच्या दोन प्रेमींमध्ये संबंध आणि गती याबद्दल अंतर्दृष्टी देते. तुम्ही कुठे आहात, प्रत्येक प्रेमी तुमच्या आयुष्यात काय आणतो हे समजून घ्या आणि कार्डांच्या मार्गदर्शनाखाली माहितीपूर्ण निर्णय घ्या.",
            "Zodiac Gift Guru": "राशिफळ भेट गुरु",
            "January": "जानेवारी",
            "February": "फेब्रुवारी",
            "March": "मार्च",
            "April": "एप्रिल",
            "May": "मे",
            "June": "जून",
            "July": "जुलै",
            "August": "ऑगस्ट",
            "September": "सप्टेंबर",
            "October": "ऑक्टोबर",
            "November": "नोव्हेंबर",
            "December": "डिसेंबर",
            "Yesterday": "काल",
            "Today": "आज",
            "Tomorrow": "उद्या",
            "Gift Recommendations": "भेट शिफारसी",
            "insight": "अंतर्दृष्टी",
            "Career": "करिअर",
            "Love": "प्रेम",
            "Finance": "वित्त",
            "Popularity": "लोकप्रियता",
            "Experience: High to Low": "अनुभव: जास्त ते कमी",
            "Experience: Low to High": "अनुभव: कमी ते जास्त",
            "Orders: High to Low": "ऑर्डर: जास्त ते कमी",
            "Orders: Low to High": "ऑर्डर: कमी ते जास्त",
            "Price: High to Low": "किंमत: जास्त ते कमी",
            "Price: Low to High": "किंमत: कमी ते जास्त",
            "Rating: High to Low": "रेटिंग: जास्त ते कमी",
            "Search name...": "नाव शोधा...",
            "Online": "ऑनलाइन",
            "Busy": "व्यस्त",
            "Exp": "अनुभव",
            "yrs": "वर्षे",
            "orders": "ऑर्डर",
            "min": "मिनिटे",
            "Chat Now": "आता चॅट करा",
            "Wait": "थांबा",
            "There are no astrologers in this category.": "या श्रेणीत कोणतेही ज्योतिष नाहीत.",
            "Sort": "क्रमवारी",
            "Filter": "फिल्टर",
            "Category": "श्रेणी",
            "All": "सर्व",
            "Sort by": "द्वारे क्रमवारी लावा",
            "Skill": "कौशल्य",
            "Language": "भाषा",
            "Reset": "रीसेट",
            "Apply": "लागू करा",
            "You have 30 seconds left. Please recharge immediately to continue the conversation.": "तुमच्याकडे 30 सेकंद शिल्लक आहे. संभाषण सुरू ठेवण्यासाठी कृपया ताबडतोब रीचार्ज करा.",
            "Free chat over! Next minutes will use wallet balance.": "मोफत चॅट संपले! पुढील मिनिटांसाठी पर्स शिल्लक वापरण्यात येईल.",
            "Complete": "पूर्ण",
            "End Chat": "चॅट समाप्त करा",
            "Message": "संदेश",
            "Hi": "हाय",
            "lets continue this chat at discounted price of": "चला ही चॅट सवलतीच्या किमतीवर सुरू ठेवू",
            "Are you sure you want to end tha chat to": "तुम्हाला नक्कीच चॅट संपवायची आहे का",
            "No": "नाही",
            "Yes": "होय",
            "Chat With Astrologer": "ज्योतिषाशी चॅट करा",
            "Appointment List": "अपॉइंटमेंट यादी",
            "My Following": "मी फॉलो करतो",
            "Recent Post": "अलीकडील पोस्ट",
            "Welcome back": "पुन्हा स्वागत आहे",
            "Manage your astrology services": "तुमच्या ज्योतिष सेवांचे व्यवस्थापन करा",
            "Logout": "लॉगआउट",
            "Login": "लॉगिन",
            "My Profile (Member Since)": "माझा प्रोफाइल (सदस्यापासून)",
            "My Followings": "माझे फॉलोइंग्ज",
            "You are following": "तुम्ही फॉलो करत आहात",
            "people": "लोक",
            "Years": "वर्षे",
            "No Following Found !!": "कोणतेही फॉलोइंग सापडले नाही !!",
            "Currently you don't have any follow.": "सध्या तुमच्याकडे कोणतेही फॉलो नाही.",
            "Hey There!": "हाय!",
            "What is your name?": "तुमचं नाव काय आहे?",
            "Enter your first Name": "तुमचं पहिले नाव टाका",
            "Enter your last Name": "तुमचं आडनाव टाका",
            "male": "पुरुष",
            "female": "स्त्री",
            "Where wrer you bron?": "तुम्ही कुठे जन्मले?",
            "Please Select Language": "कृपया भाषा निवडा",
            "english": "इंग्रजी",
            "hindi": "हिंदी",
            "north": "उत्तर",
            "south": "दक्षिण",
            "Select Chart Type": "चार्ट प्रकार निवडा",
            "Start chat with astrologer": "ज्योतिषाशी चॅट सुरू करा",
            "Search location": "स्थान शोधा",
            "Location not found !!": "स्थान सापडले नाही !!",
            "Enter bord state": "राज्य टाका",
            "Search location...": "स्थान शोधा...",
            "Astrologers": "ज्योतिष",
            "Top Astrologers. 24 * 7 customer support. Happy to help": "सर्वोत्तम ज्योतिष. २४*७ ग्राहक समर्थन. मदतीसाठी आनंदी",
            "per min": "प्रति मिनिट",
            "Top Astrologers": "सर्वोत्तम ज्योतिष",
            "rate": "दर",
            "Top Rated Astrologers": "उच्च रेटिंग असलेले ज्योतिष",
            "No astrologers found !!": "कोणतेही ज्योतिष सापडले नाही !!",
            "FAQs": "सामान्य प्रश्न",
            "Raning": "रँकिंग",
            "Raning Apointment": "रँकिंग अपॉइंटमेंट",
            "Select Other Sign": "इतर राशी निवडा",
            "Horoscopes": "राशिफळ",
            "Daily Horoscope": "दैनिक राशिफळ",
            "Weekly Horoscope": "साप्ताहिक राशिफळ",
            "Monthly Horoscope": "मासिक राशिफळ",
            "Yearly Horoscope": "वार्षिक राशिफळ",
            "Composite Friendship Table": "सामूहिक मैत्री तालिका",
            "Kp Planetary Details": "के.पी ग्रह तपशील",
            "Kp House Cusps And Chart": "के.पी घरांची सीमारेषा आणि चार्ट",
            "Ascendant Report": "लग्नांक रिपोर्ट",
            "Bhava Kundli": "भाव कुंडली",
            "Vimshottari Dasha": "विंशोत्तरी दशा",
            "Yogini Dasha": "योगिनी दशा",
            "Sadhesati Analysis": "साढेसाती विश्लेषण",
            "Sadhesati Life Analysis": "साढेसाती जीवन विश्लेषण",
            "Kalsarpa Dosha": "कालसर्प दोष",
            "Manglik Analysis": "मंगलिक विश्लेषण",
            "Planet Profiles": "ग्रह प्रोफाइल",
            "Gemstone Suggestions": "रत्न सुचना",
            "Upagraha": "उपग्रह",
            "Jaimini Astrology": "जैमिनी ज्योतिष",
            "Chara Dasha": "चर दशा",
            "Shadbala": "षड्बल",
            "Sudarshana Chakra": "सुदर्शन चक्र",
            "Bhinnashtakvarga": "भिन्नाष्टकवर्ग",
            "Yogas": "योग",
            "Introduction": "परिचय",
            "Basic Astrological Details": "मूलभूत ज्योतिषीय तपशील",
            "Planetary Positions": "ग्रह स्थिती",
            "Horoscope Charts": "कुंडली चार्ट",
            "House Cusps And Sandhi": "घरांची सीमारेषा आणि संधी",
            "Divisional Charts": "अंश चार्ट",
            "Basic Details": "मूलभूत तपशील",
            "Ghat Chakra": "घट चक्र",
            "Panchange Details": "पंचांग तपशील",
            "Astrological Details": "ज्योतिषीय तपशील",
            "Time of Birth": "जन्म वेळ",
            "Place of Birth": "जन्मस्थान",
            "Latitude": "अक्षांश",
            "Longitude": "रेखांश",
            "Timezone": "टाईमझोन",
            "Ayanamsa": "अयनांस",
            "Sunrise": "सूर्योदय",
            "Sunset": "सूर्यास्त",
            "Month": "महिना",
            "Tithi": "तिथी",
            "Yoga": "योग",
            "Karana": "करण",
            "Moon Sign": "चंद्र राशी",
            "Moon Vaar": "चंद्र वार",
            "Nakshatra": "नक्षत्र",
            "Varna": "वर्ण",
            "Vashya": "वश्य",
            "Yoni": "योनी",
            "Gana": "गण",
            "Nadi": "नाडी",
            "Sun Sign": "सूर्य राशी",
            "Tatva": "तत्त्व",
            "Paya": "पाया",
            "Yanja": "यंज",
            "Planets": "ग्रह",
            "Sign": "राशि",
            "Sign No": "राशी क्रमांक",
            "LAGNA CHART (BIRTH CHART)": "लग्नांक चार्ट (जन्म कुंडली)",
            "MOON CHART": "चंद्र चार्ट",
            "NAVMANSHA CHART (D9)": "नवांश चार्ट (D9)",
            "House": "घर",
            "Bhav Madhya": "भाव मध्य",
            "Bhav Sandhi": "भाव संधी",
            "Chalit Chart": "चलित चार्ट",
            "Sun Chart": "सूर्य चार्ट",
            "Health, Constitution, Body": "आरोग्य, प्रकृती, शरीर",
            "Hora Chart(D2)": "होरा चार्ट (D2)",
            "Finance, Wealth, Prosperity": "वित्त, संपत्ती, समृद्धी",
            "Dreshkan Chart(D3)": "द्रेशकान चार्ट (D3)",
            "Brothers, Sisters": "भाऊ, बहिणी",
            "Chathurthamasha Chart(D4)": "चतुर्थांश चार्ट (D4)",
            "Fortunes, Luck of native": "निवासीचे नशीब, भाग्य",
            "Saptamansha Chart(D7)": "सप्तमांश चार्ट (D7)",
            "Impregnation, Birth of the child": "गर्भधारण, मुलाच्या जन्म",
            "Dashamansha Chart(D10)": "दशमांश चार्ट (D10)",
            "livelihood, Profession": "उत्पन्न, व्यवसाय",
            "Dwadasha Chart(D12)": "द्वादशांश चार्ट (D12)",
            "Parents, paternal happiness": "पालक, वडीलांच्या आनंद",
            "Shodashamsha Chart(D16)": "षोडशांश चार्ट (D16)",
            "Happiness, miseries, conveyance": "आनंद, दुःख, वाहतूक",
            "Vishamansha Chart(D20)": "विशमांश चार्ट (D20)",
            "Spiritual progress, worship": "आध्यात्मिक प्रगती, पूजा",
            "Chaturvimshamsha(D24)": "चतुर्विंशांश (D24)",
            "Academic achievement, education": "शैक्षणिक कामगिरी, शिक्षण",
            "Bhamsha Chart(D27)": "भामांश चार्ट (D27)",
            "Physical strength, stamina": "शारीरिक ताकद, सहनशक्ती",
            "Trishamansha Chart(D30)": "त्रिशमांश चार्ट (D30)",
            "Evil, Adversities of life": "दुष्टता, जीवनातील अडचणी",
            "Khavedamsha Chart(D40)": "खवेदमांश चार्ट (D40)",
            "Auspicious & inauspicious effect": "शुभ व अशुभ परिणाम",
            "Akshvedansha Chart(D45)": "अक्षवेदांश चार्ट (D45)",
            "Character and couduct of the native": "निवासीचे स्वभाव व आचार",
            "Shashtymsah Chart(D60)": "षष्ट्यंश चार्ट (D60)",
            "Shows general happiness": "सामान्य आनंद दर्शवतो",
            "Degrees": "अंश",
            "Sign Lord": "राशि स्वामी",
            "Nakshatra Lord": "नक्षत्र स्वामी",
            "Sub Lord": "उप स्वामी",
            "Sub Sub Lord": "उप-उप स्वामी",
            "Lord": "स्वामी",
            "Symbol": "प्रतीक",
            "Characteristics": "वैशिष्ट्ये",
            "Day of Fast": "उपवासाचा दिवस",
            "luchy Gems": "भाग्यशाली रत्न",
            "Personality": "व्यक्तिमत्व",
            "Health": "आरोग्य",
            "Relationships": "संबंध",
            "BHAVA KUNDLI": "भाव कुंडली",
            "Bhramari": "भ्रमरी",
            "Bhadrika": "भाद्रिका",
            "Ulka": "उल्का",
            "Siddha": "सिद्ध",
            "Sankata": "संकट",
            "Mangala": "मंगल",
            "Pingala": "पिंगळा",
            "Dhanya": "धन्य",
            "Remedies Of Sadhesati": "साढेसाती उपाय",
            "Saturn Sign": "शनि राशी",
            "Is Saturn Retro?": "शनि प्रतिगामी आहे का?",
            "Phase": "स्थिती",
            "Intensity": "तीव्रता",
            "Direction": "दिशा",
            "Strength": "शक्ती",
            "Percentage": "टक्केवारी",
            "Zodiac Sign": "राशी चिन्ह",
            "Planet Degree": "ग्रह अंश",
            "Lord Of": "स्वामी",
            "Combust/Aw...": "ज्वलित/अव...",
            "Lucky Stone": "भाग्यशाली दगड",
            "Life Stone": "जीवन दगड",
            "Finger": "बोट",
            "Day": "दिवस",
            "Time to Wear": "परिधान करण्याचा वेळ",
            "Mantra": "मंत्र",
            "Upagraha Longitude": "उपग्रह रेखांश",
            "Rashi": "राशी",
            "Pada": "पदा",
            "Upagraha/Nakshatra/Sub Lord": "उपग्रह/नक्षत्र/उप स्वामी",
            "Jamini Planets": "जैमिनी ग्रह",
            "Jamini Padas": "जैमिनी पदा",
            "Code": "कोड",
            "Jamini Karakara": "जैमिनी कारक",
            "Uchcha Bala": "उच्च बल",
            "Saptavarga Bala": "सप्तवर्ग बल",
            "Yugmayugma Bhamsha Bala": "युग्मयुग्म भामांश बल",
            "Kendradi Bala": "केंद्रदी बल",
            "Drekkana Bala": "त्रेक्काना बल",
            "Total Sthana Bala": "एकूण स्थान बल",
            "Total Dig Bala": "एकूण दिशा बल",
            "Nattunnata Bala": "नाट्टुन्नता बल",
            "Paksha Bala": "पक्ष बल",
            "Tribhaga Bala": "त्रिभाग बल",
            "Varshadhipati": "वार्षाधिपती",
            "Maasadipati": "मासाधिपती",
            "Vaaradhipati": "वाराधिपती",
            "Horadhipati": "होरा अधिपती",
            "Ayana Bala": "अयन बल",
            "Yuddha Bala": "युद्ध बल",
            "Total Kaal Bala": "एकूण काळ बल",
            "Naisargika Bala": "नैसर्गिक बल",
            "Chestha Bala": "चेष्टा बल",
            "Drik Bala": "द्रिक बल",
            "Total Shadbala": "एकूण षड्बल",
            "Shadbala In Rupa": "षड्बल रुपात",
            "Min Require": "किमान आवश्यक",
            "Ratio": "अनुपात",
            "Rank": "क्रमांक",
            "Sun": "सूर्य",
            "Moon": "चंद्र",
            "Mars": "मंगल",
            "Mercury": "बुध",
            "Jupiter": "गुरु",
            "Venus": "शुक्र",
            "Saturn": "शनि",
            "Ashtakvarga": "अष्टकवर्ग",
            "Sarvashtakava": "सर्वअष्टकवर्ग",
            "Prasthara Chakra": "प्रस्थारा चक्र",
            "Ascendant": "लग्न",
            "Total": "एकूण",
            "Natural Friendship": "सामान्य मैत्री",
            "Temporary Friendship": "तात्पुरती मैत्री",
            "Five Fold Friendship": "पंचगुणा मैत्री",
            "Ketu": "केतु",
            "Rahu": "राहु",
            "Vimshottari Dasha P1": "विंशोत्तरी दशा P1",
            "Vimshottari Dasha P2": "विंशोत्तरी दशा P2",
            "AshtaKoot": "अष्टकूट",
            "Bhakut Dosha": "भकूट दोष",
            "Nadi Dosha": "नाडी दोष",
            "Ashtakoot Analysis": "अष्टकूट विश्लेषण",
            "DashaKoot": "दशाकूट",
            "Personality Report": "व्यक्तिमत्व अहवाल",
            "Match Making Report": "जोडणी अहवाल",
            "Nav Pancham Yoga": "नव पंचम योग",
            "Charan": "पद",
            "Name Alphabet": "नावातील अक्षर",
            "Planetary Position": "ग्रह स्थान",
            "Lagna Chart (Birth Chart)": "लग्नांक चार्ट (जन्म कुंडली)",
            "Moon Chart": "चंद्र चार्ट",
            "Navmansha Chart (D9)": "नवांश चार्ट (D9)",
            "Mahadasha": "महादशा",
            "End": "समाप्त",
            "Is Recommended ??": "शिफारस आहे का ??",
            "Manglik Details": "मंगलिक तपशील",
            "What is AshtaKoot ??": "अष्टकूट म्हणजे काय ??",
            "Attributes": "गुणधर्म",
            "Description": "वर्णन",
            "Received": "प्राप्त",
            "Graha Maitri": "ग्रह मैत्री",
            "Bhakoota": "भकूट",
            "What is BhaKoot Dosha ??": "भकूट दोष म्हणजे काय ??",
            "What is Nadi Dosha ??": "नाडी दोष म्हणजे काय ??",
            "Madhya": "मध्य",
            "Nadi dosha is present": "नाडी दोष उपस्थित आहे",
            "The": "हे",
            "porutham considered for horoscope matching are as follows :": "जोडणीसाठी विचारात घेतलेले पोर्तम खालीलप्रमाणे आहेत :",
            "Dina": "दिना",
            "Rajju": "राज्जू",
            "Rasyadhipati": "राशी अधिपती",
            "Vedha": "वेधा",
            "Mahendra": "महेंद्र",
            "Streedargha": "स्त्रीदर्घ",
            "Uranus": "यूरेनस",
            "Neptune": "नेप्च्यून",
            "Pluto": "प्लूटो",
            "Tara": "तारा",
            "Please fill boy's details !!": "कृपया मुलाचे तपशील भरा !!",
            "Please fill girl's details !!": "कृपया मुलीचे तपशील भरा !!",
            "Please fill chart details !!": "कृपया चार्ट तपशील भरा !!",
            "Kundli Matching": "कुंडली जुळणी",
            "Find your right one, through matchmaking": "जोडणीद्वारे आपला योग्य जोडीदार शोधा",
            "Open Kundli": "कुंडली उघडा",
            "New Matching": "नवीन जुळणी",
            "View Kundli": "कुंडली पहा",
            "Boy's Details": "मुलाचे तपशील",
            "Girl's Details": "मुलीचे तपशील",
            "Search city, state, country": "शहर, राज्य, देश शोधा",
            "Enter first name": "पहिले नाव भरा",
            "Enter last name": "आडनाव भरा",
            "Chart Style": "चार्ट शैली",
            "North Indian": "उत्तर भारतीय",
            "South Indian": "दक्षिण भारतीय",
            "English": "इंग्रजी",
            "Hindi": "हिंदी",
            "MATCH HOROSCOPE": "कुंडली जुळणी",
            "My Profile": "माझे प्रोफाइल",
            "Enter full name": "पूर्ण नाव भरा",
            "Enter email address": "ई-मेल पत्ता भरा",
            "Enter password": "पासवर्ड भरा",
            "Enter phone number": "फोन नंबर भरा",
            "Save Chanage": "बदल जतन करा",
            "Manage your astrologers recent post": "आपल्या ज्योतिषाचे अलीकडील पोस्ट व्यवस्थापित करा",
            "Show Less": "कमी दाखवा",
            "Show More": "अधिक दाखवा",
            "Total Balance": "एकूण शिल्लक",
            "Add Money": "रक्कम भरा",
            "Extra": "अतिरिक्त",
            "Transaction History": "व्यवहार इतिहास",
            "Build better products with flexible tools, helpful documentation,": "लवचिक साधने, उपयुक्त दस्तऐवजांसह उत्तम उत्पादने तयार करा,",
            "and a team that champions your growth.": "आणि तुमच्या वाढीस समर्थन करणारी टीम.",
            "Useful Link": "उपयुक्त दुवा",
            "Socials": "सोशल मीडिया",
            "Logout Seccuessfuly !!": "यशस्वीरित्या लॉगआउट !!",
            "Free Kundli": "मुफत कुंडली",
            "Horoscope": "राशिफळ",
            "Dashboard": "डॅशबोर्ड",
            "Enter your feedback !!": "आपले अभिप्राय भरा !!",
            "Languages": "भाषा",
            "incoming": "येणारे",
            "request from": "कडून विनंती",
            "Waitlist Joined !!": "वेटलिस्टमध्ये सामील झाला !!",
            "will start in": "सुरू होईल",
            "You will receive a": "आपल्याला मिळेल",
            "request when the": "विनंती जेव्हा",
            "astrologer is ready. Don’t worry! You will not be": "ज्योतिष तयार असेल. काळजी करू नका! आपल्याला",
            "charged for missing this session.": "या सत्र गमावल्याबद्दल शुल्क आकारले जाणार नाही.",
            "Accept": "स्वीकारा",
            "Reject": "नाकार करा",
            "Great, what did you like the mast? 😍": "छान, तुम्हाला काय सर्वात आवडले? 😍",
            "Skip": "उडवा",
            "Payment Information": "पेमेंट माहिती",
            "Amount": "रक्कम",
            "Tax": "कर",
            "Payment": "पेमेंट",
            "Payment Method": "पेमेंट पद्धत",
        
            "AstroSpace": "AstroSpace",
            "Astrology Consultation Platform": "Astrology Consultation Platform",
            "INVOICE": "INVOICE",
            "Consultation Service Receipt": "Consultation Service Receipt",
            "Invoice Number": "Invoice Number",
            "Date Issued": "Date Issued",
            "PAID": "PAID",
            "From": "From",
            "Bill To": "Bill To",
            "Service": "Service",
            "Booking ID": "Booking ID",
            "Description": "Description",
            "Duration": "Duration",
            "Rate": "Rate",
            "Amount": "Amount",
            "Free Consultation Time": "Free Consultation Time",
            "Complimentary session minutes": "Complimentary session minutes",
            "Free": "Free",
            "Consultation Fee": "Consultation Fee",
            "Standard rate (first block)": "Standard rate (first block)",
            "Extended Consultation Fee": "Extended Consultation Fee",
            "Premium rate (extended block)": "Premium rate (extended block)",
            "Consultation Service": "Consultation Service",
            "Astrology consultation session": "Astrology consultation session",
            "Subtotal": "Subtotal",
            "Platform Fee": "Platform Fee",
            "Included": "Included",
            "Total Amount": "Total Amount",
            "DOB": "DOB",
            "Kundali Chart Used": "Kundali Chart Used",
            "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.": "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.",
            "For support, contact us at support@astrospace.com": "For support, contact us at support@astrospace.com",
            "Free Minute": "Free Minute",
            "Verified": "Verified",
            "End Session": "End Session",
            "Voice Call": "Voice Call",
            "typing...": "typing...",
            "CANCEL": "CANCEL",
            "OK": "OK",
            "Install Progressive Web Application": "Install Progressive Web Application",
            "This site has app functionality. Install it on your device for extensive experience and easy access.": "This site has app functionality. Install it on your device for extensive experience and easy access.",
            "Install": "Install",
            "Search location": "Search location",
            "Location not found !!": "Location not found !!",
            "Waiting for remote user to join...": "Waiting for remote user to join...",
            "End Video Session": "End Video Session",
            "Initializing WebRTC P2P...": "Initializing WebRTC P2P...",
            "Access Denied (Camera/Mic)": "Access Denied (Camera/Mic)",
            "Connection Failed": "Connection Failed",
            "Time Remaining": "Time Remaining",
            "Call ended": "Call ended",

            "Offline": "Offline",}
    },
    gu: {
        translation: {
            "Enter Mobile Number !!": "મોબાઇલ નંબર દાખલ કરો !!",
            "In Valid OTP !!": "અમાન્ય OTP !!",
            "Please enter password !!": "પાસવર્ડ દાખલ કરો !!",
            "Password not match !!": "પાસવર્ડ મેચ નથી !!",
            "Reset Password": "પાસવર્ડ ફરીથી સેટ કરો",
            "Enter your phone number and new password": "તમારો ફોન નંબર અને નવો પાસવર્ડ દાખલ કરો",
            "Phone Number": "ફોન નંબર",
            "Enter your number": "તમારો નંબર દાખલ કરો",
            "Search": "શોધો",
            "Verify": "સત્યાપિત કરો",
            "You will receive a 6 digit code for": "તમને 6 અંકનો કોડ મળશે",
            "verification to": "સત્યાપન માટે",
            "Submit": "સબમિટ કરો",
            "Enter your password and new password": "તમારો પાસવર્ડ અને નવો પાસવર્ડ દાખલ કરો",
            "New Password": "નવો પાસવર્ડ",
            "Enter new password": "નવો પાસવર્ડ દાખલ કરો",
            "Confirm New Password": "નવો પાસવર્ડ પુષ્ટિ કરો",
            "Confirm new password": "નવો પાસવર્ડ પુષ્ટિ કરો",
            "Back to Login": "લોગિન પર પાછા જાઓ",
            "Back": "પાછા",
            "Enter Login Details !!": "લોગિન વિગતો દાખલ કરો !!",
            "Welcome Back!": "ફરીથી સ્વાગત છે!",
            "Sign in to your account": "તમારા એકાઉન્ટમાં સાઇન ઇન કરો",
            "Password": "પાસવર્ડ",
            "Enter your password": "તમારો પાસવર્ડ દાખલ કરો",
            "Forgot Password?": "પાસવર્ડ ભૂલી ગયા?",
            "Sign In": "સાઇન ઇન કરો",
            "Don't have an account?": "એકાઉન્ટ નથી?",
            "Sign Up": "સાઇન અપ કરો",
            "Please enter all details !!": "કૃપા કરીને તમામ વિગતો દાખલ કરો !!",
            "Please enter valid email !!": "માહિતી પૂરતી ઇમેલ દાખલ કરો !!",
            "Please enter birth place !!": "જન્મસ્થળ દાખલ કરો !!",
            "Please select language !!": "કૃપા કરીને ભાષા પસંદ કરો !!",
            "Step": "કદમ",
            "Enter Your Details": "તમારી વિગતો દાખલ કરો",
            "Hey there! what is your name?": "હાય! તમારું નામ શું છે?",
            "Full Name": "પુરું નામ",
            "Email Address": "ઇમેલ સરનામું",
            "Enter your Full Name": "તમારું પૂરું નામ દાખલ કરો",
            "Enter your email": "તમારી ઇમેલ દાખલ કરો",
            "What is your gender?": "તમારો લિંગ શું છે?",
            "Male": "પુરુષ",
            "Female": "સ્ત્રી",
            "Enter your birth date": "જન્મ તારીખ દાખલ કરો",
            "Enter your birth time": "જન્મ સમય દાખલ કરો",
            "Enter your birth Place": "જન્મ સ્થળ દાખલ કરો",
            "Do you know which languages?": "તમને કઈ ભાષાઓ આવે છે?",
            "Enter Your Place": "તમારું સ્થળ દાખલ કરો",
            "Back to Step": "પાછા પગલાં પર જાઓ",
            "Next": "આગળ",
            "My Appointments": "મારા નિમણૂક",
            "Manage your astrology consultations": "તમારા જ્યોતિષ સલાહકાર સેવાઓ મેનેજ કરો",
            "Upcoming": "આગામી",
            "Past": "ભૂતકાળ",
            "Pending": "અપેક્ષિત",
            "Accepted": "સ્વીકારાયું",
            "Start": "પ્રારંભ કરો",
            "Completed": "પૂર્ણ",
            "Canceled": "રદ",
            "ID": "આઈડી",
            "Chat": "ચેટ",
            "Audio Call": "ઓડિયો કૉલ",
            "Video Call": "વિડિઓ કૉલ",
            "View Details": "વિગતો જુઓ",
            "Cancel": "રદ કરો",
            "No Upcoming Appointment Found !!": "આગામી નિમણૂક મળ્યો નથી !!",
            "Currently you don't have any upcoming appointment.": "હાલ કોઈ આગામી નિમણૂક નથી.",
            "No Past Appointment Found !!": "ભૂતકાળની નિમણૂક નથી !!",
            "Currently you don't have any past appointment.": "હાલ કોઈ ભૂતકાળની નિમણૂક નથી.",
            "Status": "સ્થિતિ",
            "Service Type": "સેવા પ્રકાર",
            "Date": "તારીખ",
            "Time": "સમય",
            "Price": "કિંમત",
            "Booked Person Details": "બુક કરનાર વ્યક્તિની વિગતો",
            "name": "નામ",
            "Date of Birth": "જન્મ તારીખ",
            "Birth Place": "જન્મ સ્થળ",
            "Gender": "લિંગ",
            "Complete Details": "પૂર્ણ વિગતો",
            "Start Time": "પ્રારંભ સમય",
            "End Time": "અંત સમય",
            "Total Duration": "કુલ સમયગાળો",
            "Billable Time": "બિલ કરાયેલી સમય",
            "Billed Fee First": "પ્રથમ બિલ કરેલ ફી",
            "Billed Fee After": "બિલ પછીની ફી",
            "Total Consultation Fee": "કુલ સલાહકાર ફી",
            "Kundali Details": "કુંડળી વિગતો",
            "Name": "નામ",
            "Send Notification": "સૂચના મોકલો",
            "Continue Chat": "ચેટ ચાલુ રાખો",
            "Write message !!": "સંદેશ લખો !!",
            "Astrologer Ai Assistant": "જ્યોતિષ AI સહાયક",
            "Ask anything about your horoscope...": "તમારા રાશિફળ વિશે કંઈ પૂછો...",
            "Write message to assistant": "સહાયકને સંદેશ લખો",
            "Clear Chat?": "ચેટ સાફ કરવી?",
            "All messages will be deleted permanently.": "તમામ સંદેશાઓ કાયમ માટે દૂર થઈ જશે.",
            "Clear": "સાફ કરો",
            "Payment faild !!": "ચુકવણી નિષ્ફળ !!",
            "Please Complete Last Apointment !!": "કૃપા કરીને છેલ્લી નિમણૂક પૂર્ણ કરો !!",
            "Please enter comment !!": "કૃપા કરીને ટિપ્પણી દાખલ કરો !!",
            "Insufficient wallet balance !!": "પાત્ર બેલેન્સ પૂરતું નથી !!",
            "Orders": "ઓર્ડર",
            "Experience": "અનુભવ",
            "Rating": "રેટિંગ",
            "Unfollow": "અનફોલો કરો",
            "Follow": "ફોલો કરો",
            "Send Gift": "ભેટ મોકલો",
            "Start a Consultation": "સલાહકાર શરૂ કરો",
            "Chat with astrologer": "જ્યોતિષ સાથે ચેટ કરો",
            "For new user": "નવા વપરાશકર્તા માટે",
            "min free": "મિનિટ મુક્ત",
            "Call with astrologer": "જ્યોતિષ સાથે કૉલ",
            "Video call with astrologer": "જ્યોતિષ સાથે વિડિઓ કૉલ",
            "Astrologer Bio": "જ્યોતિષ પ્રોફાઇલ",
            "Reviews": "સમીક્ષાઓ",
            "Activity": "ક્રિયાપ્રતિક્રિયા",
            "FAQ's": "વારંવાર પુછાતા પ્રશ્નો",
            "Media": "મીડિયા",
            "Comment": "ટિપ્પણી",
            "No comment yet": "હજુ કોઈ ટિપ્પણી નથી",
            "start the conversation": "અનુકથન શરૂ કરો",
            "Poast your replay": "તમારો જવાબ પોસ્ટ કરો",
            "Delete comment": "ટિપ્પણી કાઢો",
            "Are you sure you want to delete this comment?": "શું તમે ખરેખર આ ટિપ્પણી કાઢી નાખવા માંગો છો?",
            "Cancle": "રદ કરો",
            "Delete": "કાઢી નાખો",
            "Intro Audio": "પ્રારંભિક ઓડિયો",
            "Intro Video": "પ્રારંભિક વિડિઓ",
            "Hear from": "સંપર્ક કરો",
            "Please select user !!": "કૃપા કરીને વપરાશકર્તા પસંદ કરો !!",
            "Please select amount !!": "કૃપા કરીને રકમ પસંદ કરો !!",
            "Please select payment method !!": "કૃપા કરીને ચુકવણી પદ્ધતિ પસંદ કરો !!",
            "Select Kundli": "કુંડળી પસંદ કરો",
            "Add Kundli": "કુંડળી ઉમેરો",
            "Minimum balance of": "ન્યૂનતમ બેલેન્સ",
            "minutes": "મિનિટ",
            "is required to start chat with": "ચેટ શરૂ કરવા માટે જરૂરી છે",
            "Wallet Balance": "વૉલેટ બેલેન્સ",
            "Required": "જરૂરી",
            "Proceed to Pay": "ચુકવણી માટે આગળ વધો",
            "extra in your": "તમારા માં વધારાનું",
            "wallet with this": "વૉલેટ સાથે આ સાથે",
            "Woohoo!": "વાહ!",
            "Recharge Amount": "રીચાર્જ રકમ",
            "GST": "GST",
            "Wallet Amount": "વૉલેટ રકમ",
            "Payble Amount": "ચુકવણીઓ રકમ",
            "Pay from Wallet": "વૉલેટમાંથી ચૂકવો",
            "Available": "ઉપલબ્ધ",
            "Payment Getway Method": "ચુકવણી ગેટવે પદ્ધતિ",
            "Continue": "ચાલુ રાખો",
            "Fortune Cookie - Unveil Your Daily Wisdom": "ફોર્ચ્યુન કૂકી - તમારું દૈનિક જ્ઞાન શોધો",
            "Crack open a fortune cookie to reveal a piece of daily wisdom. Let the message guide you through your day with positivity and insight.": "ફોર્ચ્યુન કૂકી ખોલો અને દૈનિક જ્ઞાન મેળવો. સંદેશા દ્વારા તમારી દિવસની દિશા દેખાવો.",
            "Ask The Fortune Cookie": "ફોર્ચ્યુન કૂકીને પૂછો",
            "Crack open your Fortune Cookie": "તમારી ફોર્ચ્યુન કૂકી ખોલો",
            "Crack another one open": "બીજી ખોલો",
            "Love Compatibility": "પ્રેમ સુસંગતતા",
            "Find out how compatible you are with your lover, friend, or colleague using our love compatibility calculator. Get your results now.": "અમારા પ્રેમ સુસંગતતા કેલ્ક્યુલેટર સાથે શોધો કે તમે તમારા પ્રેમી, મિત્ર અથવા સહકર્મી સાથે કેટલા સુસંગત છો. પરિણામ મેળવો.",
            "Are Aries And Taurus Compatible": "મેષ અને વૃષભ સુસંગત છે?",
            "Aries And Taurus Strengths": "મેષ અને વૃષભની શક્તિઓ",
            "Aries And Taurus Weaknesses": "મેષ અને વૃષભની દુર્બળતાઓ",
            "Aries And Taurus Elements": "મેષ અને વૃષભના તત્વો",
            "Aries And Taurus Dates": "મેષ અને વૃષભની તારીખો",
            "Are Aries And Taurus Compatibility Score": "મેષ અને વૃષભની સુસંગતતા સ્કોર",
            "General": "સામાન્ય",
            "Communication": "સંવાદ",
            "Sex": "સંબંધ",
            "Select Another": "બીજું પસંદ કરો",
            "Aries": "મેષ",
            "Taurus": "વૃષભ",
            "Gemini": "મિથુન",
            "Cancer": "કર્ક",
            "Leo": "સિંહ",
            "Virgo": "કન્યા",
            "Libra": "તુલા",
            "Scorpio": "વૃશ્ચિક",
            "Sagittarius": "ધન",
            "Capricorn": "મકર",
            "Aquarius": "કુંભ",
            "Pisces": "મીન",
            "Please select Your Partner Sign": "કૃપા કરીને તમારા સાથીદારનો રાશિ ચિહ્ન પસંદ કરો",
            "Please select Your Sign": "કૃપા કરીને તમારું રાશિ ચિહ્ન પસંદ કરો",
            "Please fill all details !!": "કૃપા કરીને તમામ વિગતો ભરો !!",
            "Discover Your Core Numbers That Define You": "તમારા મૂળ અંક શોધો જે તમને વ્યાખ્યાયિત કરે છે",
            "Explore your core numbers like Life Path, Destiny, and Personal Year—complete with strengths, challenges, and meaningful interpretations.": "તમારા મુખ્ય અંક જેમ કે જીવન માર્ગ, ભાગ્ય, અને વ્યક્તિગત વર્ષ શોધો — શક્તિઓ, પડકારો અને અર્થપૂર્ણ અર્થ સાથે.",
            "Get Your Numbers": "તમારા અંક મેળવો",
            "First Name": "પ્રથમ નામ",
            "Last Name": "અટકાયેલું નામ",
            "Method": "પદ્ધતિ",
            "Chaldean": "ચલડિયન",
            "Pythagorean": "પાઈથાગોરિયન",
            "Strengths": "શક્તિઓ",
            "Challenges": "પડકારો",
            "Advice": "સલાહ",
            "Get Report": "અહેવાલ મેળવો",
            "Select Tarot One Card": "ટેરોટ એક કાર્ડ પસંદ કરો",
            "Select Your Card": "તમારું કાર્ડ પસંદ કરો",
            "Get Another": "બીજું મેળવો",
            "Yes Or No Tarot": "હા કે ના ટેરોટ",
            "Get instant Yes or No answers to pressing questions.": "તાત્કાલિક હા કે ના જવાબ મેળવો.",
            "Daily Tarot": "દૈનિક ટેરોટ",
            "Receive daily tarot readings on love, career, and finance.": "પ્રેમ, કારકિર્દી અને નાણાકીય પર દૈનિક ટેરોટ વાંચન મેળવો.",
            "In-Depth Love Reading": "ગહન પ્રેમ વાંચન",
            "Deep dive into your love life with relationship-specific readings.": "સંબંધ વિશિષ્ટ વાંચન સાથે તમારી પ્રેમ જીવનમાં ગહન અન્વેષણ કરો.",
            "Flirt Love Reading": "ફ્લર્ટ પ્રેમ વાંચન",
            "Reveal insights into playful and romantic connections.": "ખેલખેલાટી અને રોમેન્ટિક જોડાણોમાં દ્રષ્ટિ પ્રગટાવો.",
            "Erotic Love Reading": "સાંપ્રતિક પ્રેમ વાંચન",
            "Insights into intimate and personal love dynamics.": "નજીક અને વ્યક્તિગત પ્રેમ ગતિશીલતાઓમાં દૃષ્ટિ.",
            "Egyptian Prediction": "ઇજિપ્શિયન અનુમાન",
            "Access ancient Egyptian insights beyond visible truths.": "દૃશ્યસત્યની બહાર પ્રાચીન ઇજિપ્શિયન જ્ઞાન મેળવો.",
            "Ex-Flame Reading": "એક્સ-ફ્લેમ વાંચન",
            "Explore the possibilities of rekindling with an ex-partner.": "પૂર્વ પાર્ટનર સાથે પુન:પ્રેરણા શક્યતાઓ શોધો.",
            "Made For Each Other Or Not Reading": "એકબીજાની માટે કે નહીં વાંચન",
            "Discover if your relationship has long-term potential.": "તમારા સંબંધમાં લાંબા સમયની શક્યતા છે કે કેમ શોધો.",
            "Power Life Reading": "પાવર લાઈફ વાંચન",
            "Take control of your destiny with life-changing tarot readings.": "જીવન બદલતા ટેરોટ વાંચન સાથે તમારી કિસ્મત પર નિયંત્રણ મેળવો.",
            "Know Your Friend Reading": "તમારા મિત્રને જાણો વાંચન",
            "Understand the true intentions of your friendships.": "તમારા મિત્રતાના ખરાં હેતુઓ સમજવો.",
            "Divine Angel Reading": "દિવ્ય એન્જલ વાંચન",
            "Connect with divine guidance for clarity and spiritual insight.": "સ્પષ્ટતા અને આધ્યાત્મિક દ્રષ્ટિ માટે દિવ્ય માર્ગદર્શન સાથે જોડાવા.",
            "Career Daily Reading": "કારકિર્દી દૈનિક વાંચન",
            "Elevate your career with daily tarot insights to achieve your professional goals.": "તમારા વ્યવસાયિક લક્ષ્યો હાંસલ કરવા માટે દૈનિક ટેરોટ દૃષ્ટિ સાથે કારકિર્દી ઉંચાઇ લાવો.",
            "Dream Come True Reading": "ડ્રીમ કમ ટ્રૂ વાંચન",
            "Gain insights into making your dreams and goals a reality.": "તમારા સપનાને અને લક્ષ્યોને વાસ્તવિકતા બનાવવા માટે દૃષ્ટિ મેળવો.",
            "Past Lives Connection Reading": "ભૂતકાળના જીવન જોડાણ વાંચન",
            "Explore your journey across time to understand your path ahead.": "તમારા સમયગાળા જ્યોતિવિધિમાં તમારી યાત્રા શોધો અને આગળનો માર્ગ સમજવો.",
            "Yes or No Tarot - Find Clear and Immediate Answers": "હા કે ના ટેરોટ - સ્પષ્ટ અને તાત્કાલિક જવાબ મેળવો",
            "Daily Tarot - Gain Insights Across Love, Finance, and Career": "દૈનિક ટેરોટ - પ્રેમ, નાણાકીય અને કારકિર્દી વિશે દૃષ્ટિ મેળવો",
            "In-Depth Love Tarot - Reveal the Realities of Your Relationship": "ગહન પ્રેમ ટેરોટ - તમારા સંબંધની વાસ્તવિકતાઓ શોધો",
            "Flirt Love Tarot - Discover Your Romantic Potential": "ફ્લર્ટ પ્રેમ ટેરોટ - તમારી રોમેન્ટિક ક્ષમતાઓ શોધો",
            "Erotic Love Tarot - Explore Your Intimate Desires": "સાંપ્રતિક પ્રેમ ટેરોટ - તમારી નજીકની ઇચ્છાઓ શોધો",
            "Discover the Secrets of Your Soul with Egyptian Tarot": "ઇજિપ્શિયન ટેરોટ સાથે તમારી આત્માના રહસ્યો શોધો",
            "Ex-Flame Tarot - Reignite or Release the Past": "એક્સ-ફ્લેમ ટેરોટ - ભૂતકાળ પુનર્જીવિત કરો અથવા મુક્ત કરો",
            "Made For Each Other Tarot - Discover True Compatibility": "એકબીજાની માટે ટેરોટ - સાચી સુસંગતતા શોધો",
            "Power Life Tarot - Take Control of Your Destiny": "પાવર લાઇફ ટેરોટ - તમારી કિસ્મત પર નિયંત્રણ મેળવો",
            "Know Your Friend Tarot Reading - Unveil the True Nature of Your Relationships": "તમારા મિત્ર ટેરોટ વાંચન - તમારા સંબંધોની ખરાં સ્વરૂપ શોધો",
            "Divine Angel Tarot - Receive Angelic Guidance for Clarity and Relief": "દિવ્ય એન્જલ ટેરોટ - સ્પષ્ટતા અને રાહત માટે એન્જેલિક માર્ગદર્શન મેળવો",
            "Career Daily Tarot Reading - Navigate Your Workday with Confidence": "કારકિર્દી દૈનિક ટેરોટ વાંચન - વિશ્વાસ સાથે કાર્ય દિવસને મેનેજ કરો",
            "Explore the Depths of Your Heart's Desires with a Dream Come True Tarot Reading": "ડ્રીમ કમ ટ્રૂ ટેરોટ વાંચન સાથે તમારા હૃદયની ઇચ્છાઓની ઊંડી શોધ કરો",
            "Delve into Your Past Lives - Unravel the Enigma of Your Previous Incarnations": "તમારા ભૂતકાળના જીવનમાં ડૂબકી લગાવો - તમારી પૂર્વ જન્મોની રહસ્યમયતા ઉકેલાવો",
            "The Yes or No Tarot widget offers quick, straightforward answers to your pressing questions, helping you make decisions with confidence in areas like love, finance, and career.": "હા કે ના ટેરોટ વિજેટ તમારા મહત્વના પ્રશ્નોના ઝડપી અને સ્પષ્ટ જવાબ આપે છે, પ્રેમ, નાણાકીય અને કારકિર્દી ક્ષેત્રોમાં વિશ્વાસ સાથે નિર્ણય લેવા મદદ કરે છે.",
            "Daily Tarot provides readings that focus on three key areas of your life: Love, Finance, and Career. Discover the guidance you need for each aspect of your day.": "દૈનિક ટેરોટ તમારી જીવનની ત્રણ મુખ્ય ક્ષેત્રો પર ધ્યાન કેન્દ્રિત કરીને વાંચન આપે છે: પ્રેમ, નાણાકીય અને કારકિર્દી. તમારા દિવસના દરેક પાસાની માર્ગદર્શન શોધો.",
            "In-Depth Love Tarot provides comprehensive readings to bring clarity to your love life, help you make crucial decisions, and guide you toward understanding your soulmate and future partner.": "ગહન પ્રેમ ટેરોટ તમારા પ્રેમ જીવનમાં સ્પષ્ટતા લાવવા, મહત્વપૂર્ણ નિર્ણયો લેવા અને તમારા સાથી અને ભાવિ જીવનસાથીને સમજવામાં માર્ગદર્શન આપે છે.",
            "The Flirt Love Tarot Reading provides playful insights into your romantic life. Whether it's a friendship, a new admirer, or a potential soulmate, this reading helps you navigate love with ease.": "ફ્લર્ટ પ્રેમ ટેરોટ વાંચન તમારા રોમેન્ટિક જીવનમાં રમૂજી દૃષ્ટિ આપે છે. મિત્રતા, નવા પ્રશંસક અથવા સંભવિત જીવનસાથી હોય, તે પ્રેમને સરળતાથી સમજવામાં મદદ કરે છે.",
            "This reading reveals insights into passion, love, and sexual chemistry, helping you understand your relationships and uncover hidden fantasies.": "આ વાંચન જેવું દ્રષ્ટિ આપે છે જે આતુરતા, પ્રેમ અને લૈંગિક રસાયણને સમજવામાં મદદ કરે છે, તમારા સંબંધોને સમજવા અને છુપાયેલા ફૅન્ટસી શોધવામાં મદદ કરે છે.",
            "Explore your twin flame, current struggles, ancestral roots, and past healing with the ancient wisdom of Egyptian Tarot": "ઇજિપ્શિયન ટેરોટની પ્રાચીન જ્ઞાન સાથે તમારા ટ્વિન ફ્લેમ, વર્તમાન સંઘર્ષો, વંશજ મૂળ અને ભૂતકાળની આરોગ્ય શોધો",
            "The Ex-Flame Tarot Reading provides clarity on whether to rekindle a past relationship or move on. Explore your ex’s feelings, the potential for a renewed connection, and the impact on your future.": "એક્સ-ફ્લેમ ટેરોટ વાંચન પૂર્વ સંબંધને પુનઃપ્રેરણા આપવા કે આગળ વધવા વિશે સ્પષ્ટતા આપે છે. તમારા પૂર્વ સાથેના ભાવનાઓ, નવી જોડાણની શક્યતા અને તમારા ભાવિ પર પ્રભાવ શોધો.",
            "This Tarot reading reveals whether your relationship is worth the effort, safe to pursue, and aligned with your life goals. Understand if you’re truly made for each other or if it’s time to move on.": "આ ટેરોટ વાંચન બતાવે છે કે તમારો સંબંધ પ્રયાસની લાયક છે કે કેમ, તેને અનુસરણ કરવું સલામત છે કે નહીં અને તમારા જીવનના લક્ષ્યો સાથે સુસંગત છે કે નહીં. સમજવું કે તમે ખરેખર એકબીજાની માટે બનેલા છો કે નહીં.",
            "The Power Life Tarot Reading helps you plan your life, overcome struggles, create a clear vision, and take charge of your destiny. Unlock the guidance you need to steer your life towards success.": "પાવર લાઇફ ટેરોટ વાંચન તમારી જીવન યોજના બનાવવામાં, સંઘર્ષો પર કાબૂ પામવામાં, સ્પષ્ટ દૃષ્ટિ સર્જવામાં અને તમારી કિસ્મત પર નિયંત્રણ મેળવવામાં મદદ કરે છે. સફળતા તરફ તમારી જીવનની દિશા નિયંત્રિત કરવા માટે માર્ગદર્શન મેળવો.",
            "Divine Angel Tarot connects you with your guardian angels, offering guidance to overcome challenges and find peace in love, freedom, and resolution.": "દિવ્ય એન્જલ ટેરોટ તમને તમારા રક્ષક એન્જલો સાથે જોડે છે, સંઘર્ષો પર કાબૂ પામવા અને પ્રેમ, સ્વતંત્રતા અને સમાધાનમાં શાંતિ મેળવવા માટે માર્ગદર્શન આપે છે.",
            "Career Daily Tarot offers insights to manage your workday, from handling your boss to staying proactive and managing tasks effectively. Let the Tarot guide you to a successful and stress-free day.": "કારકિર્દી દૈનિક ટેરોટ તમારી કાર્યદિનને સંભાળવા માટે દૃષ્ટિ આપે છે, બોસને સંભાળવાનું, સક્રિય રહેવું અને કાર્ય પ્રભાવી રીતે સંભાળવું. ટેરોટ તમને સફળ અને તણાવમુક્ત દિવસ તરફ માર્ગદર્શન આપે.",
            "The Dream Come True Tarot Reading helps you manifest your deepest wishes and aspirations. Whether it's love, material desires, or unfulfilled dreams, this reading offers clarity and guidance to turn your desires into reality.": "ડ્રીમ કમ ટ્રૂ ટેરોટ વાંચન તમારી ઊંડા ઇચ્છાઓ અને મહત્ત્વાકાંક્ષાઓને સાકાર કરવામાં મદદ કરે છે. પ્રેમ, ભૌતિક ઈચ્છાઓ કે અધૂરા સપનાઓ હોવા પર, આ વાંચન સ્પષ્ટતા અને માર્ગદર્શન આપે છે.",
            "Explore your past lives to understand current fears, recurring patterns, and influences. Gain clarity on challenges rooted in your previous incarnations.": "તમારા ભૂતકાળના જીવનને શોધો, વર્તમાન ભય, પુનરાવર્તિત પેટર્ન અને પ્રભાવને સમજવા માટે. પૂર્વ જન્મમાં ઊંડા પડકારોને સમજવા માટે સ્પષ્ટતા મેળવો.",
            "Select Tarot Three Card": "ટેરોટ ત્રણ કાર્ડ પસંદ કરો",
            "Heartbreak Reading": "હાર્ટબ્રેક વાંચન",
            "Find guidance and healing for a broken heart.": "તૂટેલા હૃદય માટે માર્ગદર્શન અને ઉપચાર મેળવો.",
            "Wisdom Reading": "જ્ઞાન વાંચન",
            "Balance your energies and find mental peace through wisdom.": "તમારી ઊર્જાઓને સંતુલિત કરો અને જ્ઞાનથી માનસિક શાંતિ મેળવો.",
            "Divine Magic Reading": "દિવ્ય જાદુ વાંચન",
            "Discover mystical insights with magical tarot guidance.": "જાદૂઈ ટેરોટ માર્ગદર્શન સાથે રહસ્યમય દૃષ્ટિ શોધો.",
            "Heartbreak Tarot Reading - Find Closure and Guidance": "હાર્ટબ્રેક ટેરોટ વાંચન - સમાપ્તિ અને માર્ગદર્શન મેળવો",
            "The Heartbreak Tarot Reading offers insight into the cause of your pain and provides advice on how to heal and move forward. This two-card reading delivers clarity and the necessary steps to mend your broken heart.": "હાર્ટબ્રેક ટેરોટ વાંચન તમારા દુઃખના કારણ વિશે દૃષ્ટિ આપે છે અને કેવી રીતે સુધારવું અને આગળ વધવું તેની સલાહ આપે છે. આ બે કાર્ડનું વાંચન સ્પષ્ટતા અને તૂટેલા હૃદયને મંડાવવા જરૂરી પગલાં આપે છે.",
            "Wisdom Tarot - Find Balance with Yin and Yang": "જ્ઞાન ટેરોટ - યિન અને યાંગ સાથે સંતુલન મેળવો",
            "Wisdom Tarot provides guidance by balancing the Yin and Yang energies in your life. Discover clarity, peace, and a path forward with this two-card reading.": "જ્ઞાન ટેરોટ તમારા જીવનમાં યિન અને યાંગ ઊર્જાઓને સંતુલિત કરીને માર્ગદર્શન આપે છે. આ બે કાર્ડ વાંચન સાથે સ્પષ્ટતા, શાંતિ અને આગળનો માર્ગ શોધો.",
            "Divine Magic Tarot Reading - Discover Cause and Remedy": "દિવ્ય જાદુ ટેરોટ વાંચન - કારણ અને ઉપાય શોધો",
            "The Divine Magic Tarot Reading offers insights into the root cause of your problems and provides a remedy to guide you toward resolution. With this reading, discover the steps you need to take to transform challenges into solutions.": "દિવ્ય જાદુ ટેરોટ વાંચન તમારા સમસ્યાઓના મૂળ કારણ અંગે દૃષ્ટિ આપે છે અને સમાધાન તરફ માર્ગદર્શન માટે ઉપાય આપે છે. આ વાંચન સાથે, પડકારોને ઉકેલમાં પરિવર્તિત કરવા માટે પગલાં શોધો.",
            "Please pick your cards !!": "કૃપા કરીને તમારા કાર્ડ પસંદ કરો !!",
            "Get Your Reading": "તમારું વાંચન મેળવો",
            "Select Tarot Two Card": "ટેરોટ બે કાર્ડ પસંદ કરો",
            "Love Triangle Reading": "લવ ટ્રાયએંગલ વાંચન",
            "Get clarity in choosing between multiple romantic interests.": "એકથી વધુ રોમેન્ટિક રુચિઓમાંથી પસંદગી કરવા માટે સ્પષ્ટતા મેળવો.",
            "Past-Present-Future Reading": "ભૂત-વર્તમાન-ભવિષ્ય વાંચન",
            "Love Triangle Tarot - Discover the Dynamics Between You, Lover 1, and Lover 2": "લવ ટ્રાયએંગલ ટેરોટ - તમે, પ્રેમી 1 અને પ્રેમી 2 વચ્ચેના ગતિશીલતાને શોધો",
            "Love Triangle Tarot provides insights into the relationships and dynamics between you and your two lovers. Understand where you stand, and what each lover brings into your life, and make an informed decision guided by the cards.": "લવ ટ્રાયએંગલ ટેરોટ તમારા અને તમારા બે પ્રેમીઓ વચ્ચેના સંબંધો અને ગતિશીલતાની દૃષ્ટિ આપે છે. સમજવો કે તમે ક્યાં છો, દરેક પ્રેમી તમારા જીવનમાં શું લાવે છે અને કાર્ડના માર્ગદર્શન હેઠળ સૂચિત નિર્ણય લો.",
            "Zodiac Gift Guru": "રાશિ ગિફ્ટ ગુરુ",
            "January": "જાન્યુઆરી",
            "February": "ફેબ્રુઆરી",
            "March": "માર્ચ",
            "April": "એપ્રિલ",
            "May": "મે",
            "June": "જૂન",
            "July": "જુલાઈ",
            "August": "ઓગસ્ટ",
            "September": "સપ્ટેમ્બર",
            "October": "ઓક્ટોબર",
            "November": "નવેંબર",
            "December": "ડિસેમ્બર",
            "Yesterday": "ગઇકાલે",
            "Today": "આજ",
            "Tomorrow": "કાલે",
            "Gift Recommendations": "ઉપહાર ભલામણો",
            "insight": "દૃષ્ટિ",
            "Career": "કારકિર્દી",
            "Love": "પ્રેમ",
            "Finance": "નાણાકીય",
            "Popularity": "પ્રસિદ્ધિ",
            "Experience: High to Low": "અનુભવ: ઊંચેથી નીચે",
            "Experience: Low to High": "અનુભવ: નીચેથી ઊંચે",
            "Orders: High to Low": "ઓર્ડર: ઊંચેથી નીચે",
            "Orders: Low to High": "ઓર્ડર: નીચેથી ઊંચે",
            "Price: High to Low": "મૂલ્ય: ઊંચેથી નીચે",
            "Price: Low to High": "મૂલ્ય: નીચેથી ઊંચે",
            "Rating: High to Low": "મૂલ્યાંકન: ઊંચેથી નીચે",
            "Search name...": "નામ શોધો...",
            "Online": "ઓનલાઇન",
            "Busy": "વ્યસ્ત",
            "Exp": "અનુભવ",
            "yrs": "વર્ષ",
            "orders": "ઓર્ડર",
            "min": "મિનિટ",
            "Chat Now": "હવે ચેટ કરો",
            "Wait": "પ્રતીક્ષા કરો",
            "There are no astrologers in this category.": "આ શ્રેણીમાં કોઈ જ્યોતિષી નથી.",
            "Sort": "સોટ",
            "Filter": "ફિલ્ટર",
            "Category": "શ્રેણી",
            "All": "બધા",
            "Sort by": "આધાર પર છાંટો",
            "Skill": "કૌશલ્ય",
            "Language": "ભાષા",
            "Reset": "રીસેટ",
            "Apply": "લાગૂ કરો",
            "You have 30 seconds left. Please recharge immediately to continue the conversation.": "તમારા પાસે 30 સેકંડ બાકી છે. કૃપા કરીને વાતચીત ચાલુ રાખવા માટે તરત રીચાર્જ કરો.",
            "Free chat over! Next minutes will use wallet balance.": "મફત ચેટ સમાપ્ત! આગામી મિનિટ વૉલેટ બેલેન્સથી લેવામાં આવશે.",
            "Complete": "પૂર્ણ",
            "End Chat": "ચેટ સમાપ્ત કરો",
            "Message": "સંદેશ",
            "Hi": "હાય",
            "lets continue this chat at discounted price of": "ચાલો આ ચેટ ડિસ્કાઉન્ટ કિંમતમાં ચાલુ રાખીએ",
            "Are you sure you want to end tha chat to": "શું તમે ખરેખર ચેટ પૂર્ણ કરવા માંગો છો",
            "No": "ના",
            "Yes": "હા",
            "Chat With Astrologer": "જ્યોતિષી સાથે ચેટ કરો",
            "Appointment List": "નીમણૂક સૂચિ",
            "My Following": "મારી અનુસરણ",
            "Recent Post": "તાજેતરના પોસ્ટ",
            "Welcome back": "પુનઃસ્વાગત છે",
            "Manage your astrology services": "તમારી જ્યોતિષી સેવાઓ મેનેજ કરો",
            "Logout": "લૉગઆઉટ",
            "Login": "લૉગિન",
            "My Profile (Member Since)": "મારી પ્રોફાઇલ (સભ્ય થી)",
            "My Followings": "મારા અનુસરણ",
            "You are following": "તમે અનુસરી રહ્યા છો",
            "people": "લોકો",
            "Years": "વર્ષ",
            "No Following Found !!": "કોઈ અનુસરણ મળ્યું નથી !!",
            "Currently you don't have any follow.": "આ સમયે તમારી પાસે કોઈ અનુસરણ નથી.",
            "Hey There!": "હે ત્યાં!",
            "What is your name?": "તમારું નામ શું છે?",
            "Enter your first Name": "તમારું પ્રથમ નામ દાખલ કરો",
            "Enter your last Name": "તમારું છેલ્લું નામ દાખલ કરો",
            "male": "પુરુષ",
            "female": "સ્ત્રી",
            "Where wrer you bron?": "તમે ક્યાં જન્મ્યા હતા?",
            "Please Select Language": "કૃપા કરીને ભાષા પસંદ કરો",
            "english": "અંગ્રેજી",
            "hindi": "હિન્દી",
            "north": "ઉત્તર",
            "south": "દક્ષિણ",
            "Select Chart Type": "ચાર્ટ પ્રકાર પસંદ કરો",
            "Start chat with astrologer": "જ્યોતિષી સાથે ચેટ શરૂ કરો",
            "Search location": "સ્થાન શોધો",
            "Location not found !!": "સ્થાન મળ્યું નથી !!",
            "Enter bord state": "જન્મ રાજ્ય દાખલ કરો",
            "Search location...": "સ્થાન શોધો...",
            "Astrologers": "જ્યોતિષીઓ",
            "Top Astrologers. 24 * 7 customer support. Happy to help": "શીર્ષ જ્યોતિષીઓ. 24*7 ગ્રાહક સહાય. મદદ કરવા માટે હંમેશા તૈયાર",
            "per min": "પ્રતિ મિનિટ",
            "Top Astrologers": "શીર્ષ જ્યોતિષીઓ",
            "rate": "દર",
            "Top Rated Astrologers": "સૌથી ઉચ્ચ રેટેડ જ્યોતિષીઓ",
            "No astrologers found !!": "કોઈ જ્યોતિષી મળ્યો નથી !!",
            "FAQs": "સામાન્ય પ્રશ્નો",
            "Raning": "રેનિંગ",
            "Raning Apointment": "રેનિંગ નીમણૂક",
            "Select Other Sign": "અન્ય રાશિ પસંદ કરો",
            "Horoscopes": "રાશિફળ",
            "Daily Horoscope": "દૈનિક રાશિફળ",
            "Weekly Horoscope": "સાપ્તાહિક રાશિફળ",
            "Monthly Horoscope": "માસિક રાશિફળ",
            "Yearly Horoscope": "વાર્ષિક રાશિફળ",
            "Composite Friendship Table": "કંપનીડ મિત્રતા ટેબલ",
            "Kp Planetary Details": "KP ગ્રહ વિગતો",
            "Kp House Cusps And Chart": "KP હાઉસ કસ્પ્સ અને ચાર્ટ",
            "Ascendant Report": "લગ્ન રિપોર્ટ",
            "Bhava Kundli": "ભાવ કુંડળી",
            "Vimshottari Dasha": "વિમશોતારી દશા",
            "Yogini Dasha": "યોગિની દશા",
            "Sadhesati Analysis": "સાધેસાતી વિશ્લેષણ",
            "Sadhesati Life Analysis": "સાધેસાતી જીવન વિશ્લેષણ",
            "Kalsarpa Dosha": "કલસર્પ દોષ",
            "Manglik Analysis": "મંગલિક વિશ્લેષણ",
            "Planet Profiles": "ગ્રહ પ્રોફાઇલ્સ",
            "Gemstone Suggestions": "રત્ન સૂચનો",
            "Upagraha": "ઉપગ્રહ",
            "Jaimini Astrology": "જૈમિની જ્યોતિષ",
            "Chara Dasha": "ચારા દશા",
            "Shadbala": "ષડબળ",
            "Sudarshana Chakra": "સુદર્શન ચક્ર",
            "Bhinnashtakvarga": "ભિન્નઅષ્ટકવર્ગ",
            "Yogas": "યોગ",
            "Introduction": "પરિચય",
            "Basic Astrological Details": "મૂળ જ્યોતિષીય વિગતો",
            "Planetary Positions": "ગ્રહ સ્થિતિઓ",
            "Horoscope Charts": "હોરોસ્કોપ ચાર્ટ્સ",
            "House Cusps And Sandhi": "હાઉસ કસ્પ્સ અને સંધિ",
            "Divisional Charts": "વિભાગ ચાર્ટ્સ",
            "Basic Details": "મૂળ વિગતો",
            "Ghat Chakra": "ઘટ ચક્ર",
            "Panchange Details": "પંચાંગ વિગતો",
            "Astrological Details": "જ્યોતિષીય વિગતો",
            "Time of Birth": "જન્મ સમય",
            "Place of Birth": "જન્મ સ્થાન",
            "Latitude": "અક્ષાંશ",
            "Longitude": "દેશાંશ",
            "Timezone": "સમય ઝોન",
            "Ayanamsa": "અયનમ્ષા",
            "Sunrise": "સૂર્યોદય",
            "Sunset": "સૂર્યાસ્ત",
            "Month": "મહિનો",
            "Tithi": "તિથી",
            "Yoga": "યોગ",
            "Karana": "કરાણા",
            "Moon Sign": "ચંદ્ર રાશિ",
            "Moon Vaar": "ચંદ્રવાર",
            "Nakshatra": "નક્ષત્ર",
            "Varna": "વર્ણ",
            "Vashya": "વશ્ય",
            "Yoni": "યોગિની",
            "Gana": "ગણ",
            "Nadi": "નાડી",
            "Sun Sign": "સૂર્ય રાશિ",
            "Tatva": "તત્વ",
            "Paya": "પાયા",
            "Yanja": "યાંજા",
            "Planets": "ગ્રહો",
            "Sign": "રાશિ",
            "Sign No": "રાશિ નંબર",
            "LAGNA CHART (BIRTH CHART)": "લગ્ન ચાર્ટ (જન્મ ચાર્ટ)",
            "MOON CHART": "ચંદ્ર ચાર્ટ",
            "NAVMANSHA CHART (D9)": "નવમંશ ચાર્ટ (D9)",
            "House": "હાઉસ",
            "Bhav Madhya": "ભાવ મધ્ય",
            "Bhav Sandhi": "ભાવ સંધિ",
            "Chalit Chart": "ચાલિત ચાર્ટ",
            "Sun Chart": "સૂર્ય ચાર્ટ",
            "Health, Constitution, Body": "સ્વાસ્થ્ય, બંધારણ, શરીર",
            "Hora Chart(D2)": "હોરા ચાર્ટ (D2)",
            "Finance, Wealth, Prosperity": "નાણાકીય, સંપત્તિ, સમૃદ્ધિ",
            "Dreshkan Chart(D3)": "દ્રેશ્કન ચાર્ટ (D3)",
            "Brothers, Sisters": "ભાઇઓ, બહેનો",
            "Chathurthamasha Chart(D4)": "ચતુર્થામશ ચાર્ટ (D4)",
            "Fortunes, Luck of native": "જન્મનારની ભાગ્ય, નસીબ",
            "Saptamansha Chart(D7)": "સપ્તમંશ ચાર્ટ (D7)",
            "Impregnation, Birth of the child": "ગર્ભધારણ, બાળકનું જન્મ",
            "Dashamansha Chart(D10)": "દશમંશ ચાર્ટ (D10)",
            "livelihood, Profession": "જીવનયાપન, વ્યવસાય",
            "Dwadasha Chart(D12)": "દ્વાદશ ચાર્ટ (D12)",
            "Parents, paternal happiness": "પેરેંટ્સ, પિતૃક ખુશી",
            "Shodashamsha Chart(D16)": "ષોડશમંશ ચાર્ટ (D16)",
            "Happiness, miseries, conveyance": "ખુશી, દુઃખ, પરિવહન",
            "Vishamansha Chart(D20)": "વિશમંશ ચાર્ટ (D20)",
            "Spiritual progress, worship": "આધ્યાત્મિક પ્રગતિ, પૂજા",
            "Chaturvimshamsha(D24)": "ચતુર્વિમશમશ (D24)",
            "Academic achievement, education": "શૈક્ષણિક સફળતા, શિક્ષણ",
            "Bhamsha Chart(D27)": "ભામશ ચાર્ટ (D27)",
            "Physical strength, stamina": "શારીરિક શક્તિ, સહનશક્તિ",
            "Trishamansha Chart(D30)": "ત્રિશમંશ ચાર્ટ (D30)",
            "Evil, Adversities of life": "દુઃખ, જીવનની મુશ્કેલીઓ",
            "Khavedamsha Chart(D40)": "ખાવે덤શ ચાર્ટ (D40)",
            "Auspicious & inauspicious effect": "શુભ અને અશુભ અસર",
            "Akshvedansha Chart(D45)": "અક્ષવેદાંશ ચાર્ટ (D45)",
            "Character and couduct of the native": "સ્થાનિકની વ્યક્તિત્વ અને વર્તન",
            "Shashtymsah Chart(D60)": "ષષ્ટિમંશ ચાર્ટ (D60)",
            "Shows general happiness": "સામાન્ય ખુશી દર્શાવે છે",
            "Degrees": "ડિગ્રી",
            "Sign Lord": "રાશિ ભગવાન",
            "Nakshatra Lord": "નક્ષત્ર ભગવાન",
            "Sub Lord": "ઉપ ભગવાન",
            "Sub Sub Lord": "ઉપ ઉપ ભગવાન",
            "Lord": "ભગવાન",
            "Symbol": "પ્રતીક",
            "Characteristics": "લક્ષણો",
            "Day of Fast": "ઉપવાસનો દિવસ",
            "luchy Gems": "ભાગ્યશાળી રત્નો",
            "Personality": "વ્યક્તિત્વ",
            "Health": "સ્વાસ્થ્ય",
            "Relationships": "સંબંધો",
            "BHAVA KUNDLI": "ભાવ કુંડળી",
            "Bhramari": "ભ્રમરી",
            "Bhadrika": "ભદ્રિકા",
            "Ulka": "ઉલ્કા",
            "Siddha": "સિદ્ધ",
            "Sankata": "સંકટ",
            "Mangala": "મંગળ",
            "Pingala": "પિંગળા",
            "Dhanya": "ધન્ય",
            "Remedies Of Sadhesati": "સાધેસાતી ઉપાય",
            "Saturn Sign": "શનિ રાશિ",
            "Is Saturn Retro?": "શું શનિ વક્ર છે?",
            "Phase": "અવસ્થા",
            "Intensity": "તીવ્રતા",
            "Direction": "દિશા",
            "Strength": "શક્તિ",
            "Percentage": "પ્રતિશત",
            "Zodiac Sign": "રાશિ ચિહ્ન",
            "Planet Degree": "ગ્રહ ડિગ્રી",
            "Lord Of": "ભગવાન",
            "Combust/Aw...": "સળગવું/અવ...",
            "Lucky Stone": "ભાગ્યશાળી પથ્થર",
            "Life Stone": "જીવન પથ્થર",
            "Finger": "ઊંગળી",
            "Day": "દિવસ",
            "Time to Wear": "પहनવાનો સમય",
            "Mantra": "મંત્ર",
            "Upagraha Longitude": "ઉપગ્રહ દેશાંશ",
            "Rashi": "રાશિ",
            "Pada": "પાદ",
            "Upagraha/Nakshatra/Sub Lord": "ઉપગ્રહ/નક્ષત્ર/ઉપ ભગવાન",
            "Jamini Planets": "જૈમિની ગ્રહો",
            "Jamini Padas": "જૈમિની પાદ",
            "Code": "કોડ",
            "Jamini Karakara": "જૈમિની કારકર",
            "Uchcha Bala": "ઉચ્ચ બળ",
            "Saptavarga Bala": "સપ્તવર્ગ બળ",
            "Yugmayugma Bhamsha Bala": "યુગમયુગ્મ ભમ્ષ બળ",
            "Kendradi Bala": "કેન્દ્રડી બળ",
            "Drekkana Bala": "દ્રેક્કન બળ",
            "Total Sthana Bala": "કુલ સ્થાન બળ",
            "Total Dig Bala": "કુલ દિશા બળ",
            "Nattunnata Bala": "નટુન્નાતા બળ",
            "Paksha Bala": "પક્ષ બળ",
            "Tribhaga Bala": "ત્રિભાજ બળ",
            "Varshadhipati": "વર્ષાધિપતિ",
            "Maasadipati": "માસાધિપતિ",
            "Vaaradhipati": "વારાધિપતિ",
            "Horadhipati": "હોરાધિપતિ",
            "Ayana Bala": "અયન બળ",
            "Yuddha Bala": "યુદ્ધ બળ",
            "Total Kaal Bala": "કુલ કાલ બળ",
            "Naisargika Bala": "નૈસર્ગિક બળ",
            "Chestha Bala": "ચેષ્ટા બળ",
            "Drik Bala": "દૃક બળ",
            "Total Shadbala": "કુલ ષડબળ",
            "Shadbala In Rupa": "રૂપમાં ષડબળ",
            "Min Require": "ન્યૂનતમ આવશ્યકતા",
            "Ratio": "અનુપાત",
            "Rank": "રેનક",
            "Sun": "સૂર્ય",
            "Moon": "ચંદ્ર",
            "Mars": "મંગળ",
            "Mercury": "બુધ",
            "Jupiter": "ગુરૂ",
            "Venus": "શુક્ર",
            "Saturn": "શનિ",
            "Ashtakvarga": "અષ્ટકવર્ગ",
            "Sarvashtakava": "સર્વઅષ્ટકવર્ગ",
            "Prasthara Chakra": "પ્રસ્થારા ચક્ર",
            "Ascendant": "લગ્ન",
            "Total": "કુલ",
            "Natural Friendship": "પ્રાકૃતિક મિત્રતા",
            "Temporary Friendship": "અસ્થાયી મિત્રતા",
            "Five Fold Friendship": "પાંચગુણિત મિત્રતા",
            "Ketu": "કેતુ",
            "Rahu": "રાહુ",
            "Vimshottari Dasha P1": "વિમશોતારી દશા P1",
            "Vimshottari Dasha P2": "વિમશોતારી દશા P2",
            "AshtaKoot": "અષ્ટકૂટ",
            "Bhakut Dosha": "ભાકુટ દોષ",
            "Nadi Dosha": "નાડી દોષ",
            "Ashtakoot Analysis": "અષ્ટકૂટ વિશ્લેષણ",
            "DashaKoot": "દશકૂટ",
            "Personality Report": "વ્યક્તિત્વ રિપોર્ટ",
            "Match Making Report": "મૅચ મેકિંગ રિપોર્ટ",
            "Nav Pancham Yoga": "નવ પંચમ યોગ",
            "Charan": "પગ",
            "Name Alphabet": "નામના અક્ષર",
            "Planetary Position": "ગ્રહ સ્થિતિ",
            "Lagna Chart (Birth Chart)": "લગ્ન ચાર્ટ (જન્મ ચાર્ટ)",
            "Moon Chart": "ચંદ્ર ચાર્ટ",
            "Navmansha Chart (D9)": "નવમંશ ચાર્ટ (D9)",
            "Mahadasha": "મહાદશા",
            "End": "સમાપ્ત",
            "Is Recommended ??": "શિફારસ છે ??",
            "Manglik Details": "મંગલિક વિગતો",
            "What is AshtaKoot ??": "અષ્ટકૂટ શું છે ??",
            "Attributes": "ગુણધર્મો",
            "Description": "વર્ણન",
            "Received": "મળ્યું",
            "Graha Maitri": "ગ્રહમૈત્રી",
            "Bhakoota": "ભાકુટા",
            "What is BhaKoot Dosha ??": "ભાકૂટ દોષ શું છે ??",
            "What is Nadi Dosha ??": "નાડી દોષ શું છે ??",
            "Madhya": "મધ્ય",
            "Nadi dosha is present": "નાડી દોષ હાજર છે",
            "The": "દીઠ",
            "porutham considered for horoscope matching are as follows :": "જન્મકુંડળી મેલ માટે ધ્યાનમાં લેવાતા પોરુથમ નીચે મુજબ છે :",
            "Dina": "દિન",
            "Rajju": "રાજજુ",
            "Rasyadhipati": "રાશિાધિપતિ",
            "Vedha": "વેધા",
            "Mahendra": "મહેન્દ્ર",
            "Streedargha": "સ્ત્રીદીર્ઘા",
            "Uranus": "યુરેનસ",
            "Neptune": "નેપ્ચ્યૂન",
            "Pluto": "પ્લૂટો",
            "Tara": "તારા",
            "Please fill boy's details !!": "કૃપા કરીને છોકરાનું વિગત ભરો !!",
            "Please fill girl's details !!": "કૃપા કરીને છોકરીનું વિગત ભરો !!",
            "Please fill chart details !!": "કૃપા કરીને ચાર્ટ વિગતો ભરો !!",
            "Kundli Matching": "કુંડળી મેળ",
            "Find your right one, through matchmaking": "મેલ સાથે તમારો યોગ્ય જીવનસાથી શોધો",
            "Open Kundli": "કુંડળી ખોલો",
            "New Matching": "નવું મેળ",
            "View Kundli": "કુંડળી જુઓ",
            "Boy's Details": "છોકરાનું વિગત",
            "Girl's Details": "છોકરીનું વિગત",
            "Search city, state, country": "શહેર, રાજ્ય, દેશ શોધો",
            "Enter first name": "પ્રથમ નામ દાખલ કરો",
            "Enter last name": "છેલ્લું નામ દાખલ કરો",
            "Chart Style": "ચાર્ટ શૈલી",
            "North Indian": "ઉત્તર ભારતીય",
            "South Indian": "દક્ષિણ ભારતીય",
            "English": "અંગ્રેજી",
            "Hindi": "હિન્દી",
            "MATCH HOROSCOPE": "જન્મકુંડળી મેળ",
            "My Profile": "મારું પ્રોફાઇલ",
            "Enter full name": "પૂર્ણ નામ દાખલ કરો",
            "Enter email address": "ઇમેઇલ સરનામું દાખલ કરો",
            "Enter password": "પાસવર્ડ દાખલ કરો",
            "Enter phone number": "ફોન નંબર દાખલ કરો",
            "Save Chanage": "બદલાવ સાચવો",
            "Manage your astrologers recent post": "તમારા જ્યોતિષીઓની તાજેતરની પોસ્ટ વ્યવસ્થાપિત કરો",
            "Show Less": "ઓછું બતાવો",
            "Show More": "વધુ બતાવો",
            "Total Balance": "કુલ બેલેન્સ",
            "Add Money": "પૈસા ઉમેરો",
            "Extra": "અતिरिक्त",
            "Transaction History": "લેણદેણનો ઈતિહાસ",
            "Build better products with flexible tools, helpful documentation,": "લવચીક સાધનો, સહાયક દસ્તાવેજીકરણ સાથે શ્રેષ્ઠ ઉત્પાદન બનાવો,",
            "and a team that champions your growth.": "અને તમારી વૃદ્ધિને સમર્થન આપતી ટીમ.",
            "Useful Link": "ઉપયોગી લિંક",
            "Socials": "સોશિયલ મીડિયા",
            "Logout Seccuessfuly !!": "લોગઆઉટ સફળતાપૂર્વક !!",
            "Free Kundli": "મફત કુંડળી",
            "Horoscope": "જન્મકુંડળી",
            "Dashboard": "ડેશબોર્ડ",
            "Enter your feedback !!": "તમારો પ્રતિસાદ દાખલ કરો !!",
            "Languages": "ભાષાઓ",
            "incoming": "આવતી",
            "request from": "ની વિનંતી",
            "Waitlist Joined !!": "વેઇટલિસ્ટ જોડાયા !!",
            "will start in": "શરૂ થશે",
            "You will receive a": "તમને મળશે",
            "request when the": "વિનંતી જ્યારે",
            "astrologer is ready. Don’t worry! You will not be": "જ્યોતિષ તૈયાર છે. ચિંતા ન કરો! તમને નહીં",
            "charged for missing this session.": "આ સત્ર ચૂકી ગયા માટે ચાર્જ કરવામાં આવશે.",
            "Accept": "સ્વીકારો",
            "Reject": "અસ્વીકારો",
            "Great, what did you like the mast? 😍": "ઉત્કૃષ્ટ, તમને શું સૌથી વધુ ગમ્યું? 😍",
            "Skip": "ઉલટાવો",
            "Payment Information": "ચુકવણી માહિતી",
            "Amount": "રકમ",
            "Tax": "કર",
            "Payment": "ચુકવણી",
            "Payment Method": "ચુકવણી રીત",
        
            "AstroSpace": "AstroSpace",
            "Astrology Consultation Platform": "Astrology Consultation Platform",
            "INVOICE": "INVOICE",
            "Consultation Service Receipt": "Consultation Service Receipt",
            "Invoice Number": "Invoice Number",
            "Date Issued": "Date Issued",
            "PAID": "PAID",
            "From": "From",
            "Bill To": "Bill To",
            "Service": "Service",
            "Booking ID": "Booking ID",
            "Description": "Description",
            "Duration": "Duration",
            "Rate": "Rate",
            "Amount": "Amount",
            "Free Consultation Time": "Free Consultation Time",
            "Complimentary session minutes": "Complimentary session minutes",
            "Free": "Free",
            "Consultation Fee": "Consultation Fee",
            "Standard rate (first block)": "Standard rate (first block)",
            "Extended Consultation Fee": "Extended Consultation Fee",
            "Premium rate (extended block)": "Premium rate (extended block)",
            "Consultation Service": "Consultation Service",
            "Astrology consultation session": "Astrology consultation session",
            "Subtotal": "Subtotal",
            "Platform Fee": "Platform Fee",
            "Included": "Included",
            "Total Amount": "Total Amount",
            "DOB": "DOB",
            "Kundali Chart Used": "Kundali Chart Used",
            "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.": "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.",
            "For support, contact us at support@astrospace.com": "For support, contact us at support@astrospace.com",
            "Free Minute": "Free Minute",
            "Verified": "Verified",
            "End Session": "End Session",
            "Voice Call": "Voice Call",
            "typing...": "typing...",
            "CANCEL": "CANCEL",
            "OK": "OK",
            "Install Progressive Web Application": "Install Progressive Web Application",
            "This site has app functionality. Install it on your device for extensive experience and easy access.": "This site has app functionality. Install it on your device for extensive experience and easy access.",
            "Install": "Install",
            "Search location": "Search location",
            "Location not found !!": "Location not found !!",
            "Waiting for remote user to join...": "Waiting for remote user to join...",
            "End Video Session": "End Video Session",
            "Initializing WebRTC P2P...": "Initializing WebRTC P2P...",
            "Access Denied (Camera/Mic)": "Access Denied (Camera/Mic)",
            "Connection Failed": "Connection Failed",
            "Time Remaining": "Time Remaining",
            "Call ended": "Call ended",

            "Offline": "Offline",}
    },
    ch: {
        translation: {
            "Enter Mobile Number !!": "请输入手机号 !!",
            "In Valid OTP !!": "无效的验证码 !!",
            "Please enter password !!": "请输入密码 !!",
            "Password not match !!": "密码不匹配 !!",
            "Reset Password": "重置密码",
            "Enter your phone number and new password": "输入您的手机号和新密码",
            "Phone Number": "手机号",
            "Enter your number": "输入您的号码",
            "Search": "搜索",
            "Verify": "验证",
            "You will receive a 6 digit code for": "您将收到一个六位数验证码用于",
            "verification to": "验证",
            "Submit": "提交",
            "Enter your password and new password": "输入您的密码和新密码",
            "New Password": "新密码",
            "Enter new password": "输入新密码",
            "Confirm New Password": "确认新密码",
            "Confirm new password": "确认新密码",
            "Back to Login": "返回登录",
            "Back": "返回",
            "Enter Login Details !!": "输入登录信息 !!",
            "Welcome Back!": "欢迎回来！",
            "Sign in to your account": "登录您的账户",
            "Password": "密码",
            "Enter your password": "输入您的密码",
            "Forgot Password?": "忘记密码？",
            "Sign In": "登录",
            "Don't have an account?": "没有账户？",
            "Sign Up": "注册",
            "Please enter all details !!": "请输入所有信息 !!",
            "Please enter valid email !!": "请输入有效的邮箱 !!",
            "Please enter birth place !!": "请输入出生地 !!",
            "Please select language !!": "请选择语言 !!",
            "Step": "步骤",
            "Enter Your Details": "输入您的信息",
            "Hey there! what is your name?": "你好！你叫什么名字？",
            "Full Name": "全名",
            "Email Address": "电子邮箱",
            "Enter your Full Name": "输入您的全名",
            "Enter your email": "输入您的邮箱",
            "What is your gender?": "您的性别？",
            "Male": "男",
            "Female": "女",
            "Enter your birth date": "输入出生日期",
            "Enter your birth time": "输入出生时间",
            "Enter your birth Place": "输入出生地点",
            "Do you know which languages?": "您会哪些语言？",
            "Enter Your Place": "输入您的所在地",
            "Back to Step": "返回上一步",
            "Next": "下一步",
            "My Appointments": "我的预约",
            "Manage your astrology consultations": "管理您的占星咨询",
            "Upcoming": "即将到来",
            "Past": "过去",
            "Pending": "待处理",
            "Accepted": "已接受",
            "Start": "开始",
            "Completed": "已完成",
            "Canceled": "已取消",
            "ID": "编号",
            "Chat": "聊天",
            "Audio Call": "语音通话",
            "Video Call": "视频通话",
            "View Details": "查看详情",
            "Cancel": "取消",
            "No Upcoming Appointment Found !!": "未找到即将到来的预约 !!",
            "Currently you don't have any upcoming appointment.": "您目前没有任何即将到来的预约。",
            "No Past Appointment Found !!": "未找到过去的预约 !!",
            "Currently you don't have any past appointment.": "您目前没有任何过去的预约。",
            "Status": "状态",
            "Service Type": "服务类型",
            "Date": "日期",
            "Time": "时间",
            "Price": "价格",
            "Booked Person Details": "预约人信息",
            "name": "姓名",
            "Date of Birth": "出生日期",
            "Birth Place": "出生地",
            "Gender": "性别",
            "Complete Details": "完整信息",
            "Start Time": "开始时间",
            "End Time": "结束时间",
            "Total Duration": "总时长",
            "Billable Time": "计费时间",
            "Billed Fee First": "先收费",
            "Billed Fee After": "后收费",
            "Total Consultation Fee": "总咨询费",
            "Kundali Details": "星盘详情",
            "Name": "姓名",
            "Send Notification": "发送通知",
            "Continue Chat": "继续聊天",
            "Write message !!": "输入消息 !!",
            "Astrologer Ai Assistant": "占星师 AI 助手",
            "Ask anything about your horoscope...": "问关于您星盘的任何问题...",
            "Write message to assistant": "向助手发送消息",
            "Clear Chat?": "清空聊天？",
            "All messages will be deleted permanently.": "所有消息将被永久删除。",
            "Clear": "清空",
            "Payment faild !!": "支付失败 !!",
            "Please Complete Last Apointment !!": "请完成上一次预约 !!",
            "Please enter comment !!": "请输入评论 !!",
            "Insufficient wallet balance !!": "钱包余额不足 !!",
            "Orders": "订单",
            "Experience": "经验",
            "Rating": "评分",
            "Unfollow": "取消关注",
            "Follow": "关注",
            "Send Gift": "送礼物",
            "Start a Consultation": "开始咨询",
            "Chat with astrologer": "与占星师聊天",
            "For new user": "新用户专用",
            "min free": "分钟免费",
            "Call with astrologer": "与占星师通话",
            "Video call with astrologer": "与占星师视频通话",
            "Astrologer Bio": "占星师简介",
            "Reviews": "评价",
            "Activity": "活动",
            "FAQ's": "常见问题",
            "Media": "媒体",
            "Comment": "评论",
            "No comment yet": "暂无评论",
            "start the conversation": "开始对话",
            "Poast your replay": "发布您的回复",
            "Delete comment": "删除评论",
            "Are you sure you want to delete this comment?": "您确定要删除此评论吗？",
            "Cancle": "取消",
            "Delete": "删除",
            "Intro Audio": "介绍音频",
            "Intro Video": "介绍视频",
            "Hear from": "来自",
            "Please select user !!": "请选择用户 !!",
            "Please select amount !!": "请选择金额 !!",
            "Please select payment method !!": "请选择支付方式 !!",
            "Select Kundli": "选择星盘",
            "Add Kundli": "添加星盘",
            "Minimum balance of": "最低余额",
            "minutes": "分钟",
            "is required to start chat with": "开始聊天需要",
            "Wallet Balance": "钱包余额",
            "Required": "必需",
            "Proceed to Pay": "继续支付",
            "extra in your": "额外的在您的",
            "wallet with this": "钱包中使用此",
            "Woohoo!": "哇哦！",
            "Recharge Amount": "充值金额",
            "GST": "消费税",
            "Wallet Amount": "钱包金额",
            "Payble Amount": "应付金额",
            "Pay from Wallet": "从钱包支付",
            "Available": "可用",
            "Payment Getway Method": "支付网关方式",
            "Continue": "继续",
            "Fortune Cookie - Unveil Your Daily Wisdom": "幸运饼干 - 揭示每日智慧",
            "Crack open a fortune cookie to reveal a piece of daily wisdom. Let the message guide you through your day with positivity and insight.": "打开幸运饼干，揭示每日智慧。让信息以积极和洞察力引导您的一天。",
            "Ask The Fortune Cookie": "询问幸运饼干",
            "Crack open your Fortune Cookie": "打开你的幸运饼干",
            "Crack another one open": "再打开一个",
            "Love Compatibility": "爱情匹配",
            "Find out how compatible you are with your lover, friend, or colleague using our love compatibility calculator. Get your results now.": "使用我们的爱情匹配计算器，了解您与恋人、朋友或同事的契合度。立即查看结果。",
            "Are Aries And Taurus Compatible": "白羊座和金牛座匹配吗",
            "Aries And Taurus Strengths": "白羊座与金牛座的优点",
            "Aries And Taurus Weaknesses": "白羊座与金牛座的弱点",
            "Aries And Taurus Elements": "白羊座与金牛座元素",
            "Aries And Taurus Dates": "白羊座与金牛座日期",
            "Are Aries And Taurus Compatibility Score": "白羊座和金牛座的匹配分数",
            "General": "总体",
            "Communication": "沟通",
            "Sex": "性",
            "Select Another": "选择另一个",
            "Aries": "白羊座",
            "Taurus": "金牛座",
            "Gemini": "双子座",
            "Cancer": "巨蟹座",
            "Leo": "狮子座",
            "Virgo": "处女座",
            "Libra": "天秤座",
            "Scorpio": "天蝎座",
            "Sagittarius": "射手座",
            "Capricorn": "摩羯座",
            "Aquarius": "水瓶座",
            "Pisces": "双鱼座",
            "Please select Your Partner Sign": "请选择您的伴侣星座",
            "Please select Your Sign": "请选择您的星座",
            "Please fill all details !!": "请填写所有信息 !!",
            "Discover Your Core Numbers That Define You": "发现定义您的核心数字",
            "Explore your core numbers like Life Path, Destiny, and Personal Year—complete with strengths, challenges, and meaningful interpretations.": "探索您的核心数字，如生命路径、命运和个人年份——包括优点、挑战及有意义的解读。",
            "Get Your Numbers": "获取您的数字",
            "First Name": "名字",
            "Last Name": "姓氏",
            "Method": "方法",
            "Chaldean": "迦勒底法",
            "Pythagorean": "毕达哥拉斯法",
            "Strengths": "优点",
            "Challenges": "挑战",
            "Advice": "建议",
            "Get Report": "获取报告",
            "Select Tarot One Card": "选择塔罗牌一张",
            "Select Your Card": "选择您的牌",
            "Get Another": "再抽一张",
            "Yes Or No Tarot": "是或否塔罗",
            "Get instant Yes or No answers to pressing questions.": "立即获得针对紧迫问题的“是或否”答案。",
            "Daily Tarot": "每日塔罗",
            "Receive daily tarot readings on love, career, and finance.": "每日获取爱情、事业和财运的塔罗解读。",
            "In-Depth Love Reading": "深入爱情解读",
            "Deep dive into your love life with relationship-specific readings.": "通过针对关系的塔罗解读深入了解您的爱情生活。",
            "Flirt Love Reading": "调情爱情解读",
            "Reveal insights into playful and romantic connections.": "揭示调情和浪漫关系的洞察。",
            "Erotic Love Reading": "亲密爱情解读",
            "Insights into intimate and personal love dynamics.": "深入了解亲密和个人爱情动态。",
            "Egyptian Prediction": "埃及占卜",
            "Access ancient Egyptian insights beyond visible truths.": "获取超越可见真相的古埃及智慧。",
            "Ex-Flame Reading": "前任解读",
            "Explore the possibilities of rekindling with an ex-partner.": "探索与前伴侣复合的可能性。",
            "Made For Each Other Or Not Reading": "是否天作之合解读",
            "Discover if your relationship has long-term potential.": "发现您的关系是否有长期潜力。",
            "Power Life Reading": "掌控人生解读",
            "Take control of your destiny with life-changing tarot readings.": "通过改变人生的塔罗解读掌控您的命运。",
            "Know Your Friend Reading": "了解朋友解读",
            "Understand the true intentions of your friendships.": "了解朋友的真实意图。",
            "Divine Angel Reading": "神圣天使解读",
            "Connect with divine guidance for clarity and spiritual insight.": "与神圣指引连接，获得清晰和灵性洞察。",
            "Career Daily Reading": "职业每日解读",
            "Elevate your career with daily tarot insights to achieve your professional goals.": "通过每日塔罗洞察提升职业，实现职业目标。",
            "Dream Come True Reading": "梦想成真解读",
            "Gain insights into making your dreams and goals a reality.": "获得将梦想和目标变为现实的洞察。",
            "Past Lives Connection Reading": "前世连接解读",
            "Explore your journey across time to understand your path ahead.": "探索跨越时间的旅程，理解未来的道路。",
            "Yes or No Tarot - Find Clear and Immediate Answers": "是或否塔罗 - 获得明确快速的答案",
            "Daily Tarot - Gain Insights Across Love, Finance, and Career": "每日塔罗 - 获取爱情、财务和职业洞察",
            "In-Depth Love Tarot - Reveal the Realities of Your Relationship": "深入爱情塔罗 - 揭示您关系的真相",
            "Flirt Love Tarot - Discover Your Romantic Potential": "调情爱情塔罗 - 发掘您的浪漫潜力",
            "Erotic Love Tarot - Explore Your Intimate Desires": "亲密爱情塔罗 - 探索您的亲密欲望",
            "Discover the Secrets of Your Soul with Egyptian Tarot": "通过埃及塔罗发现灵魂的秘密",
            "Ex-Flame Tarot - Reignite or Release the Past": "前任塔罗 - 重新点燃或释放心结",
            "Made For Each Other Tarot - Discover True Compatibility": "天作之合塔罗 - 发现真实匹配度",
            "Power Life Tarot - Take Control of Your Destiny": "掌控人生塔罗 - 掌握您的命运",
            "Know Your Friend Tarot Reading - Unveil the True Nature of Your Relationships": "了解朋友塔罗 - 揭示您关系的真实本质",
            "Divine Angel Tarot - Receive Angelic Guidance for Clarity and Relief": "神圣天使塔罗 - 获得天使指引以获得清晰和舒缓",
            "Career Daily Tarot Reading - Navigate Your Workday with Confidence": "职业每日塔罗解读 - 自信应对工作日",
            "Explore the Depths of Your Heart's Desires with a Dream Come True Tarot Reading": "通过梦想成真塔罗解读探索内心深处的渴望",
            "Delve into Your Past Lives - Unravel the Enigma of Your Previous Incarnations": "探索前世 - 解开前世之谜",
            "The Yes or No Tarot widget offers quick, straightforward answers to your pressing questions, helping you make decisions with confidence in areas like love, finance, and career.": "是或否塔罗小工具提供快速、直接的答案，帮助您在爱情、财务和事业等领域自信地做出决策。",
            "Daily Tarot provides readings that focus on three key areas of your life: Love, Finance, and Career. Discover the guidance you need for each aspect of your day.": "每日塔罗提供针对生活中三个关键领域的解读：爱情、财务和事业。为您每天的各个方面提供所需指引。",
            "In-Depth Love Tarot provides comprehensive readings to bring clarity to your love life, help you make crucial decisions, and guide you toward understanding your soulmate and future partner.": "深入爱情塔罗提供全面解读，帮助您理清爱情生活，做出重要决定，并引导您了解灵魂伴侣和未来伴侣。",
            "The Flirt Love Tarot Reading provides playful insights into your romantic life. Whether it's a friendship, a new admirer, or a potential soulmate, this reading helps you navigate love with ease.": "调情爱情塔罗为您的浪漫生活提供趣味洞察。无论是友谊、新的倾慕者，还是潜在的灵魂伴侣，此解读都能帮助您轻松应对爱情。",
            "This reading reveals insights into passion, love, and sexual chemistry, helping you understand your relationships and uncover hidden fantasies.": "此解读揭示激情、爱情和性化学的洞察，帮助您理解人际关系并发掘隐藏的幻想。",
            "Explore your twin flame, current struggles, ancestral roots, and past healing with the ancient wisdom of Egyptian Tarot": "通过古埃及塔罗探索您的双生火焰、当前困境、祖先根源和前世疗愈。",
            "The Ex-Flame Tarot Reading provides clarity on whether to rekindle a past relationship or move on. Explore your ex’s feelings, the potential for a renewed connection, and the impact on your future.": "前任塔罗解读帮助您明确是否重燃旧情或继续前行。探索前任的感受、复合可能性及对未来的影响。",
            "This Tarot reading reveals whether your relationship is worth the effort, safe to pursue, and aligned with your life goals. Understand if you’re truly made for each other or if it’s time to move on.": "此塔罗解读揭示您的关系是否值得努力、是否安全可行，并是否符合您的人生目标。了解您们是否真心相配，或是该向前看。",
            "The Power Life Tarot Reading helps you plan your life, overcome struggles, create a clear vision, and take charge of your destiny. Unlock the guidance you need to steer your life towards success.": "掌控人生塔罗帮助您规划生活、克服困难、明确目标，并掌握命运。获取指导，引领生活走向成功。",
            "Divine Angel Tarot connects you with your guardian angels, offering guidance to overcome challenges and find peace in love, freedom, and resolution.": "神圣天使塔罗将您与守护天使连接，提供指导以克服挑战，并在爱情、自由与解决问题中找到平和。",
            "Career Daily Tarot offers insights to manage your workday, from handling your boss to staying proactive and managing tasks effectively. Let the Tarot guide you to a successful and stress-free day.": "职业每日塔罗提供管理工作日的洞察，从应对上司到积极主动及高效任务管理，让塔罗指引您度过成功且无压力的一天。",
            "The Dream Come True Tarot Reading helps you manifest your deepest wishes and aspirations. Whether it's love, material desires, or unfulfilled dreams, this reading offers clarity and guidance to turn your desires into reality.": "梦想成真塔罗帮助您实现最深切的愿望与抱负。无论是爱情、物质欲望，还是未完成的梦想，此解读提供清晰指引，将愿望变为现实。",
            "Explore your past lives to understand current fears, recurring patterns, and influences. Gain clarity on challenges rooted in your previous incarnations.": "探索前世以理解当前的恐惧、重复模式和影响。清晰了解源自前世的挑战。",
            "Select Tarot Three Card": "选择塔罗三张牌",
            "Heartbreak Reading": "失恋解读",
            "Find guidance and healing for a broken heart.": "为破碎的心提供指导和疗愈。",
            "Wisdom Reading": "智慧解读",
            "Balance your energies and find mental peace through wisdom.": "通过智慧平衡能量，获得心理平和。",
            "Divine Magic Reading": "神奇魔法解读",
            "Discover mystical insights with magical tarot guidance.": "通过魔法塔罗获得神秘洞察。",
            "Heartbreak Tarot Reading - Find Closure and Guidance": "失恋塔罗 - 获得释怀与指引",
            "The Heartbreak Tarot Reading offers insight into the cause of your pain and provides advice on how to heal and move forward. This two-card reading delivers clarity and the necessary steps to mend your broken heart.": "失恋塔罗解读揭示痛苦的原因，并提供疗愈与前行的建议。这一两牌解读带来清晰与修复破碎心灵的步骤。",
            "Wisdom Tarot - Find Balance with Yin and Yang": "智慧塔罗 - 阴阳平衡",
            "Wisdom Tarot provides guidance by balancing the Yin and Yang energies in your life. Discover clarity, peace, and a path forward with this two-card reading.": "智慧塔罗通过平衡您生活中的阴阳能量提供指导。通过两牌解读获得清晰、平和及前进之路。",
            "Divine Magic Tarot Reading - Discover Cause and Remedy": "神奇魔法塔罗 - 探索原因与解决",
            "The Divine Magic Tarot Reading offers insights into the root cause of your problems and provides a remedy to guide you toward resolution. With this reading, discover the steps you need to take to transform challenges into solutions.": "神奇魔法塔罗解读揭示问题根源，并提供解决方案指引。通过此解读，发现将挑战转化为解决方案的步骤。",
            "Please pick your cards !!": "请选择您的牌 !!",
            "Get Your Reading": "获取您的解读",
            "Select Tarot Two Card": "选择塔罗两张牌",
            "Love Triangle Reading": "三角恋解读",
            "Get clarity in choosing between multiple romantic interests.": "在多个浪漫对象间做出选择时获得清晰指导。",
            "Past-Present-Future Reading": "过去-现在-未来解读",
            "Love Triangle Tarot - Discover the Dynamics Between You, Lover 1, and Lover 2": "三角恋塔罗 - 探索您与恋人1和恋人2之间的关系动态",
            "Love Triangle Tarot provides insights into the relationships and dynamics between you and your two lovers. Understand where you stand, and what each lover brings into your life, and make an informed decision guided by the cards.": "三角恋塔罗提供您与两位恋人之间关系与动态的洞察。了解自身立场、每位恋人带来的影响，并根据塔罗做出明智决策。",
            "Zodiac Gift Guru": "星座礼物大师",
            "January": "一月",
            "February": "二月",
            "March": "三月",
            "April": "四月",
            "May": "五月",
            "June": "六月",
            "July": "七月",
            "August": "八月",
            "September": "九月",
            "October": "十月",
            "November": "十一月",
            "December": "十二月",
            "Yesterday": "昨天",
            "Today": "今天",
            "Tomorrow": "明天",
            "Gift Recommendations": "礼物推荐",
            "insight": "洞察",
            "Career": "职业",
            "Love": "爱情",
            "Finance": "财务",
            "Popularity": "受欢迎度",
            "Experience: High to Low": "经验：高到低",
            "Experience: Low to High": "经验：低到高",
            "Orders: High to Low": "订单：高到低",
            "Orders: Low to High": "订单：低到高",
            "Price: High to Low": "价格：高到低",
            "Price: Low to High": "价格：低到高",
            "Rating: High to Low": "评分：高到低",
            "Search name...": "搜索姓名...",
            "Online": "在线",
            "Busy": "忙碌",
            "Exp": "经验",
            "yrs": "年",
            "orders": "订单",
            "min": "分钟",
            "Chat Now": "立即聊天",
            "Wait": "等待",
            "There are no astrologers in this category.": "此类别暂无占星师。",
            "Sort": "排序",
            "Filter": "筛选",
            "Category": "类别",
            "All": "全部",
            "Sort by": "排序方式",
            "Skill": "技能",
            "Language": "语言",
            "Reset": "重置",
            "Apply": "应用",
            "You have 30 seconds left. Please recharge immediately to continue the conversation.": "您还有30秒，请立即充值以继续对话。",
            "Free chat over! Next minutes will use wallet balance.": "免费聊天结束！接下来的时间将使用钱包余额。",
            "Complete": "完成",
            "End Chat": "结束聊天",
            "Message": "消息",
            "Hi": "嗨",
            "lets continue this chat at discounted price of": "让我们以优惠价格继续聊天",
            "Are you sure you want to end tha chat to": "您确定要结束聊天吗",
            "No": "否",
            "Yes": "是",
            "Chat With Astrologer": "与占星师聊天",
            "Appointment List": "预约列表",
            "My Following": "我的关注",
            "Recent Post": "最新帖子",
            "Welcome back": "欢迎回来",
            "Manage your astrology services": "管理您的占星服务",
            "Logout": "登出",
            "Login": "登录",
            "My Profile (Member Since)": "我的资料（会员自）",
            "My Followings": "我的关注",
            "You are following": "您正在关注",
            "people": "人",
            "Years": "年",
            "No Following Found !!": "未找到关注 !!",
            "Currently you don't have any follow.": "您目前没有任何关注。",
            "Hey There!": "嗨！",
            "What is your name?": "你叫什么名字？",
            "Enter your first Name": "输入您的名字",
            "Enter your last Name": "输入您的姓氏",
            "male": "男",
            "female": "女",
            "Where wrer you bron?": "你出生在哪里？",
            "Please Select Language": "请选择语言",
            "english": "英语",
            "hindi": "印地语",
            "north": "北",
            "south": "南",
            "Select Chart Type": "选择星盘类型",
            "Start chat with astrologer": "开始与占星师聊天",
            "Search location": "搜索地点",
            "Location not found !!": "未找到地点 !!",
            "Enter bord state": "输入出生州",
            "Search location...": "搜索地点...",
            "Astrologers": "占星师",
            "Top Astrologers. 24 * 7 customer support. Happy to help": "顶级占星师，全天候客户支持，乐意为您服务",
            "per min": "每分钟",
            "Top Astrologers": "顶级占星师",
            "rate": "费率",
            "Top Rated Astrologers": "最高评价占星师",
            "No astrologers found !!": "未找到占星师 !!",
            "FAQs": "常见问题",
            "Raning": "预约中",
            "Raning Apointment": "预约中",
            "Select Other Sign": "选择其他星座",
            "Horoscopes": "星座运势",
            "Daily Horoscope": "每日运势",
            "Weekly Horoscope": "每周运势",
            "Monthly Horoscope": "每月运势",
            "Yearly Horoscope": "每年运势",
            "Composite Friendship Table": "复合友谊表",
            "Kp Planetary Details": "KP行星详情",
            "Kp House Cusps And Chart": "KP宫头与星盘",
            "Ascendant Report": "上升星座报告",
            "Bhava Kundli": "宫位星盘",
            "Vimshottari Dasha": "二十年周期达沙",
            "Yogini Dasha": "女神达沙",
            "Sadhesati Analysis": "萨德萨蒂分析",
            "Sadhesati Life Analysis": "萨德萨蒂人生分析",
            "Kalsarpa Dosha": "卡尔萨帕不良星位",
            "Manglik Analysis": "Manglik分析",
            "Planet Profiles": "行星简介",
            "Gemstone Suggestions": "宝石建议",
            "Upagraha": "副行星",
            "Jaimini Astrology": "贾米尼占星",
            "Chara Dasha": "行星流年达沙",
            "Shadbala": "六力分析",
            "Sudarshana Chakra": "苏达尔沙纳轮",
            "Bhinnashtakvarga": "八分星力表",
            "Yogas": "瑜伽组合",
            "Introduction": "介绍",
            "Basic Astrological Details": "基本占星信息",
            "Planetary Positions": "行星位置",
            "Horoscope Charts": "星盘图表",
            "House Cusps And Sandhi": "宫头与连接点",
            "Divisional Charts": "分盘图表",
            "Basic Details": "基本信息",
            "Ghat Chakra": "Ghat轮",
            "Panchange Details": "万年历详情",
            "Astrological Details": "占星详情",
            "Time of Birth": "出生时间",
            "Place of Birth": "出生地点",
            "Latitude": "纬度",
            "Longitude": "经度",
            "Timezone": "时区",
            "Ayanamsa": "黄道差",
            "Sunrise": "日出",
            "Sunset": "日落",
            "Month": "月份",
            "Tithi": "农历日",
            "Yoga": "瑜伽",
            "Karana": "卡拉纳",
            "Moon Sign": "月亮星座",
            "Moon Vaar": "星期几",
            "Nakshatra": "星宿",
            "Varna": "种姓",
            "Vashya": "控制属性",
            "Yoni": "阴阳属性",
            "Gana": "性格类型",
            "Nadi": "脉象",
            "Sun Sign": "太阳星座",
            "Tatva": "元素",
            "Paya": "财富状况",
            "Yanja": "能量属性",
            "Planets": "行星",
            "Sign": "星座",
            "Sign No": "星座编号",
            "LAGNA CHART (BIRTH CHART)": "上升星盘（出生盘）",
            "MOON CHART": "月亮盘",
            "NAVMANSHA CHART (D9)": "纳夫曼沙盘 (D9)",
            "House": "宫位",
            "Bhav Madhya": "宫位中心",
            "Bhav Sandhi": "宫位连接点",
            "Chalit Chart": "Chalit星盘",
            "Sun Chart": "太阳盘",
            "Health, Constitution, Body": "健康、体质、身体",
            "Hora Chart(D2)": "Hora盘 (D2)",
            "Finance, Wealth, Prosperity": "财务、财富、繁荣",
            "Dreshkan Chart(D3)": "Dreshkan盘 (D3)",
            "Brothers, Sisters": "兄弟姐妹",
            "Chathurthamasha Chart(D4)": "Chathurthamasha盘 (D4)",
            "Fortunes, Luck of native": "本命运势、运气",
            "Saptamansha Chart(D7)": "Saptamansha盘 (D7)",
            "Impregnation, Birth of the child": "受孕、子女出生",
            "Dashamansha Chart(D10)": "Dashamansha盘 (D10)",
            "livelihood, Profession": "生计、职业",
            "Dwadasha Chart(D12)": "Dwadasha盘 (D12)",
            "Parents, paternal happiness": "父母、父系幸福",
            "Shodashamsha Chart(D16)": "Shodashamsha盘 (D16)",
            "Happiness, miseries, conveyance": "幸福、不幸、出行",
            "Vishamansha Chart(D20)": "Vishamansha盘 (D20)",
            "Spiritual progress, worship": "精神进展、崇拜",
            "Chaturvimshamsha(D24)": "Chaturvimshamsha盘 (D24)",
            "Academic achievement, education": "学业成就、教育",
            "Bhamsha Chart(D27)": "Bhamsha盘 (D27)",
            "Physical strength, stamina": "体力与耐力",
            "Trishamansha Chart(D30)": "三分盘 (D30)",
            "Evil, Adversities of life": "恶运与生活逆境",
            "Khavedamsha Chart(D40)": "Khavedamsha盘 (D40)",
            "Auspicious & inauspicious effect": "吉凶影响",
            "Akshvedansha Chart(D45)": "Akshvedansha盘 (D45)",
            "Character and couduct of the native": "性格与行为",
            "Shashtymsah Chart(D60)": "Shashtyamsa盘 (D60)",
            "Shows general happiness": "显示总体幸福感",
            "Degrees": "度数",
            "Sign Lord": "星座主星",
            "Nakshatra Lord": "星宿主星",
            "Sub Lord": "子星主星",
            "Sub Sub Lord": "子子星主星",
            "Lord": "主星",
            "Symbol": "符号",
            "Characteristics": "特征",
            "Day of Fast": "斋日",
            "luchy Gems": "幸运宝石",
            "Personality": "个性",
            "Health": "健康",
            "Relationships": "人际关系",
            "BHAVA KUNDLI": "宫位星盘",
            "Bhramari": "Bhramari",
            "Bhadrika": "Bhadrika",
            "Ulka": "Ulka",
            "Siddha": "Siddha",
            "Sankata": "Sankata",
            "Mangala": "Mangala",
            "Pingala": "Pingala",
            "Dhanya": "Dhanya",
            "Remedies Of Sadhesati": "萨德萨蒂化解方法",
            "Saturn Sign": "土星星座",
            "Is Saturn Retro?": "土星是否逆行？",
            "Phase": "相位",
            "Intensity": "强度",
            "Direction": "方向",
            "Strength": "力量",
            "Percentage": "百分比",
            "Zodiac Sign": "黄道星座",
            "Planet Degree": "行星度数",
            "Lord Of": "主星之属",
            "Combust/Aw...": "焚烧/照亮…",
            "Lucky Stone": "幸运石",
            "Life Stone": "生命石",
            "Finger": "手指",
            "Day": "星期",
            "Time to Wear": "佩戴时间",
            "Mantra": "咒语",
            "Upagraha Longitude": "副行星经度",
            "Rashi": "拉西",
            "Pada": "帕达",
            "Upagraha/Nakshatra/Sub Lord": "副行星/星宿/子星主星",
            "Jamini Planets": "贾米尼行星",
            "Jamini Padas": "贾米尼帕达",
            "Code": "代码",
            "Jamini Karakara": "贾米尼卡拉卡拉",
            "Uchcha Bala": "高能量",
            "Saptavarga Bala": "七力",
            "Yugmayugma Bhamsha Bala": "组合分力",
            "Kendradi Bala": "中心力",
            "Drekkana Bala": "三分力",
            "Total Sthana Bala": "总位置力",
            "Total Dig Bala": "总方向力",
            "Nattunnata Bala": "提升力",
            "Paksha Bala": "月半力",
            "Tribhaga Bala": "三分力",
            "Varshadhipati": "年度主星",
            "Maasadipati": "月度主星",
            "Vaaradhipati": "周主星",
            "Horadhipati": "小时主星",
            "Ayana Bala": "黄道力",
            "Yuddha Bala": "战斗力",
            "Total Kaal Bala": "总时间力",
            "Naisargika Bala": "自然力",
            "Chestha Bala": "努力力",
            "Drik Bala": "视力力",
            "Total Shadbala": "总六力",
            "Shadbala In Rupa": "六力数值",
            "Min Require": "最小需求",
            "Ratio": "比率",
            "Rank": "等级",
            "Sun": "太阳",
            "Moon": "月亮",
            "Mars": "火星",
            "Mercury": "水星",
            "Jupiter": "木星",
            "Venus": "金星",
            "Saturn": "土星",
            "Ashtakvarga": "八分星力表",
            "Sarvashtakava": "总八分星力表",
            "Prasthara Chakra": "Prasthara轮",
            "Ascendant": "上升星座",
            "Total": "总计",
            "Natural Friendship": "自然友谊",
            "Temporary Friendship": "临时友谊",
            "Five Fold Friendship": "五重友谊",
            "Ketu": "凯图",
            "Rahu": "拉胡",
            "Vimshottari Dasha P1": "二十年达沙 P1",
            "Vimshottari Dasha P2": "二十年达沙 P2",
            "AshtaKoot": "八因子匹配",
            "Bhakut Dosha": "Bhakut不良",
            "Nadi Dosha": "Nadi不良",
            "Ashtakoot Analysis": "八因子分析",
            "DashaKoot": "达沙匹配",
            "Personality Report": "个性报告",
            "Match Making Report": "婚配报告",
            "Nav Pancham Yoga": "Nav Pancham瑜伽",
            "Charan": "脚位",
            "Name Alphabet": "姓名字母",
            "Planetary Position": "行星位置",
            "Lagna Chart (Birth Chart)": "上升星盘（出生盘）",
            "Moon Chart": "月亮盘",
            "Navmansha Chart (D9)": "纳夫曼沙盘 (D9)",
            "Mahadasha": "大达沙",
            "End": "结束",
            "Is Recommended ??": "是否推荐？",
            "Manglik Details": "Manglik 详情",
            "What is AshtaKoot ??": "什么是八因子匹配？",
            "Attributes": "属性",
            "Description": "描述",
            "Received": "已收到",
            "Graha Maitri": "行星友好度",
            "Bhakoota": "Bhakoota",
            "What is BhaKoot Dosha ??": "什么是Bhakoot不良？",
            "What is Nadi Dosha ??": "什么是Nadi不良？",
            "Madhya": "中间",
            "Nadi dosha is present": "存在Nadi不良",
            "The": "该",
            "porutham considered for horoscope matching are as follows :": "用于婚配的porutham如下：",
            "Dina": "Dina",
            "Rajju": "Rajju",
            "Rasyadhipati": "Rasyadhipati",
            "Vedha": "Vedha",
            "Mahendra": "Mahendra",
            "Streedargha": "Streedargha",
            "Uranus": "天王星",
            "Neptune": "海王星",
            "Pluto": "冥王星",
            "Tara": "Tara",
            "Please fill boy's details !!": "请填写男方信息！！",
            "Please fill girl's details !!": "请填写女方信息！！",
            "Please fill chart details !!": "请填写星盘信息！！",
            "Kundli Matching": "星盘匹配",
            "Find your right one, through matchmaking": "通过婚配找到你的另一半",
            "Open Kundli": "打开星盘",
            "New Matching": "新匹配",
            "View Kundli": "查看星盘",
            "Boy's Details": "男方信息",
            "Girl's Details": "女方信息",
            "Search city, state, country": "搜索城市、州、国家",
            "Enter first name": "输入名字",
            "Enter last name": "输入姓氏",
            "Chart Style": "星盘样式",
            "North Indian": "北印度风格",
            "South Indian": "南印度风格",
            "English": "英语",
            "Hindi": "印地语",
            "MATCH HOROSCOPE": "匹配星盘",
            "My Profile": "我的资料",
            "Enter full name": "输入全名",
            "Enter email address": "输入电子邮件地址",
            "Enter password": "输入密码",
            "Enter phone number": "输入电话号码",
            "Save Chanage": "保存更改",
            "Manage your astrologers recent post": "管理占星师最近的帖子",
            "Show Less": "显示较少",
            "Show More": "显示更多",
            "Total Balance": "总余额",
            "Add Money": "充值",
            "Extra": "额外",
            "Transaction History": "交易记录",
            "Build better products with flexible tools, helpful documentation,": "使用灵活工具和有用文档构建更好的产品，",
            "and a team that champions your growth.": "以及支持你成长的团队。",
            "Useful Link": "有用链接",
            "Socials": "社交媒体",
            "Logout Seccuessfuly !!": "注销成功！！",
            "Free Kundli": "免费星盘",
            "Horoscope": "星座运势",
            "Dashboard": "仪表板",
            "Enter your feedback !!": "请输入您的反馈！！",
            "Languages": "语言",
            "incoming": "来电",
            "request from": "请求来自",
            "Waitlist Joined !!": "已加入等待名单！！",
            "will start in": "将在…开始",
            "You will receive a": "您将收到一个",
            "request when the": "请求当",
            "astrologer is ready. Don’t worry! You will not be": "占星师准备好时。别担心！您不会",
            "charged for missing this session.": "因错过此会话而被收费。",
            "Accept": "接受",
            "Reject": "拒绝",
            "Great, what did you like the mast? 😍": "太棒了，你最喜欢什么？😍",
            "Skip": "跳过",
            "Payment Information": "支付信息",
            "Amount": "金额",
            "Tax": "税金",
            "Payment": "支付",
            "Payment Method": "支付方式",
        
            "AstroSpace": "AstroSpace",
            "Astrology Consultation Platform": "Astrology Consultation Platform",
            "INVOICE": "INVOICE",
            "Consultation Service Receipt": "Consultation Service Receipt",
            "Invoice Number": "Invoice Number",
            "Date Issued": "Date Issued",
            "PAID": "PAID",
            "From": "From",
            "Bill To": "Bill To",
            "Service": "Service",
            "Booking ID": "Booking ID",
            "Description": "Description",
            "Duration": "Duration",
            "Rate": "Rate",
            "Amount": "Amount",
            "Free Consultation Time": "Free Consultation Time",
            "Complimentary session minutes": "Complimentary session minutes",
            "Free": "Free",
            "Consultation Fee": "Consultation Fee",
            "Standard rate (first block)": "Standard rate (first block)",
            "Extended Consultation Fee": "Extended Consultation Fee",
            "Premium rate (extended block)": "Premium rate (extended block)",
            "Consultation Service": "Consultation Service",
            "Astrology consultation session": "Astrology consultation session",
            "Subtotal": "Subtotal",
            "Platform Fee": "Platform Fee",
            "Included": "Included",
            "Total Amount": "Total Amount",
            "DOB": "DOB",
            "Kundali Chart Used": "Kundali Chart Used",
            "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.": "Thank you for choosing AstroSpace. This invoice is generated automatically and is a valid record of your consultation.",
            "For support, contact us at support@astrospace.com": "For support, contact us at support@astrospace.com",
            "Free Minute": "Free Minute",
            "Verified": "Verified",
            "End Session": "End Session",
            "Voice Call": "Voice Call",
            "typing...": "typing...",
            "CANCEL": "CANCEL",
            "OK": "OK",
            "Install Progressive Web Application": "Install Progressive Web Application",
            "This site has app functionality. Install it on your device for extensive experience and easy access.": "This site has app functionality. Install it on your device for extensive experience and easy access.",
            "Install": "Install",
            "Search location": "Search location",
            "Location not found !!": "Location not found !!",
            "Waiting for remote user to join...": "Waiting for remote user to join...",
            "End Video Session": "End Video Session",
            "Initializing WebRTC P2P...": "Initializing WebRTC P2P...",
            "Access Denied (Camera/Mic)": "Access Denied (Camera/Mic)",
            "Connection Failed": "Connection Failed",
            "Time Remaining": "Time Remaining",
            "Call ended": "Call ended",

            "Offline": "Offline",}
    },
}

const savedLanguage = secureLocalStorage.getItem('I18') || 'en';
i18n.use(initReactI18next).init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false
    }
})

export default i18n;